const local = {
  orgProjects: {
  "title": "سازمان‌ها و پروژه‌ها",
  "manage": "مدیریت پروژه‌ها",
  "selectProject": "انتخاب پروژه",
  "selected": "انتخاب‌شده",
  "initialize": "راه‌اندازی سازمان شخصی",
  "disabled": "دسترسی به سازمان و پروژه در دسترس نیست.",
  "developmentOnly": "هر سازمان شخصی فقط یک مالک دارد.",
  "userBilling": "کلیدها، پرداخت و تاریخچه گفتگو همچنان از حساب فعلی شما استفاده می‌کنند. انتخاب پروژه موجودی را جابه‌جا نمی‌کند.",
  "projectName": "نام پروژه",
  "createProject": "ساخت پروژه",
  "failed": "بارگذاری یا تغییر سازمان و پروژه ممکن نشد. دوباره تلاش کنید.",
  "save": "ذخیره",
  "organizationName": "نام سازمان",
  "rename": "تغییر نام",
  "refresh": "تازه‌سازی",
  "emptyProjects": "پروژه فعالی وجود ندارد. برای انتخاب زمینه، یک پروژه بسازید.",
  "projects": "پروژه‌ها",
  "organization": "سازمان",
  "owner": "مالک",
  "organizationId": "شناسه سازمان",
  "personalAccount": "حساب شخصی",
  "currentContext": "زمینه فعلی",
  "switchContext": "باز کردن زمینه سازمان و پروژه",
  "tagline": "کارهای خود را سازمان‌دهی کنید و زمینه پروژه را انتخاب کنید.",
  "preview": "پیش‌نمایش توسعه",
  "projectHint": "پروژه‌ها متعلق به این سازمان شخصی‌اند. انتخاب پروژه فقط زمینه نشست شما را تغییر می‌دهد.",
  "accountScope": "همچنان در حساب شخصی شما",
  "accountKeys": "کلیدهای API شخصی",
  "accountBilling": "امور مالی شخصی",
  "keysDisabled": "کلیدهای API پروژه هنوز در دسترس نیستند. کلیدهای فعلی تغییری نمی‌کنند.",
  "cancel": "انصراف",
  "saved": "تغییرات ذخیره شد.",
  "contextChanged": "زمینه پروژه تغییر کرد. امور مالی و کلیدهای API تغییری نکردند.",
  "loading": "در حال تازه‌سازی زمینه…",
  "failedShort": "زمینه در دسترس نیست",
  "refreshFailed": "تازه‌سازی ممکن نشد. آخرین زمینه بارگذاری‌شده نمایش داده می‌شود؛ پیش از تغییر، دوباره تازه‌سازی کنید.",
  "setupTitle": "فضایی برای کارهای شما",
  "setupHint": "سازمان شخصی و نخستین پروژه خود را راه‌اندازی کنید. کلیدها و موجودی فعلی در حساب شما می‌مانند.",
  "projectLimit": "این سازمان توسعه به سقف 50 پروژه رسیده است.",
  "findProject": "پیدا کردن پروژه",
  "searchProjects": "جست‌وجوی پروژه‌ها",
  "searchPlaceholder": "نام، توضیحات یا شناسه پروژه",
  "matchingProjects": "پروژه‌های نمایش‌داده‌شده",
  "noSearchResults": "پروژه‌ای با جست‌وجوی شما پیدا نشد. نام دیگری را امتحان کنید یا جست‌وجو را پاک کنید.",
  "clearSearch": "پاک کردن جست‌وجو",
  "dashboardScope": "داده‌های پیشخان",
  "projectContext": "زمینه پروژه",
  "noProjectContext": "پروژه‌ای انتخاب نشده است",
  "homeAccountScope": "موجودی، مصارف و کلیدهای API اینجا متعلق به حساب شخصی شماست، نه پروژه انتخاب‌شده.",
  "navigationScope": "انتخاب پروژه فقط زمینه ناوبری را تغییر می‌دهد. مصارف، امور مالی و کلیدهای API حساب فیلتر نمی‌شوند.",
  "projectDescription": "توضیحات (اختیاری)",
  "editProject": "ویرایش پروژه",
  "createHint": "ساخت پروژه، آن را برای این نشست انتخاب می‌کند. کلیدهای API فعلی و امور مالی تغییری نمی‌کنند.",
  "updateFailed": "تأیید تغییر ممکن نشد. پیش‌نویس شما حفظ شده است؛ زمینه را تازه‌سازی کنید و پیش از تلاش دوباره آن را بررسی کنید.",
  "usageAccountScope": "مصارف متعلق به حساب شخصی شماست. فیلترهای زیر همچنان اعمال می‌شوند؛ انتخاب پروژه این داده‌ها را فیلتر نمی‌کند.",
  "keysAccountScope": "این کلیدهای API متعلق به حساب شخصی شما هستند. انتخاب پروژه دسترسی‌ها یا امور مالی آن‌ها را تغییر نمی‌دهد."
},
  view: {
    grid: 'موزائیکی',
    list: 'لیست',
    compact: 'فشرده'
  },
  calculator: {
    title: 'ماشین حساب هزینه API',
    description: 'هزینه یک درخواست یا بار کاری ماهانه را با نرخ‌های نمایش‌داده‌شده مدل، شامل کارمزد پردازش صورتحساب قابل اعمال، برآورد کنید.',
    estimateSetup: 'تنظیم برآورد',
    totalPayable: 'مبلغ قابل پرداخت',
    providerUsageCost: 'هزینه مصرف مدل با نرخ قابل پرداخت',
    platformFeeZero: 'کارمزد پلتفرم AvalAI برای خدمات پایه (در حال حاضر 0٪)',
    effectivePerRequest: 'هزینه مؤثر هر درخواست',
    dominantCostDriver: 'بیشترین عامل هزینه',
    providerUsageTruth: 'usage ارائه‌دهنده مقدار مصرف قابل محاسبه را مشخص می‌کند. مبلغ نهایی در صورتحساب AvalAI ثبت می‌شود.',
    exchangeUnavailable: 'نرخ تبدیل در دسترس نیست',
    currentExchangeRate: 'نرخ تبدیل فعلی',
    unitDefinition: 'هزینه API با واحد اعتبار (UNIT) محاسبه می‌شود.',
    fallbackCatalog: 'نسخه محدود فهرست عمومی فعال است.',
    unsupportedPrice: 'در حال حاضر قابل محاسبه نیست',
    requests: 'تعداد درخواست‌ها',
    monthlyGrowth: 'رشد ماهانه',
    forecastHorizon: 'بازه پیش‌بینی',
    maxResults: 'حداکثر نتیجه در هر ابزار جست‌وجوی وب',
    monthCount: '{count} ماه',
    assumptions: 'نرخ‌ها و فرضیات',
    retry: 'تلاش دوباره',
    retryExchange: 'تلاش دوباره برای نرخ تبدیل',
    copyEstimate: 'کپی خلاصه برآورد',
    copySuccess: 'برآورد کپی شد',
    copyFailed: 'کپی برآورد انجام نشد',
    resetExample: 'بازنشانی نمونه',
    openTokenizer: 'باز کردن توکن‌پرداز',
    countTokensHint: 'تعداد توکن ورودی را نمی‌دانید؟ متن را در توکن‌پرداز بشمارید؛ نتیجه به همین‌جا برمی‌گردد.',
    handoffApplied: 'تعداد توکن ورودی از توکن‌پرداز آمده است: {count} توکن برای {model}.',
    handoffModelMissing: 'مدل {model} در فهرست قیمت‌ها نیست؛ تعداد توکن اعمال نشد و مدل قبلی حفظ شد.',
    dismiss: 'متوجه شدم',
    model: 'مدل',
    serviceTier: 'سطح سرویس',
    catalogUnavailable: 'قیمت‌گذاری عمومی در دسترس نیست',
    noPricing: 'قیمت قابل محاسبه‌ای برای این مدل منتشر نشده است.',
    thresholdRateApplied: 'برای این بار کاری نرخ پنجره زمینه بزرگ‌تر فعال است.',
    usageType: 'نوع استفاده',
    quantity: 'مقدار',
    rate: 'نرخ قابل پرداخت مدل',
    serviceTier_standard: 'استاندارد',
    serviceTier_flex: 'انعطاف‌پذیر',
    serviceTier_batch: 'دسته‌ای',
    serviceTier_priority: 'اولویت‌دار',
    serviceTier_default: 'استاندارد',
    unit_million_tokens: 'یک میلیون توکن',
    unit_thousand_tokens: 'هزار توکن',
    rateScale: 'مقیاس نرخ',
    rateScalePerMillion: 'به ازای هر یک میلیون توکن',
    rateScalePerThousand: 'به ازای هر هزار توکن',
    unit_character: 'نویسه',
    unit_second: 'ثانیه',
    unit_image: 'تصویر',
    unit_video_second: 'ثانیه ویدئو',
    unit_page: 'صفحه',
    unit_query: 'ابزار جست‌وجوی وب',
    unit_megapixel: 'مگاپیکسل',
    unit_citation: 'استناد',
    pricing_input: 'توکن ورودی',
    pricing_cached_input: 'توکن ورودی کش‌شده',
    pricing_cache_creation_input: 'توکن ایجاد کش',
    pricing_output: 'توکن خروجی',
    pricing_reasoning_output: 'توکن خروجی استدلال',
    pricing_audio_input: 'توکن ورودی صوت',
    pricing_audio_cached_input: 'توکن ورودی صوت کش‌شده',
    pricing_audio_output: 'توکن خروجی صوت',
    pricing_image_input: 'توکن ورودی تصویر',
    pricing_image_cached_input: 'توکن ورودی تصویر کش‌شده',
    pricing_image_output: 'توکن خروجی تصویر',
    pricing_video_input: 'توکن ورودی ویدئو',
    pricing_character_input: 'نویسه ورودی',
    pricing_time: 'مدت زمان',
    pricing_video_output: 'ویدئوی تولیدشده',
    pricing_image_generation: 'تصویر تولیدشده',
    pricing_page_input: 'صفحه ورودی',
    pricing_annotation_page_input: 'صفحه حاشیه‌نویسی',
    pricing_query_input: 'ابزار جست‌وجوی وب',
    pricing_megapixel: 'مگاپیکسل',
    pricing_citation: 'استناد',
    pricing_other: 'سایر موارد استفاده',
    compareModels: 'مقایسه مدل‌ها',
    maxComparison: 'حداکثر چهار مدل را مقایسه کنید',
    estimatedCost: 'هزینه برآوردشده',
    differenceFromLowest: 'اختلاف با کمترین هزینه',
    context: 'پنجره زمینه',
    endpoints: 'نقاط پایانی',
    capabilities: 'قابلیت‌ها',
    pricingSource: 'منبع قیمت‌گذاری',
    provider: 'ارائه‌دهنده',
    minimumTier: 'حداقل سطح حساب',
    serviceTiers: 'سطوح سرویس',
    lifecycleRelease: 'تاریخ انتشار',
    lifecycleSnapshot: 'تاریخ نسخه ثابت',
    lifecycleDeprecation: 'تاریخ توقف',
    lifecycleUnpublished: 'منتشر نشده',
    estimateUnavailable: 'برآورد در دسترس نیست',
    cumulativeCost: 'هزینه تجمعی',
    forecastTable: 'جزئیات پیش‌بینی',
    month: 'ماه',
    rateInput: 'ورودی',
    rateCached: 'کش‌شده',
    rateOutput: 'خروجی',
    unit: 'UNIT',
    irt: 'تومان',
    tokenRange: '{input} / {output}',
    emptyEstimateTitle: 'برای برآورد هزینه، میزان مصرف را وارد کنید',
    emptyEstimateHint: 'برای مشاهده برآورد زنده، تعداد توکن‌ها یا درخواست‌ها را در بالا وارد کنید.',
    comparisonSelected: '{count} / {max} انتخاب‌شده',
    comparisonEmptyTitle: 'مدل‌ها را برای مقایسه انتخاب کنید',
    comparisonEmptyHint: 'تا چهار مدل را در بالا انتخاب کنید تا هزینه‌ها، نرخ‌ها و قابلیت‌ها را کنار هم ببینید.',
    comparisonBestValue: 'بهترین ارزش',
    comparisonMoreItems: '+{count} مورد دیگر'
  },
  tokenizer: {
    title: 'توکن‌پرداز مرورگر',
    description: 'ببینید متن شما با کدگذاری مدل‌های OpenAI به چند توکن تقسیم می‌شود. همه‌چیز در مرورگر انجام می‌شود.',
    providerUsageTitle: 'میزان استفاده اعلام‌شده توسط ارائه‌دهنده معتبر است',
    providerUsageTruth:
      'AvalAI روش توکن‌پردازی یا تعداد توکن قابل صورتحساب را تعیین نمی‌کند. شیء usage ارائه‌دهنده که در پاسخ API بازگردانده می‌شود، مرجع نهایی است.',
    localEstimateOnly:
      'این برآورد محلی فقط متن ساده را پوشش می‌دهد. ابزارها، اسکیماها، فایل‌ها، تصویر، صوت و قالب‌بندی ارائه‌دهنده می‌توانند مصرف بیشتری ایجاد کنند.',
    supportedModel: 'مدل پشتیبانی‌شده',
    encoding: 'کدگذاری',
    placeholder: 'متن را برای بررسی توکن‌ها وارد کنید…',
    showExample: 'نمایش نمونه',
    clear: 'پاک کردن',
    copyText: 'کپی متن',
    tokens: 'توکن‌ها',
    characters: 'نویسه‌ها',
    words: 'واژه‌ها',
    averageCharacters: 'میانگین نویسه در هر توکن',
    contextUsage: 'زمینه مصرف‌شده',
    visualization: 'نمایش توکن‌ها',
    textView: 'متن',
    idView: 'شناسه توکن',
    visualizationTruncated: 'فقط {count} توکن نخست نمایش داده می‌شود؛ شمارش کل کامل است.',
    textTooLarge: 'متن نباید بیش از ۲٬۰۰۰٬۰۰۰ نویسه داشته باشد.',
    workerFailed: 'توکن‌پرداز مرورگر راه‌اندازی نشد. دوباره تلاش کنید.',
    noSupportedModels: 'هیچ مدل فهرست‌شده‌ای توسط کتابخانه نصب‌شده پشتیبانی نمی‌شود.',
    localPrivacy: 'توکن‌پردازی در مرورگر انجام می‌شود و متن شما برای AvalAI ارسال نمی‌شود.',
    noticeCompact: 'شمارش نهایی را شیء usage در پاسخ ارائه‌دهنده تعیین می‌کند.',
    moreDetails: 'جزئیات بیشتر',
    useInCalculatorHint: 'تعداد توکن‌های این متن به‌عنوان توکن ورودی مدل {model} در ماشین حساب قرار می‌گیرد.',
    needTextForCalculator: 'برای ارسال به ماشین حساب، ابتدا متنی وارد کنید.',
    modelPreselected: 'مدل {model} از ماشین حساب انتخاب شد.',
    requestedModelUnsupported: 'مدل {requested} در مرورگر توکن‌پردازی نمی‌شود؛ {fallback} انتخاب شد.',
    useInCalculator: 'استفاده در ماشین حساب',
    copySuccess: 'متن کپی شد',
    copyFailed: 'کپی متن انجام نشد',
    emptyVisualization: 'برای بررسی مرز توکن‌ها متن وارد کنید.',
    catalogUnavailable: 'فهرست عمومی مدل‌ها در دسترس نیست',
    retry: 'تلاش دوباره'
  },
  costTools: {
    switchLabel: 'ابزارهای هزینه',
    calculatorHint: 'برآورد هزینه هر درخواست یا بار کاری بر اساس قیمت ارائه‌دهنده',
    tokenizerHint: 'شمارش توکن‌های یک متن در مرورگر، بدون ارسال به سرور'
  },
  support: {
    title: 'مرکز پشتیبانی',
    description: 'دریافت کمک و مدیریت تیکت‌های پشتیبانی',
    myTickets: 'تیکت‌های من',
    createTicket: 'ایجاد تیکت',
    agent: 'پشتیبان',

    aiOperations: {
      title: 'عملیات هوش مصنوعی پشتیبانی',
      description: 'سلامت اجرای سامانه و فراداده امن اجراهای بین‌تیکتی را بررسی کنید.',
      accessDenied: 'قابلیت مشاهده عملیات هوش مصنوعی پشتیبانی برای شما فعال نیست.',
      openRun: 'باز کردن در عملیات هوش مصنوعی',
      tabs: {
        overview: 'نمای کلی',
        runs: 'اجراها',
        evaluations: 'ارزیابی‌ها',
        replays: 'بازاجراها',
        releases: 'انتشارها'
      },
      workflow: {
        progress: 'پیشرفت گردش‌کار انتشار',
        currentPhase: 'مرحله جاری',
        blockerCount: '{count} مانع',
        phases: {
          evidence: 'بررسی اسناد',
          approval: 'تایید مستقل',
          shadow: 'عرضه سایه',
          support_admin: 'آزمایش مدیران پشتیبانی',
          selected_agents: 'پشتیبان‌های منتخب',
          all_support: 'همه پشتیبان‌ها',
          steady_state: 'وضعیت پایدار',
          terminal: 'پایان‌یافته'
        },
        statuses: {
          blocked: 'مسدود',
          waiting: 'در انتظار',
          ready: 'آماده',
          active: 'فعال',
          complete: 'کامل',
          terminal: 'پایان‌یافته'
        },
        stepStates: {
          complete: 'کامل',
          current: 'جاری',
          upcoming: 'پیش رو',
          terminal: 'پیش نرفته'
        },
        blockers: {
          customer_activation_disabled: 'فعال‌سازی برای مشتری همچنان غیرفعال است.',
          hard_gate_failed: 'یکی از دروازه‌های قطعی لازم پذیرفته نشد.',
          dataset_expired: 'اعتبار اسناد مجموعه‌داده پیوندخورده پایان یافته است.',
          approval_terminal: 'چرخه تایید به وضعیت پایانی رسیده است.',
          approval_incomplete: 'تایید لازم کامل نشده است.',
          independent_approver_required: 'تاییدکننده‌ای مستقل لازم است.',
          minimum_soak_incomplete: 'حداقل زمان پایش مرحله کامل نشده است.',
          eligible_runs_insufficient: 'تعداد اجرای واجد شرایط این مرحله کافی نیست.',
          health_safety_failure: 'اسناد سلامت یا ایمنی پذیرفته نشد.',
          rollout_paused: 'عرضه موقتا متوقف است.',
          rollout_fenced: 'عرضه محصور شده است.',
          rollout_rolled_back: 'عرضه بازگردانی شده است.'
        },
        actions: {
          approve: 'تایید انتشار',
          reject: 'رد انتشار',
          cancel: 'لغو درخواست تایید',
          escalate: 'ارجاع تایید به سطح بالاتر',
          re_request: 'درخواست دوباره تایید',
          execute_release: 'اجرای انتشار تاییدشده',
          start_support_admin: 'شروع آزمایش مدیران پشتیبانی',
          advance: 'پیش‌برد عرضه',
          mark_steady_state: 'ثبت وضعیت پایدار',
          pause: 'توقف موقت عرضه',
          resume: 'ادامه عرضه',
          fence: 'محصور کردن عرضه',
          rollback: 'بازگردانی عرضه',
          development_precondition: 'ایجاد اسناد توسعه'
        },
        evidence: {
          title: 'اسناد گردش‌کار ارائه‌شده توسط درخواست‌کننده',
          showDetails: 'نمایش جزئیات',
          hideDetails: 'پنهان کردن جزئیات',
          hardGate: 'اسناد دروازه قطعی',
          hardGateSummary: 'تعدادهای کامل دروازه قطعی و بررسی‌های یکپارچگی زیر را بازبینی کنید.',
          datasetFreshness: 'تازگی مجموعه‌داده',
          datasetFreshnessSummary: 'نسخه، هش و مهلت تازگی مجموعه‌داده پیوندخورده را در ادامه بازبینی کنید.',
          calibration: 'اسناد کالیبراسیون',
          calibrationSummary: 'نتیجه، تعدادها، نرخ خطا و پوشش دسته‌های کالیبراسیون را در ادامه بازبینی کنید.',
          adversarial: 'اسناد خصمانه',
          adversarialSummary: 'خلاصه محدود تولید و پوشش خصمانه را در ادامه بازبینی کنید.',
          approval: 'اسناد تایید',
          approvalSummary: 'چرخه کامل تایید وابسته به نسخه را در ادامه بازبینی کنید.',
          statuses: {
            pass: 'پذیرفته‌شده',
            fail: 'ناموفق',
            unavailable: 'در دسترس نیست',
            pending: 'در انتظار'
          }
        },
        actionPanel: {
          currentState: 'وضعیت جاری گردش‌کار',
          unavailable: 'گردش‌کار در دسترس نیست',
          blockers: 'موانع به‌ترتیب',
          customerReadOnly: 'رکوردهای گردش‌کار مشتری فقط خواندنی هستند و هیچ اقدامی ندارند.',
          invalidReadOnly: 'داده نامعتبر یا در دسترس‌نبودن گردش‌کار فقط خواندنی است.',
          noAction: 'در حال حاضر هیچ اقدام مجاز اعلام‌شده از سوی سرور وجود ندارد.',
          nextActions: 'اقدام‌های بعدی موجود',
          openLinkedRollout: 'باز کردن عرضه پیوندخورده'
        },
        approvalDialog: {
          title: 'اقدام تایید انتشار',
          description: 'نامزد پیوندخورده را بررسی کنید و دلیل و اسناد لازم را وارد کنید.'
        },
        rolloutDialog: {
          title: 'اقدام کنترل عرضه',
          description: 'اسناد لازم برای اقدام وابسته به نسخه دقیق اعلام‌شده از سوی سرور را وارد کنید.'
        },
        fields: {
          close: 'بستن پنجره',
          candidateHash: 'هش نامزد',
          approvalVersion: 'نسخه تایید',
          action: 'اقدام',
          reason: 'دلیل',
          evidence: 'اسناد',
          cancel: 'انصراف',
          submit: 'ارسال اقدام',
          currentStage: 'مرحله جاری',
          expectedRevision: 'نسخه مورد انتظار',
          safetyEvidence: 'اسناد قبولی ایمنی',
          healthEvidence: 'اسناد قبولی سلامت',
          evaluatedCount: 'تعداد بررسی‌شده',
          failureCount: 'تعداد ناموفق',
          passed: 'اسناد پذیرفته شده است',
          clearTriggers: 'محرک‌های بدون رخداد عرضه',
          pauseTrigger: 'تعداد محرک توقف موقت',
          fenceTrigger: 'تعداد محرک محصورسازی',
          rollbackTrigger: 'تعداد محرک بازگردانی',
          triggerClear: 'محرک بدون رخداد است',
          stageCompletion: 'اسناد تکمیل مرحله',
          completed: 'مرحله کامل شده است',
          safetyPassed: 'ایمنی مرحله پذیرفته شده است',
          healthPassed: 'سلامت مرحله پذیرفته شده است',
          firedTrigger: 'اسناد محرک رخ‌داده',
          reasonCode: 'کد دلیل محرک',
          triggerCount: 'تعداد محرک رخ‌داده',
          confirmDestructive: 'این اقدام مخرب عرضه را آگاهانه تایید می‌کنم.'
        },
        validation: {
          reasonLength: 'دلیل باید بین ۸ تا ۱۰۰۰ نویسه باشد.',
          evidenceLength: 'اسناد باید بین ۸ تا ۲۰۰۰ نویسه باشد.',
          reasonCode: 'کد دلیل باید ۱ تا ۱۲۸ نویسه باشد و فقط با حروف کوچک انگلیسی، عدد و نویسه‌های . _ : - نوشته شود.',
          firedTrigger: 'حداقل یک محرک رخ‌داده ثبت کنید.',
          passEvidence: 'تعدادهای بررسی و خطا باید معتبر باشند و اسناد پذیرفته شود.',
          clearTriggers: 'همه محرک‌های توقف موقت، محصورسازی و بازگردانی باید بدون رخداد باشند.',
          confirmationRequired: 'تایید صریح لازم است.'
        },
        warnings: {
          pause: 'توقف موقت، پیشرفت عرضه را تا فراهم‌شدن اقدام ادامه مجاز متوقف می‌کند.',
          fence: 'محصورسازی از فعال‌سازی بیشتر عرضه جلوگیری می‌کند.',
          rollback: 'بازگردانی این عرضه را غیرفعال می‌کند و بازیابی صریح لازم دارد.',
          rollbackNoPhaseOneRestore: 'بازگردانی، فاز ۱ را به‌طور خودکار برنمی‌گرداند.'
        },
        errors: {
          stepUpRequired: 'پیش از ادامه این اقدام، احراز هویت تکمیلی تازه لازم است.',
          forbidden: 'دیگر مجاز به انجام این اقدام نیستید.',
          conflict: 'گردش‌کار تغییر کرده است و وضعیت مرجع باید دوباره بارگذاری شود.',
          invalidInput: 'اسناد ارسال‌شده گردش‌کار نامعتبر است.',
          auditUnavailable: 'خدمت ممیزی لازم موقتا در دسترس نیست.',
          rateLimited: 'تعداد درخواست‌های گردش‌کار بیش از حد است. کمی بعد دوباره تلاش کنید.',
          requestFailed: 'تکمیل اقدام گردش‌کار ممکن نبود.',
          invalidResponse: 'خدمت گردش‌کار پاسخی نامعتبر برای نمایش امن برگرداند.'
        },
        results: {
          ready: 'برای ورود اطلاعات بررسی‌شده آماده است.',
          submitting: 'در حال ارسال اقدام گردش‌کار…',
          succeeded: 'اقدام موفق بود و وضعیت مرجع در حال به‌روزرسانی است.',
          failed: 'اقدام کامل نشد.',
          refreshed: 'وضعیت مرجع گردش‌کار به‌روزرسانی شد.'
        }
      },
      developmentPreconditionDialog: {
        title: 'ایجاد اسناد عرضه برای توسعه',
        description:
          'فیکسچر، مرحله و نسخه اعلام‌شده از سرور را بررسی کنید و سپس تیکت کنترل کیفیت و درخواست‌کننده داخلی موجود را مشخص کنید.',
        warning: 'فقط برای محیط توسعه: این کار اسناد مصنوعی و ماندگار عرضه را ایجاد می‌کند و تایید تولید نیست.',
        close: 'بستن پنجره',
        fixtureId: 'شناسه فیکسچر',
        stage: 'مرحله',
        revision: 'نسخه مورد انتظار',
        ticketId: 'شناسه تیکت کنترل کیفیت موجود',
        requesterId: 'شناسه UUID درخواست‌کننده داخلی',
        confirm: 'ایجاد اسناد توسعه',
        cancel: 'انصراف',
        submitting: 'در حال ایجاد اسناد ماندگار توسعه…',
        success: 'اسناد توسعه ایجاد شد و وضعیت مرجع عرضه به‌روزرسانی شد.',
        rolloutId: 'شناسه عرضه',
        candidateHash: 'هش نامزد',
        runCount: 'تعداد اجراهای متعلق به فیکسچر',
        runDigest: 'چکیده شناسه اجراهای متعلق به فیکسچر',
        receiptHash: 'هش رسید',
        validation: {
          ticketId: 'یک شناسه تیکت عدد صحیح و مثبت وارد کنید.',
          requesterId: 'یک UUID متعارف با حروف کوچک وارد کنید.'
        },
        errors: {
          stepUpRequired: 'پیش از ایجاد اسناد توسعه، احراز هویت تکمیلی تازه لازم است.',
          forbidden: 'دیگر مجاز به ایجاد اسناد توسعه نیستید.',
          conflict:
            'عرضه تغییر کرده و وضعیت مرجع به‌روزرسانی شده است؛ این پنجره را ببندید و مرحله و نسخه جدید را بررسی کنید.',
          invalidInput: 'ورودی پیش‌شرط توسعه نامعتبر است.',
          auditUnavailable: 'ممیزی لازم برای اسناد توسعه موقتا در دسترس نیست.',
          rateLimited: 'تعداد درخواست‌های پیش‌شرط توسعه بیش از حد است. کمی بعد دوباره تلاش کنید.',
          requestFailed: 'تکمیل درخواست پیش‌شرط توسعه ممکن نبود.',
          invalidResponse: 'خدمت پیش‌شرط توسعه پاسخی نامعتبر برای نمایش امن برگرداند.'
        }
      },
      releaseRequest: {
        open: 'درخواست نامزد انتشار داخلی',
        title: 'درخواست نامزد انتشار داخلی',
        internalOnly:
          'فقط برای پشتیبانی داخلی است. این درخواست به تایید مستقل نیاز دارد و هوش مصنوعی مشتری را استقرار یا فعال نمی‌کند.',
        reviewDescription: 'بازاجرای تغییرناپذیر، پیکربندی و اسناد ارزیابی را پیش از ادامه بازبینی کنید.',
        justificationDescription:
          'برای تاییدکننده مستقل، توضیح محدود و متنی ساده بنویسید. شما درخواست بررسی می‌دهید و انتشار را تایید نمی‌کنید.',
        reviewHeading: 'بازبینی تغییرناپذیر بازاجرا',
        justificationHeading: 'زمینه درخواست تایید',
        contentWarning:
          'فقط متن ساده بنویسید. تیکت، پیش‌نویس خصوصی، داده شخصی، اطلاعات احراز هویت، خروجی ارائه‌دهنده، نشانی اینترنتی، Markdown یا استدلال پنهان را وارد نکنید.',
        serverRevalidation:
          'سرور پیش از پذیرش درخواست، تکمیل بازاجرا، پیکربندی، اسناد، مجوز و احراز هویت تکمیلی را دوباره اعتبارسنجی می‌کند.',
        continue: 'ادامه',
        back: 'بازگشت',
        close: 'بستن',
        submit: 'درخواست تایید مستقل',
        retryExact: 'ارسال دوباره همان درخواست',
        abandon: 'رها کردن درخواست در انتظار',
        reason: 'دلیل',
        reasonHelp:
          'فقط متن ساده بنویسید. توضیح دهید چرا این بازاجرای کامل‌شده باید بررسی شود؛ تیکت، پیش‌نویس خصوصی، داده شخصی، اطلاعات احراز هویت، خروجی ارائه‌دهنده، نشانی اینترنتی، Markdown یا استدلال پنهان را وارد نکنید.',
        evidence: 'زمینه اسناد برای بازبین',
        evidenceHelp:
          'فقط متن ساده بنویسید. ارجاع‌های امن اسناد را خلاصه کنید؛ تیکت، پیش‌نویس خصوصی، داده شخصی، اطلاعات احراز هویت، خروجی ارائه‌دهنده، نشانی اینترنتی، Markdown یا استدلال پنهان را وارد نکنید.',
        watchdogPolicyHeading: 'خط پایه تغییرناپذیر دیده‌بان',
        watchdogPolicyHelp:
          'خط پایه ایمنی پنج‌دقیقه‌ای تاییدشده به این نامزد متصل است و سرور آن را دوباره اعتبارسنجی می‌کند.',
        watchdogBaselineRate: 'نرخ خطای خط پایه بر حسب واحد پایه',
        watchdogBaselineRateHelp: 'یک عدد صحیح از ۰ تا ۱۰۰۰۰ وارد کنید.',
        watchdogBaselineSource: 'منبع اسناد خط پایه',
        watchdogBaselineSourceHelp: 'منبع اسناد محدود برای تعیین خط پایه را انتخاب کنید.',
        watchdogBaselineEvidenceHash: 'هش SHA-256 اسناد خط پایه',
        watchdogBaselineEvidenceHashHelp:
          'چکیده متعارف SHA-256 با ۶۴ نویسه کوچک را برای اسناد نگهداری‌شده خط پایه وارد کنید.',
        watchdogBaselineSources: {
          shadowValidation: 'اعتبارسنجی سایه',
          historicalRuntime: 'اجرای تاریخی'
        },
        acknowledgement:
          'می‌دانم که این اقدام فقط بررسی مستقل را درخواست می‌کند؛ با آن انتشار را تایید یا مستقر نمی‌کنم و هوش مصنوعی مشتری را فعال نمی‌کنم.',
        submitting: 'در حال درخواست تایید مستقل…',
        success: 'نامزد انتشار داخلی درخواست شد و همچنان در انتظار تایید مستقل است.',
        stepUpRequired:
          'احراز هویت تکمیلی تازه لازم است. پیش‌نویس شما حفظ شده است؛ پس از احراز هویت آن را بازبینی و دوباره ارسال کنید.',
        forbidden: 'دیگر مجاز به درخواست این نامزد انتشار داخلی نیستید.',
        invalidRequest: 'درخواست نامعتبر است. پیش از ارسال دوباره، فیلدهای محدود را بازبینی کنید.',
        configurationMismatch:
          'پیکربندی بازاجرا دیگر با اسناد سرور همخوان نیست. مقادیر تغییرناپذیر را دوباره بارگذاری و بازبینی کنید.',
        evidenceUnavailable: 'اسناد تغییرناپذیر لازم برای ارزیابی در دسترس نیست. هیچ نامزد انتشاری درخواست نشد.',
        idempotencyConflict:
          'کلید این درخواست با محتوای دیگری تداخل دارد. پیش از ارسال درخواست تازه، پیش‌نویس را بازبینی کنید.',
        rateLimited: 'تعداد درخواست‌های انتشار بیش از حد است. کمی بعد دوباره تلاش کنید.',
        ambiguous:
          'نتیجه نامشخص است. تلاش دوباره فقط همان درخواست را بدون هیچ تغییری ارسال می‌کند؛ برای ویرایش، ابتدا درخواست در انتظار را رها کنید.',
        navigationFailed: 'درخواست موفق بود، اما پیمایش انجام نشد. نامزد انتشار مرجع را باز کنید:',
        emptyValue: 'در دسترس نیست',
        blockers: {
          notCompleted: 'فقط بازاجرای ارزیابی کامل‌شده را می‌توان برای بررسی انتشار داخلی فرستاد.',
          configurationUnavailable: 'پیکربندی تغییرناپذیر نامزد در دسترس نیست یا اعتبار ندارد.',
          evidenceUnavailable: 'اسناد تغییرناپذیر ارزیابی در دسترس نیست یا اعتبار ندارد.',
          permissionRequired:
            'دسترسی درخواست انتشار در دسترس نیست. مجوزهای خود را تازه‌سازی کنید یا از مدیر مجاز بخواهید.',
          pendingRequest:
            'درخواست انتشار برای بازاجرای ارزیابی دیگری همچنان در انتظار است. پیش از درخواست انتشار دیگر، آن را تعیین تکلیف کنید.'
        },
        labels: {
          replay: 'بازاجرای ارزیابی',
          evaluationSet: 'مجموعه ارزیابی',
          dataset: 'مجموعه‌داده',
          datasetVersion: 'نسخه مجموعه‌داده',
          datasetHash: 'هش مجموعه‌داده',
          policy: 'خط‌مشی',
          prompt: 'دستور',
          model: 'مدل',
          embedding: 'تعبیه‌سازی',
          index: 'نمایه',
          thresholds: 'هش آستانه‌ها',
          hardGate: 'اسناد دروازه قطعی',
          cases: 'مورد',
          languageCases: 'موارد انگلیسی و فارسی',
          safetyFailures: 'نشت داده حساس یا خروجی بسیار ناامن',
          governanceFailures: 'خطاهای مجوز، مخاطب، بین‌تیکتی، نشانی یا نشانه‌گذاری',
          factualSupport: 'ادعاهای مستند و همه ادعاهای واقعی',
          integrityChecks: 'یکپارچگی بازیابی، استقرار و تازگی داده',
          baseline: 'مقایسه با خط پایه',
          baselineCounts: 'قبولی خط پایه و نامزد',
          regressions: 'پسرفت‌ها',
          calibration: 'کالیبراسیون مستقل',
          independentLabels: 'نتیجه با برچسب مستقل',
          calibrationLanguages: 'نتایج انگلیسی و فارسی',
          errorBasisPoints: 'خطای داده کنارگذاشته‌شده بر حسب واحد پایه',
          categoryCoverage: 'پوشش دسته‌ها',
          passed: 'پذیرفته‌شده',
          failed: 'ناموفق',
          characterCount: '{count} از {max} نویسه'
        },
        validation: {
          reasonRequired: 'وارد کردن دلیل لازم است.',
          reasonTooLong: 'دلیل نباید بیش از ۱۰۰۰ نویسه باشد.',
          evidenceRequired: 'وارد کردن زمینه اسناد برای بازبین لازم است.',
          evidenceTooLong: 'زمینه اسناد برای بازبین نباید بیش از ۲۰۰۰ نویسه باشد.',
          watchdogBaselineRateRequired: 'نرخ خطای خط پایه الزامی است.',
          watchdogBaselineRateInvalid: 'یک عدد صحیح از ۰ تا ۱۰۰۰۰ وارد کنید.',
          watchdogBaselineEvidenceHashRequired: 'هش اسناد خط پایه الزامی است.',
          watchdogBaselineEvidenceHashInvalid: 'هش SHA-256 با ۶۴ نویسه کوچک وارد کنید.',
          acknowledgementRequired: 'پیش از ارسال، مرز بررسی مستقل را بپذیرید.'
        }
      },
      filters: {
        window: 'بازه زمانی',
        language: 'زبان',
        operation: 'عملیات',
        state: 'وضعیت',
        ticket: 'شماره تیکت',
        ticketPlaceholder: 'TK-…',
        datasetKey: 'کلید مجموعه‌داده',
        datasetKeyPlaceholder: 'support-core',
        evaluationSetId: 'شناسه مجموعه ارزیابی',
        all: 'همه'
      },
      windows: {
        '1h': 'یک ساعت گذشته',
        '24h': '۲۴ ساعت گذشته',
        '7d': '۷ روز گذشته',
        '30d': '۳۰ روز گذشته'
      },
      languages: {
        en: 'انگلیسی',
        fa: 'فارسی'
      },
      audiences: {
        internal: 'داخلی',
        agent: 'پشتیبان'
      },
      evidenceStatus: {
        dataset: {
          missing: 'موجود نیست',
          fresh: 'تازه',
          expired: 'منقضی‌شده'
        },
        hardGate: {
          missing: 'موجود نیست',
          passed: 'قبول‌شده',
          failed: 'ردشده'
        },
        calibration: {
          missing: 'موجود نیست',
          uncalibrated: 'کالیبره‌نشده',
          eligible: 'واجد شرایط',
          passed: 'قبول‌شده',
          failed: 'ردشده'
        }
      },
      calibrationPresentation: {
        uncalibrated: 'رسید کالیبراسیون موجود نیست',
        eligible: 'آستانه‌ها برآورده شده‌اند؛ تایید در انتظار است',
        passed: 'شواهد کالیبراسیون پذیرفته شد',
        failed: 'شواهد کالیبراسیون این انتشار را مسدود می‌کند'
      },
      calibrationBinding: {
        title: 'شواهد کالیبراسیون متصل به نامزد',
        bindingVersion: 'نسخه اتصال',
        enforcementMode: 'حالت اعمال',
        policyId: 'شناسه سیاست',
        policyHash: 'هش سیاست',
        artifactId: 'شناسه مصنوع',
        artifactHash: 'هش مصنوع',
        releaseScore: 'امتیاز انتشار کالیبره‌شده (نقطه پایه)',
        heldOutError: 'خطای کالیبراسیون بخش نگه‌داشته‌شده (نقطه پایه)',
        approvalId: 'شناسه تایید مصنوع',
        approvalHash: 'هش شواهد تایید',
        modes: { observe: 'حالت مشاهده', enforced: 'حالت اعمال' }
      },
      metrics: {
        totalRuns: 'کل اجراها',
        completion: 'نرخ تکمیل',
        blocked: 'نرخ توقف',
        failure: 'نرخ خطا',
        timeout: 'نرخ پایان مهلت',
        latency: 'زمان مراحل',
        timingDescription: 'تعداد رویدادهای هر مرحله، نه زمان کل پاسخ. زمان رویدادهای نامشخص ثبت نشده است.',
        timingEvents: 'رویدادهای مراحل',
        retrievalEvents: 'رویدادهای بازیابی',
        noSample: 'در این بازه اجرایی ثبت نشده است',
        retrieval: 'سلامت بازیابی',
        degraded: 'افت‌کیفیت',
        zeroResults: 'بدون نتیجه',
        evaluation: 'اسناد ارزیابی',
        dataset: 'مجموعه‌داده',
        hardGates: 'دروازه‌های قطعی',
        calibration: 'کالیبراسیون',
        rollouts: 'خلاصه عرضه',
        active: 'فعال',
        paused: 'متوقف موقت',
        fenced: 'محصور'
      },
      runs: {
        title: 'صف اجراها',
        empty: 'اجرایی با این فیلترها پیدا نشد.',
        select: 'برای بررسی فراداده امن، یک اجرا را انتخاب کنید.',
        resultCount: '{count} اجرا در این صفحه',
        rowLabel: 'باز کردن اجرای {run} برای تیکت {ticket}',
        loading: 'در حال بارگذاری اجراها…',
        refreshFailed: 'به‌روزرسانی انجام نشد؛ آخرین اجراهای بارگذاری‌شده نمایش داده می‌شوند.'
      },
      evaluations: {
        title: 'مجموعه‌داده‌های ارزیابی',
        datasets: 'مجموعه‌داده‌ها',
        calibration: 'کالیبراسیون',
        empty: 'هیچ مجموعه‌داده ارزیابی با این فیلتر پیدا نشد.',
        select: 'برای بررسی فراداده امن، یک مجموعه‌داده ارزیابی را انتخاب کنید.',
        resultCount: '{count} مجموعه‌داده ارزیابی در این صفحه',
        rowLabel: 'باز کردن مجموعه‌داده ارزیابی {dataset}، نسخه {version}',
        loading: 'در حال بارگذاری مجموعه‌داده‌های ارزیابی…'
      },
      calibration: {
        title: 'شواهد کالیبراسیون', detailTitle: 'جزئیات مصنوع کالیبراسیون', actionsTitle: 'اقدام‌های کنترل‌شده', loading: 'در حال بارگذاری شواهد کالیبراسیون…', unavailable: 'شواهد کالیبراسیون موقتا در دسترس نیست.', empty: 'هیچ مصنوع کالیبراسیونی با این فیلتر پیدا نشد.', selectArtifact: 'یک مصنوع را برای بررسی شواهد تغییرناپذیر آن انتخاب کنید.', refreshing: 'در حال به‌روزرسانی؛ نمایش شواهد پذیرفته‌شده کالیبراسیون.', stale: 'به‌روزرسانی ناموفق بود؛ نمایش شواهد پذیرفته‌شده کالیبراسیون.', resultCount: '{count} مصنوع کالیبراسیون در این صفحه', status: 'وضعیت مصنوع', allStatuses: 'همه وضعیت‌ها', applyFilter: 'اعمال فیلتر', failed: 'ناموفق', eligible: 'واجد شرایط', passed: 'گذرانده', observe: 'حالت مشاهده', enforced: 'حالت اعمال', policyVersion: 'نسخه سیاست', bindingSequence: 'ترتیب اتصال', outcomes: '{count} نتیجه', artifactId: 'شناسه مصنوع', manifestId: 'شناسه فهرست', policyId: 'شناسه سیاست', artifactPolicyMode: 'حالت سیاست متصل به مصنوع', evaluationRunId: 'شناسه اجرای ارزیابی', manifestProgress: 'پیشرفت فهرست', activeReviewSessions: 'نشست‌های بازبینی فعال', approvalEffectiveStatus: 'وضعیت موثر تایید', releaseScore: 'امتیاز انتشار کالیبره‌شده (نقطه پایه)', calibrationError: 'خطای کالیبراسیون بخش نگه‌داشته‌شده (نقطه پایه)', criticalVetoes: 'وتوهای بحرانی', missingGates: 'دروازه‌های مفقود', artifactHash: 'هش مصنوع', algorithmVersion: 'نسخه الگوریتم', artifactSchemaVersion: 'نسخه طرح‌واره مصنوع', countsTitle: 'شمارش‌های تجمیعی', categoryCoverageTitle: 'پوشش دسته‌ها', trainingComponentsTitle: 'تجمیع مولفه‌های آموزش', holdoutComponentsTitle: 'تجمیع مولفه‌های نگه‌داشته‌شده', bucketMapping: 'نگاشت سطل‌های کالیبره', bucketRange: 'بازه امتیاز', bucketPrediction: 'نقطه پایه پیش‌بینی‌شده', bucketTraining: 'پذیرفته‌شده آموزش / نتایج', bucketHoldout: 'پذیرفته‌شده نگه‌داشته‌شده / نتایج', createManifest: 'ایجاد فهرست', finalizeManifest: 'نهایی‌سازی فهرست', reason: 'دلیل', evidence: 'شاهد', serverVerification: 'سرور ممکن است پیش از پذیرش اقدام کنترل‌شده، احراز هویت تازه بخواهد.', requestApproval: 'درخواست تایید مصنوع', executeArtifact: 'اجرای تایید مصنوع', requestActivation: 'درخواست فعال‌سازی سیاست', activatePolicy: 'فعال‌سازی سیاست تاییدشده', approve: 'تایید', reject: 'رد', cancel: 'لغو', reviewLauncherTitle: 'بازبینی کالیبراسیون', reviewLauncherDescription: 'نقش مستقل بازبینی را برای فهرست انتخاب‌شده برگزینید.', reviewStarting: 'در حال آغاز نشست بازبینی خصوصی…', reviewUnavailable: 'نشست بازبینی آغاز نشد.',
        reviewRoles: { primary: 'بازبینی اصلی', secondary: 'بازبینی ثانویه', adjudicator: 'بازبینی داوری' },
        counts: { total: 'کل نتایج', english: 'نتایج انگلیسی', persian: 'نتایج فارسی', training: 'نتایج آموزش', holdout: 'نتایج نگه‌داشته‌شده', secondary_reviewed: 'نتایج بازبینی ثانویه', disagreements: 'ناهم‌خوانی‌ها', adjudications: 'داوری‌ها', critical_vetoes: 'وتوهای بحرانی' },
        categoryCoverage: { safety: 'ایمنی', privacy: 'حریم خصوصی', authorization: 'مجوزدهی', audience: 'مخاطب', cross_ticket: 'جداسازی بین‌تیکتی', unsafe_url_markdown: 'نشانی یا نشانه‌گذاری ناامن', factual_grounding: 'پشتوانه واقعی', retrieval_integrity: 'یکپارچگی بازیابی', deployment_integrity: 'یکپارچگی استقرار' },
        trainingComponents: { retrieval_evidence: 'شواهد بازیابی', claim_coverage: 'پوشش ادعا', deterministic_policy: 'سیاست قطعی', model_reviewer: 'تجمیع بازبین مدل', evaluation_result: 'نتیجه ارزیابی' },
        holdoutComponents: { retrieval_evidence: 'شواهد بازیابی', claim_coverage: 'پوشش ادعا', deterministic_policy: 'سیاست قطعی', model_reviewer: 'تجمیع بازبین مدل', evaluation_result: 'نتیجه ارزیابی' },
        gates: { minimum_labeled_outcomes: 'حداقل نتایج برچسب‌خورده', minimum_english_outcomes: 'حداقل نتایج انگلیسی', minimum_persian_outcomes: 'حداقل نتایج فارسی', minimum_holdout_outcomes: 'حداقل نتایج نگه‌داشته‌شده', minimum_secondary_reviewed_outcomes: 'حداقل نتایج بازبینی ثانویه', minimum_release_score_basis_points: 'حداقل امتیاز انتشار', minimum_category_coverage: 'حداقل پوشش دسته', holdout_bucket_without_training_prediction: 'سطل نگه‌داشته‌شده بدون پیش‌بینی آموزشی', maximum_held_out_calibration_error_basis_points: 'بیشینه خطای نگه‌داشته‌شده', critical_hard_veto: 'وتوی سخت بحرانی' }
      },
      evaluationDetail: {
        title: 'جزئیات مجموعه‌داده ارزیابی',
        datasetKey: 'کلید مجموعه‌داده',
        version: 'نسخه',
        datasetHash: 'هش مجموعه‌داده',
        schemaHash: 'هش طرح‌واره',
        created: 'زمان ایجاد',
        exampleCount: 'نمونه‌ها',
        languages: 'زبان‌ها',
        categories: 'دسته‌ها',
        examples: 'نمونه‌های ارزیابی',
        inputHash: 'هش ورودی',
        expectedHash: 'هش خروجی مورد انتظار',
        sourceRun: 'شناسه اجرای منبع',
        attested: 'تایید متصدی',
        redactionAttested: 'تایید حذف اطلاعات حساس',
        expires: 'انقضای محتوا',
        purged: 'پاک‌سازی محتوا'
      },
      evaluationOrigins: {
        synthetic: 'مصنوعی',
        manually_redacted: 'پاک‌سازی‌شده به‌صورت دستی'
      },
      evaluationCategories: {
        response_quality: 'کیفیت پاسخ',
        citation_grounding: 'پشتوانه استناد',
        safety: 'ایمنی',
        privacy: 'حریم خصوصی',
        routing: 'مسیریابی',
        multilingual: 'چندزبانه'
      },
      adversarial: {
        coverageTitle: 'پوشش آزمون‌های خصمانه',
        evidenceTitle: 'اسناد بازاجرای خصمانه',
        releaseSummaryTitle: 'خلاصه خصمانه انتشار',
        kind: 'نوع آزمون خصمانه',
        schemaVersion: 'نسخه طرح‌واره',
        registryVersion: 'نسخه رجیستری',
        state: 'وضعیت',
        total: 'کل موارد',
        requiredCells: 'خانه‌های زبانی لازم',
        coveredCells: 'خانه‌های زبانی پوشش‌داده‌شده',
        languageColumns: {
          en: 'انگلیسی',
          fa: 'فارسی'
        },
        evidence: {
          total: 'کل',
          passed: 'پذیرفته‌شده',
          failed: 'ناموفق',
          blocked: 'متوقف‌شده'
        },
        states: {
          passed: 'پذیرفته‌شده',
          failed: 'ناموفق',
          blocked: 'متوقف‌شده'
        },
        kinds: {
          prompt_injection: 'تزریق پرامپت',
          secret_pii_exfiltration: 'استخراج اطلاعات محرمانه یا هویتی',
          unsafe_output: 'خروجی ناامن',
          authorization_bypass: 'دور زدن مجوز',
          audience_confusion: 'اشتباه در تشخیص مخاطب',
          cross_ticket_leakage: 'نشت میان تیکت‌ها',
          unsafe_url_markdown: 'نشانی یا مارک‌داون ناامن',
          factual_citation_manipulation: 'دست‌کاری واقعیت یا ارجاع',
          retrieval_tampering: 'دست‌کاری بازیابی',
          unicode_bidi_obfuscation: 'مبهم‌سازی جهت متن یونیکد'
        }
      },
      releaseSections: {
        candidates: 'نامزدها',
        rollouts: 'عرضه‌ها'
      },
      customerReadiness: {
        title: 'آمادگی مشتری',
        activationDisabled: 'فعال‌سازی برای مشتری همچنان غیرفعال است.',
        refresh: 'به‌روزرسانی',
        retry: 'تلاش دوباره',
        loading: 'در حال بارگذاری آمادگی مشتری…',
        unavailable: 'اسناد آمادگی مشتری هنوز در دسترس نیست.',
        evaluatedAt: 'زمان ارزیابی',
        evidenceAt: 'زمان ثبت اسناد',
        approvalProgress: 'پیشرفت تایید',
        openRelease: 'باز کردن نامزد انتشار داخلی',
        openRollout: 'باز کردن عرضه داخلی',
        openCustomerRelease: 'باز کردن نامزد انتشار مشتری',
        openEvaluation: 'باز کردن مجموعه ارزیابی',
        openReplay: 'باز کردن بازاجرای ارزیابی',
        internalBaseline: 'خط مبنای داخلی',
        customerCandidate: 'نامزد مشتری',
        statuses: {
          not_ready: 'آماده نیست',
          pilot_ready: 'آماده اجرای آزمایشی'
        },
        groups: {
          baseline: 'خط مبنا',
          evaluation: 'ارزیابی',
          governance: 'حاکمیت',
          policy: 'سیاست',
          safety: 'ایمنی',
          operations: 'عملیات',
          invariant: 'قواعد همیشگی'
        },
        errors: {
          stepUpRequired: 'برای مشاهده این وضعیت، احراز هویت تکمیلی تازه لازم است.',
          evidenceUnavailable: 'اسناد آمادگی مشتری در دسترس نیست.',
          auditUnavailable: 'ممیزی آمادگی مشتری موقتا در دسترس نیست.',
          rateLimited: 'تعداد درخواست‌های مشاهده بیش از حد است. کمی بعد دوباره تلاش کنید.',
          invalidResponse: 'خدمت آمادگی مشتری پاسخی نامعتبر برای نمایش امن برگرداند.',
          revoked: 'دسترسی مشاهده آمادگی مشتری دیگر در دسترس نیست.',
          unavailable: 'خدمت آمادگی مشتری موقتا در دسترس نیست.',
          requestFailed: 'تکمیل درخواست آمادگی مشتری ممکن نبود.'
        },
        gates: {
          internal_steady_state: 'پایداری کامل پشتیبانی داخلی',
          internal_safety_health: 'ایمنی و سلامت خط مبنا',
          internal_operational_clear: 'نبود مانع عملیاتی داخلی',
          customer_candidate_present: 'وجود نامزد انتشار مشتری',
          customer_privacy_safety: 'حریم خصوصی و ایمنی مشتری',
          customer_authorization_isolation: 'مجوز و جداسازی مشتری',
          customer_safe_rendering: 'نمایش امن محتوای مشتری',
          customer_grounding: 'اتکای پاسخ مشتری به اسناد',
          customer_retrieval_deployment: 'یکپارچگی بازیابی و استقرار',
          customer_bilingual_coverage: 'پوشش دوزبانه مشتری',
          customer_adversarial_replay: 'بازپخش خصمانه مشتری',
          customer_evidence_freshness: 'تازگی اسناد مشتری',
          customer_dual_approval: 'تایید دو نفره مشتری',
          customer_separation_of_duty: 'تفکیک وظایف تایید',
          customer_category_allowlist: 'فهرست مجاز دسته‌بندی‌های مشتری',
          customer_explicit_consent: 'رضایت صریح مشتری',
          customer_bot_disclosure: 'اعلام ربات به مشتری',
          customer_budget_limits: 'محدودیت بودجه مشتری',
          customer_human_intervention: 'مسیر مداخله انسانی',
          customer_feedback_voting: 'بازخورد و رای‌دهی مشتری',
          customer_stale_ticket_fence: 'جلوگیری از انتشار بر اساس وضعیت قدیمی تیکت',
          customer_monitoring_visibility: 'مشاهده‌پذیری پایش مشتری',
          customer_rollback_rehearsal: 'تمرین بازگشت مشتری',
          customer_activation_disabled: 'غیرفعال ماندن فعال‌سازی مشتری'
        },
        states: {
          passed: 'پذیرفته‌شده',
          missing: 'موجود نیست',
          failed: 'ناموفق',
          expired: 'منقضی‌شده'
        },
        reasons: {
          requirements_met: 'الزامات برقرار هستند.',
          evidence_missing: 'اسناد ضروری موجود نیست.',
          evidence_not_recorded: 'اسناد پایدار ضروری ثبت نشده است.',
          evidence_failed: 'اسناد ضروری پذیرفته نشد.',
          evidence_expired: 'اعتبار اسناد ضروری پایان یافته است.',
          internal_baseline_not_recorded: 'اسناد خط مبنای داخلی ثبت نشده است.',
          internal_steady_state_incomplete: 'پایداری کامل داخلی هنوز برقرار نیست.',
          internal_safety_health_not_recorded: 'اسناد ایمنی و سلامت داخلی ثبت نشده است.',
          internal_safety_health_failed: 'اسناد ایمنی یا سلامت داخلی پذیرفته نشد.',
          internal_operational_clear_not_recorded: 'اسناد نبود مانع عملیاتی داخلی ثبت نشده است.',
          internal_operational_clear_failed: 'مانع عملیاتی داخلی همچنان وجود دارد.',
          customer_candidate_not_recorded: 'نامزد مشتری ثبت نشده است.',
          privacy_safety_failure: 'اسناد حریم خصوصی یا ایمنی مشتری پذیرفته نشد.',
          authorization_isolation_failure: 'اسناد مجوز یا جداسازی پذیرفته نشد.',
          unsafe_rendering_detected: 'نمایش ناامن محتوای مشتری شناسایی شد.',
          unsupported_factual_claims: 'ادعاهای واقعی بدون پشتوانه شناسایی شد.',
          retrieval_deployment_failure: 'یکپارچگی بازیابی یا استقرار پذیرفته نشد.',
          bilingual_coverage_missing: 'پوشش ضروری فارسی و انگلیسی موجود نیست.',
          dataset_freshness_failure: 'اسناد تازگی مجموعه‌داده پذیرفته نشد.',
          dataset_evidence_expired: 'اعتبار اسناد مجموعه‌داده پایان یافته است.',
          adversarial_evidence_not_recorded: 'اسناد بازاجرای خصمانه ثبت نشده است.',
          adversarial_coverage_incomplete: 'پوشش ضروری آزمون‌های خصمانه کامل نیست.',
          adversarial_replay_failed: 'یک مورد بازاجرای خصمانه ناموفق یا متوقف شد.',
          adversarial_evidence_expired: 'اعتبار اسناد بازاجرای خصمانه پایان یافته است.',
          adversarial_evidence_integrity_failure: 'یکپارچگی اسناد بازاجرای خصمانه پذیرفته نشد.',
          customer_policy_evidence_not_recorded: 'اسناد سیاست مشتری ثبت نشده است.',
          customer_category_allowlist_invalid: 'اسناد فهرست مجاز دسته‌بندی‌های مشتری پذیرفته نشد.',
          customer_explicit_consent_policy_invalid: 'اسناد سیاست رضایت صریح مشتری پذیرفته نشد.',
          customer_bot_disclosure_policy_invalid: 'اسناد سیاست اعلام ربات به مشتری پذیرفته نشد.',
          customer_budget_limits_invalid: 'اسناد محدودیت بودجه مشتری پذیرفته نشد.',
          customer_policy_evidence_integrity_failure: 'یکپارچگی اسناد سیاست مشتری پذیرفته نشد.',
          customer_control_evidence_not_recorded: 'اسناد کنترل‌های مشتری ثبت نشده است.',
          customer_control_evidence_integrity_failure: 'یکپارچگی اسناد کنترل‌های مشتری پذیرفته نشد.',
          customer_control_evidence_expired: 'اعتبار اسناد کنترل‌های مشتری پایان یافته است.',
          customer_human_intervention_invalid: 'بررسی‌های مسیر مداخله انسانی پذیرفته نشد.',
          customer_feedback_voting_invalid: 'بررسی‌های بازخورد و رای‌دهی مشتری پذیرفته نشد.',
          customer_stale_ticket_fence_invalid: 'بررسی‌های جلوگیری از انتشار بر اساس وضعیت قدیمی تیکت پذیرفته نشد.',
          approval_incomplete: 'تایید ضروری مشتری کامل نشده است.',
          approval_not_approved: 'تایید مشتری پذیرفته نشده است.',
          approval_expired: 'اعتبار تایید مشتری پایان یافته است.',
          actors_not_independent: 'افراد تاییدکننده استقلال لازم را ندارند.',
          actor_authorization_invalid: 'مجوز یکی از افراد تاییدکننده دیگر معتبر نیست.'
        }
      },
      releaseCandidates: {
        title: 'نامزدهای انتشار',
        empty: 'هیچ نامزد انتشاری با این فیلترها پیدا نشد.',
        select: 'برای بررسی اسناد حاکمیتی، یک نامزد انتشار را انتخاب کنید.',
        resultCount: 'نامزدهای انتشار در این صفحه: {count}',
        rowLabel:
          'باز کردن نامزد انتشار {id}، مخاطب {audience}، وضعیت تایید {approval}، دروازه قطعی {hardGate}، کالیبراسیون {calibration}، مرحله گردش‌کار {phase}، وضعیت گردش‌کار {status}، {blockers}',
        loading: 'در حال بارگذاری نامزدهای انتشار…',
        audienceFilter: 'مخاطب',
        calibrationFilter: 'وضعیت کالیبراسیون',
        approvalFilter: 'وضعیت تایید',
        evaluationSetFilter: 'شناسه مجموعه ارزیابی',
        evaluationSetPlaceholder: '019fc900-0000-7000-8000-000000000000',
        pagination: 'صفحه‌های نامزدهای انتشار',
        page: 'صفحه'
      },
      releaseDetail: {
        title: 'جزئیات نامزد انتشار',
        candidateId: 'شناسه نامزد',
        candidateHash: 'هش نامزد',
        evidenceHash: 'هش اسناد',
        audience: 'مخاطب',
        createdAt: 'زمان ایجاد',
        dataset: 'اسناد مجموعه‌داده',
        datasetVersion: 'نسخه مجموعه‌داده',
        datasetHash: 'هش مجموعه‌داده',
        datasetFreshUntil: 'تازگی مجموعه‌داده تا',
        configuration: 'پیکربندی انتشار',
        policyIdentity: 'هویت سیاست',
        policyHash: 'هش سیاست',
        promptIdentity: 'هویت پرامپت',
        promptHash: 'هش پرامپت',
        modelIdentity: 'هویت مدل',
        modelHash: 'هش مدل',
        embeddingIdentity: 'هویت بردارسازی',
        embeddingHash: 'هش بردارسازی',
        indexIdentity: 'هویت نمایه',
        indexHash: 'هش نمایه',
        thresholdsHash: 'هش آستانه‌ها',
        evaluationRun: 'بازاجرای ارزیابی',
        evaluationSetId: 'شناسه مجموعه ارزیابی',
        evaluationDatasetKey: 'کلید مجموعه‌داده ارزیابی',
        evaluationDatasetVersion: 'نسخه مجموعه‌داده ارزیابی',
        evaluationDatasetHash: 'هش مجموعه‌داده ارزیابی',
        evaluationSchemaHash: 'هش طرح‌واره ارزیابی',
        evaluationSetCreatedAt: 'زمان ایجاد مجموعه ارزیابی',
        evaluationRunId: 'شناسه اجرای ارزیابی',
        baselineConfigurationHash: 'هش پیکربندی پایه',
        candidateConfigurationHash: 'هش پیکربندی نامزد',
        evaluationState: 'وضعیت ارزیابی',
        totalExamples: 'کل نمونه‌ها',
        processedExamples: 'نمونه‌های پردازش‌شده',
        passedExamples: 'نمونه‌های پذیرفته‌شده',
        failedExamples: 'نمونه‌های ناموفق',
        blockedExamples: 'نمونه‌های متوقف‌شده',
        evaluationStartedAt: 'زمان شروع ارزیابی',
        evaluationCompletedAt: 'زمان تکمیل ارزیابی',
        evaluationRunCreatedAt: 'زمان ایجاد اجرای ارزیابی',
        hardGates: 'اسناد دروازه‌های قطعی',
        hardGatePassed: 'قبولی دروازه قطعی',
        calibration: 'اسناد کالیبراسیون',
        calibrationStatus: 'وضعیت کالیبراسیون',
        calibrationPassed: 'قبولی کالیبراسیون',
        calibrationEvidence: 'مقادیر اسناد کالیبراسیون',
        calibrationCounts: 'مقادیر ثبت‌شده کالیبراسیون',
        calibrationEvidenceCategories: 'پوشش دسته‌های اسناد',
        calibrationCategories: 'پوشش دسته‌های ثبت‌شده',
        approval: 'چرخه تایید',
        approvalId: 'شناسه تایید',
        approvalAction: 'کنش تایید',
        approvalStatus: 'وضعیت تایید',
        customerDisabled: 'فعال‌سازی برای مشتری همچنان غیرفعال است.',
        requiredApprovers: 'تعداد تاییدکنندگان لازم',
        approvalVersion: 'نسخه تایید',
        requestedAt: 'زمان درخواست',
        expiresAt: 'زمان انقضا',
        decidedAt: 'زمان تصمیم',
        secondaryDecidedAt: 'زمان تصمیم دوم',
        executedAt: 'زمان اجرا',
        escalationLevel: 'سطح ارجاع',
        escalatedAt: 'زمان ارجاع',
        cancelledAt: 'زمان لغو',
        expiredAt: 'زمان انقضای چرخه',
        lifecycleUpdatedAt: 'آخرین به‌روزرسانی چرخه'
      },
      releaseWatchdog: {
        title: 'سیاست تغییرناپذیر دیده‌بان',
        readOnlyDescription:
          'آستانه‌های ایمنی پنج‌دقیقه‌ای و خط پایه تاییدشده متصل به این نامزد انتشار به‌صورت فقط‌خواندنی نمایش داده می‌شوند.',
        bindingVersion: 'نسخه اتصال',
        policyHash: 'هش سیاست دیده‌بان',
        windowSeconds: 'ثانیه‌های پنجره',
        minimumRunCount: 'حداقل تعداد اجرا',
        absoluteRate: 'نرخ مطلق خطا یا پایان مهلت بر حسب واحد پایه',
        baselineRate: 'نرخ خط پایه خطا یا پایان مهلت بر حسب واحد پایه',
        baselineMultiplier: 'ضریب خط پایه بر حسب واحد پایه',
        retrievalStreakThreshold: 'آستانه تداوم خطای بازیابی',
        baselineSource: 'منبع اسناد خط پایه',
        baselineEvidenceHash: 'هش اسناد خط پایه',
        sources: {
          shadow_validation: 'اعتبارسنجی سایه',
          historical_runtime: 'اجرای تاریخی'
        }
      },
      customerPolicy: {
        title: 'اسناد سیاست مشتری',
        schemaVersion: 'نسخه طرح‌واره',
        identity: 'هویت سیاست',
        hash: 'هش سیاست',
        categoryCount: 'دسته‌بندی‌های مجاز',
        customFieldCount: 'فیلدهای سفارشی مجاز',
        categoryRegistryHash: 'هش رجیستری دسته‌بندی',
        consentContractVersion: 'نسخه قرارداد رضایت',
        disclosureVersion: 'نسخه اعلام ربات',
        budgetContractVersion: 'نسخه قرارداد بودجه',
        budgetScopeCount: 'دامنه‌های بودجه'
      },
      customerControls: {
        title: 'اسناد کنترل‌های مشتری',
        snapshotHash: 'هش تصویر لحظه‌ای',
        contractHash: 'هش قرارداد',
        validatorVersion: 'نسخه اعتبارسنج',
        validatedAt: 'زمان اعتبارسنجی',
        freshUntil: 'اعتبار تا',
        freshness: 'وضعیت اعتبار',
        current: 'معتبر',
        expired: 'منقضی‌شده',
        status: 'وضعیت',
        contractVersion: 'نسخه قرارداد',
        reason: 'دلیل',
        statuses: {
          passed: 'پذیرفته‌شده',
          failed: 'ناموفق'
        },
        requiredChecks: 'بررسی‌های لازم',
        passedChecks: 'بررسی‌های پذیرفته‌شده',
        humanIntervention: 'مسیر مداخله انسانی',
        feedbackVoting: 'بازخورد و رای‌دهی مشتری',
        staleTicketFence: 'جلوگیری از انتشار بر اساس وضعیت قدیمی تیکت'
      },
      releaseApprovalStatuses: {
        pending: 'در انتظار',
        approved: 'تاییدشده',
        rejected: 'ردشده',
        executed: 'اجراشده',
        cancelled: 'لغوشده',
        expired: 'منقضی‌شده'
      },
      releaseAudiences: {
        internal: 'پشتیبانی داخلی',
        customer: 'مشتری'
      },
      releaseErrors: {
        list: 'نامزدهای انتشار موقتا در دسترس نیستند.',
        detail: 'این نامزد انتشار موقتا در دسترس نیست.',
        invalidQuery: 'فیلترهای انتشار معتبر نیستند.',
        invalidCursor: 'این صفحه انتشار دیگر در دسترس نیست. به صفحه نخست برگردید.',
        notFound: 'نامزد انتشار درخواستی پیدا نشد.',
        auditUnavailable: 'ممیزی حاکمیتی انتشار موقتا در دسترس نیست.',
        rateLimited: 'تعداد درخواست‌های خواندن انتشار بیش از حد است. کمی بعد دوباره تلاش کنید.',
        invalidResponse: 'خدمت انتشار پاسخی نامعتبر برای نمایش امن برگرداند.',
        revoked: 'دسترسی به عملیات هوش مصنوعی پشتیبانی دیگر در دسترس نیست.',
        unavailable: 'حاکمیت انتشار موقتا در دسترس نیست.',
        requestFailed: 'تکمیل درخواست انتشار ممکن نبود.'
      },
      rollouts: {
        title: 'عرضه‌ها',
        empty: 'هیچ عرضه‌ای با این فیلترها پیدا نشد.',
        select: 'برای بررسی پیشرفت و اسناد حاکمیتی، یک عرضه را انتخاب کنید.',
        resultCount: 'عرضه‌ها در این صفحه: {count}',
        rowLabel:
          'باز کردن عرضه {id}، مخاطب {audience}، مرحله {stage}، وضعیت {status}، بازنگری {revision}، نامزد انتشار {candidateHash}، به‌روزرسانی {updated}، مرحله گردش‌کار {phase}، وضعیت گردش‌کار {workflowStatus}، {blockers}',
        loading: 'در حال بارگذاری عرضه‌ها…',
        audienceFilter: 'مخاطب',
        stageFilter: 'مرحله عرضه',
        statusFilter: 'وضعیت عرضه',
        pagination: 'صفحه‌های عرضه',
        page: 'صفحه'
      },
      rolloutDetail: {
        title: 'جزئیات عرضه',
        refresh: 'بازآوری',
        refreshing: 'در حال بازآوری جزئیات عرضه…',
        refreshCompleted: 'بازآوری کامل شد. زمان مشاهده: {observedAt}.',
        rolloutId: 'شناسه عرضه',
        audience: 'مخاطب',
        stage: 'مرحله',
        status: 'وضعیت',
        enabled: 'فعال',
        customerActivationEnabled: 'فعال‌سازی برای مشتری',
        activationAvailable: 'امکان فعال‌سازی',
        releaseCandidate: 'نامزد انتشار',
        revision: 'بازنگری',
        createdAt: 'زمان ایجاد',
        updatedAt: 'زمان به‌روزرسانی',
        stageTiming: 'زمان‌بندی مرحله',
        startedAt: 'زمان شروع عرضه',
        stageStartedAt: 'زمان شروع مرحله',
        priorStage: 'مرحله پیشین',
        steadyStateReachedAt: 'زمان رسیدن به وضعیت پایدار',
        counts: 'تعداد واجدان شرایط و اجراها',
        eligibleAgentCount: 'کارشناسان واجد شرایط',
        activatedAgentCount: 'کارشناسان فعال‌شده',
        eligibleRunCount: 'اجراهای واجد شرایط',
        priorStageDurationSeconds: 'مدت مرحله پیشین به ثانیه',
        priorStageEligibleRunCount: 'اجراهای واجد شرایط مرحله پیشین',
        allSupportDurationSeconds: 'مدت مرحله همه پشتیبانی به ثانیه',
        allSupportEligibleRunCount: 'اجراهای واجد شرایط همه پشتیبانی',
        completion: 'اسناد تکمیل',
        safety: 'اسناد ایمنی',
        health: 'اسناد سلامت',
        pause: 'اسناد توقف',
        fence: 'اسناد حصار ایمنی',
        rollback: 'اسناد بازگردانی',
        pauseAt: 'زمان توقف',
        fenceAt: 'زمان اعمال حصار ایمنی',
        rollbackAt: 'زمان بازگردانی',
        pauseEvidence: 'اسناد محرک توقف',
        fenceEvidence: 'اسناد محرک حصار ایمنی',
        rollbackEvidence: 'اسناد محرک بازگردانی',
        fenceReasonCode: 'کد دلیل حصار ایمنی',
        rollbackReasonCode: 'کد دلیل بازگردانی',
        dataset: 'اسناد مجموعه‌داده',
        datasetVersion: 'نسخه مجموعه‌داده',
        datasetHash: 'هش مجموعه‌داده',
        datasetFreshUntil: 'تازگی مجموعه‌داده تا',
        hardGates: 'اسناد دروازه‌های قطعی',
        hardGatePassed: 'قبولی دروازه قطعی',
        calibration: 'اسناد کالیبراسیون',
        calibrationStatus: 'وضعیت کالیبراسیون',
        calibrationPassed: 'قبولی کالیبراسیون',
        calibrationEvidence: 'مقادیر اسناد کالیبراسیون',
        calibrationCounts: 'مقادیر ثبت‌شده کالیبراسیون',
        calibrationEvidenceCategories: 'پوشش دسته‌های اسناد',
        calibrationCategories: 'پوشش دسته‌های ثبت‌شده',
        customerDisabled: 'فعال‌سازی برای مشتری همچنان غیرفعال است.'
      },
      rolloutStages: {
        shadow: 'پایش سایه‌ای',
        support_admin: 'آزمایش مدیران پشتیبانی',
        selected_agents: 'کارشناسان منتخب',
        all_support: 'همه پشتیبانی'
      },
      rolloutStatuses: {
        disabled: 'غیرفعال',
        enabled: 'فعال',
        paused: 'متوقف‌شده',
        fenced: 'حصارگذاری‌شده',
        rolled_back: 'بازگردانده‌شده'
      },
      rolloutEvidence: {
        priorStage: 'تکمیل مرحله پیشین',
        currentStage: 'تکمیل مرحله جاری',
        passSummary: '{evaluated} بررسی، {failures} خطا، قبولی: {status}',
        triggerSummary: '{triggers} محرک، وضعیت پاک: {status}',
        completionSummary: 'تکمیل: {completed}؛ ایمنی: {safety}؛ سلامت: {health}',
        reasonCode: 'کد دلیل'
      },
      rolloutWatchdog: {
        title: 'دیده‌بان خودکار عرضه',
        readOnlyDescription:
          'سیاست استخراج‌شده از سرور، آخرین ایست بازرسی تصمیم و تعداد سیگنال‌های بحرانی در انتظار به‌صورت فقط‌خواندنی نمایش داده می‌شوند.',
        availability: 'دسترس‌پذیری',
        policyVersion: 'نسخه سیاست',
        policyHash: 'هش سیاست',
        windowSeconds: 'ثانیه‌های پنجره',
        minimumRunCount: 'حداقل تعداد اجرا',
        absoluteRate: 'نرخ مطلق خطا یا پایان مهلت بر حسب واحد پایه',
        baselineRate: 'نرخ خط پایه خطا یا پایان مهلت بر حسب واحد پایه',
        baselineMultiplier: 'ضریب خط پایه بر حسب واحد پایه',
        retrievalStreakThreshold: 'آستانه تداوم خطای بازیابی',
        latestCheckpoint: 'آخرین ایست بازرسی',
        observationStatus: 'وضعیت مشاهده ایست بازرسی',
        decision: 'تصمیم ایست بازرسی',
        reason: 'دلیل ایست بازرسی',
        retrievalFailureStreak: 'تداوم جاری خطای بازیابی',
        pendingCriticalSignals: 'سیگنال‌های بحرانی در انتظار',
        unavailableReasons: {
          watchdog_policy_unavailable: 'سیاست دیده‌بان نامزد در دسترس نیست.'
        },
        observationStatuses: {
          available: 'در دسترس',
          unavailable: 'در دسترس نیست',
          not_applicable: 'مشمول نیست'
        },
        decisions: {
          none: 'بدون اقدام خودکار',
          pause: 'متوقف‌شده',
          fence: 'حصارگذاری‌شده'
        },
        reasons: {
          watchdog: {
            clear: 'هیچ آستانه دیده‌بان رد نشد.',
            absolute_rate: 'آستانه مطلق خطا یا پایان مهلت رد شد.',
            baseline_rate: 'ضریب خط پایه تاییدشده رد شد.',
            retrieval_streak: 'آستانه تداوم خطای بازیابی رسید.',
            critical_signal: 'یک سیگنال بحرانی جاری نیازمند حصارگذاری بود.'
          }
        }
      },
      watchdogHistory: {
        title: 'تاریخچه ایست‌های بازرسی',
        description: 'اسناد تغییرناپذیر و فقط‌خواندنی دیده‌بان این عرضه، از جدیدترین به قدیمی‌ترین.',
        view: 'نمایش تاریخچه ایست‌های بازرسی',
        hide: 'پنهان‌کردن تاریخچه ایست‌های بازرسی',
        loading: 'در حال بارگذاری تاریخچه ایست‌های بازرسی…',
        empty: 'هیچ ایست بازرسی دیده‌بانی برای این عرضه در دسترس نیست.',
        retry: 'تلاش دوباره',
        refresh: 'به‌روزرسانی',
        previous: 'قبلی',
        next: 'بعدی',
        page: 'صفحه',
        freshness: {
          updated: 'تاریخچه به‌روزرسانی شد',
          refreshing: 'در حال به‌روزرسانی؛ نمایش تاریخچه پذیرفته‌شده',
          stale: 'به‌روزرسانی ناموفق بود؛ نمایش تاریخچه پذیرفته‌شده'
        },
        fields: {
          id: 'شناسه ایست بازرسی',
          rolloutRevision: 'نسخه عرضه',
          rolloutStage: 'مرحله عرضه',
          bucketStartedAt: 'آغاز پنجره',
          bucketEndedAt: 'پایان پنجره',
          observationStatus: 'وضعیت مشاهده',
          totalRunCount: 'کل اجراها',
          terminalRunCount: 'اجراهای پایانی',
          failureOrTimeoutCount: 'خطاها یا پایان مهلت‌ها',
          failureOrTimeoutRate: 'نرخ خطا یا پایان مهلت',
          retrievalHealth: 'سلامت بازیابی',
          retrievalFailureStreak: 'خطاهای متوالی بازیابی',
          criticalSignalCount: 'سیگنال‌های بحرانی',
          decision: 'تصمیم',
          reason: 'دلیل حاکمیتی',
          transitionRevision: 'نسخه گذار',
          evaluatedAt: 'زمان ارزیابی',
          createdAt: 'زمان ثبت'
        },
        decisions: {
          none: 'بدون اقدام خودکار',
          pause: 'توقف',
          fence: 'حصارگذاری'
        },
        reasons: {
          clear: 'هیچ آستانه دیده‌بان رد نشد.',
          absoluteRate: 'آستانه مطلق خطا یا پایان مهلت رد شد.',
          baselineRate: 'ضریب خط پایه تاییدشده رد شد.',
          retrievalStreak: 'آستانه خطاهای متوالی بازیابی رسید.',
          criticalSignal: 'یک سیگنال بحرانی جاری نیازمند حصارگذاری بود.'
        },
        observationStatuses: {
          available: 'در دسترس',
          unavailable: 'در دسترس نیست',
          notApplicable: 'مشمول نیست'
        },
        retrievalHealth: {
          pass: 'قابل قبول',
          fail: 'ناموفق',
          notObserved: 'مشاهده‌نشده',
          unavailable: 'در دسترس نیست'
        }
      },
      rolloutObservation: {
        title: 'اسناد مشاهده‌شده زمان اجرا',
        readOnlyDescription: 'تجمیع‌های فقط‌خواندنی مشاهده‌شده از پنجره عرضه جاری.',
        statuses: {
          available: 'اسناد مشاهده‌شده در دسترس است',
          notApplicable: 'مشاهده‌پذیر نیست'
        },
        reasons: {
          shadow_stage: 'اسناد مرحله سایه‌ای، مشاهده فعال عرضه نیست.',
          disabled: 'عرضه غیرفعال است؛ بنابراین سنجه‌های مشاهده‌شده کاربرد ندارند.',
          paused: 'عرضه متوقف است؛ بنابراین سنجه‌های مشاهده‌شده کاربرد ندارند.',
          fenced: 'عرضه حصارگذاری شده است؛ بنابراین سنجه‌های مشاهده‌شده کاربرد ندارند.',
          rolled_back: 'عرضه بازگردانی شده است؛ بنابراین سنجه‌های مشاهده‌شده کاربرد ندارند.',
          steady_state: 'عرضه در وضعیت پایدار است؛ بنابراین این مشاهده کاربرد ندارد.',
          customer_disabled: 'فعال‌سازی مشتری همچنان غیرفعال است؛ بنابراین سنجه‌های مشاهده‌شده کاربرد ندارند.'
        },
        observedAt: 'زمان مشاهده',
        window: 'پنجره مشاهده',
        stageTotal: 'اجراهای مرحله',
        terminal: 'اجراهای پایانی',
        recentFiveMinutes: 'پنج دقیقه اخیر',
        failureTimeoutRate: 'نرخ خطا یا مهلت‌گذشته (نقطه پایه)',
        blocked: 'اجراهای متوقف‌شده',
        retrievalObserved: 'اجراهای مشاهده‌شده بازیابی',
        retrievalDegraded: 'اجراهای بازیابی کاهش‌یافته',
        retrievalZeroResult: 'اجراهای بازیابی با نتیجه صفر',
        retrievalUnavailable: 'خطاهای بازیابی دردسترس‌نبودن',
        reviewerObserved: 'اجراهای مشاهده‌شده بازبین',
        reviewerUnavailable: 'اجراهای بازبین دردسترس‌نبودن',
        latencyTotal: 'رویدادهای تأخیر — کل',
        latencyUnder100Ms: 'رویدادهای تأخیر — کمتر از ۱۰۰ میلی‌ثانیه',
        latency100To499Ms: 'رویدادهای تأخیر — ۱۰۰ تا ۴۹۹ میلی‌ثانیه',
        latency500To1999Ms: 'رویدادهای تأخیر — ۵۰۰ تا ۱٬۹۹۹ میلی‌ثانیه',
        latency2000To9999Ms: 'رویدادهای تأخیر — ۲٬۰۰۰ تا ۹٬۹۹۹ میلی‌ثانیه',
        latency10000PlusMs: 'رویدادهای تأخیر — ۱۰٬۰۰۰ میلی‌ثانیه یا بیشتر',
        latencyUnknown: 'رویدادهای تأخیر — نامشخص',
        datasetCurrent: 'مجموعه‌داده جاری',
        runtimeAvailable: 'زمان اجرا در دسترس',
        configurationMatches: 'پیکربندی منطبق است',
        freshnessCurrent: 'تازگی جاری'
      },
      rolloutErrors: {
        list: 'عرضه‌ها موقتا در دسترس نیستند.',
        detail: 'این عرضه موقتا در دسترس نیست.',
        invalidQuery: 'فیلترهای عرضه معتبر نیستند.',
        invalidCursor: 'این صفحه عرضه دیگر در دسترس نیست. به صفحه نخست برگردید.',
        notFound: 'عرضه درخواستی پیدا نشد.',
        auditUnavailable: 'ممیزی حاکمیتی عرضه موقتا در دسترس نیست.',
        rateLimited: 'تعداد درخواست‌های خواندن عرضه بیش از حد است. کمی بعد دوباره تلاش کنید.',
        invalidResponse: 'خدمت عرضه پاسخی نامعتبر برای نمایش امن برگرداند.',
        revoked: 'دسترسی به عملیات هوش مصنوعی پشتیبانی دیگر در دسترس نیست.',
        unavailable: 'حاکمیت عرضه موقتا در دسترس نیست.',
        requestFailed: 'تکمیل درخواست عرضه ممکن نبود.'
      },
      replays: {
        title: 'بازاجراهای ارزیابی',
        empty: 'هیچ بازاجرای ارزیابی با این فیلترها پیدا نشد.',
        select: 'برای بررسی پیشرفت و اسناد امن، یک بازاجرا را انتخاب کنید.',
        resultCount: '{count} بازاجرا در این صفحه',
        rowLabel: 'باز کردن بازاجرای {id} برای مجموعه‌داده {dataset} با وضعیت {state}',
        loading: 'در حال بارگذاری بازاجراهای ارزیابی…',
        error: 'بازاجراهای ارزیابی موقتا در دسترس نیستند.',
        stateFilter: 'وضعیت بازاجرا',
        evaluationSetFilter: 'شناسه مجموعه ارزیابی',
        evaluationSetPlaceholder: '00000000-0000-0000-0000-000000000000',
        replayId: 'شناسه بازاجرا',
        progress: 'پیشرفت',
        pagination: 'صفحه‌های بازاجرا',
        page: 'صفحه'
      },
      replayDetail: {
        title: 'جزئیات بازاجرای ارزیابی',
        select: 'برای بررسی نتایج تجمیعی امن، یک بازاجرا را انتخاب کنید.',
        loading: 'در حال بارگذاری جزئیات بازاجرا…',
        replayId: 'شناسه بازاجرا',
        progress: 'پیشرفت',
        totalExamples: 'کل نمونه‌ها',
        processedExamples: 'نمونه‌های پردازش‌شده',
        passedExamples: 'نمونه‌های پذیرفته‌شده',
        failedExamples: 'نمونه‌های ناموفق',
        blockedExamples: 'نمونه‌های متوقف‌شده',
        progressRevision: 'بازنگری پیشرفت',
        started: 'زمان شروع',
        completed: 'زمان تکمیل',
        dataset: 'مجموعه‌داده ارزیابی',
        evaluationSetId: 'شناسه مجموعه ارزیابی',
        configurations: 'مقایسه پیکربندی‌ها',
        baselineConfiguration: 'پیکربندی پایه',
        candidateConfiguration: 'پیکربندی نامزد',
        configurationId: 'شناسه پیکربندی',
        configurationHash: 'هش پیکربندی',
        policyIdentity: 'هویت سیاست',
        policyHash: 'هش سیاست',
        promptIdentity: 'هویت پرامپت',
        promptHash: 'هش پرامپت',
        modelIdentity: 'هویت مدل',
        modelHash: 'هش مدل',
        embeddingIdentity: 'هویت بردارسازی',
        embeddingHash: 'هش بردارسازی',
        indexVersion: 'نسخه نمایه',
        indexManifest: 'هش فهرست نمایه',
        thresholdsHash: 'هش آستانه‌ها',
        hardGates: 'اسناد دروازه‌های قطعی',
        baselineComparison: 'مقایسه با پایه',
        calibration: 'اسناد کالیبراسیون'
      },
      replayPreflight: {
        title: 'اجرای بازاجرای ارزیابی',
        description: 'مجموعه ارزیابی ثابت و پیکربندی‌های پایه و نامزد حل‌شده را تایید کنید.',
        bootstrapWarning:
          'اسناد پیکربندی راه‌اندازی اولیه، تایید انتشار نیست؛ انتشار همچنان دروازه‌های مستقل خود را دارد.',
        createdReplayReady: 'این بازاجرا قبلا ایجاد شده است. باز کردن آن هیچ بازاجرا یا اجرای تازه‌ای را آغاز نمی‌کند.',
        expires: 'انقضای کشف پیکربندی',
        validUntil: 'معتبر تا',
        refresh: 'به‌روزرسانی پیکربندی‌ها',
        confirm: 'اجرای بازاجرا',
        loading: 'در حال حل پیکربندی‌های بازاجرا…',
        unavailable: 'کشف پیکربندی بازاجرا در دسترس نیست.',
        expired: 'اعتبار این پیکربندی‌های حل‌شده تمام شده است. پیش از ادامه آن‌ها را به‌روز کنید.',
        notReady: 'تا رفع همه موانع پیکربندی، بازاجرا آغاز نمی‌شود.',
        evaluation: 'مجموعه‌داده ارزیابی',
        configurationComparison: 'پیکربندی‌های حل‌شده',
        baseline: 'پایه',
        candidate: 'نامزد',
        exampleCount: 'نمونه‌ها',
        englishCount: 'نمونه‌های انگلیسی',
        persianCount: 'نمونه‌های فارسی'
      },
      replayCancel: {
        title: 'بازاجرای ارزیابی لغو شود؟',
        description: 'لغو، نتیجه قطعی سامانه است و دلیل متنی آزاد نمی‌پذیرد.'
      },
      replayTransport: {
        idle: 'آماده‌به‌کار',
        live: 'زنده',
        reconnecting: 'در حال اتصال دوباره',
        polling: 'واکشی دوره‌ای',
        terminal: 'پایان‌یافته',
        unavailable: 'در دسترس نیست'
      },
      replayErrors: {
        list: 'فهرست بازاجراها موقتا در دسترس نیست.',
        detail: 'جزئیات این بازاجرا موقتا در دسترس نیست.',
        discovery: 'حل پیکربندی‌های بازاجرا ممکن نبود.',
        create: 'ایجاد بازاجرا انجام نشد. می‌توانید دوباره تلاش کنید.',
        cancel: 'لغو بازاجرا انجام نشد. دوباره تلاش کنید.',
        configurationChanged: 'پیکربندی‌های بازاجرا تغییر کرده‌اند. مقایسه به‌روز‌شده را بررسی و دوباره تایید کنید.',
        datasetUnavailable: 'مجموعه‌داده ارزیابی برای بازاجرا در دسترس نیست.',
        auditUnavailable: 'اسناد ممیزی بازاجرا در دسترس نیست.',
        revoked: 'دسترسی به بازاجرا دیگر فعال نیست.',
        invalidResponse: 'خدمت بازاجرا پاسخی نامعتبر برای نمایش امن برگرداند.',
        notFound: 'بازاجرای درخواستی پیدا نشد.',
        invalidRequest: 'درخواست بازاجرا دیگر معتبر نیست. اطلاعات را به‌روز و دوباره تلاش کنید.',
        invalidCursor: 'این صفحه بازاجرا دیگر در دسترس نیست. به صفحه نخست برگردید.',
        idempotencyConflict: 'این درخواست بازاجرا با یک درخواست موجود تداخل دارد.',
        streamUnavailable: 'به‌روزرسانی زنده بازاجرا موقتا در دسترس نیست.',
        rateLimited: 'اتصال‌های به‌روزرسانی بازاجرا بیش از حد هستند. واکشی دوره‌ای در صورت امکان ادامه می‌یابد.',
        conflict: 'بازاجرا پیش از تکمیل این عملیات تغییر کرد. اطلاعات را به‌روز و دوباره تلاش کنید.',
        unavailable: 'خدمت بازاجرا موقتا در دسترس نیست.',
        navigationFailed: 'بازاجرا ایجاد شد، اما رفتن به جزئیات آن انجام نشد. برای ادامه بخش بازاجراها را باز کنید.',
        requestFailed: 'تکمیل درخواست بازاجرا ممکن نبود.'
      },
      replayActions: {
        runReplay: 'اجرای بازاجرا',
        backToReplays: 'بازگشت به بازاجراها',
        cancel: 'لغو بازاجرا',
        confirm: 'تایید لغو',
        keep: 'ادامه بازاجرا',
        close: 'بستن',
        refreshConfigurations: 'به‌روزرسانی پیکربندی‌ها',
        confirmReplay: 'تایید بازاجرا'
      },
      replayStates: {
        queued: 'در صف',
        running: 'در حال اجرا',
        completed: 'تکمیل‌شده',
        blocked: 'متوقف‌شده',
        failed: 'ناموفق',
        cancelled: 'لغوشده'
      },
      replayBlockers: {
        candidate_unavailable: 'پیکربندی نامزد در دسترس نیست.',
        baseline_unavailable: 'پیکربندی پایه در دسترس نیست.',
        runtime_unsupported: 'محیط اجرای حل‌شده از بازاجرا پشتیبانی نمی‌کند.',
        replay_configuration_changed: 'یکی از پیکربندی‌های بازاجرا تغییر کرده است.',
        configuration_unresolved: 'حل یکی از پیکربندی‌های ضروری ممکن نبود.',
        configuration_mismatch: 'پیکربندی‌های حل‌شده با قرارداد بازاجرا سازگار نیستند.',
        retrieval_integrity_failed: 'الزامات یکپارچگی بازیابی برقرار نیست.'
      },
      replayHardGates: {
        evaluatedCaseCount: 'موارد ارزیابی‌شده',
        englishCaseCount: 'موارد انگلیسی',
        persianCaseCount: 'موارد فارسی',
        secretPiiLeakCount: 'نشت اطلاعات محرمانه یا شخصی',
        criticalUnsafeOutputCount: 'خروجی‌های ناامن بحرانی',
        authorizationFailureCount: 'خطاهای مجوزدهی',
        audienceFailureCount: 'خطاهای مخاطب',
        crossTicketFailureCount: 'خطاهای بین‌تیکتی',
        unsafeUrlMarkdownCount: 'نشانی یا نشانه‌گذاری ناامن',
        factualClaimCount: 'ادعاهای واقعی',
        supportedFactualClaimCount: 'ادعاهای واقعی دارای پشتوانه',
        retrievalIntegrityPassed: 'قبولی یکپارچگی بازیابی',
        deploymentIntegrityPassed: 'قبولی یکپارچگی استقرار',
        datasetFreshnessPassed: 'قبولی تازگی مجموعه‌داده'
      },
      replayBaseline: {
        evaluatedCaseCount: 'موارد ارزیابی‌شده',
        baselinePassedCaseCount: 'موارد پذیرفته‌شده پایه',
        candidatePassedCaseCount: 'موارد پذیرفته‌شده نامزد',
        regressionCount: 'پسرفت‌ها',
        passed: 'قبولی مقایسه'
      },
      replayCalibration: {
        independentlyLabeledOutcomeCount: 'نتایج برچسب‌خورده مستقل',
        englishOutcomeCount: 'نتایج انگلیسی',
        persianOutcomeCount: 'نتایج فارسی',
        heldOutErrorBasisPoints: 'خطای داده کنارگذاشته‌شده بر حسب واحد پایه'
      },
      replayCalibrationCategories: {
        safety: 'ایمنی',
        privacy: 'حریم خصوصی',
        authorization: 'مجوزدهی',
        audience: 'مخاطب',
        cross_ticket: 'جداسازی بین‌تیکتی',
        url_markdown: 'ایمنی نشانی و نشانه‌گذاری',
        factual_grounding: 'پشتوانه واقعی',
        retrieval_integrity: 'یکپارچگی بازیابی',
        deployment_integrity: 'یکپارچگی استقرار'
      },
      detail: {
        title: 'جزئیات اجرا',
        ticket: 'تیکت',
        request: 'شناسه درخواست',
        requester: 'شناسه درخواست‌کننده',
        conversation: 'شناسه گفتگو',
        operation: 'عملیات',
        language: 'زبان',
        state: 'وضعیت',
        stage: 'مرحله',
        cursor: 'نشانگر رویداد',
        created: 'ایجاد',
        updated: 'به‌روزرسانی',
        completed: 'تکمیل',
        blockCategory: 'دسته توقف',
        failureCategory: 'دسته خطا',
        model: 'مدل',
        prompt: 'نسخه پرامپت',
        attempts: 'تعداد تلاش',
        reasonCode: 'کد دلیل توقف',
        errorCode: 'کد خطا',
        detectorOrigin: 'منشأ تشخیص توقف',
        detectorVersion: 'نسخه تشخیص‌دهنده',
        indexVersion: 'نسخه نمایه',
        diagnosticValues: {
          countBands: { zero: 'صفر', one: 'یک', few: 'چند', several: 'چندین', many: 'بسیار' },
          timingBands: {
            under_100_ms: 'کمتر از 100 میلی‌ثانیه',
            '100_499_ms': '100–499 میلی‌ثانیه',
            '500_1999_ms': '500–1999 میلی‌ثانیه',
            '2000_9999_ms': '2000–9999 میلی‌ثانیه',
            '10000_plus_ms': '10000 میلی‌ثانیه یا بیشتر',
            unknown: 'نامشخص'
          },
          outcomes: { accepted: 'پذیرفته‌شده', rejected: 'ردشده' },
          sourceKinds: { none: 'بدون منبع', knowledge_base: 'پایگاه دانش', documentation: 'مستندات', account_data: 'اطلاعات حساب', mixed: 'چند نوع منبع' },
          scoreBands: { zero: 'صفر', low: 'کم', medium: 'متوسط', high: 'زیاد' },
          repairDecisions: { none: 'بدون اصلاح', repair: 'اصلاح پاسخ', block: 'توقف پاسخ' },
          releaseDecisions: { retry: 'تلاش دوباره' }
        },
        detectorOrigins: {
          model_flag: 'پرچم ایمنی مدل پاسخ‌گو',
          local_redaction: 'بررسی داده‌های حساس',
          rendered_output: 'بررسی ایمنی متن پاسخ',
          provider_filter: 'فیلتر ایمنی ارائه‌دهنده',
          reviewer: 'بازبین مستقل هوش مصنوعی',
          unknown: 'نامشخص'
        },
        sources: 'منابع',
        events: 'تاریخچه امن رویدادها'
      },
      actions: {
        refresh: 'به‌روزرسانی',
        reset: 'بازنشانی',
        retry: 'تلاش دوباره',
        previous: 'صفحه قبل',
        next: 'صفحه بعد',
        backToRuns: 'بازگشت به اجراها',
        backToEvaluations: 'بازگشت به ارزیابی‌ها',
        runReplay: 'اجرای بازاجرا',
        backToReplays: 'بازگشت به بازاجراها',
        cancelReplay: 'لغو بازاجرا',
        confirmCancelReplay: 'تایید لغو',
        keepReplayRunning: 'ادامه بازاجرا',
        close: 'بستن',
        refreshConfigurations: 'به‌روزرسانی پیکربندی‌ها',
        confirmReplay: 'تایید بازاجرا',
        openCreatedReplay: 'باز کردن بازاجرای ایجادشده',
        backToReleaseCandidates: 'بازگشت به نامزدهای انتشار',
        backToRollouts: 'بازگشت به عرضه‌ها',
        openReleaseCandidate: 'باز کردن نامزد انتشار'
      },
      status: {
        loading: 'در حال بارگذاری عملیات هوش مصنوعی پشتیبانی…',
        refreshed: 'داده‌های عملیات هوش مصنوعی پشتیبانی به‌روز شد.'
      },
      freshness: {
        updated: 'به‌روزرسانی‌شده در',
        refreshing: 'در حال به‌روزرسانی؛ نمایش اسناد به‌روزشده در',
        stale: 'به‌روزرسانی ناموفق بود؛ نمایش اسناد ثبت‌شده در'
      },
      errors: {
        summary: 'خلاصه عملیات موقتا در دسترس نیست.',
        runs: 'صف اجراها موقتا در دسترس نیست.',
        detail: 'جزئیات این اجرا موقتا در دسترس نیست.',
        rateLimited: 'درخواست‌های عملیات هوش مصنوعی پشتیبانی در حال حاضر محدود شده‌اند. لطفا بعدا دوباره تلاش کنید.',
        evaluations: 'مجموعه‌داده‌های ارزیابی موقتا در دسترس نیستند.',
        evaluationDetail: 'جزئیات این مجموعه‌داده ارزیابی موقتا در دسترس نیست.',
        revoked: 'دسترسی به عملیات هوش مصنوعی پشتیبانی دیگر در دسترس نیست.'
      },
      common: {
        notAvailable: 'در دسترس نیست',
        yes: 'بله',
        no: 'خیر'
      }
    },

    // Navigation
    navigation: {
      dashboard: 'داشبورد',
      backToDashboard: 'بازگشت به داشبورد',
      createTicket: 'ایجاد تیکت',
      myTickets: 'تیکت‌های من',
      allTickets: 'همه تیکت‌ها',
      openTickets: 'تیکت‌های باز',
      inProgress: 'در حال انجام',
      resolved: 'حل شده'
    },

    // Ticket properties
    ticket: {
      subject: 'موضوع',
      description: 'توضیحات',
      status: 'وضعیت',
      priority: 'اولویت',
      category: 'دسته‌بندی',
      createdAt: 'ایجاد شده',
      updatedAt: 'به‌روزرسانی شده',
      assignedTo: 'اختصاص داده شده به',
      ticketNumber: 'شماره تیکت',
      replies: 'پاسخ‌ها',
      attachments: 'فایل‌های پیوست',
      details: 'جزئیات تیکت',
      information: 'اطلاعات تیکت',
      createdBy: 'ایجاد شده توسط',
      username: 'نام کاربری',
      email: 'ایمیل',
      phone: 'شماره تلفن',
      notProvided: 'ندارد',
      resolvedAt: 'حل شده در',
      slaDueAt: 'موعد SLA',
      internalNotes: 'یادداشت‌های داخلی',
      addressInfo: 'اطلاعات آدرس',
      customFields: 'فیلدهای سفارشی',
      selectTicket: 'انتخاب تیکت {ticketNumber}',
      read: 'خوانده شده',
      unread: 'خوانده نشده',
      newBadge: 'جدید',
      updatedBadge: 'به‌روز شده',
      unseenByAgents: 'هنوز توسط هیچ پشتیبانی دیده نشده است',
      updatedSinceView: 'پس از آخرین بازدید شما به‌روزرسانی شده است',
      newCustomerReply: 'پاسخ جدید',
      newCustomerReplyHint: 'کاربر پاسخ داده است — در انتظار پاسخ شما',
      newAgentReply: 'پاسخ جدید',
      newAgentReplyHint: 'پشتیبانی پاسخ داده است — پاسخ جدیدی دارید',
      unassigned: 'اختصاص نیافته',
      unassignedHint: 'این تیکت هنوز به هیچ پشتیبانی اختصاص داده نشده است',
      lastAgentViewAt: 'آخرین بازدید پشتیبان',
      customerLastViewedAt: 'آخرین بازدید کاربر',
      cardAriaLabel: 'تیکت {ticketNumber}: {subject}',
      activityBy: 'توسط: {name}',
      agentReplied: 'پشتیبان پاسخ داد',
      aiReplied: 'دستیار هوش مصنوعی پاسخ داد',
      aiDraftCreated: 'پیش‌نویس خصوصی هوش مصنوعی',
      internalNoteAdded: 'یادداشت داخلی ثبت شد',
      systemReplied: 'پیام سیستم',
      customerReplied: 'کاربر پاسخ داد',
      supportReplied: 'پشتیبانی پاسخ داد',
      youReplied: 'شما پاسخ دادید',
      lastUpdated: 'آخرین به‌روزرسانی',
      replyCount: '{count} پاسخ',
      customerContact: 'اطلاعات تماس مشتری',
      contactNotProvided: 'ایمیل یا شماره تلفن ثبت نشده است',
      createdLabel: 'ایجاد',
      customerReference: 'کاربر {id}',
      unknownCustomer: 'کاربر',
      apiTier4PriorityHint: 'کاربر سطح ۴ API — دارای اولویت بالاتر در پشتیبانی.',
      apiTier5PriorityHint: 'کاربر سطح ۵ API — دارای بالاترین اولویت در پشتیبانی.'
    },

    queue: {
      awaitingAgent: 'در انتظار پاسخ',
      neverAnswered: 'بدون پاسخ پشتیبان',
      waitingUnder12h: 'انتظار کمتر از ۱۲ ساعت',
      waiting12To24h: 'انتظار ۱۲ تا ۲۴ ساعت',
      waitingOver24h: 'انتظار بیش از ۲۴ ساعت',
      neverAnsweredBadge: 'بدون پاسخ',
      neverAnsweredHint: 'هیچ پشتیبانی هنوز پاسخ عمومی برای کاربر ارسال نکرده است',
      notHandled: 'رسیدگی‌نشده',
      userReplied: 'پاسخ کاربر',
      waitingForAgent: 'در انتظار پشتیبان؛ {duration}',
      waitingAgeAria: 'کاربر به مدت {duration} در انتظار پاسخ پشتیبان است',
      aria: {
        awaitingAgent: '{count} تیکت در انتظار پاسخ پشتیبان',
        neverAnswered: '{count} تیکت که هنوز پشتیبان پاسخ نداده است',
        waitingUnder12h: '{count} تیکت با انتظار کمتر از ۱۲ ساعت',
        waiting12To24h: '{count} تیکت با انتظار بین ۱۲ تا ۲۴ ساعت',
        waitingOver24h: '{count} تیکت با انتظار بیش از ۲۴ ساعت'
      }
    },

    account: {
      title: 'حساب کاربری مشتری',
      joinedDate: 'تاریخ عضویت',
      totalPaid: 'مجموع پرداختی (واحد)',
      subscriptionType: 'نوع اشتراک',
      subscriptionStart: 'شروع اشتراک',
      subscriptionEnd: 'پایان اشتراک',
      apiTier: 'سطح API',
      active: 'فعال',
      expired: 'منقضی‌شده',
      noSubscription: 'بدون اشتراک'
    },

    customerAdmin: {
      recordTools: {
        search: 'جستجو در موارد بارگذاری‌شده',
        searchTickets: 'شماره تیکت، موضوع یا دسته‌بندی',
        searchKeys: 'نام کلید، کلید پوشانده‌شده، شناسه یا دامنه',
        searchModels: 'جستجو در مدل‌های دریافت‌شده',
        allStatuses: 'همه وضعیت‌ها',
        unresolved: 'حل‌نشده',
        allPriorities: 'همه اولویت‌ها',
        unassignedOnly: 'فقط تیکت‌های بدون مسئول',
        sort: 'مرتب‌سازی بر اساس',
        newest: 'جدیدترین',
        latestActivity: 'آخرین فعالیت',
        highestPriority: 'بیشترین اولویت',
        allKeyTypes: 'همه انواع کلید',
        externalKeys: 'کلیدهای مشتری',
        internalKeys: 'کلیدهای داخلی',
        recentlyUsed: 'آخرین استفاده',
        expiryOrder: 'نزدیک‌ترین تاریخ انقضا',
        shown: '{shown} مورد از {loaded} مورد بارگذاری‌شده مطابق است',
        limitedTickets: 'این بخش حداکثر ۱۰۰ تیکت اخیر را بارگذاری می‌کند. شمارش وضعیت‌ها و فیلترها مربوط به {loaded} تیکت بارگذاری‌شده است؛ این حساب در مجموع {total} تیکت دارد.',
        keyCoverage: 'این حساب {total} کلید دارد. شمارش وضعیت‌ها و فیلترها مربوط به {loaded} کلید بارگذاری‌شده از حداکثر ۱۰۰ کلید جدیدتر است.',
        loadedKeys: 'کلیدهای بارگذاری‌شده',
        noMatches: 'هیچ مورد بارگذاری‌شده‌ای با این فیلترها مطابقت ندارد.',
        failuresOnly: 'فقط مدل‌های دارای درخواست ناموفق',
        failureRate: 'نرخ خطا',
        mostRequests: 'بیشترین درخواست',
        mostFailures: 'بیشترین درخواست ناموفق',
        highestFailureRate: 'بیشترین نرخ خطا',
        mostTokens: 'بیشترین توکن',
        unclassified: 'نتیجه دیگر یا گزارش‌نشده',
        unclassifiedNotice: 'نتیجه برخی درخواست‌ها در این بازه به‌عنوان موفق یا ناموفق دسته‌بندی نشده است.',
        inconsistentOutcomes: 'تعداد نتایج گزارش‌شده از مجموع درخواست‌ها بیشتر است. تا رفع این مغایرت، نرخ‌ها در دسترس نیستند.',
        outcomesUntracked: 'در حال حاضر فقط درخواست‌های موفق ثبت می‌شوند؛ بنابراین همه اعداد این بخش مربوط به درخواست‌های موفق است. درخواست‌های ناموفق و دارای خطا هنوز ثبت نمی‌شوند و به همین دلیل نمایش داده نمی‌شوند.',
        noActivity: 'در این بازه هیچ درخواستی ثبت نشده است.',
        modelCoverage: 'فیلترها روی {loaded} مدل دریافت‌شده از حداکثر ۵۰ مدل با بیشترین درخواست اعمال می‌شوند. آمار بالا مربوط به کل بازه است.',
        limitedModels: 'تفکیک مدل‌های دریافت‌شده همه درخواست‌های آمار کل را پوشش نمی‌دهد. مدل‌هایی که در فهرست نیستند نیز ممکن است فعالیت داشته باشند.',
        tokenSubsets: 'توکن‌های کش‌شده بخشی از توکن ورودی و توکن‌های استدلال بخشی از توکن خروجی هستند.',
        quickFilters: 'فیلترهای سریع',
        allPayments: 'همه پرداخت‌ها',
        failedPayments: 'ناموفق',
        unconfirmedPayments: 'تأییدنشده',
        paymentsWithErrors: 'دارای خطا',
        reportsPolling: 'تا زمانی که این بخش باز است، وضعیت گزارش‌های در انتظار هر ۱۰ ثانیه بررسی می‌شود.',
        timesZone: 'زمان‌ها در منطقه زمانی {zone} نمایش داده می‌شوند',
        keyId: 'شناسه کلید',
        revokedAt: 'زمان لغو',
        suspendedAt: 'زمان تعلیق',
      },
      billing: {
        quotaUnavailable: 'سهمیه تلاش موقتا در دسترس نیست. تا مشخص شدن سهمیه باقی‌مانده، اعطای اعتبار ممکن نیست.',
        activityAttempt: 'تلاش',
        actionAvailability: 'امکان انجام عملیات',
        diagnostics: {
          purchase: 'خرید و پرداخت',
          paymentId: 'شناسه پرداخت',
          paymentReference: 'مرجع پرداخت',
          purchaseCategory: 'نوع خرید',
          documentVersion: 'نسخه سند',
          createdAt: 'زمان ایجاد',
          updatedAt: 'آخرین تغییر',
          availableAt: 'زمان آماده شدن',
          artifact: 'فایل سند فعلی',
          artifactFilename: 'نام فایل',
          artifactSize: 'اندازه به بایت',
          artifactCreatedAt: 'زمان ایجاد سند',
          registration: 'جزئیات ثبت حسابداری',
          registrationScope: 'دامنه ثبت',
          registrationAttempts: 'تلاش‌های ثبت',
          registrationLastAttempt: 'آخرین تلاش ثبت',
          registrationSynced: 'زمان تکمیل ثبت',
          registrationError: 'خطای ثبت',
          delivery: 'جزئیات تحویل ایمیل',
          emailPolicy: 'سیاست رضایت ارسال ایمیل',
          emailAttempts: 'تلاش‌های ایمیل',
          emailSentAt: 'زمان ارسال ایمیل',
          emailError: 'خطای ایمیل',
          failure: 'جزئیات خطای طبقه‌بندی‌شده',
          failureAt: 'زمان خطا',
          failureField: 'فیلد مرتبط',
          failureIssue: 'اشکال اعتبارسنجی'
        },
        issues: { required: 'الزامی', invalid: 'نامعتبر', too_long: 'بیش از حد طولانی' },
        persistedAvailable: 'نسخه ذخیره‌شده جدید سند صورتحساب آماده است.',
        persistedStatus: 'وضعیت پردازش تغییر کرد. سند فعلی و جزئیات خطا را بررسی کنید.',
        activationTitle: 'اعتبار فعال‌سازی پشتیبانی',
        activationPolicy:
          'این اقدام یک‌باره پشتیبانی هفت روز اعتبار دارد. هر تلاش پذیرفته‌شده، حتی تلاش ناموفق، از سقف مشترک ۲۴ تلاش در بازه شناور ۲۴ ساعته کم می‌کند.',
        refresh: 'تازه‌سازی',
        loading: 'در حال بارگذاری…',
        refreshError: 'تازه‌سازی ناموفق بود؛ اطلاعات بارگذاری‌شده قبلی نمایش داده می‌شود.',
        unavailable: 'در دسترس نیست',
        lifetimeAward: 'اعتبار فعال‌سازی اعطاشده قبلی',
        tomans: 'تومان',
        quota: 'تلاش‌های باقی‌مانده در بازه شناور ۲۴ ساعته',
        nextAvailable: 'زمان مجاز تلاش بعدی',
        activationChoice: 'اعتبار فعال‌سازی افزوده',
        choose: 'یک گزینه انتخاب کنید',
        choiceAmounts: 'افزودن {amount} تومان ← مجموع اعطاشده {total} تومان',
        activationReason: 'دلیل (اختیاری)',
        activationReasonHint:
          'توضیح اختیاری برای سایر کارشناسان. این متن فقط به صورت درهم‌سازی یک‌طرفه برای ممیزی ذخیره می‌شود، نه به شکل متن خوانا، و بر شرایط یا مبلغ اثری ندارد.',
        activationReasonCount: '{count} از ۱۰۰۰ نویسه',
        activationReasonTooLong: 'دلیل بیش از ۱۰۰۰ نویسه است. آن را کوتاه کنید یا خالی بگذارید.',
        activationNoReason: 'دلیلی ثبت نشده است',
        review: 'بازبینی اعطای اعتبار',
        confirmActivation: 'تأیید اعطای اعتبار فعال‌سازی',
        customer: 'مشتری',
        newAward: 'اعتبار جدید',
        resultingTotal: 'مجموع اعتبار اعطاشده پس از این اقدام',
        sevenDays: 'اعتبار: هفت روز از زمان اعطا.',
        activationSuccess: 'اعتبار فعال‌سازی اعطا شد. شرایط و سهمیه فعلی در حال تازه‌سازی است.',
        activationSuccessDetail: '{amount} تومان اعطا شد. شناسه اعطا {grant}. معتبر تا {expires} ({zone}).',
        activationBlocked: 'در حال حاضر اعطای اعتبار برای این مشتری ممکن نیست.',
        activationReasonLabel: 'دلیل',
        activationOpen: 'بازکردن',
        activationClose: 'بستن',
        activationStatusEligible: 'واجد شرایط',
        activationStatusUnavailable: 'در دسترس نیست',
        addressTitle: 'نشانی‌های صورتحساب ذخیره‌شده',
        savedAddressMeaning:
          'نشانی ذخیره‌شده برای خریدهای آینده است. ذخیره نشانی، صورتحساب موجود یا تصویر اولیه خریدار آن را تغییر نمی‌دهد.',
        timeZone: 'منطقه زمانی نمایش',
        empty: 'رکوردی یافت نشد.',
        defaultAddress: 'نشانی پیش‌فرض',
        archivedAddress: 'بایگانی‌شده — ویرایش در دسترس نیست',
        vatValidation: 'اطلاعات ارزش افزوده نیازمند بررسی است',
        edit: 'ویرایش نشانی',
        newAddress: 'نشانی جدید',
        individual: 'شخص حقیقی',
        company: 'شرکت',
        save: 'ذخیره نشانی',
        cancel: 'انصراف',
        addressSaved: 'نشانی صورتحساب ذخیره شد. صورتحساب‌های موجود تغییری نکردند.',
        draftRetained: 'پیش‌نویس حفظ شده است. پیش از تلاش دوباره، وضعیت فعلی را تازه‌سازی و بازبینی کنید.',
        invoiceTitle: 'صورتحساب‌های مشتری',
        documentType: 'نوع سند',
        documentStatus: 'وضعیت سند',
        all: 'همه',
        vat: 'صورتحساب ارزش افزوده',
        standard: 'رسید بدون ارزش افزوده',
        dateFrom: 'از تاریخ',
        dateTo: 'تا تاریخ',
        paymentId: 'شناسه پرداخت',
        filter: 'اعمال فیلترها',
        invoice: 'صورتحساب',
        totalPaid: 'مجموع پرداختی',
        confirmedAt: 'زمان تأیید',
        trackingCode: 'کد رهگیری',
        copyTrackingCode: 'کپی کد رهگیری',
        trackingCodeCopied: 'کد رهگیری کپی شد',
        trackingCodeCopyFailed: 'کد رهگیری کپی نشد',
        pages: 'صفحه‌های صورتحساب',
        page: 'صفحه',
        pageRange: 'نمایش {first}–{last} از {count}',
        emptyFiltered: 'هیچ صورتحسابی با این فیلترها مطابقت ندارد. فیلترها را گسترده یا پاک کنید.',
        technicalDetails: 'جزئیات فنی',
        buyerDetails: 'جزئیات خریدار و نشانی',
        previous: 'قبلی',
        next: 'بعدی',
        generation: 'تولید سند',
        accounting: 'ثبت حسابداری',
        paymentProof: 'تأیید پرداخت',
        email: 'ایمیل صورتحساب',
        failure: 'دسته امن خطا',
        taxObservation: 'شناسه مالیاتی مشاهده‌شده (نشانه پذیرش سامانه مؤدیان نیست)',
        originalBuyer: 'تصویر اولیه خریدار',
        effectiveBuyer: 'خریدار مؤثر صورتحساب',
        originalMeaning: 'اطلاعات تغییرناپذیر خریدار که برای این خرید ثبت شده است.',
        effectiveMeaning: 'اطلاعات خریدار پس از اصلاح تأییدشده برای این صورتحساب.',
        currentAddress: 'نشانی ذخیره‌شده فعلی',
        download: 'دانلود PDF صورتحساب',
        operatorReason: 'دلیل کارشناس (۱۰ تا ۵۰۰ نویسه)',
        operatorReasonCount: '{count} از ۵۰۰ نویسه (حداقل ۱۰)',
        retry: 'درخواست تلاش دوباره برای تولید',
        correction: 'بازبینی اصلاح خریدار صورتحساب',
        correctionMeaning:
          'اصلاح فقط برای همین صورتحساب اعمال می‌شود. سرور پیشنهاد را اعتبارسنجی و نسخه بازبینی‌شده را پیش از ثبت تأیید می‌کند.',
        useAddress: 'پر کردن از نشانی ذخیره‌شده',
        preview: 'پیش‌نمایش اصلاح',
        reviewCorrection: 'بازبینی اصلاح استانداردشده خریدار',
        field: 'فیلد',
        before: 'خریدار فعلی',
        after: 'خریدار پیشنهادی',
        applyCorrection: 'اعمال اصلاح بازبینی‌شده',
        activity: 'فعالیت صورتحساب',
        activityPages: 'صفحه‌های فعالیت',
        pendingAdmission:
          'درخواست برای پردازش پذیرفته شده یا به تعویق افتاده است. تکمیل سند هنوز در انتظار است؛ تا زمانی که این بخش باز است وضعیت تازه می‌شود.',
        fields: {
          details: 'اطلاعات خریدار',
          contact: 'اطلاعات تماس',
          type: 'نوع خریدار',
          name: 'نام',
          company_name: 'نام شرکت',
          first_name: 'نام',
          last_name: 'نام خانوادگی',
          national_id: 'شناسه ملی',
          tax_id: 'شناسه مالیاتی',
          registration_number: 'شماره ثبت',
          company_register_number: 'شماره ثبت شرکت',
          address: 'نشانی',
          city: 'شهر',
          state: 'استان',
          postal_code: 'کد پستی',
          phone: 'تلفن',
          mobile: 'تلفن همراه',
          email: 'ایمیل',
          phone_number: 'شماره تلفن',
          email_address: 'نشانی ایمیل',
          country: 'کد کشور',
          unknown: 'اطلاعات صورتحساب'
        },
        codes: {
          personal: 'حسابداری شخص حقیقی',
          business: 'حسابداری شرکت',
          subscription: 'اشتراک',
          credit_topup: 'افزایش اعتبار',
          credit_package: 'بسته اعتبار',
          enqueued: 'در صف قرار گرفته',
          requested: 'ایمیل به درخواست مشتری',
          historical_unknown: 'رضایت تاریخی نامشخص',
          waiting_document: 'در انتظار سند',
          preparing: 'در حال آماده‌سازی ارسال',
          uncertain: 'نتیجه تحویل نامشخص',
          skipped_no_recipient: 'اجرا نشد: گیرنده موجود نیست',
          superseded: 'جایگزین شده',
          issuance_failed: 'صدور صورتحساب ناموفق بود.',
          render_failed: 'تولید نمای سند ناموفق بود.',
          storage_unavailable: 'ذخیره‌سازی سند در دسترس نیست.',
          InvoiceStorageUnavailable: 'ذخیره‌سازی سند در دسترس نیست.',
          missing_recipient: 'گیرنده ایمیل در دسترس نیست.',
          customer_email_suppressed: 'ایمیل مشتری طبق سیاست ارسال نمی‌شود.',
          email_delivery_failed: 'تحویل ایمیل ناموفق بود.',
          retry_exhausted: 'تلاش‌های مجدد تمام شده؛ بازبینی دستی لازم است.',
          ambiguous_write: 'نتیجه نوشتن قبلی نامشخص است؛ تطبیق لازم است.',
          remote_identity_conflict: 'تعارض هویت حسابداری نیازمند بررسی است.',
          remote_identity_incomplete: 'هویت حسابداری ناقص است.',
          business_payment_reconciliation: 'پرداخت شرکت نیازمند تطبیق است.',
          contact_snapshot_mismatch: 'اطلاعات تماس با تصویر ذخیره‌شده متفاوت است.',
          contact_reconciliation_required: 'تطبیق اطلاعات تماس لازم است.',
          buyer_identity_conflict:
            'شناسه‌های مخاطب ذخیره‌شده در حسابداری با خریدار فاکتور تعارض دارند. پیش از تلاش دوباره، هویت خریدار و مخاطب حسابداری را بررسی کنید.',
          contact_identity_unverified:
            'هویت مخاطب حسابداری هنوز در برابر خریدار فاکتور تایید نشده است. پیش از تلاش دوباره، تطابق هویت با خریدار را تایید کنید.',
          buyer_identifier_malformed:
            'قالب یا نوع یکی از شناسه‌های خریدار معتبر نیست. پیش از تلاش دوباره، اطلاعات خریدار را از مسیر مجاز اصلاح بررسی کنید.',
          buyer_name_missing:
            'نام خریدار موجود نیست. پیش از تلاش دوباره، آن را از مسیر مجاز اصلاح بررسی و تکمیل کنید.',
          buyer_name_unusable:
            'نام خریدار برای حسابداری قابل استفاده نیست. پیش از تلاش دوباره، قالب و نوع آن را از مسیر مجاز اصلاح بررسی کنید.',
          contact_row_malformed:
            'ساختار رکورد مخاطب حسابداری غیرمنتظره است. پیش از تلاش دوباره، درخواست بررسی رکورد را ثبت کنید.',
          contact_lookup_incomplete:
            'جست‌وجوی مخاطب حسابداری کامل نشده است. پیش از انتخاب یا ایجاد مخاطب، کامل بودن نتیجه جست‌وجو را تایید کنید.',
          contact_lookup_changed:
            'مخاطب حسابداری هنگام جست‌وجو تغییر کرده است. پیش از تلاش دوباره، اطلاعات را تازه‌سازی و هویت فعلی را تایید کنید.',
          contact_name_requires_review:
            'نام مخاطب حسابداری نیازمند بازبینی است. پیش از تلاش دوباره، تعلق مخاطب به خریدار فاکتور را تایید کنید.',
          contact_operation_requires_review:
            'عملیات قبلی مخاطب حسابداری نیازمند بررسی است. پیش از تلاش دوباره، نتیجه آن را تطبیق دهید؛ عملیات را دوباره ارسال نکنید.',
          contact_binding_invalid:
            'اتصال فاکتور به مخاطب معتبر نیست. پیش از تلاش دوباره، فاکتور، محدوده حسابداری و هویت مخاطب را بررسی کنید.',
          contact_binding_requires_unissued_invoice:
            'اتصال مخاطب فقط پیش از صدور فاکتور مجاز است. به‌جای اتصال دوباره، عملیات مالی موجود را بررسی و تطبیق دهید.',
          contact_tax_correction_unverified:
            'سامانه پشتیبان برای اصلاح شناسه مالیاتی مخاطب تلاش کرده، اما نتیجه آن تایید نشده است. صدور فاکتور را تا پایان تطبیق متوقف نگه دارید. عملیات موجود را تطبیق دهید و نتیجه به‌روزرسانی را پیش از تلاش دوباره برای صدور فاکتور با خواندن دوباره تایید کنید؛ اصلاح را دوباره ارسال نکنید.',
          payment_destination_unverified: 'مقصد پرداخت تأیید نشده است.',
          payment_proof_invalid: 'مدرک پرداخت معتبر نیست.',
          payment_proof_conflict: 'مدرک پرداخت با هویت ثبت‌شده تعارض دارد.',
          legacy_vat_manual_only: 'صورتحساب ارزش افزوده تاریخی نیازمند بررسی دستی است.',
          invoice_claimed: 'پردازش صورتحساب قبلا در اختیار کارگر قرار گرفته است.',
          invoice_requires_review: 'صورتحساب نیازمند بررسی است.',
          already_available: 'سند از قبل آماده است.',
          request_limit_reached: 'سقف درخواست‌ها تکمیل شده است.',
          retry_cooldown: 'تا پایان مهلت تلاش مجدد صبر کنید.',
          buyer_correction_required: 'ابتدا اطلاعات خریدار باید اصلاح شود.',
          vat_preflight_invalid: 'اعتبارسنجی ارزش افزوده موفق نبود.',
          invoice_email_started: 'پردازش ایمیل صورتحساب قبلا آغاز شده است.',
          buyer_correction_schema_unavailable: 'اصلاح خریدار موقتا در دسترس نیست.',
          buyer_correction_schema_invalid: 'پیکربندی اصلاح خریدار معتبر نیست.',
          buyer_correction_invalid: 'اصلاح خریدار معتبر نیست.',
          snapshot_invalid: 'تصویر اولیه خریدار معتبر نیست.',
          buyer_proposal_invalid: 'اطلاعات پیشنهادی خریدار معتبر نیست.',
          operator_reason_invalid: 'دلیل کارشناس باید ۱۰ تا ۵۰۰ نویسه باشد.',
          buyer_failure_unknown: 'دسته‌بندی امن خطای خریدار ممکن نیست.',
          later_buyer_failure_required: 'برای اصلاح، خطای اعتبارسنجی خریدار در مرحله بعد لازم است.',
          buyer_unchanged: 'اطلاعات پیشنهادی خریدار تغییری نکرده است.',
          invoice_has_fiscal_work: 'عملیات مالی ثبت‌شده مانع این ویرایش است.',
          invoice_has_documents: 'اسناد موجود صورتحساب مانع این ویرایش هستند.',
          invoice_has_contact_work: 'عملیات مخاطب حسابداری مانع این ویرایش است.',
          payment_identity_changed: 'هویت پرداخت تغییر کرده؛ بررسی لازم است.',
          reviewed_state_required: 'پیش از اعمال، پیشنهاد فعلی را پیش‌نمایش و بازبینی کنید.',
          reviewed_state_changed: 'وضعیت بازبینی‌شده صورتحساب تغییر کرد. پیش‌نویس حفظ شده؛ پیش‌نمایش جدید بسازید.',
          document_unavailable: 'سند در دسترس نیست.',
          unreported: 'گزارش نشده',
          registered: 'ثبت‌شده',
          reconciling: 'در حال تطبیق',
          deferred: 'به تعویق افتاده',
          sending: 'در حال ارسال',
          cancelled: 'لغوشده',
          delivered: 'تحویل‌شده',
          vat_buyer_details_required: 'اطلاعات خریدار الزامی است.',
          vat_buyer_details_invalid: 'اطلاعات خریدار معتبر نیست.',
          vat_buyer_details_too_long: 'اطلاعات خریدار بیش از حد طولانی است.',
          vat_buyer_type_required: 'نوع خریدار الزامی است.',
          vat_buyer_type_invalid: 'نوع خریدار معتبر نیست.',
          vat_buyer_type_too_long: 'نوع خریدار بیش از حد طولانی است.',
          vat_buyer_name_required: 'نام الزامی است.',
          vat_buyer_name_invalid: 'نام معتبر نیست.',
          vat_buyer_name_too_long: 'نام بیش از حد طولانی است.',
          vat_buyer_company_name_required: 'نام شرکت الزامی است.',
          vat_buyer_company_name_invalid: 'نام شرکت معتبر نیست.',
          vat_buyer_company_name_too_long: 'نام شرکت بیش از حد طولانی است.',
          vat_buyer_national_id_required: 'شناسه ملی الزامی است.',
          vat_buyer_national_id_invalid: 'شناسه ملی معتبر نیست.',
          vat_buyer_national_id_too_long: 'شناسه ملی بیش از حد طولانی است.',
          vat_buyer_tax_id_required: 'شناسه مالیاتی الزامی است.',
          vat_buyer_tax_id_invalid: 'شناسه مالیاتی معتبر نیست.',
          vat_buyer_tax_id_too_long: 'شناسه مالیاتی بیش از حد طولانی است.',
          vat_buyer_registration_number_required: 'شماره ثبت الزامی است.',
          vat_buyer_registration_number_invalid: 'شماره ثبت معتبر نیست.',
          vat_buyer_registration_number_too_long: 'شماره ثبت بیش از حد طولانی است.',
          vat_buyer_postal_code_required: 'کد پستی الزامی است.',
          vat_buyer_postal_code_invalid: 'کد پستی معتبر نیست.',
          vat_buyer_postal_code_too_long: 'کد پستی بیش از حد طولانی است.',
          vat_buyer_address_required: 'نشانی الزامی است.',
          vat_buyer_address_invalid: 'نشانی معتبر نیست.',
          vat_buyer_address_too_long: 'نشانی بیش از حد طولانی است.',
          vat_buyer_phone_required: 'تلفن الزامی است.',
          vat_buyer_phone_invalid: 'تلفن معتبر نیست.',
          vat_buyer_phone_too_long: 'تلفن بیش از حد طولانی است.',
          vat_buyer_mobile_required: 'تلفن همراه الزامی است.',
          vat_buyer_mobile_invalid: 'تلفن همراه معتبر نیست.',
          vat_buyer_mobile_too_long: 'تلفن همراه بیش از حد طولانی است.',
          vat_buyer_email_required: 'ایمیل الزامی است.',
          vat_buyer_email_invalid: 'ایمیل معتبر نیست.',
          vat_buyer_email_too_long: 'ایمیل بیش از حد طولانی است.',
          vat_buyer_contact_required: 'اطلاعات تماس الزامی است.',
          vat_buyer_contact_invalid: 'اطلاعات تماس معتبر نیست.',
          vat_buyer_contact_too_long: 'اطلاعات تماس بیش از حد طولانی است.',
          eligible: 'واجد شرایط اقدام انتخاب‌شده',
          completed: 'اقدام یک‌باره فعال‌سازی انجام شده است.',
          contact_claimed: 'برای اطلاعات تماس تأییدشده قبلا اعتبار فعال‌سازی ثبت شده است.',
          history_unavailable: 'سوابق فعال‌سازی در دسترس نیست؛ تعیین شرایط ممکن نیست.',
          customer_unavailable: 'مشتری در دسترس نیست.',
          verified_identity_required: 'هویت تأییدشده الزامی است.',
          schema_unavailable: 'سرویس فعال‌سازی در دسترس نیست.',
          attempt_quota_exceeded: 'سهمیه تلاش فعال‌سازی تمام شده است.',
          write_quota_exceeded: 'سهمیه عملیات نوشتن کارشناسان تمام شده است.',
          invalid_reason: 'دلیل بیش از حد طولانی یا نامعتبر است. آن را کوتاه کنید یا خالی بگذارید.',
          invalid_mode: 'گزینه انتخاب‌شده دیگر در دسترس نیست. تازه‌سازی کنید و دوباره انتخاب کنید.',
          address_changed: 'نشانی ذخیره‌شده تغییر کرده است. پیش از ذخیره، نسخه جدید را باز کنید.',
          address_archived: 'این نشانی بایگانی شده و قابل ویرایش نیست.',
          invoice_changed: 'وضعیت صورتحساب تغییر کرده است. پیش‌نمایش جدید را بررسی کنید.',
          invoice_not_eligible: 'این صورتحساب واجد شرایط این اقدام نیست.',
          needs_proposal: 'پیشنهاد اعتبارسنجی‌شده لازم است.',
          unavailable: 'در دسترس نیست',
          queued: 'در صف',
          queue_deferred: 'پذیرش در صف به تعویق افتاده',
          already_queued: 'از قبل در صف',
          already_applied: 'اصلاح قبلا اعمال شده',
          processing: 'در حال پردازش',
          available: 'آماده',
          failed: 'ناموفق',
          needs_reconciliation: 'نیازمند تطبیق',
          ready: 'آماده',
          pending: 'در انتظار',
          synced: 'ثبت‌شده',
          verified: 'تأییدشده',
          unverified: 'تأییدنشده',
          not_applicable: 'نامرتبط',
          sent: 'ارسال‌شده',
          suppressed: 'ارسال متوقف طبق سیاست',
          unknown: 'جزئیات بیشتر در دسترس نیست.'
        },
        events: {
          snapshot_created: 'تصویر خریدار ثبت شد',
          invoice_queued: 'صورتحساب در صف قرار گرفت',
          invoice_processing: 'پردازش صورتحساب آغاز شد',
          invoice_available: 'سند صورتحساب آماده شد',
          invoice_ready: 'صورتحساب آماده شد',
          issuance_failed: 'صدور صورتحساب ناموفق بود',
          hesabfa_registration_deferred: 'ثبت حسابداری به تعویق افتاد',
          hesabfa_registration_pending: 'ثبت حسابداری در انتظار است',
          hesabfa_registration_failed: 'ثبت حسابداری ناموفق بود',
          hesabfa_registration_synced: 'ثبت حسابداری انجام شد',
          hesabfa_reconciliation_required: 'تطبیق حسابداری لازم است',
          hesabfa_payment_verified: 'فعالیت تأیید پرداخت ثبت شد',
          hesabfa_contact_bound: 'مخاطب حسابداری مرتبط شد',
          customer_generation_enqueued: 'درخواست سند مشتری در صف قرار گرفت',
          buyer_correction_applied: 'اصلاح خریدار اعمال شد',
          artifact_download_url_created: 'پیوند دانلود سند ایجاد شد',
          customer_email_resend_failed: 'ارسال مجدد ایمیل ناموفق بود',
          customer_email_resend_suppressed: 'ارسال مجدد ایمیل متوقف شد',
          customer_email_resent: 'ایمیل صورتحساب دوباره ارسال شد',
          legacy_vat_automation_skipped: 'خودکارسازی ارزش افزوده تاریخی اجرا نشد',
          processing_started: 'پردازش آغاز شد',
          artifact_stored: 'سند ذخیره شد',
          invoice_emailed: 'صورتحساب ایمیل شد',
          invoice_email_failed: 'ایمیل صورتحساب ناموفق بود',
          invoice_email_skipped_no_recipient: 'گیرنده ایمیل در دسترس نبود',
          hesabfa_invoice_saved: 'صورتحساب حسابداری ذخیره شد',
          personal_hesabfa_accounting_failed: 'حسابداری شخص حقیقی ناموفق بود',
          personal_hesabfa_reconciliation_required: 'تطبیق حسابداری شخص حقیقی لازم است',
          customer_email_resend_requested: 'ارسال مجدد ایمیل درخواست شد',
          buyer_support_review_requested: 'بازبینی خریدار توسط پشتیبانی درخواست شد',
          buyer_validation_classified: 'اعتبارسنجی خریدار ثبت شد',
          seller_correction_applied: 'اصلاح فروشنده اعمال شد',
          operator_retry_requested: 'تلاش دوباره کارشناس درخواست شد',
          unknown: 'فعالیت صورتحساب ثبت شد'
        },
        amounts: {
          original_amount: 'مبلغ اولیه',
          subtotal: 'جمع جزء',
          discount_amount: 'تخفیف',
          vat_amount: 'ارزش افزوده',
          total_paid: 'مجموع پرداختی'
        }
      },
      title: 'مرکز مدیریت مشتری',
      open: 'باز کردن مرکز مدیریت',
      openAria: 'باز کردن مرکز مدیریت مشتری تیکت {ticket}',
      staffOnly: 'ویژه کارشناسان و مدیران پشتیبانی',
      sectionNavigation: 'بخش‌های مدیریت مشتری',
      ticketScopedIdentity: 'هویت مشتری فقط از همین تیکت تعیین می‌شود',
      userScopedIdentity: 'مشتری بر اساس شناسه حساب تعیین شده است (جستجوی پشتیبانی)',
      privacyTitle: 'دسترسی حساس و ثبت‌شونده',
      privacyNotice:
        'اطلاعات تیکت {ticket} فقط هنگام نیاز بارگیری می‌شود. هر مشاهده موفق ثبت شده و با بستن این پنجره پاک می‌شود.',
      privacyNoticeUser:
        'اطلاعات این حساب مشتری فقط هنگام نیاز بارگیری می‌شود. هر مشاهده موفق ثبت شده و با بستن این پنجره پاک می‌شود.',
      loadingSection: 'اطلاعات مدیریت مشتری در حال بارگیری است',
      refreshingSection: 'این بخش در حال به‌روزرسانی است…',
      refreshSection: 'به‌روزرسانی {section}',
      sectionLoaded: 'بخش {section} بارگیری شد',
      scrollableTable: 'جدول پیمایشی مدیریت مشتری',
      scrollHint: 'برای مشاهده ستون‌های بیشتر، جدول را افقی پیمایش کنید. برای جزئیات چرخه و مالی، ردیف را باز کنید.',
      accountActions: {
        menuAria: 'عملیات تماس و حساب {customer}',
        copyEmail: 'کپی ایمیل',
        emailCopied: 'ایمیل مشتری کپی شد',
        copyPhone: 'کپی شماره تلفن',
        phoneCopied: 'شماره تلفن مشتری کپی شد',
        copyId: 'کپی شناسه حساب',
        idCopied: 'شناسه حساب کپی شد',
        copyFailed: 'کپی اطلاعات مشتری ممکن نبود',
        openManagement: 'باز کردن مدیریت حساب در زبانه جدید'
      },
      sections: {
        invoices: 'صورتحساب‌ها',
        addresses: 'نشانی‌ها',
        overview: 'نمای کلی حساب',
        tickets: 'تیکت‌ها',
        credits: 'اعتبار و بسته‌ها',
        activity: 'فعالیت API',
        apiKeys: 'کلیدهای API',
        payments: 'پرداخت‌ها',
        affiliates: 'همکاری در فروش',
        reports: 'گزارش‌ها'
      },
      sectionDescriptions: {
        invoices: 'اسناد صورتحساب، خریداران و وضعیت امن پردازش را بررسی کنید.',
        addresses: 'نشانی‌های صورتحساب ذخیره‌شده را مدیریت کنید.',
        overview: 'هویت، وضعیت حساب، شاخص‌های امنیتی، مجموع استفاده و اشتراک مشتری را بررسی کنید.',
        tickets: 'تیکت‌های اخیر مشتری، وضعیت آن‌ها و تیکت‌های احتمالا تکراری را بررسی کنید.',
        credits: 'مانده اعتبار، اعتبارهای هدیه، بسته‌های خریداری‌شده، انقضا و دامنه سرویس را ببینید.',
        activity: 'حجم درخواست، مصرف توکن، هزینه، مدل‌ها، ارائه‌دهندگان و سطح سرویس را تحلیل کنید.',
        apiKeys: 'فهرست کلیدهای پوشانده‌شده، وضعیت عملیاتی، محدودیت‌ها، بودجه و آخرین استفاده را بررسی کنید.',
        payments: 'تراکنش‌ها، وضعیت چرخه، مبالغ و علت امن خطا را فیلتر و بررسی کنید.',
        affiliates: 'عملکرد معرفی، کمیسیون‌ها، برداشت‌ها و جزئیات چرخه را بررسی کنید.',
        reports: 'گزارش مصرف قابل مشاهده برای مشتری بسازید و وضعیت تحویل و دانلود آن را مدیریت کنید.'
      },
      tickets: {
        total: 'کل',
        open: 'باز',
        empty: 'این مشتری تیکتی ندارد.',
        noSubject: '(بدون موضوع)',
        truncated: '{count} تیکت اخیر نمایش داده می‌شود',
        duplicatesTitle: 'تیکت‌های احتمالا تکراری ({count})',
        duplicateCount: '{count} تیکت ({open} باز) در بازه زمانی نزدیک ثبت شده‌اند',
        actions: {
          menuAria: 'عملیات تیکت {ticket}',
          copyId: 'کپی شناسه تیکت',
          copied: 'تیکت {ticket} کپی شد',
          copyFailed: 'کپی شناسه تیکت ممکن نبود',
          openManagement: 'باز کردن در مدیریت تیکت‌ها'
        },
        columns: {
          ticket: 'تیکت',
          subject: 'موضوع',
          status: 'وضعیت',
          priority: 'اولویت',
          category: 'دسته‌بندی',
          created: 'ایجاد'
        }
      },
      search: {
        launch: 'یافتن مشتری',
        openAria: 'جستجوی مشتری و باز کردن مرکز مدیریت',
        title: 'یافتن مشتری',
        notice: 'با نام کاربری، ایمیل یا شماره تلفن جستجو کنید تا مرکز مدیریت هر حساب باز شود.',
        placeholder: 'نام کاربری، ایمیل یا تلفن…',
        submit: 'جستجو',
        minLength: 'حداقل {count} کاراکتر وارد کنید',
        fastHint: 'شماره تلفن یا ایمیل کامل، یا ابتدای نام کاربری را وارد کنید و سپس جستجو را بزنید.',
        searching: 'در حال جستجو…',
        prompt: 'برای جستجوی مشتری، تایپ کنید.',
        noResults: 'مشتری منطبقی یافت نشد.',
        truncated: 'نتایج بیشتری وجود دارد — جستجو را دقیق‌تر کنید.',
        error: 'جستجو ناموفق بود. دوباره تلاش کنید.',
        open: 'باز کردن',
        copyId: 'کپی شناسه',
        idCopied: 'شناسه مشتری کپی شد',
        openTickets: '{count} باز',
        deepHint: 'حساب‌های حذف‌شده فقط با جستجوی عمیق پیدا می‌شوند؛ این جستجو همه فیلدها را بررسی می‌کند و کندتر است.',
        deepSubmit: 'جستجوی عمیق',
        deepBadge: 'جستجوی عمیق',
        matchedBy: {
          phone: 'مطابقت با تلفن',
          email: 'مطابقت با ایمیل',
          username: 'مطابقت با نام کاربری',
          deep: 'جستجوی عمیق'
        },
        state: {
          active: 'فعال',
          deleted: 'حذف‌شده',
          suspended: 'تعلیق‌شده',
          inactive: 'غیرفعال',
          guest: 'مهمان'
        }
      },
      common: {
        yes: 'بله',
        no: 'خیر',
        retry: 'تلاش دوباره',
        noRecords: 'رکوردی یافت نشد',
        confirm: 'تایید',
        cancel: 'انصراف'
      },
      timeframes: {
        lastHour: 'یک ساعت گذشته',
        last6Hours: '۶ ساعت گذشته',
        last12Hours: '۱۲ ساعت گذشته',
        lastDay: '۲۴ ساعت گذشته',
        last2Days: '۲ روز گذشته',
        last3Days: '۳ روز گذشته',
        lastWeek: '۷ روز گذشته',
        last28Days: '۲۸ روز گذشته',
        last30Days: '۳۰ روز گذشته',
        lastMonth: 'یک ماه گذشته',
        last3Months: '۳ ماه گذشته',
        hours: '{count} ساعت'
      },
      purchaseItems: {
        api: 'اعتبار API',
        credit_package: 'بسته اعتبار',
        tier1: 'سطح ۱',
        tier2: 'پلاس',
        tier2_30: 'پلاس · ۳۰ روز',
        tier2_90: 'پلاس · ۹۰ روز',
        tier2_180: 'پلاس · ۱۸۰ روز',
        tier2_365: 'پلاس · ۳۶۵ روز',
        tier3: 'سطح ۳'
      },
      fields: {
        fullName: 'نام کامل',
        joinedAt: 'تاریخ عضویت',
        lastLogin: 'آخرین ورود',
        country: 'کشور',
        accountType: 'نوع حساب',
        registrationMethod: 'روش ثبت‌نام',
        language: 'زبان',
        updatedAt: 'به‌روزرسانی',
        name: 'نام',
        scope: 'دامنه',
        status: 'وضعیت',
        lastUsed: 'آخرین استفاده',
        model: 'مدل',
        provider: 'ارائه‌دهنده',
        serviceTier: 'سطح سرویس',
        type: 'نوع',
        amount: 'مبلغ',
        details: 'جزئیات',
        createdAt: 'ایجاد',
        expiresAt: 'انقضا',
        trackingCode: 'کد رهگیری',
        actions: 'عملیات'
      },
      overview: {
        verification: 'شاخص‌های احراز و امنیت',
        emailVerified: 'تایید ایمیل',
        phoneVerified: 'تایید تلفن',
        googleVerified: 'تایید ایمیل گوگل',
        twoFactor: 'احراز هویت دو مرحله‌ای',
        suspended: 'تعلیق شده',
        deleted: 'حذف شده',
        guest: 'حساب مهمان',
        dataConsent: 'رضایت استفاده از داده',
        totalPaid: 'کل پرداخت',
        suspensionDate: 'زمان تعلیق',
        suspensionReason: 'علت امن تعلیق',
        deletedAt: 'زمان حذف',
        chats: 'گفتگوهای فعال',
        messages: 'پیام‌های فعال',
        apiKeys: 'کلیدهای API',
        activeApiKeys: 'کلیدهای API فعال',
        subscription: 'اشتراک',
        periodDays: 'دوره (روز)'
      },
      credits: {
        noCredit: 'حساب اعتباری یافت نشد',
        remainingIrt: 'مانده تومانی',
        remainingUnit: 'مانده واحد',
        limit: 'سقف اعتبار',
        grants: 'اعتبارهای هدیه',
        packages: 'بسته‌های خریداری‌شده',
        updatedAt: 'به‌روزرسانی اعتبار',
        lastToppedUp: 'آخرین افزایش اعتبار',
        linkedOrganization: 'استفاده از اعتبار سازمان متصل',
        exhausted: 'مصرف‌شده',
        price: 'قیمت خرید',
        discount: 'تخفیف',
        purchasedAt: 'زمان خرید',
        instrument: 'اعتبار',
        packageInstanceId: 'شناسه بسته خریداری‌شده',
        packageTemplateId: 'شناسه قالب بسته',
        noPackageTemplate: 'بدون قالب متصل',
        allowedServices: 'سرویس‌های مجاز',
        allServices: 'همه سرویس‌ها',
        scopeDetails: 'جزئیات دامنه',
        unrestrictedScope: 'بدون محدودیت دامنه',
        openPackageDetails: 'نمایش جزئیات {package}',
        allStatusesHint: 'برای نمایش همه وضعیت\u200cها، هیچ گزینه\u200cای را انتخاب نکنید.',
        filterByStatus: 'فیلتر بر اساس وضعیت',
        searchPlaceholder: 'نام، شناسه خرید، شناسه قالب، سرویس یا محدودیت مدل',
        visibleCount: 'نمایش {visible} از {total}',
        grantId: 'شناسه اعتبار هدیه',
        startsAt: 'شروع اعتبار',
        openGrantDetails: 'نمایش جزئیات {grant}',
        searchGrants: 'توضیحات، شناسه اعتبار هدیه، سرویس یا محدودیت مدل',
        expiryFilter: 'بازه انقضا',
        anyExpiry: 'همه تاریخ\u200cهای انقضا',
        expiresIn7Days: 'انقضا در ۷ روز آینده',
        expiresIn30Days: 'انقضا در ۳۰ روز آینده',
        noExpiry: 'بدون انقضا',
        highestRemaining: 'بیشترین مانده اعتبار',
        lowestRemaining: 'کمترین مانده اعتبار',
        reportedStatuses: 'وضعیت\u200cهای گزارش\u200cشده',
        coverage: '{loaded} مورد از مجموع {total} مورد بارگذاری شده است. جستجو، فیلتر و مرتب\u200cسازی حداکثر ۱۰۰ مورد اخیر را پوشش می\u200cدهند.',
        expiryReference: 'بازه\u200cهای انقضا و وضعیت\u200cها بر اساس آخرین تازه\u200cسازی اعتبار هستند.',
        extend: {
          button: 'تمدید',
          packageTitle: 'تمدید بسته اعتباری',
          grantTitle: 'تمدید اعتبار اهدایی',
          target: 'اعتبار',
          currentEndDate: 'انقضای فعلی',
          previousEndDate: 'انقضای قبلی',
          resultTitle: 'آخرین تغییر ذخیره\u200cشده انقضا',
          restrictionsRemain: 'تاریخ انقضا ذخیره شد. این محدودیت\u200cهای گزارش\u200cشده همچنان برقرارند؛ تغییر انقضا اعتباری اضافه نمی\u200cکند.',
          addsExpiry: 'این اعتبار در حال حاضر بدون انقضاست. با ذخیره تاریخ، برای آن انقضا تعیین می\u200cشود.',
          shortensExpiry: 'تاریخ انتخاب\u200cشده پیش از انقضای فعلی است و مدت اعتبار را کوتاه می\u200cکند.',
          newEndDate: 'تاریخ انقضای جدید',
          datePlaceholder: 'تاریخ آینده را انتخاب کنید',
          policyNotice:
            'تغییر انقضا اعتباری اضافه نمی‌کند. اعتبار مصرف‌شده، باطل‌شده یا معلق ممکن است همچنان قابل استفاده نباشد.',
          clearRevoked: 'ابطال‌شده',
          clearRevokedHint: 'پرچم ابطال نیز پاک شود',
          clearSuspended: 'معلق‌شده',
          clearSuspendedHint: 'پرچم تعلیق نیز پاک شود',
          success: 'تاریخ انقضا با موفقیت ذخیره شد',
          errors: {
            resultUnverified: 'پاسخ با این اعتبار مطابقت نداشت. پیش از ارسال دوباره، فهرست اعتبارها را تازه\u200cسازی کنید.',
            packageNotFound: 'این بسته اعتباری برای این کاربر یافت نشد.',
            grantNotFound: 'این اعتبار اهدایی برای این کاربر یافت نشد.',
            invalidEndDate: 'تاریخ انقضای جدید باید در آینده باشد.',
            endDateTooFar: 'تاریخ انقضای جدید بیش از حد دور است (حداکثر ۳۶۵ روز).',
            invalidActor: 'حساب شما برای انجام این عملیات مجاز نیست.',
            unavailable: 'تمدید انجام نشد. لطفا دوباره تلاش کنید.'
          }
        }
      },
      metrics: {
        requests: 'درخواست‌ها',
        successfulRequests: 'درخواست‌های موفق',
        successful: 'موفق',
        successRate: 'نرخ موفقیت',
        failed: 'ناموفق',
        tokens: 'توکن‌ها',
        costUnit: 'هزینه (واحد)',
        paidUnit: 'پرداخت‌شده (واحد)',
        paidIrt: 'پرداخت‌شده (تومان)',
        paidGrantIrt: 'پرداخت از اعتبار هدیه (تومان)',
        promptTokens: 'توکن ورودی',
        completionTokens: 'توکن خروجی',
        reasoningTokens: 'توکن استدلال',
        cachedTokens: 'توکن کش‌شده'
      },
      activity: {
        models: 'مصرف مدل‌ها',
        providers: 'ارائه‌دهندگان',
        serviceTiers: 'سطوح سرویس',
        tokenBreakdown: 'تفکیک توکن'
      },
      apiKeys: {
        maskedKey: 'کلید پوشانده‌شده',
        models: 'مدل‌ها',
        endpoints: 'نقاط پایانی',
        monthlyQuota: 'سهمیه ماهانه',
        totalBudget: 'بودجه کل',
        budgetUsed: 'بودجه مصرف‌شده',
        internal: 'کلید داخلی',
        maskingNotice:
          'فقط فراداده کلید پوشانده‌شده نمایش داده می‌شود. کلید خام API و محدودیت‌های IP هرگز در دسترس نیست.'
      },
      filters: {
        any: 'همه',
        apply: 'اعمال فیلترها',
        clear: 'پاک کردن فیلترها',
        activeCount: '{count} فیلتر فعال',
        confirmed: 'تایید شده',
        failed: 'ناموفق',
        hasError: 'دارای خطا',
        dateRange: 'بازه تاریخ',
        status: 'فیلتر وضعیت'
      },
      payments: {
        tracking: 'شناسه پرداخت',
        trackingPlaceholder: 'شناسه عددی، UUID تراکنش یا کد پیگیری دقیق',
        paymentId: 'شناسه پرداخت',
        transactionId: 'شناسه تراکنش',
        item: 'مورد خرید',
        amount: 'مبلغ',
        discountAmount: 'مبلغ تخفیف',
        netAmount: 'مبلغ خالص',
        paidAmount: 'مبلغ پرداختی',
        method: 'روش',
        paymentType: 'نوع پرداخت',
        vat: 'نیازمند مالیات ارزش افزوده',
        confirmedAt: 'زمان تایید',
        failedAt: 'زمان خطا',
        failureReason: 'علت امن خطا',
        bankDetails: 'جزئیات تراکنش بانکی',
        recheck: 'بررسی مجدد',
        recheckConfirmTitle: 'این پرداخت دوباره بررسی شود؟',
        recheckConfirmDescription:
          'این عملیات از ارائه‌دهنده پرداخت می‌خواهد {identifier} را دوباره اعتبارسنجی کند و ممکن است پرداخت را تایید و خرید مشتری را اعمال کند. این تلاش ممیزی می‌شود.',
        recheckConfirmAction: 'بررسی مجدد پرداخت',
        recheckConfirmed: 'ارائه‌دهنده پرداخت را تایید کرد. رکورد پرداخت به‌روز شد.',
        recheckNotConfirmed: 'ارائه‌دهنده پرداخت را تایید نکرد. آخرین وضعیت پرداخت نمایش داده می‌شود.',
        recheckUnavailable: 'این پرداخت در وضعیت فعلی قابل بررسی مجدد نیست.',
        recheckRateLimited: 'تعداد بررسی‌های مجدد پرداخت زیاد است. کمی صبر کنید و دوباره تلاش کنید.',
        recheckFailed: 'بررسی مجدد پرداخت ممکن نبود. جزئیات ارائه‌دهنده نمایش داده نشد.',
        recheckIneligible: {
          already_confirmed: 'این پرداخت قبلا تایید شده است.',
          missing_tracking: 'این پرداخت کد پیگیری قابل اعتبارسنجی ندارد.',
          unavailable: 'این پرداخت به تراکنش قابل اعتبارسنجی ارائه‌دهنده متصل نیست.'
        }
      },
      recordTypes: {
        all: 'همه رکوردها',
        commission: 'کمیسیون‌ها',
        withdrawal: 'برداشت‌ها'
      },
      affiliates: {
        referral: 'خلاصه معرفی',
        code: 'کد معرفی',
        createdAt: 'زمان ایجاد معرفی',
        lastSuccessful: 'آخرین معرفی موفق',
        completedAt: 'زمان تکمیل',
        rejectedAt: 'زمان رد',
        totalReferrals: 'کل معرفی‌ها',
        successfulReferrals: 'معرفی‌های موفق',
        earnings: 'کل درآمد',
        confirmed_commission: 'کمیسیون تاییدشده',
        pending_commission: 'کمیسیون در انتظار',
        withdrawn: 'برداشت‌شده',
        pending_withdrawal: 'برداشت در انتظار'
      },
      reports: {
        generate: 'ساخت گزارش',
        generateCustomerVisible: 'ساخت گزارش قابل مشاهده برای مشتری',
        frame: 'بازه زمانی',
        language: 'زبان',
        origin: 'منشا',
        expiresAt: 'انقضا',
        copyLink: 'کپی پیوند مشتری',
        download: 'دانلود',
        created: 'گزارش مشتری ثبت شد',
        statusUpdated: 'وضعیت یک گزارش در انتظار تغییر کرد.',
        submitSummary:
          'این عملیات گزارش {frame} به زبان {language} را برای مشتری می‌سازد و به صفحه گزارش‌های او می‌افزاید.',
        unavailable_pending: 'گزارش هنوز در حال ساخته‌شدن است.',
        unavailable_failed: 'ساخت گزارش ناموفق بود و امکان دانلود ندارد.',
        unavailable_completed: 'فایل گزارش در دسترس نیست یا منقضی شده است.',
        linkCopied: 'پیوند صفحه گزارش مشتری کپی شد',
        copyFailed: 'کپی پیوند گزارش ممکن نبود',
        downloadFailed: 'دانلود گزارش ممکن نبود',
        customerVisibleNotice:
          'گزارش ساخته‌شده توسط پشتیبانی متعلق به مشتری است و در صفحه گزارش‌های او نمایش داده می‌شود. پیوند اشتراک‌گذاری‌شده فقط پیوند احراز‌شده پلتفرم است و هرگز نشانی فضای ذخیره‌سازی نیست.'
      },
      origins: {
        self_service: 'ایجاد توسط مشتری',
        support: 'پشتیبانی'
      },
      status: {
        total: 'کل',
        yes: 'بله',
        no: 'خیر',
        enabled: 'فعال',
        disabled: 'غیرفعال',
        active: 'فعال',
        inactive: 'غیرفعال',
        revoked: 'لغوشده',
        suspended: 'تعلیق‌شده',
        expired: 'منقضی‌شده',
        draft: 'پیش‌نویس',
        locked: 'قفل‌شده',
        processing: 'در حال پردازش',
        confirmed: 'تاییدشده',
        pending: 'در انتظار',
        completed: 'تکمیل‌شده',
        rejected: 'ردشده',
        cancelled: 'لغوشده',
        failed: 'ناموفق'
      },
      validation: {
        tracking:
          'شناسه عددی پرداخت، UUID تراکنش یا کد پیگیری دقیق را فقط با حروف، عدد، نقطه، زیرخط، دونقطه، ممیز یا خط تیره وارد کنید.',
        dateRange: 'بازه‌ای مرتب و حداکثر ۳۶۶ روزه انتخاب کنید.',
        confirmedAndFailed: 'پرداخت نمی‌تواند هم تاییدشده و هم ناموفق باشد.',
        confirmedStateFailed: 'پرداخت با وضعیت تاییدشده نمی‌تواند ناموفق نیز فیلتر شود.',
        failedStateConfirmed: 'پرداخت با وضعیت ناموفق نمی‌تواند تاییدشده نیز فیلتر شود.'
      },
      gatewayBypass: {
        title: 'دور زدن تطبیق کارت با موبایل درگاه',
        status: 'وضعیت فعلی',
        enabled: 'فعال',
        disabled: 'غیرفعال',
        description:
          'با فعال بودن، این مشتری مورد اعتماد از تایید کارت‌به‌موبایل زیبال برای پرداخت خریدها معاف می‌شود. این گزینه محدودیت هفتگی پرداخت با تلفن تاییدنشده را دور نمی‌زند.',
        enableAction: 'فعال‌سازی معافیت',
        disableAction: 'غیرفعال‌سازی معافیت',
        confirmTitle: 'تغییر معافیت درگاه؟',
        confirmEnable:
          'معافیت تایید کارت‌به‌موبایل برای این مشتری فعال شود؟ فقط برای حساب‌های معتبر و مورد اعتماد انجام دهید.',
        confirmDisable: 'معافیت تایید کارت‌به‌موبایل برای این مشتری غیرفعال شود؟',
        enabledSuccess: 'معافیت درگاه برای این مشتری فعال شد.',
        disabledSuccess: 'معافیت درگاه برای این مشتری غیرفعال شد.',
        unavailable: 'تغییر معافیت درگاه برای این مشتری ممکن نبود.'
      },
      subscription: {
        title: 'لغو اشتراک پلاس و بازپرداخت',
        noPaidSubscription: 'این مشتری اشتراک پولی فعالی ندارد.',
        remainingDays: 'روزهای باقی‌مانده',
        estimatedRefund: 'بازپرداخت تخمینی',
        purchasedAt: 'تاریخ خرید',
        payment: 'پرداخت مرتبط',
        bankDetails: 'جزئیات تراکنش بانکی',
        refundTitle: 'بازپرداخت انجام شد',
        refundAmount: 'مبلغ بازپرداخت',
        paidAmount: 'مبلغ واقعی پرداخت‌شده',
        cancelAction: 'لغو اشتراک و بازپرداخت',
        notCancellable:
          'این اشتراک از اینجا قابل لغو نیست. فقط اشتراک‌های پلاس (tier2) فعال با پرداخت دارای کد رهگیری واجد شرایط هستند.',
        cancelModalTitle: 'لغو اشتراک پلاس',
        cancelWarning:
          'این کار بلافاصله اشتراک را پایان می‌دهد، اعتبارهای اشتراک باقی‌مانده را حذف می‌کند و بازپرداخت را محاسبه می‌کند. این عمل قابل بازگشت نیست.',
        trackingConfirmLabel: 'برای تایید، کد رهگیری پرداخت را وارد کنید',
        trackingConfirmHint:
          'دکمه لغو تنها زمانی فعال می‌شود که کد رهگیری واردشده دقیقا با پرداخت اشتراک مطابقت داشته باشد.',
        cancelConfirmAction: 'لغو و بازپرداخت',
        cancelSuccess: 'اشتراک لغو و بازپرداخت محاسبه شد.',
        cancelUnavailable: 'لغو اشتراک ممکن نبود. کد رهگیری و وضعیت اشتراک را بررسی کنید.',
        policy: {
          title: 'سیاست بازپرداخت',
          elapsed: 'زمان سپری‌شده از خرید',
          daysUnit: 'روز',
          refundAmount: 'بازپرداخت طبق سیاست',
          full24h: 'بازپرداخت کامل (کمتر از ۲۴ ساعت)',
          full3d: 'بازپرداخت کامل (کمتر از ۳ روز)',
          prorated: 'بازپرداخت به‌نسبت روزهای باقی‌مانده',
          ineligible: 'قابل محاسبه خودکار نیست'
        },
        templates: {
          copyButton: 'کپی متن پاسخ',
          proposal: 'پیشنهاد بازپرداخت (فارسی)',
          done: 'اتمام بازپرداخت (فارسی)',
          copied: 'متن در کلیپ‌بورد کپی شد.',
          copyFailed: 'کپی متن در کلیپ‌بورد ممکن نبود.'
        }
      },
      errors: {
        title: 'بارگیری این بخش ممکن نبود',
        refreshTitle: 'به‌روزرسانی این بخش ممکن نبود',
        forbidden: 'دسترسی مدیر پشتیبانی شما تایید نشد.',
        notFound: 'تیکت یا رکورد محدود به مشتری یافت نشد.',
        rateLimited: 'تعداد درخواست‌های حساس زیاد است. کمی صبر کنید و دوباره تلاش کنید.',
        loadFailed: 'اطلاعات حساس مشتری موقتا در دسترس نیست.',
        writeFailed: 'انجام این عملیات ممکن نبود.',
        writeQuotaExceeded: 'به سقف روزانه عملیات حساس پشتیبانی رسیده‌اید.'
      }
    },

    // Status values
    statuses: {
      open: 'باز',
      inProgress: 'در حال انجام',
      waitingCustomer: 'در انتظار کاربر',
      waitingForAgent: 'در انتظار کارشناس',
      resolved: 'حل شده',
      closed: 'بسته شده'
    },

    // Status values (alternative format for compatibility)
    status: {
      open: 'باز',
      in_progress: 'در حال انجام',
      inProgress: 'در حال انجام',
      waiting_customer: 'در انتظار کاربر',
      waitingCustomer: 'در انتظار کاربر',
      waiting_for_agent: 'در انتظار کارشناس',
      waitingForAgent: 'در انتظار کارشناس',
      resolved: 'حل شده',
      closed: 'بسته شده'
    },

    // Priority values
    priorities: {
      low: 'پایه',
      medium: 'متوسط',
      high: 'بالا',
      critical: 'بحرانی'
    },

    // Priority values (alternative format for compatibility)
    priority: {
      low: 'پایه',
      medium: 'متوسط',
      high: 'بالا',
      critical: 'بحرانی'
    },

    // Categories
    categories: {
      title: 'دسته‌بندی‌های پشتیبانی',
      technical: 'مسئله فنی',
      billing: 'صورتحساب',
      account: 'حساب کاربری',
      feature: 'درخواست ویژگی',
      bug: 'گزارش باگ',
      other: 'سایر'
    },

    // Actions
    actions: {
      create: 'ایجاد تیکت',
      reply: 'ارسال پاسخ',
      previewReply: 'پیش‌نمایش پاسخ',
      attach: 'پیوست فایل',
      filter: 'فیلتر',
      search: 'جستجوی تیکت‌ها...',
      submit: 'ارسال',
      cancel: 'لغو',
      cancellation: {
        title: 'لغو بسته',
        openFor: 'لغو بسته {name}',
        walletOnly:
          'هر بازگشت واجد شرایط فقط به اعتبار عادی کیف پول باقی‌مانده شما افزوده می‌شود و هرگز بازپرداخت بانکی نیست.',
        usage: 'مصرف',
        sendCode: 'ارسال کد تایید',
        otpLabel: 'کد تایید شش‌رقمی',
        confirm: 'تایید لغو',
        receipt: 'رسید لغو',
        serverTime: 'زمان سرور',
        advisory: 'پیش‌نمایش اطلاع‌رسانی',
        lockedRevalidation: 'نیازمند بازبینی قفل‌شده',
        returnDestination: 'مقصد بازگشت',
        bankRefund: 'بازپرداخت بانکی',
        deadline: 'مهلت لغو',
        deadlineRemaining: 'زمان باقی‌مانده',
        usageLimit: 'سقف مصرف',
        faceCredit: 'اعتبار اولیه بسته',
        remainingCredit: 'اعتبار باقی‌مانده بسته',
        consumedCredit: 'اعتبار مصرف‌شده بسته',
        allocatedPaid: 'مبلغ پرداخت تخصیص‌یافته',
        walletReturn: 'بازگشت به کیف پول',
        eligible: 'این بسته برای لغو واجد شرایط است. شرایط نهایی پیش از تکمیل دوباره بررسی می‌شود.',
        channel: 'کانال تایید',
        challengeId: 'شناسه چالش',
        sentAt: 'زمان ارسال',
        expiresAt: 'زمان انقضا',
        challengeExpires: 'انقضای کد تا',
        maxAttempts: 'حداکثر تلاش',
        otpHelp: 'دقیقا شش رقم ASCII وارد کنید. کد پس از بستن این گفت‌وگو نگهداری نمی‌شود.',
        cancellationId: 'شناسه لغو',
        packageId: 'شناسه بسته',
        allocationId: 'شناسه تخصیص',
        paymentId: 'شناسه پرداخت',
        walletBefore: 'موجودی کیف پول پیش از لغو',
        walletAfter: 'موجودی کیف پول پس از لغو',
        completedAt: 'زمان تکمیل',
        receiptHash: 'هش رسید',
        reasons: {
          feature_disabled: 'لغو در دسترس نیست.',
          package_inactive: 'این بسته فعال نیست.',
          cancellation_window_elapsed: 'مهلت ۲۴ ساعته پایان یافته است.',
          invalid_package_amounts: 'مقادیر بسته قابل تایید نیستند.',
          usage_limit_exceeded: 'مصرف از سقف ۵٫۰۰٪ بیشتر است.',
          missing_purchase_allocation: 'تخصیص خرید در دسترس نیست.',
          payment_not_confirmed: 'پرداخت تایید نشده است.',
          paid_amount_unavailable: 'مبلغ پرداخت در دسترس نیست.',
          allocation_amount_unavailable: 'مبلغ تخصیص در دسترس نیست.',
          wallet_return_nonpositive: 'بازگشت کیف پولی وجود ندارد.',
          already_cancelled: 'این بسته قبلا لغو شده است.',
          authority_mismatch: 'تازه‌سازی و تلاش مجدد کنید.',
          verified_destination_unavailable: 'مقصد تاییدشده در دسترس نیست.',
          cancellation_ineligible: 'بسته واجد شرایط نیست.',
          challenge_context_changed: 'شرایط تغییر کرده است.',
          malformed_otp: 'شش رقم ASCII وارد کنید.',
          malformed_challenge: 'چالش نامعتبر است.',
          challenge_mismatch: 'چالش مطابقت ندارد.',
          challenge_consumed: 'چالش استفاده شده است.',
          challenge_not_delivered: 'کد تایید هنوز در حال ارسال است. کمی صبر کنید و دوباره تلاش کنید.',
          challenge_not_active: 'چالش فعال نیست.',
          challenge_expired: 'چالش منقضی شده است.',
          challenge_attempts_exhausted: 'تلاش‌ها تمام شده است.',
          challenge_binding_mismatch: 'زمینه تغییر کرده است.',
          consumption_evidence_mismatch: 'مصرف تغییر کرده است.',
          otp_invalid: 'کد نادرست است.',
          not_found: 'لغو در دسترس نیست.',
          rate_limited: 'تلاش زیاد است.',
          network_error: 'اتصال ناموفق بود.',
          unknown_error: 'لغو کامل نشد.'
        }
      },
      save: 'ذخیره',
      edit: 'ویرایش',
      delete: 'حذف',
      close: 'بستن تیکت',
      reopen: 'باز کردن مجدد تیکت',
      closeTicket: 'بستن تیکت',
      reopenTicket: 'باز کردن مجدد تیکت',
      moreActions: 'عملیات بیشتر',
      assign: 'اختصاص',
      viewDetails: 'مشاهده جزئیات',
      downloadAttachment: 'دانلود',
      viewAll: 'مشاهده همه',
      back: 'بازگشت',
      changeStatus: 'تغییر وضعیت',
      changePriority: 'تغییر اولویت',
      download: 'دانلود',
      searchAll: 'جستجو در همه تیکت‌ها...',
      clearFilters: 'پاک کردن فیلترها',
      retryNow: 'تلاش مجدد',
      refresh: 'بروزرسانی',
      refreshDashboardStats: 'بروزرسانی آمار داشبورد',
      refreshTicketDetails: 'بروزرسانی جزئیات تیکت',
      assignTicket: 'باز کردن کنترل‌های اختصاص تیکت {ticketNumber}',
      changeTicketStatus: 'باز کردن کنترل‌های وضعیت تیکت {ticketNumber}',
      ticketsRefreshed: 'تیکت‌ها بروزرسانی شدند',
      createTicket: 'ایجاد تیکت',
      yes: 'بله',
      no: 'خیر',
      resolveAndReply: 'حل و ارسال پاسخ',
      closeAndReply: 'بستن و ارسال پاسخ'
    },

    // پیش‌نمایش پاسخ برای کارشناسان
    preview: {
      title: 'پیش‌نمایش پاسخ',
      subtitle: 'قبل از ارسال، پاسخ خود را بررسی کنید',
      internalNoteTitle: 'پیش‌نمایش یادداشت داخلی',
      replyContent: 'متن پاسخ',
      internalReply: 'یادداشت داخلی',
      publicReply: 'پاسخ عمومی',
      internalNote: 'این یک یادداشت داخلی است و فقط برای کارشناسان قابل مشاهده است',
      publicNote: 'این پاسخ برای کاربر قابل مشاهده خواهد بود',
      agentsOnly: 'فقط کارشناسان',
      characters: 'کاراکتر',
      statusChange: 'وضعیت تغییر خواهد کرد به',
      currentStatus: 'فعلی',
      confirmTitle: 'آماده ارسال؟',
      confirmMessage: 'لطفا محتوای بالا را با دقت بررسی کنید. پس از ارسال، این پاسخ برای کاربر قابل مشاهده خواهد بود.',
      confirmMessageInternal:
        'این یادداشت داخلی فقط برای کارشناسان و تیم پشتیبانی قابل مشاهده است. کاربر این پیام را نخواهد دید.',
      checkContent: 'محتوا را از نظر صحت بررسی کرده‌ام',
      checkTone: 'لحن پیام حرفه‌ای و مفید است',
      checkCustomerVisible: 'می‌دانم که این پاسخ برای کاربر قابل مشاهده خواهد بود',
      unmodifiedTemplateTitle: 'قالب بدون تغییر شناسایی شد',
      unmodifiedTemplateMessage:
        'شما قالب یا پاسخ آماده درج‌شده را ویرایش نکرده‌اید. لطفا بررسی کنید و مطمئن شوید این پاسخ برای این تیکت صحیح است، سپس ادامه دهید.',
      unmodifiedTemplateAcknowledge: 'می‌دانم که این قالب/پاسخ آماده را تغییر نداده‌ام و تایید می‌کنم پاسخ صحیح است',
      edit: 'ویرایش پاسخ',
      confirm: 'ارسال پاسخ',
      sendInternal: 'ارسال یادداشت داخلی',
      escToCancel: 'برای لغو کلید Esc را فشار دهید'
    },

    // Forms
    forms: {
      subjectPlaceholder: 'موضوع تیکت را وارد کنید',
      descriptionPlaceholder: 'مسئله را شرح دهید...',
      replyPlaceholder: 'پیام خود را وارد کنید...',
      selectCategory: 'دسته‌بندی را انتخاب کنید',
      selectPriority: 'اولویت را انتخاب کنید',
      selectOption: 'گزینه را انتخاب کنید',
      emailPlaceholder: 'name@example.com',
      cardNumberPlaceholder: '۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰',
      cardNumberLabel: 'شماره کامل ۱۶ رقمی کارت بانکی',
      cardNumberHelp: 'شماره کامل ۱۶ رقمی کارت بانکی را وارد کنید.',
      ibanPlaceholder: 'IR ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰۰۰ ۰۰',
      fileUpload: 'آپلود فایل',
      dragDropFiles: 'فایل‌ها را اینجا بکشید و رها کنید یا کلیک کنید',
      maxFileSize: 'حداکثر اندازه فایل: {size} مگابایت',
      allowedTypes: 'انواع فایل مجاز: {types}',
      useTemplate: 'استفاده از قالب',
      selectTemplate: 'قالب را انتخاب کنید',
      cannedResponses: 'پاسخ‌های آماده',
      selectCannedResponse: 'پاسخ آماده را انتخاب کنید',
      categorySpecificFields: 'فیلدهای مخصوص دسته‌بندی',
      dynamicOptionsLoadError:
        'بارگذاری پیشنهادهای این فیلد ممکن نشد. اگر این فیلد پشتیبانی کند، همچنان می‌توانید مقدار را دستی وارد کنید.',
      dynamicOptionsEmpty: 'پیشنهادی برای این فیلد در دسترس نیست.',
      dynamicManualEntryHint: 'برای مقدار دلخواه، آن را تایپ کنید و Enter بزنید.',
      unsupportedFieldType: 'نوع فیلد پشتیبانی نمی‌شود: {type}',
      unsupportedFieldContactSupport: 'این نوع فیلد پشتیبانی نمی‌شود. لطفا با پشتیبانی تماس بگیرید.'
    },

    customerAI: {
      initialResponseLabel: 'اجازه می‌دهم دستیار هوش مصنوعی به این تیکت پاسخ دهد',
      initialResponseDisclosure:
        'دستیار هوش مصنوعی ممکن است تا زمانی که کارشناس رسیدگی به تیکت را بر عهده بگیرد، به آن پاسخ دهد. ممکن است اشتباه کند. پاسخ‌ها بر پایه منابع AvalAI و در صورت نیاز، اطلاعات مرتبط حساب شما تهیه می‌شوند. می‌توانید درخواست بررسی کارشناس بدهید.',
      optOutWarning:
        'بدون پاسخ‌های هوش مصنوعی، کارشناس پشتیبانی به تیکت شما پاسخ می‌دهد. پاسخ کارشناس بسته به صف درخواست‌ها ممکن است تا ۲۴ ساعت یا بیشتر زمان ببرد.',
      queuedTitle: 'پاسخ هوش مصنوعی در صف قرار گرفت',
      queuedNote:
        'پاسخ کمکی هوش مصنوعی در حال آماده‌سازی است. در این فاصله می‌توانید همچنان از بخش پشتیبانی استفاده کنید.',
      replyDisclosure: 'این پاسخ توسط هوش مصنوعی AvalAI آماده شده و ممکن است اشتباه داشته باشد.',
      accountToolsConsulted: 'دستیار این اطلاعات حساب را بررسی کرده است:',
      accountTools: {
        wallet: 'موجودی کیف پول',
        credit_sources: 'بسته‌ها و اعتبارهای هدیه',
        package_catalog: 'بسته‌های قابل خرید',
        api_keys: 'کلیدهای API',
        usage_stats: 'آمار مصرف',
        usage_reports: 'گزارش‌های مصرف',
        subscription: 'اشتراک',
        payments: 'پرداخت‌ها'
      },
      sources: 'منابع',
      thumbsUp: 'پاسخ مفید بود',
      thumbsDown: 'پاسخ مفید نبود',
      requestAgentReview: 'درخواست بررسی کارشناس',
      feedbackReason: 'دلیل',
      feedbackComment: 'توضیحات تکمیلی (اختیاری)',
      submitFeedback: 'ثبت بازخورد',
      cancelFeedback: 'انصراف',
      statusLoading: 'وضعیت پاسخ هوش مصنوعی در حال بررسی است.',
      statusPending: 'پاسخ هوش مصنوعی در حال آماده‌سازی است.',
      statusClarification: 'پاسخ هوش مصنوعی به توضیح بیشتری از سوی شما نیاز دارد.',
      statusHumanRequired: 'پاسخ‌گویی خودکار در دسترس نیست. می‌توانید بررسی کارشناس را درخواست کنید.',
      statusAutoRequested: 'این تیکت به‌صورت خودکار برای بررسی به تیم پشتیبانی ارجاع شده است.',
      statusHumanRequested: 'درخواست بررسی کارشناس ثبت شده است.',
      statusStopped: 'پاسخ‌گویی خودکار متوقف شده است.',
      statusAnswered: 'پاسخ هوش مصنوعی در گفت‌وگو در دسترس است.',
      statusNotRequested: 'هیچ پاسخ خودکاری در حال پردازش نیست.',
      statusGenerating: 'دستیار در حال نوشتن پاسخ است.',
      statusFailed: 'دستیار نتوانست این پاسخ را تکمیل کند. می‌توانید از کارشناس کمک بگیرید.',
      statusLimitReached: 'دستیار فعلا نمی‌تواند پاسخ خودکار بیشتری بفرستد. کارشناس می‌تواند کمک به شما را ادامه دهد.',
      statusUnavailable: 'بررسی وضعیت دستیار ممکن نشد.',
      statusRefreshing: 'در حال بررسی وضعیت تازه…',
      statusRefreshFailed: 'بررسی تازه ناموفق بود. آخرین وضعیت دریافت‌شده نشان داده می‌شود.',
      loadingReply: 'در حال بارگذاری پاسخ…',
      statusRetry: 'دوباره تلاش کنید',
      recheck: 'بررسی دوباره',
      viewResult: 'دیدن پاسخ',
      resultUnavailable: 'بارگذاری آخرین پاسخ ممکن نشد. دوباره تلاش کنید.',
      draft: {
        title: 'پیش‌نویس هوش مصنوعی برای بررسی کارشناس',
        awaitingApproval: 'در انتظار تایید کارشناس',
        private: 'فقط کارشناسان پشتیبانی می‌توانند این پیش‌نویس را ببینند.',
        reasonLabel: 'دلیل نیاز به بررسی',
        needsContentReview: 'نیاز به بررسی پیش از ارسال',
        contentReviewRequired: 'پیش از ارسال، پیش‌نویس را بررسی و بر اساس منابع آن اصلاح کنید.',
        contentReviewUnknown: 'بررسی متن اصلی در دسترس نیست. پیش از ارسال، پیش‌نویس را با منابع آن بررسی و ویرایش کنید.',
        source: 'منبع',
        approve: 'تایید و ارسال',
        edit: 'ویرایش پیش‌نویس',
        editPlaceholder: 'پاسخ پیشنهادی را ویرایش کنید',
        emptyEditHint: 'برای تایید، متن پاسخ را وارد کنید.',
        editAndApprove: 'تایید پاسخ ویرایش‌شده',
        cancelEdit: 'انصراف از ویرایش',
        pending: 'در حال انتشار پاسخ بررسی‌شده…',
        error: 'تایید پیش‌نویس ممکن نشد. تیکت را بررسی کنید و دوباره تلاش کنید.',
        validationError: 'پیش از ارسال، متن و منابع پاسخ باید معتبر باشند.',
        publicationUnconfirmed: 'انتشار پاسخ تایید نشد. پیش از تلاش دوباره، وضعیت تیکت را بررسی کنید.',
        recheckPublication: 'بررسی انتشار پاسخ',
        conflictRefresh: 'این پیش‌نویس قابل تایید نیست. تیکت را بررسی کنید و پاسخ را خودتان بنویسید.',
        manualReply: 'نوشتن پاسخ',
        manualReplyUnavailable: 'برای نوشتن پاسخ، ابتدا تیکت را دوباره باز کنید.',
        superseded: 'این پیش‌نویس دیگر معتبر نیست.',
        noOutput: 'دستیار متن قابل استفاده‌ای تولید نکرد. کارشناس باید پاسخ را بنویسد.',
        approvedBadge: 'تاییدشده توسط کارشناس',
        modifiedBadge: 'ویرایش‌شده پیش از تایید',
        approvalSuccess: 'پاسخ هوش مصنوعی پس از بررسی منتشر شد.',
        reasons: {
          disabled: 'دستیار هنگام رسیدگی به این درخواست غیرفعال شد.',
          unsupported_category: 'این دسته از تیکت‌ها به بررسی کارشناس نیاز دارد.',
          sensitive_request: 'این درخواست به تشخیص کارشناس نیاز دارد.',
          grounding_failed: 'پاسخ با منابع موجود پشتیبانی نشد.',
          safety_block: 'دستیار نتوانست این پاسخ را با اطمینان ارسال کند.',
          invalid_output: 'پاسخ از بررسی‌های پیش از انتشار عبور نکرد.',
          budget_exhausted: 'سقف پاسخ‌گویی دستیار پر شده است.',
          provider_failure: 'سرویس دستیار پاسخ را تکمیل نکرد.',
          stale_ticket: 'تیکت هنگام آماده‌سازی پاسخ تغییر کرد.',
          consent_withdrawn: 'مشتری رضایت استفاده از هوش مصنوعی را پس گرفت.',
          human_activity: 'کارشناس رسیدگی به تیکت را بر عهده گرفت.',
          unknown: 'دستیار این تیکت را به کارشناس ارجاع داد.'
        },
        unavailableReasons: {
          no_output: 'متنی برای تایید در این پیش‌نویس وجود ندارد.',
          missing_evidence: 'اطلاعات لازم برای تایید کامل نیست. تیکت را بررسی کنید و پاسخ را خودتان بنویسید.',
          stale: 'تیکت پس از ایجاد این پیش‌نویس تغییر کرده است.',
          already_approved: 'این پیش‌نویس قبلا تایید شده است.',
          unavailable: 'این پیش‌نویس قابل تایید نیست. می‌توانید پاسخ را خودتان بنویسید.'
        },
        grounding: {
          grounded: 'ارزیابی دستیار: پاسخ با منابع پشتیبانی می‌شود',
          partially_grounded: 'ارزیابی دستیار: بخشی از پاسخ با منابع پشتیبانی می‌شود',
          not_required: 'ارزیابی دستیار: پاسخ به منبع نیاز ندارد',
          failed: 'ارزیابی دستیار: بررسی منابع ناموفق بود',
          unverified: 'ارزیابی دستیار: منابع بررسی نشده‌اند'
        }
      },
      feedbackReasons: {
        incorrect: 'نادرست',
        outdated: 'قدیمی',
        unhelpful: 'غیرمفید',
        unclear: 'نامفهوم',
        other: 'سایر موارد'
      },
      errors: {
        unavailable: 'وضعیت پاسخ هوش مصنوعی موقتا در دسترس نیست.',
        feedback: 'ثبت بازخورد ممکن نشد. دوباره تلاش کنید.'
      },
      humanReview: {
        title: 'بررسی کارشناس درخواست شود؟',
        confirmHistory: 'پاسخ‌گویی خودکار متوقف می‌شود. گفت‌وگو و سابقه پاسخ‌های موجود همچنان در دسترس می‌ماند.',
        confirm: 'درخواست بررسی',
        cancel: 'انصراف',
        success: 'درخواست بررسی کارشناس ثبت شد.',
        error: 'درخواست بررسی کارشناس ثبت نشد. دوباره تلاش کنید.'
      },
      agentQueue: {
        state: 'وضعیت هوش مصنوعی',
        feedback: 'بازخورد فعلی',
        responses: 'پاسخ‌های هوش مصنوعی'
      },
      agentSession: {
        title: 'هوش مصنوعی مشتری',
        handoffHint: 'پاسخ خودکار به مشتری نرسید. در ویرایشگر زیر پاسخ دهید.',
        handoffAfterRepliesHint: 'این تیکت پاسخ‌های قبلی هوش مصنوعی دارد. پیش از ادامه پاسخ‌گویی به مشتری، گفتگو را بررسی کنید.',
        pendingHint: 'پاسخ خودکار برای مشتری در حال آماده‌سازی است.',
        answeredHint: 'مشتری پاسخ خودکار را دریافت کرده است؛ پیش از پاسخ دادن آن را بررسی کنید.',
        responses: '{count} پاسخ منتشرشده',
        enrollmentDecline: 'دلیل ارجاع هنگام فعال‌سازی هوش مصنوعی',
        enrollmentDeclines: {
          rollout_denied: 'فعال‌سازی هوش مصنوعی در مرحله فعلی عرضه در دسترس نیست.',
          owner_mismatch: 'صاحب تیکت برای فعال‌سازی هوش مصنوعی تأیید نشد.',
          category_mismatch: 'دسته‌بندی تیکت پیش از فعال‌سازی هوش مصنوعی تغییر کرد.',
          category_denied: 'فعال‌سازی هوش مصنوعی برای این دسته‌بندی در دسترس نیست.',
          attachment_present: 'تیکت پیوست دارد و باید توسط کارشناس بررسی شود.',
          custom_fields_invalid: 'اطلاعات تیکت برای فعال‌سازی هوش مصنوعی قابل تأیید نبود.',
          sensitive_field_present: 'اطلاعات تیکت شامل مواردی است که دستیار نمی‌تواند خودکار بررسی کند.',
          network_digest_invalid: 'اطلاعات شبکه برای فعال‌سازی هوش مصنوعی قابل تأیید نبود.',
          budget_exhausted: 'سهمیه فعال‌سازی هوش مصنوعی به پایان رسیده است.',
          configuration_invalid: 'تنظیمات فعال‌سازی هوش مصنوعی در دسترس نیست.',
          enrollment_internal_error: 'فعال‌سازی هوش مصنوعی پیش از پردازش ناموفق بود.'
        },
        lastTransition: 'آخرین تغییر وضعیت',
        states: {
          not_requested: 'درخواست‌نشده',
          queued: 'در صف',
          processing: 'در حال پردازش',
          answered: 'پاسخ داده‌شده',
          clarification_requested: 'درخواست توضیح ارسال شد',
          clarification_queued: 'توضیح در صف پردازش',
          answered_after_clarification: 'پاسخ داده‌شده پس از توضیح',
          human_requested: 'بازبینی کارشناس درخواست شد',
          human_required: 'به کارشناس ارجاع شد',
          stopped: 'متوقف‌شده'
        }
      },
      agentMeta: {
        answer: 'پاسخ هوش مصنوعی',
        clarification: 'درخواست توضیح هوش مصنوعی',
        grounded: 'مبتنی بر منبع',
        not_required: 'بدون نیاز به منبع',
        voteUp: 'بازخورد مفید',
        voteDown: 'بازخورد غیرمفید',
        humanPending: 'در انتظار بررسی کارشناس',
        accountTool: 'اطلاعات حساب مشتری که هوش مصنوعی خوانده است (فقط خواندنی، فقط صاحب تیکت)',
        stopReasons: {
          enrolled: 'پاسخ هوش مصنوعی فعال شد',
          attempt_started: 'تلاش هوش مصنوعی آغاز شد',
          answer_published: 'پاسخ هوش مصنوعی منتشر شد',
          clarification_published: 'درخواست توضیح هوش مصنوعی منتشر شد',
          clarification_answered: 'توضیح تکمیلی پاسخ داده شد',
          follow_up: 'پیگیری مشتری برای پاسخ هوش مصنوعی در صف قرار گرفت',
          budget_exhausted: 'سهمیه پاسخ هوش مصنوعی تمام شد؛ بررسی کارشناس لازم است',
          preparation_failed: 'آماده‌سازی پاسخ هوش مصنوعی ناموفق بود؛ بررسی کارشناس لازم است',
          customer_request: 'با درخواست مشتری متوقف شد',
          human_activity: 'پس از فعالیت کارشناس متوقف شد',
          policy_block: 'پاسخ خودکار متوقف شد؛ بررسی کارشناس لازم است',
          provider_failure: 'پس از خطای سرویس هوش مصنوعی متوقف شد',
          stale_ticket: 'به دلیل تغییر تیکت متوقف شد',
          disabled: 'هوش مصنوعی مشتری غیرفعال شد',
          retention_cleanup: 'به دلیل پاک‌سازی دوره نگهداری متوقف شد'
        }
      }
    },

    // Priority selection guidance (create ticket)
    priorityGuide: {
      infoLabel: 'اولویت تیکت چگونه کار می‌کند',
      infoTrigger: 'بیشتر بیاموزید',
      currentMax: 'پلن شما می‌تواند اولویت را تا سطح {level} تنظیم کند.',
      lockedTooltip: 'اولویت {level} در پلن فعلی شما در دسترس نیست.',
      lockedOption: '{level} (نیازمند ارتقا)',
      modalTitle: 'انتخاب اولویت مناسب',
      modalIntro:
        'اولویت به تیم پشتیبانی ما کمک می‌کند تا میزان فوریت مشکل شما را درک کند. سطوح اولویت بالاتر برای حساب‌های دارای اشتراک پلاس یا سطح دسترسی API بالاتر در نظر گرفته شده‌اند تا تیم ما بتواند ابتدا به فوری‌ترین موارد رسیدگی کند.',
      yourAccess: 'دسترسی فعلی شما',
      yourAccessLow:
        'حساب شما می‌تواند تیکت‌هایی با اولویت پایه ایجاد کند. این گزینه برای پرسش‌های عمومی و درخواست‌های غیرفوری مناسب است.',
      yourAccessMedium:
        'حساب شما می‌تواند اولویت را تا سطح متوسط تنظیم کند — از اینکه عضو پلاس هستید یا به سطح دسترسی API ۳ رسیده‌اید سپاسگزاریم.',
      yourAccessHigh: 'حساب شما به لطف سطح دسترسی API ۴، می‌تواند اولویت را تا سطح بالا تنظیم کند.',
      yourAccessCritical:
        'حساب شما به لطف سطح دسترسی API ۵، می‌تواند اولویت را تا سطح بحرانی (بالاترین سطح) تنظیم کند.',
      unlockedBySubscription: 'با اشتراک پلاس شما فعال شده است',
      unlockedByApiTier: 'با سطح دسترسی API شما فعال شده است',
      ladderTitle: 'سطوح اولویت',
      levels: {
        lowTitle: 'پایه',
        lowRequirement: 'در دسترس همه',
        lowDescription: 'پرسش‌های عمومی و درخواست‌های غیرفوری.',
        mediumTitle: 'متوسط',
        mediumRequirement: 'اشتراک پلاس یا سطح دسترسی API ۳ به بالا',
        mediumDescription: 'مشکلاتی که بر کار شما تاثیر دارند اما کمی قابل انتظار هستند.',
        highTitle: 'بالا',
        highRequirement: 'سطح دسترسی API ۴ به بالا',
        highDescription: 'مشکلات مهمی که نیاز به رسیدگی سریع دارند.',
        criticalTitle: 'بحرانی',
        criticalRequirement: 'سطح دسترسی API ۵',
        criticalDescription: 'اختلالات فوری و تاثیرگذار بر کسب‌وکار.'
      },
      availableBadge: 'در پلن شما در دسترس است',
      lockedBadge: 'در پلن شما نیست',
      upgradeTitle: 'به اولویت بالاتری نیاز دارید؟',
      upgradeDescription:
        'برای فعال‌سازی سطوح اولویت بالاتر، به اشتراک پلاس ارتقا دهید یا سطح دسترسی API خود را افزایش دهید.',
      viewPlusPlans: 'مشاهده پلن‌های پلاس',
      viewApiTiers: 'مشاهده سطوح دسترسی API',
      agentNote:
        'کارشناسان پشتیبانی ما می‌توانند اولویت هر تیکت را پس از ایجاد آن تغییر دهند، پس اگر نمی‌توانید سطح دلخواه خود را انتخاب کنید نگران نباشید. تمامی درخواست‌های پشتیبانی در اسرع وقت بررسی خواهند شد.',
      close: 'متوجه شدم'
    },

    // Filters
    filters: {
      title: 'فیلترها',
      status: 'وضعیت',
      statusHint: 'صف کارشناس را بر اساس وضعیت فعلی گردش کار تیکت فیلتر کنید.',
      allStatuses: 'همه وضعیت‌ها',
      priority: 'اولویت',
      category: 'دسته‌بندی',
      dateRange: 'بازه زمانی',
      assignedTo: 'اختصاص داده شده به',
      createdBy: 'ایجاد شده توسط',
      clearFilters: 'پاک کردن فیلترها',
      applyFilters: 'اعمال فیلترها',
      showFilters: 'نمایش فیلترها',
      hideFilters: 'مخفی کردن فیلترها',
      activeFilters: 'فیلترهای فعال',
      search: 'جستجو',
      searchPlaceholder: 'جستجو در تیکت‌ها، ایمیل یا تلفن…',
      searchHint: 'در متن و شماره تیکت جستجو کنید یا ایمیل یا شماره تلفن کامل مشتری را وارد کنید.',
      searchSubmit: 'جستجو',
      unassigned: 'بدون مسئول',
      assignedToMe: 'اختصاص داده شده به من',
      assignee: 'مسئول',
      customerAccount: 'نوع حساب کاربر',
      apiAccounts: 'سطح دسترسی API',
      chatAccounts: 'اشتراک چت',
      apiTier: 'سطح API',
      apiTierZero: 'API فعال نشده',
      apiTier0: 'سطح ۰ API',
      apiTier1: 'سطح ۱ API',
      apiTier2: 'سطح ۲ API',
      apiTier3: 'سطح ۳ API',
      apiTier4: 'سطح ۴ API',
      apiTier5: 'سطح ۵ API',
      plusSubscription: 'اشتراک پلاس',
      freeAccount: 'حساب رایگان',
      collaboration: 'پیگیری پشتیبانی',
      needsHumanReview: 'نیازمند بررسی کارشناس'
    },

    // View modes
    viewModes: {
      grid: 'نمایش موزائیکی',
      list: 'نمایش لیستی'
    },

    // Views
    views: {
      grid: 'موزائیک',
      list: 'لیست'
    },

    // Sorting
    sorting: {
      sortBy: 'مرتب‌سازی بر اساس',
      newest: 'جدیدترین',
      oldest: 'قدیمی‌ترین',
      priority: 'اولویت',
      status: 'وضعیت',
      updated: 'به‌روزرسانی شده اخیر',
      createdAt: 'تاریخ ایجاد',
      updatedAt: 'تاریخ به‌روزرسانی',
      subject: 'موضوع',
      recommended: 'اولویت پیشنهادی',
      waitingTime: 'زمان انتظار',
      ascending: 'مرتب‌سازی صعودی',
      descending: 'مرتب‌سازی نزولی'
    },

    // Messages
    messages: {
      noTickets: 'تیکت یافت نشد',
      noTicketsDescription: 'شما هنوز هیچ تیکت پشتیبانی ایجاد نکرده‌اید.',
      ticketCreated: 'تیکت با موفقیت ایجاد شد',
      ticketUpdated: 'تیکت با موفقیت به‌روزرسانی شد',
      replyAdded: 'پاسخ با موفقیت اضافه شد',
      fileUploaded: 'فایل با موفقیت آپلود شد',
      ticketClosed: 'تیکت با موفقیت بسته شد',
      ticketReopened: 'تیکت با موفقیت باز شد',
      confirmCloseTicket:
        'آیا مطمئن هستید که می‌خواهید این تیکت را ببندید؟ این کار از پاسخ‌های بیشتر جلوگیری می‌کند تا زمانی که تیکت دوباره باز شود.',
      confirmReopenTicket:
        'آیا مطمئن هستید که می‌خواهید این تیکت را دوباره باز کنید؟ این کار اجازه می‌دهد پاسخ‌های جدید اضافه شوند.',
      errorClosingTicket: 'خطا در بستن تیکت',
      errorReopeningTicket: 'خطا در باز کردن مجدد تیکت',
      ticketInactive: 'این تیکت غیرفعال است. برای افزودن پاسخ، ابتدا آن را دوباره باز کنید.',
      ticketResolvedHelp: 'این تیکت حل شده است.',
      ticketClosedHelp: 'این تیکت بسته شده است.',
      ticketReopenHelp: 'به کمک بیشتری نیاز دارید؟ برای ادامه گفتگو این تیکت را دوباره باز کنید. تاریخچه و پیش‌نویس شما حفظ می‌شوند.',
      ticketReopening: 'در حال باز کردن مجدد…',
      reopenUnconfirmed: 'باز شدن مجدد تیکت تایید نشد. پیش از تلاش دوباره، وضعیت فعلی تیکت را بررسی کنید.',
      loadingTickets: 'در حال بارگذاری تیکت‌ها...',
      loadingTicket: 'در حال بارگذاری جزئیات تیکت...',
      errorLoadingTickets: 'خطا در بارگذاری تیکت‌ها',
      errorLoadingTicket: 'خطا در بارگذاری جزئیات تیکت',
      errorLoadingDashboard: 'خطا در بارگذاری داشبورد پشتیبانی',
      profileUnavailable: 'نمایه پشتیبانی موقتا در دسترس نیست.',
      statisticsUnavailable: 'آمار پشتیبانی موقتا در دسترس نیست.',
      ticketNotFoundWithNumber: 'تیکت {ticketNumber} یافت نشد. ممکن است حذف شده باشد.',
      ticketLoadFailedWithNumber: 'خطا در بارگذاری تیکت {ticketNumber}. لطفا دوباره تلاش کنید.',
      errorRefreshingDashboardStats: 'خطا در بروزرسانی آمار داشبورد',
      errorCreatingTicket: 'خطا در ایجاد تیکت',
      errorAddingReply: 'خطا در ارسال پاسخ',
      replySubmissionChecking:
        'وضعیت ارسال مشخص نیست. در حال بررسی گفتگو… پیش‌نویس و پیوست‌های شما حفظ شده‌اند.',
      replySubmissionUnconfirmed:
        'وضعیت ارسال هنوز مشخص نیست. گفتگو تازه‌سازی شد. برای جلوگیری از ارسال تکراری، پیش از ارسال دوباره آن را بررسی کنید. پیش‌نویس و پیوست‌های شما حفظ شده‌اند.',
      replySubmissionRefreshFailed:
        'وضعیت ارسال مشخص نیست و تازه‌سازی گفتگو انجام نشد. پیش‌نویس و پیوست‌های شما حفظ شده‌اند. برای جلوگیری از ارسال تکراری، پیش از ارسال دوباره گفتگو را تازه‌سازی و بررسی کنید.',
      aiReplySubmissionUncertain:
        'ممکن است پاسخ ارسال شده باشد. بدون تغییر دوباره تلاش کنید یا پیش از ارسال پاسخ متفاوت، تیکت را تازه‌سازی کنید.',
      aiReplyChangedAfterUncertainSubmission:
        'این پاسخ پس از ارسال نامشخص تغییر کرده است. پیش از ارسال نسخه ویرایش‌شده، تیکت را تازه‌سازی کنید.',
      statusUpdated: 'وضعیت با موفقیت به‌روزرسانی شد',
      errorUpdatingStatus: 'خطا در به‌روزرسانی وضعیت',
      priorityUpdated: 'اولویت با موفقیت به‌روزرسانی شد',
      errorUpdatingPriority: 'خطا در به‌روزرسانی اولویت',
      ticketAssigned: 'تیکت با موفقیت اختصاص داده شد',
      ticketUnassigned: 'اختصاص تیکت با موفقیت لغو شد',
      errorAssigningTicket: 'خطا در اختصاص تیکت',
      ticketNotFound: 'تیکت یافت نشد',
      ticketNotFoundDesc: 'تیکت مورد نظر شما وجود ندارد یا شما مجوز مشاهده آن را ندارید.',
      retrySuccess: 'عملیات با موفقیت انجام شد',
      retryFailed: 'تلاش مجدد ناموفق بود. لطفا دوباره تلاش کنید.',
      resetSuccess: 'بازنشانی با موفقیت انجام شد',
      resetFailed: 'بازنشانی ناموفق بود. لطفا دوباره تلاش کنید.',
      ticketsRefreshed: 'تیکت‌ها با موفقیت به‌روزرسانی شدند',
      loadError: 'خطا در بارگذاری داده‌ها. لطفا دوباره تلاش کنید.',
      searchError: 'جستجو ناموفق بود. لطفا دوباره تلاش کنید.',
      feedbackError: 'خطا در ارسال بازخورد. لطفا دوباره تلاش کنید.',
      exportSuccess: 'تیکت‌ها با موفقیت خروجی گرفته شدند',
      exportError: 'خطا در خروجی گرفتن از تیکت‌ها',
      networkError: 'خطای شبکه. لطفا اتصال خود را بررسی کرده و دوباره تلاش کنید.'
    },

    // Dashboard
    dashboard: {
      title: 'پشتیبانی',
      returnToChat: 'بازگشت به صفحه گفتگوها',
      returnToChatHint: 'درخواست‌های پشتیبانی خود را اینجا مدیریت کنید و هر زمان خواستید به گفتگوها برگردید.',
      overview: 'نمای کلی',
      myStats: 'آمار من',
      recentActivity: 'فعالیت‌های اخیر',
      quickActions: 'اقدامات سریع',
      totalTickets: 'کل تیکت‌ها',
      openTickets: 'تیکت‌های باز',
      resolvedTickets: 'تیکت‌های حل شده',
      avgResponseTime: 'میانگین زمان پاسخ'
    },

    // Ticket details
    ticketDetails: {
      conversation: 'مکالمه',
      information: 'اطلاعات تیکت',
      createdBy: 'ایجاد شده توسط',
      assignedTo: 'اختصاص داده شده به',
      lastUpdated: 'آخرین به‌روزرسانی',
      timeSpent: 'زمان صرف شده',
      slaStatus: 'وضعیت SLA',
      onTime: 'به موقع',
      overdue: 'عقب افتاده',
      dueIn: 'موعد در {time}',
      toggleInformation: 'تغییر نمایش اطلاعات تیکت'
    },

    // Message and reply types
    message: {
      original: 'پیام اصلی',
      viewRaw: 'نمایش متن خام',
      viewFormatted: 'نمایش بهینه',
      copy: 'کپی پیام',
      copyFormatted: 'کپی',
      copyRaw: 'کپی متن خام',
      copiedFormatted: 'کپی شد',
      copiedRaw: 'متن خام کپی شد',
      copyFailed: 'کپی پیام انجام نشد'
    },

    replyType: {
      public: 'عمومی',
      internal: 'داخلی'
    },

    // Reply form labels
    reply: {
      type: 'نوع پاسخ',
      public: 'پاسخ عمومی',
      internal: 'یادداشت داخلی',
      templateLanguage: 'زبان قالب پاسخ',
      templateFa: 'فارسی',
      templateEn: 'English',
      resetTemplate: 'بازنشانی قالب',
      resetTemplateConfirm: 'با بازنشانی، پیش‌نویس فعلی شما با قالب خالی پاسخ جایگزین می‌شود. ادامه می‌دهید؟',
      templateHint: 'پاسخ خود را بین خط درود و خطوط پایانی بنویسید.',
      refreshTemplates: 'به‌روزرسانی قالب‌ها',
      refreshCannedResponses: 'به‌روزرسانی پاسخ‌ها',
      searchCannedResponses: 'جست‌وجوی پاسخ بر اساس عنوان، متن یا دسته‌بندی',
      cannedResponsesLoading: 'در حال بارگیری پاسخ‌های آماده…',
      cannedResponsesEmpty: 'پاسخ آماده‌ای در دسترس نیست. دوباره بارگیری کنید.',
      cannedResponsesNoResults: 'پاسخ آماده‌ای مطابق جست‌وجوی شما پیدا نشد.',
      clearCannedResponse: 'پاک کردن انتخاب',
      insertCannedResponse: 'درج در پیش‌نویس',
      replaceCannedResponse: 'جایگزینی متن پاسخ',
      appendCannedResponse: 'افزودن به انتها',
      cannedRelevance: {
        category: 'پیشنهادشده برای این دسته‌بندی',
        general: 'پاسخ عمومی',
        other: 'دسته‌بندی دیگر'
      },
      templatesUnavailable:
        'قالب‌های پاسخ در حال حاضر در دسترس نیستند. می‌توانید پاسخ را آزادانه بنویسید یا قالب‌ها را دوباره بارگیری کنید.',
      scenario: 'سناریوی پاسخ',
      selectScenario: 'درج قالب سناریو',
      suggestedScenario: 'پیشنهاد برای این تیکت: {title}',
      customFieldSummary: 'جزئیات ثبت‌شده توسط کاربر',
      insertCustomFieldSummary: 'درج جزئیات'
    },

    aiAssistant: {
      title: 'دستیار هوش مصنوعی',
      suggestions: 'پیشنهادها',
      chat: 'گفت‌وگوی خصوصی',
      sources: 'منابع',
      languages: { en: 'انگلیسی', fa: 'فارسی' },
      operationDescriptions: {
        generate_reply: 'با استفاده از گفت‌وگوی تیکت و منابع پشتیبانی موجود، پاسخی آماده کنید.',
        improve: 'وضوح و نگارش پیش‌نویس پاسخ در پایین را بهتر کنید.',
        shorten: 'پیش‌نویس پاسخ در پایین را با حفظ نکته‌های اصلی کوتاه‌تر کنید.',
        expand: 'پیش‌نویس پاسخ در پایین را نگه دارید و جمله‌هایی از مستندات پشتیبانی، همراه با منبع، به آن اضافه کنید.',
        change_tone: 'پیش‌نویس پاسخ در پایین را با لحن دلخواه بازنویسی کنید.',
        translate: 'پیش‌نویس پاسخ در پایین را با حفظ سطرها، عددها و کدها به زبان انتخاب‌شده برای پاسخ ترجمه کنید.',
        custom: 'خواسته خود را بنویسید. دستیار جمله‌های پیش‌نویس پاسخ در پایین را نگه می‌دارد و می‌تواند جمله‌هایی از مستندات به آن اضافه کند.'
      },
      translateTo: 'ترجمه به {language}',
      customGenerate: 'ایجاد پیشنهاد',
      responseLanguage: 'زبان پاسخ: {language}. برای تغییر آن از ویرایشگر پاسخ استفاده کنید.',
      draftRequiredHint: 'برای بهبود، کوتاه‌سازی، گسترش، تغییر لحن یا ترجمه، ابتدا در ویرایشگر پاسخ پایین یک پیش‌نویس بنویسید.',
      inputsChanged: 'پیش‌نویس یا تنظیمات پس از این پیشنهاد تغییر کرده‌اند. برای استفاده از نسخه فعلی، پیشنهاد تازه‌ای ایجاد کنید.',
      privateChatHint: 'درباره این تیکت از دستیار بپرسید. این گفت‌وگو برای مشتری ارسال نمی‌شود.',
      messageAssistant: 'پیام به دستیار',
      sendToAssistant: 'ارسال به دستیار',
      noConversation: 'یک گفت‌وگو از فهرست انتخاب کنید یا برای پرسیدن درباره این تیکت، گفت‌وگوی تازه‌ای شروع کنید.',
      conversationLoading: 'در حال بارگیری گفت‌وگو…',
      conversationReadFailed: 'تاریخچه گفت‌وگو بارگیری نشد. پیش‌نویس شما حفظ شده است.',
      emptyHistory: 'این گفت‌وگو پیامی ندارد. برای ادامه، گفت‌وگوی تازه‌ای شروع کنید.',
      resultPrivateHint: 'پیش از افزودن پیشنهاد به پیش‌نویس، آن را بررسی کنید. افزودن پیشنهاد، پاسخی برای مشتری ارسال نمی‌کند.',
      applyDescriptions: {
        insert: 'در محل ذخیره‌شده نشانگر درج می‌شود و در صورت انتخاب متن، جای آن را می‌گیرد.',
        replace: 'تمام متن پیش‌نویس پاسخ فعلی با این پیشنهاد جایگزین می‌شود.',
        append: 'این پیشنهاد به انتهای پیش‌نویس پاسخ فعلی اضافه می‌شود.'
      },
      regenerateOriginal: 'ایجاد دوباره با ورودی‌های اولیه',
      operations: {
        chat: 'گفت‌وگو',
        generate_reply: 'ایجاد پاسخ',
        improve: 'بهبود پیش‌نویس',
        shorten: 'کوتاه‌تر کردن پیش‌نویس',
        expand: 'گسترش پیش‌نویس',
        change_tone: 'تغییر لحن',
        translate: 'ترجمه',
        custom: 'دستور سفارشی'
      },
      tones: {
        professional: 'حرفه‌ای',
        empathetic: 'همدلانه',
        concise: 'مختصر',
        friendly: 'صمیمی'
      },
      operation: 'چه کاری می‌خواهید انجام دهید؟',
      tone: 'لحن',
      customInstruction: 'دستور مشخص خود را بنویسید',
      generate: 'ایجاد',
      loading: 'در حال آماده‌سازی پاسخ...',
      emptySuggestions: 'برای آماده‌سازی پیشنهاد، کاری را از بالا انتخاب کنید؛ سپس پیشنهاد را پیش از افزودن به پیش‌نویس بررسی کنید.',
      emptyChat: 'درباره این تیکت سؤال بپرسید، توضیح بخواهید یا روش پاسخ‌گویی را بررسی کنید.',
      draftTooLong: 'طول پیش‌نویس باید حداکثر {max} نویسه باشد.',
      requestTooLong: 'مجموع طول پیش‌نویس و دستور باید حداکثر {max} نویسه باشد.',
      chatRequestTooLong: 'مجموع طول پیش‌نویس و پیام باید حداکثر {max} نویسه باشد.',
      clarificationWarning: 'اطلاعات بیشتری لازم است. پیش از استفاده از این پاسخ، پرسش تکمیلی را بررسی کنید.',
      insert: 'درج در محل نشانگر',
      replace: 'جایگزینی پیش‌نویس',
      append: 'افزودن به انتهای پیش‌نویس',
      applyMode: 'روش اعمال در پیش‌نویس',
      apply: 'اعمال در پیش‌نویس',
      copy: 'رونوشت',
      regenerate: 'ایجاد دوباره',
      discard: 'کنار گذاشتن',
      thumbsUp: 'مفید بود',
      thumbsDown: 'مفید نبود',
      newConversation: 'گفت‌وگوی جدید',
      archiveConversation: 'بایگانی گفت‌وگو',
      selectConversation: 'انتخاب گفت‌وگو',
      conversationLabel: 'گفت‌وگوی {index}، {status}',
      conversationStatus: {
        active: 'فعال',
        archived: 'بایگانی‌شده',
        expired: 'منقضی‌شده'
      },
      loadOlder: 'بارگیری پیام‌های قدیمی‌تر',
      chatPlaceholder: 'مثلا: چه اطلاعاتی در این تیکت کم است؟',
      send: 'ارسال',
      retry: 'تلاش دوباره',
      retryCountdown: 'تلاش دوباره تا {seconds} ثانیه دیگر',
      retryCountdownSingular: 'تلاش دوباره تا ۱ ثانیه دیگر',
      retryReady: 'اکنون می‌توانید دوباره تلاش کنید.',
      collapse: 'جمع کردن',
      expand: 'باز کردن',
      disabled: 'دستیار هوش مصنوعی برای این حساب فعال نیست.',
      availability: {
        safetyStopped:
          'دستیار هوش مصنوعی به‌دلیل توقف ایمنی موقتا در دسترس نیست. پیش‌نویس و پاسخ‌های تیکت شما تغییری نمی‌کنند.',
        configuredOff:
          'دستیار هوش مصنوعی در تنظیمات غیرفعال است. پیش‌نویس و پاسخ‌های تیکت شما تغییری نمی‌کنند.',
        unavailable:
          'در حال حاضر امکان تأیید آمادگی دستیار هوش مصنوعی وجود ندارد. پیش‌نویس و پاسخ‌های تیکت شما تغییری نمی‌کنند.',
        checking:
          'در حال بررسی دسترس‌پذیری دستیار هوش مصنوعی هستیم. پیش‌نویس و پاسخ‌های تیکت شما تغییری نمی‌کنند.',
        refresh: 'به‌روزرسانی وضعیت'
      },
      recovery: {
        action: 'بازبینی بازیابی محلی',
        title: 'بازبینی بازیابی محلی هوش مصنوعی',
        description: 'پیش از تأیید صریح این بازیابی صرفا محلی، شواهد فعلی را بازبینی کنید.',
        expectedRevision: 'نسخه مورد انتظار کنترل',
        incidents: 'دسته‌های رخداد بحرانی',
        incidentCount: 'تعداد رخدادهای بحرانی',
        evidenceCheckedAt: 'زمان بررسی شواهد',
        expiresAt: 'زمان انقضای بازبینی',
        unknownOriginWarning: 'منشأ نامشخص برای برخی رخدادهای نگه‌داری‌شده ثبت شده است. پیش از ادامه این خطر را بررسی کنید.',
        evidenceUnavailable: 'شواهد بازیابی در دسترس یا کامل نیست. تأیید غیرفعال است.',
        noIncidents: 'طبق شواهد بازیابی، رخداد بحرانی نگه‌داری‌شده‌ای گزارش نشده است.',
        oldRequests: 'درخواست‌های قدیمی از سر گرفته نمی‌شوند.',
        confirmLabel: 'شواهد را بازبینی کردم و این بازیابی محلی را صریحا تأیید می‌کنم.',
        cancel: 'انصراف',
        confirm: 'تأیید بازیابی',
        retry: 'تلاش دوباره برای همین تأیید',
        close: 'بستن بازبینی بازیابی',
        status: {
          loading: 'در حال بارگیری شواهد بازیابی.',
          ready: 'شواهد بازیابی برای بازبینی آماده است.',
          submitting: 'در حال ارسال تأیید صریح بازیابی.',
          expired: 'این بازبینی بازیابی منقضی شده است. آن را ببندید و بازبینی تازه‌ای بگیرید.',
          forbidden: 'مجوز یا نشست بازیابی شما دیگر در دسترس نیست.',
          conflict: 'وضعیت بازیابی تغییر کرده است. این بازبینی را ببندید و توقف فعلی را بررسی کنید.',
          rateLimited: 'درخواست‌های بازیابی محدود شده‌اند. پیش از بازبینی تازه صبر کنید.',
          unavailable: 'شواهد بازیابی موقتا در دسترس نیست.',
          invalidResponse: 'اعتبار پاسخ بازیابی قابل تأیید نبود.',
          uncertain: 'نتیجه تأیید نامشخص است. فقط برای بازخوانی همین درخواست دقیق دوباره تلاش کنید.'
        },
        incidentKinds: {
          privacy_leak: 'نشت حریم خصوصی',
          unsafe_output: 'خروجی ناامن',
          authorization_failure: 'شکست مجوزدهی',
          retrieval_integrity_failure: 'شکست یکپارچگی بازیابی'
        },
        missingGates: {
          preparation_budget: 'بودجه آماده‌سازی',
          readiness_cache: 'حافظه آمادگی',
          identity: 'هویت بازیابی',
          control_revision: 'نسخه کنترل',
          control_not_stopped: 'وضعیت توقف کنترل',
          evidence_incomplete: 'شواهد کامل بازیابی',
          incident_limit: 'حد رخدادها',
          worker_readiness: 'آمادگی پردازشگر',
          retrieval_readiness: 'آمادگی بازیابی اطلاعات',
          configuration_changed: 'پیکربندی پایدار'
        }
      },
      expiredConversation: 'این گفت‌وگو منقضی شده است. برای ادامه، گفت‌وگوی جدیدی آغاز کنید.',
      readOnlyConversation: 'این گفت‌وگو فقط برای مشاهده در دسترس است.',
      ai_disabled: 'دستیار هوش مصنوعی برای این حساب فعال نیست.',
      ai_forbidden: 'شما اجازه استفاده از دستیار هوش مصنوعی برای این تیکت را ندارید.',
      ai_rollout_unavailable:
        'دستیار هوش مصنوعی تا فعال شدن انتشار کنترل‌شده پشتیبانی در دسترس نیست. پاسخ‌های عادی همچنان در دسترس هستند.',
      ai_rate_limited: 'تعداد درخواست‌ها بیش از حد مجاز است. {retry_after} ثانیه دیگر دوباره تلاش کنید.',
      ai_rate_limited_singular: 'تعداد درخواست‌ها بیش از حد مجاز است. ۱ ثانیه دیگر دوباره تلاش کنید.',
      ai_rate_limited_generic: 'تعداد درخواست‌ها بیش از حد مجاز است. کمی بعد دوباره تلاش کنید.',
      ai_context_rejected: 'استفاده امن از اطلاعات این تیکت ممکن نبود. تیکت را بررسی و دوباره تلاش کنید.',
      ai_output_blocked: 'پاسخ ایجادشده در بررسی‌های ایمنی مسدود شد.',
      ai_provider_unavailable: 'دستیار هوش مصنوعی موقتا در دسترس نیست. بعدا دوباره تلاش کنید.',
      ai_timeout: 'زمان درخواست هوش مصنوعی به پایان رسید. دوباره تلاش کنید.',
      ai_invalid_output: 'پاسخ ایجادشده معتبر نبود. پاسخ تازه‌ای ایجاد کنید.',
      ai_conversation_expired: 'این گفت‌وگو منقضی شده است. گفت‌وگوی جدیدی آغاز کنید.',
      ai_idempotency_conflict: 'این درخواست با درخواست قبلی تداخل دارد. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      not_authenticated: 'نشست شما منقضی شده است. برای استفاده از دستیار هوش مصنوعی دوباره وارد شوید.',
      not_found: 'این گفت‌وگو یا پیام هوش مصنوعی دیگر در دسترس نیست. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      invalid_request: 'درخواست هوش مصنوعی نامعتبر بود. ورودی‌ها را بررسی و دوباره تلاش کنید.',
      missing_idempotency_key: 'تلاش دوباره برای این درخواست ایمن نبود. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      invalid_idempotency_key: 'تلاش دوباره برای این درخواست ایمن نبود. صفحه را به‌روزرسانی و دوباره تلاش کنید.',
      ai_conversation_limit: 'پیش از آغاز گفت‌وگوی جدید، یکی از گفت‌وگوهای فعال را بایگانی کنید.',
      run_terminal: 'این درخواست پیش‌تر به پایان رسیده و دیگر نمی‌توان آن را لغو کرد.',
      run_not_retryable: 'دیگر نمی‌توان این درخواست را دوباره اجرا کرد. به‌جای آن پاسخ تازه‌ای ایجاد کنید.',
      retry_payload_mismatch: 'تلاش دوباره دیگر با درخواست اصلی هم‌خوانی ندارد. به‌جای آن پاسخ تازه‌ای ایجاد کنید.',
      invalid_cursor: 'به‌روزرسانی زندهٔ این درخواست ناهم‌گام شده است. برای ادامه دوباره متصل شوید.',
      run_events_expired: 'تاریخچهٔ پیشرفت این درخواست منقضی شده است. به‌جای آن پاسخ تازه‌ای ایجاد کنید.',
      ai_stream_limit: 'اتصال‌های زندهٔ زیادی باز است. زبانهٔ تیکت دیگری را ببندید و دوباره متصل شوید.',
      retryFailed: 'تلاش دوباره به بررسی نیاز دارد.',
      cancelFailed: 'لغو اجرا تأیید نشد.',
      privateSession: 'این نشست خصوصی است و فقط کارشناسان مجاز پشتیبانی می‌توانند محتوای آن را ببینند.',
      reviewWarning: 'پیش از ارسال، متن پیشنهادی هوش مصنوعی را از نظر درستی و ایمنی بررسی کنید.',
      feedbackReasons: {
        incorrect: 'نادرست',
        irrelevant: 'نامرتبط',
        incomplete: 'ناقص',
        unsafe: 'ناامن',
        outdated: 'قدیمی',
        poorTone: 'لحن نامناسب',
        other: 'سایر موارد'
      },
      feedbackComment: 'توضیحات تکمیلی (اختیاری)',
      feedbackDialogTitle: 'دلیل مفید نبودن پاسخ را ثبت کنید',
      feedbackFormLabel: 'بازخورد درباره پاسخ هوش مصنوعی',
      feedbackReason: 'دلیل',
      feedbackReasonPlaceholder: 'یک دلیل انتخاب کنید',
      feedbackSubmit: 'ثبت بازخورد',
      feedbackCancel: 'انصراف',
      accessibility: {
        panel: 'بخش دستیار هوش مصنوعی',
        conversationSelector: 'انتخاب گفت‌وگوی دستیار هوش مصنوعی',
        chatInput: 'نوشتن پیام برای دستیار هوش مصنوعی',
        sendMessage: 'ارسال پیام به دستیار هوش مصنوعی'
      },
      run: {
        title: 'روند اجرای درخواست',
        history: 'مشاهده مراحل اجرا',
        connection: {
          connecting: 'در حال اتصال به به‌روزرسانی‌های زنده',
          live: 'به‌روزرسانی‌های زنده برقرار است',
          reconnecting: 'در حال اتصال دوباره به به‌روزرسانی‌های زنده',
          polling: 'به‌روزرسانی دوره‌ای فعال است',
          stale: 'به‌روزرسانی‌های زنده با تاخیر دریافت می‌شود',
          offline: 'اتصال اینترنت برقرار نیست'
        },
        state: {
          queued: 'در صف',
          running: 'در حال اجرا',
          completed: 'تکمیل‌شده',
          blocked: 'مسدودشده',
          failed: 'ناموفق',
          cancelled: 'لغوشده'
        },
        stage: {
          intake: 'آماده‌سازی درخواست',
          context: 'خواندن اطلاعات تیکت',
          retrieval: 'یافتن منابع مرتبط',
          generation: 'نگارش پاسخ',
          validation: 'بررسی پاسخ',
          review: 'بازبینی پاسخ',
          repair: 'اصلاح پاسخ',
          finalization: 'نهایی‌سازی پاسخ',
          persistence: 'ذخیره پاسخ',
          finished: 'پایان‌یافته'
        },
        reviewerStatus: {
          approve: 'بازبینی تایید شد',
          repair: 'بازبینی نیازمند اصلاح است',
          block: 'بازبینی انتشار را مسدود کرد',
          unavailable: 'بازبین در دسترس نیست'
        },
        repairStatus: {
          not_requested: 'اصلاحی درخواست نشده است',
          requested: 'اصلاح درخواست شد',
          completed: 'اصلاح تکمیل شد',
          exhausted: 'حد مجاز اصلاح به پایان رسید'
        },
        blockCategory: {
          content_safety: 'ایمنی محتوا',
          prompt_security: 'امنیت دستور',
          sensitive_data: 'داده حساس',
          grounding: 'بدون پشتوانه در منابع',
          policy: 'پیوند یا قالب‌بندی غیرمجاز',
          human_review: 'نیاز به کارشناس پشتیبانی',
          unknown: 'پیشنهاد قابل‌اتکا نیست'
        },
        failureCategory: {
          provider_unavailable: 'خدمت در دسترس نیست',
          retrieval_unavailable: 'مستندات در دسترس نیست',
          reviewer_unavailable: 'بازبین در دسترس نیست',
          timeout: 'مهلت اجرا به پایان رسید',
          stale_context: 'اطلاعات تیکت هنگام پردازش تغییر کرد',
          permission_changed: 'سطح دسترسی هنگام پردازش تغییر کرد',
          internal: 'خطای پردازش'
        },
        blockRemediation: {
          content_safety: 'محتوای ناامن را از پیش‌نویس حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          prompt_security: 'دستورهای نامطمئن را از تیکت یا پیش‌نویس حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          sensitive_data: 'اطلاعات ورود و داده‌های شخصی غیرضروری را حذف کنید و سپس درخواست تازه‌ای آغاز کنید.',
          grounding: 'منابع را بررسی کنید یا اطلاعات تاییدشده به تیکت بیفزایید و سپس درخواست تازه‌ای آغاز کنید.',
          policy: 'پیشنهاد شامل پیوند، نشانی وب یا قالب‌بندی‌ای بود که نمایش آن مجاز نیست. دوباره امتحان کنید یا پاسخ را خودتان بنویسید و به صفحه مستندات پیوند دهید.',
          human_review:
            'پاسخ هوش مصنوعی در دسترس قرار نگرفت. تیکت را بررسی کنید و پاسخ را در ویرایشگر پاسخ بنویسید. این اجرا قابل تأیید یا ادامه نیست.',
          unknown: 'دستیار نتوانست برای این درخواست پیشنهاد قابل‌اتکایی آماده کند. کار دیگری را انتخاب کنید، درخواست را ساده‌تر کنید یا پاسخ را خودتان بنویسید.'
        },
        failureRemediation: {
          provider_unavailable: 'پس از برقراری خدمت، از گزینه تلاش دوباره استفاده کنید یا درخواست تازه‌ای آغاز کنید.',
          retrieval_unavailable: 'دستیار نتوانست مستندات پشتیبانی را بخواند. پس از دسترسی به منابع دوباره تلاش کنید، یا با استفاده از مستنداتی که بررسی کرده‌اید پاسخ بنویسید.',
          reviewer_unavailable: 'تا برقراری خدمت بازبینی صبر کنید و سپس دوباره تلاش کنید.',
          timeout: 'دامنه درخواست را کاهش دهید و درخواست تازه‌ای آغاز کنید.',
          stale_context: 'تیکت را به‌روزرسانی کنید و بر پایه وضعیت کنونی آن درخواست تازه‌ای آغاز کنید.',
          permission_changed: 'سطح دسترسی را به‌روزرسانی کنید و در صورت نیاز با مدیر پشتیبانی تماس بگیرید.',
          internal: 'اطلاعات تیکت را بررسی کنید و در صورت آمادگی، درخواست تازه‌ای آغاز کنید.'
        },
        availabilityRemediation: {
          ready: 'پیش از ادامه، راهنمای اجرای کنونی را بررسی کنید.',
          safety_stopped: 'تا زمانی که توقف ایمنی فعال است، ایجاد و تلاش دوباره در دسترس نیست.',
          configured_off: 'تا زمانی که دستیار هوش مصنوعی غیرفعال است، ایجاد و تلاش دوباره در دسترس نیست.',
          unavailable: 'تا زمان تأیید آمادگی، ایجاد و تلاش دوباره در دسترس نیست.'
        },
        cancel: 'لغو اجرا',
        retry: 'تلاش دوباره برای اجرا',
        retryUnavailable: 'تلاش دوباره دیگر در دسترس نیست، زیرا درخواست اصلی آن آزاد شده است.',
        retryUnverified: 'پاسخ تلاش دوباره قابل تایید نبود. برای بررسی همان درخواست، دوباره تلاش کنید.',
        retryUnverifiedReleased: 'پاسخ تلاش دوباره قابل تایید نبود. پیش از ادامه، وضعیت فعلی را بررسی کنید.',
        reconnect: 'اتصال دوباره',
        transportDegraded: 'اجرا همچنان فعال است، اما دریافت به‌روزرسانی‌های زنده اختلال دارد.',
        retrievalDegraded: 'برخی منابع پشتیبانی در دسترس نبودند؛ بنابراین این پاسخ ممکن است بر شواهد کمتری از حد معمول تکیه کند.',
        cancelling: 'در حال لغو…',
        blocked: 'این اجرا به‌دلیل کنترل ایمنی یا بازبینی متوقف شد.',
        humanReviewBlocked: 'این تیکت به پاسخ کارشناس پشتیبانی نیاز دارد.',
        failed: 'تکمیل این اجرا ممکن نبود.',
        remediation: 'اطلاعات تیکت را بررسی کنید و در صورت آمادگی، درخواست تازه‌ای آغاز کنید.',
        diagnostics: 'اطلاعات فنی ویژه مدیر',
        technicalDiagnostics: 'اطلاعات فنی',
        diagnosticFields: {
          code: 'کد',
          request_id: 'شناسه درخواست',
          duration_ms: 'مدت‌زمان (میلی‌ثانیه)',
          attempt_count: 'تعداد تلاش‌ها',
          item_count: 'تعداد موارد',
          model_version: 'نسخه مدل',
          prompt_version: 'نسخه دستور',
          policy_version: 'نسخه سیاست',
          retrieval_version: 'نسخه بازیابی',
          reviewer_version: 'نسخه بازبین',
          repair_decision: 'تصمیم اصلاح',
          release_decision: 'تصمیم انتشار',
          attempt_band: 'بازه تلاش',
          count_band: 'بازه تعداد',
          timing_band: 'بازه زمانی',
          outcome: 'نتیجه',
          retryable: 'قابل تلاش دوباره',
          source_kind: 'نوع منبع',
          retrieval_count_band: 'بازه نتایج بازیابی',
          score_band: 'بازه امتیاز',
          reviewer_status: 'وضعیت بازبین',
          repair_status: 'وضعیت اصلاح',
          degraded: 'کاهش کیفیت',
          dense_candidate_count: 'تعداد نامزدهای برداری',
          full_text_candidate_count: 'تعداد نامزدهای متن کامل',
          fused_candidate_count: 'تعداد نامزدهای ادغام‌شده',
          selected_character_count: 'تعداد نویسه‌های انتخاب‌شده'
        },
        sources: 'منابع استفاده‌شده در این اجرا',
        untitledSource: 'منبع بی‌عنوان'
      }
    },

    collaboration: {
      title: 'همکاری کارشناسان',
      internalNoteCollaboration: 'همکاری داخلی',
      internalNoteHelp:
        'از یادداشت داخلی برای درخواست بررسی، واگذاری ادامه کار، افزودن دنبال‌کننده و جلب توجه سایر کارشناسان به این تیکت استفاده کنید.',
      mentionedAgents: 'اشاره به کارشناسان',
      watchers: 'دنبال‌کننده‌ها',
      selectAgents: 'کارشناسانی را برای اطلاع‌رسانی انتخاب کنید',
      selectWatchers: 'کارشناسان دنبال‌کننده این تیکت را انتخاب کنید',
      requestedAction: 'اقدام درخواستی',
      selectAction: 'انتخاب اقدام',
      urgency: 'فوریت',
      dueAt: 'مهلت انجام',
      dueAtPlaceholder: 'YYYY-MM-DD HH:mm یا تاریخ ISO',
      handoff: 'تحویل کار',
      handoffTo: 'تحویل به',
      selectHandoffAgent: 'کارشناس مقصد را انتخاب کنید',
      requiresAcknowledgment: 'کارشناسان اشاره‌شده باید دریافت را تایید کنند',
      requiresAcknowledgmentShort: 'نیازمند تایید',
      needsAttention: 'نیازمند توجه',
      mentionedMe: 'به من اشاره شده',
      watching: 'دنبال می‌کنم',
      handoffToMe: 'به من تحویل شده',
      acknowledge: 'تایید دریافت',
      acknowledged: 'درخواست توجه تایید شد',
      resolve: 'حل شد',
      resolved: 'درخواست توجه حل شد',
      errorAcknowledging: 'تایید درخواست توجه ناموفق بود',
      errorResolving: 'حل درخواست توجه ناموفق بود',
      pendingAttentionCount: '{count} درخواست توجه در انتظار',
      actions: {
        review: 'بررسی',
        continue: 'ادامه تیکت',
        handoff: 'تحویل گرفتن',
        investigate: 'بررسی فنی',
        approve: 'تایید',
        fyi: 'جهت اطلاع'
      },
      urgencies: {
        low: 'کم',
        normal: 'معمولی',
        high: 'زیاد',
        urgent: 'فوری'
      }
    },

    // Replies section
    replies: {
      title: 'پاسخ‌ها',
      add: 'افزودن پاسخ'
    },

    // Attachments section
    attachments: {
      title: 'فایل‌های پیوست',
      scanStatuses: {
        queued: 'در صف اسکن',
        scanning: 'در حال اسکن',
        clean: 'اسکن شد',
        infected: 'مسدود',
        error: 'خطای اسکن'
      },
      scanPendingProcedure: 'دانلود پس از پایان اسکن امنیتی فعال می‌شود.',
      scanErrorProcedure: 'اسکن ناموفق بود. کارشناسان می‌توانند پیش از انتشار دوباره اسکن را اجرا کنند.',
      infectedProcedure: 'این فایل مسدود شده و قابل دانلود نیست.',
      scanFailedSafe: 'این فایل تا زمان بررسی امنیتی موقتا در دسترس نیست.',
      infectedSafe: 'این فایل توسط اسکن امنیتی مسدود شد.',
      retryScan: 'تلاش دوباره',
      retryScanSuccess: 'اسکن فایل دوباره در صف قرار گرفت.',
      retryScanFailed: 'امکان تلاش دوباره برای اسکن فایل وجود ندارد.',
      downloadBlocked: 'این فایل تا زمان تایید اسکن امنیتی قابل دانلود نیست.',
      downloadFailed: 'دانلود این فایل پیوست امکان‌پذیر نیست.',
      preview: 'پیش‌نمایش',
      previewFailed: 'پیش‌نمایش این فایل پیوست امکان‌پذیر نیست.',
      previewUnavailable: 'پیش‌نمایش فقط برای تصاویر، PDF و فایل‌های متنی تاییدشده در دسترس است.',
      previewLoading: 'در حال بارگذاری پیش‌نمایش…',
      previewError: {
        title: 'پیش‌نمایش در دسترس نیست',
        fetch:
          'امکان بارگذاری این فایل برای پیش‌نمایش وجود ندارد. ممکن است مرورگر آن را مسدود کرده باشد یا فایل موقتا در دسترس نباشد. می‌توانید آن را دانلود کنید.',
        mismatch:
          'نوع فایل گزارش‌شده توسط سرور با نوع مورد انتظار برای پیش‌نمایش هم‌خوانی ندارد، بنابراین نمایش آن امن نیست. برای باز کردن فایل، آن را دانلود کنید.',
        render: 'این فایل در پیش‌نمایش قابل نمایش نیست. برای باز کردن با برنامه‌ای دیگر، آن را دانلود کنید.',
        unavailable: 'این فایل در این بخش قابل پیش‌نمایش نیست. برای باز کردن فایل، آن را دانلود کنید.'
      },
      downloadInstead: 'دانلود فایل',
      retryPreview: 'تلاش دوباره',
      pdfPreviewBlockedTitle: 'ممکن است پیش‌نمایش PDF مسدود شده باشد',
      pdfPreviewFallback:
        'تنظیمات مرورگر ممکن است پیش‌نمایش PDF مسدود کند. فایل را دانلود کنید یا اگر مرورگر اجازه می‌دهد آن را در تب جدید باز کنید.',
      previewAlt: 'پیش‌نمایش {fileName}',
      actions: 'عملیات فایل پیوست',
      openInNewTab: 'باز کردن در تب جدید',
      contentTypeMismatch:
        'نوع فایل گزارش‌شده توسط سرور با نوع مورد انتظار برای پیش‌نمایش هم‌خوانی ندارد. پیش‌نمایش مسدود شد.',
      unverifiedSource: 'این فایل توسط کاربر ارسال شده است. با احتیاط پیش‌نمایش کنید و فقط در صورت نیاز دانلود کنید.',
      ready: 'آماده',
      unavailable: 'در دسترس نیست',
      states: {
        ready: 'آماده',
        preparing: 'در حال آماده‌سازی',
        unavailable: 'در دسترس نیست'
      },
      previewTypes: {
        image: 'تصویر',
        pdf: 'PDF',
        text: 'متن',
        file: 'فایل'
      }
    },

    // Knowledge Base
    knowledgeBase: {
      needHelp: 'نیاز به راهنمایی دارید؟',
      title: 'پایگاه دانش',
      articles: 'مقاله',
      popularArticles: 'مقاله‌های پربازدید',
      views: 'بازدید',
      helpful: 'مفید',
      noArticles: 'مقاله‌ای پیدا نشد',
      noArticlesDesc: 'در حال حاضر مقاله‌ای برای نمایش وجود ندارد.',
      noArticlesInCategory: 'هنوز مقاله‌ای در این دسته‌بندی منتشر نشده است.',
      stillNeedHelp: 'هنوز به کمک نیاز دارید؟',
      wasHelpful: 'آیا این مقاله مفید بود؟',
      yes: 'بله',
      no: 'خیر',
      thanksFeedback: 'از بازخورد شما سپاسگزاریم.',
      sorryNotHelpful: 'متاسفیم که این مقاله مفید نبود. برای راهنمایی بیشتر با پشتیبانی تماس بگیرید.',
      searchPlaceholder: 'جستجو در مقاله‌ها...',
      browseByCategory: 'مرور بر اساس دسته‌بندی',
      searchResults: 'نتایج جستجو',
      articleResults: 'مقاله‌های پایگاه دانش',
      documentationResults: 'مستندات',
      readDocs: 'مشاهده مستندات',
      noResults: 'نتیجه‌ای پیدا نشد',
      noResultsDesc: 'هیچ مقاله یا مستندی با جستجوی شما هم‌خوانی نداشت. کلیدواژه‌های دیگری را امتحان کنید.',
      ticketSubjectPrefix: 'پرسش درباره:',
      ticketSubjectFallback: 'درخواست پشتیبانی',
      readingTime: '{minutes} دقیقه مطالعه',
      resultsFor: 'نتایج برای «{query}»',
      resultsCount: '{count} نتیجه',
      publishedOn: 'تاریخ انتشار',
      categories: {
        gettingStarted: {
          name: 'شروع کار',
          description: 'راهنماهای اولیه برای راه‌اندازی و استفاده از AvalAI'
        },
        accountManagement: {
          name: 'مدیریت حساب',
          description: 'مدیریت حساب کاربری و پروفایل شما'
        },
        billingPayments: {
          name: 'صورتحساب و پرداخت',
          description: 'صورتحساب، فاکتورها و اطلاعات پرداخت'
        },
        technicalSupport: {
          name: 'پشتیبانی فنی',
          description: 'عیب‌یابی مشکلات فنی و دسترسی به سرویس'
        },
        featuresTips: {
          name: 'نکات و قابلیت‌ها',
          description: 'نکات کاربردی برای استفاده بهتر از قابلیت‌های پلتفرم'
        },
        apiDocumentation: {
          name: 'مستندات API',
          description: 'راهنماهای توسعه‌دهنده، مرجع API و کمک برای یکپارچه‌سازی'
        },
        troubleshooting: {
          name: 'عیب‌یابی',
          description: 'راهنمای مرحله‌به‌مرحله برای حل مشکلات رایج'
        },
        featureGuides: {
          name: 'راهنمای قابلیت‌ها',
          description: 'راهنماهایی برای یادگیری و استفاده از قابلیت‌های محصول'
        }
      }
    },

    // File upload
    fileUpload: {
      selectFiles: 'انتخاب فایل‌ها',
      uploadFiles: 'آپلود فایل‌ها',
      uploading: 'در حال آپلود...',
      uploadComplete: 'آپلود کامل شد',
      uploadFailed: 'آپلود ناموفق',
      removeFile: 'حذف فایل',
      removeFileNamed: 'حذف {fileName}',
      fileCount: '{current} از {max} فایل',
      fileSize: 'اندازه فایل',
      fileName: 'نام فایل',
      units: {
        bytes: 'بایت',
        kilobytes: 'کیلوبایت',
        megabytes: 'مگابایت',
        gigabytes: 'گیگابایت'
      },
      errors: {
        fileTooLarge: 'فایل بیش از حد بزرگ است. حداکثر اندازه {maxSize} است',
        invalidFileType: 'نوع فایل نامعتبر است',
        fileAlreadyAdded: 'فایل قبلا اضافه شده است'
      },
      messages: {
        uploadSuccess: '{count} فایل با موفقیت آپلود شد',
        uploadFailed: '{count} فایل آپلود نشد',
        uploadError: 'خطا در آپلود فایل'
      }
    },

    // Polling
    polling: {
      updatesUnavailable: 'به‌روزرسانی گفتگو ناموفق بود؛ پیام‌های دریافت‌شده همچنان نمایش داده می‌شوند.',
      maxRetriesExceeded: 'حداکثر تعداد تلاش مجدد به پایان رسید. نظرسنجی متوقف شد.',
      fetchError: 'خطا در دریافت داده‌ها',
      tooManyRequests: 'تعداد درخواست بیش از حد مجاز',
      tooManyRequestsDesc: 'تعداد درخواست‌ها از حد مجاز فراتر است، لطفا پس از چند لحظه دوباره تلاش کنید.'
    },

    // Errors
    errors: {
      partialLoadTitle: 'بخشی از داده‌های پشتیبانی بارگذاری نشد',
      partialLoadDescription:
        'بخشی از داده‌های پشتیبانی موقتا در دسترس نیست. همچنان می‌توانید تیکت بسازید، تیکت‌های موجود را ببینید یا دوباره تلاش کنید.',
      networkError: 'خطای شبکه',
      permissionError: 'عدم دسترسی',
      notFoundError: 'یافت نشد',
      genericError: 'خطایی رخ داده است',
      timeoutError: 'زمان درخواست تمام شد',
      serverError: 'خطای سرور',
      maintenanceError: 'در حال تعمیر و نگهداری',
      networkErrorDesc: 'عدم اتصال به سرور. لطفا اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.',
      permissionErrorDesc: 'شما مجوز دسترسی به این منبع را ندارید. لطفا با مدیر سیستم تماس بگیرید.',
      notFoundErrorDesc: 'منبع درخواستی یافت نشد.',
      genericErrorDesc: 'خطایی در بارگذاری داده‌ها رخ داده است. لطفا دوباره تلاش کنید.',
      timeoutErrorDesc: 'درخواست بیش از حد طول کشید. لطفا دوباره تلاش کنید.',
      serverErrorDesc:
        'سرور با خطا مواجه شد (502). لطفا بعدا دوباره تلاش کنید یا در صورت ادامه مشکل با پشتیبانی تماس بگیرید.',
      maintenanceErrorDesc: 'سیستم در حال تعمیر و نگهداری است. لطفا بعدا دوباره تلاش کنید.',
      withErrorCode: '{message} (خطا: {code})',
      tryAgain: 'تلاش دوباره',
      contactSupport: 'تماس با پشتیبانی'
    },

    // Auth required
    authRequired: {
      title: 'احراز هویت لازم است',
      description: 'لطفا وارد شوید تا بتوانید به سیستم پشتیبانی دسترسی داشته باشید و تیکت‌هایتان را مدیریت کنید.',
      loginButton: 'ورود'
    },

    // Empty states
    emptyStates: {
      noTickets: {
        title: 'تیکت یافت نشد',
        description: 'اولین تیکت پشتیبانی خود را ایجاد کنید.',
        action: 'ایجاد تیکت'
      },
      noReplies: {
        title: 'هنوز پاسخی نیست',
        description: 'اولین نفری باشید که به این تیکت پاسخ می‌دهد.'
      },
      noAttachments: {
        title: 'فایل پیوستی نیست',
        description: 'هیچ فایلی به این تیکت پیوست نشده است.'
      },
      noSearchResults: {
        description: 'سعی کنید عبارت جستجو یا فیلترهای خود را تغییر دهید.'
      },
      noData: {
        description: 'داده‌ای در دسترس نیست.'
      }
    },

    // Validation
    validation: {
      subjectRequired: 'موضوع ضروری است',
      descriptionRequired: 'توضیحات ضروری است',
      categoryRequired: 'لطفا دسته‌بندی را انتخاب کنید',
      priorityRequired: 'لطفا اولویت را انتخاب کنید',
      fileTooBig: 'فایل {fileName} بیش از حد بزرگ است. حداکثر اندازه {size}MB',
      tooManyFiles: 'تعداد فایل‌ها زیاد است. حداکثر {max} فایل',
      invalidFileType: 'فایل {fileName} نوع نامعتبری دارد. انواع مجاز: {allowedTypes}',
      maxFilesExceeded: 'تعداد فایل‌ها از حد مجاز بیشتر است',
      formErrors: 'لطفا خطاهای فرم را قبل از ارسال رفع کنید',
      replyRequired: 'محتوای پاسخ ضروری است',
      // Dynamic field validation
      fieldRequired: 'فیلد {field} ضروری است',
      invalidCardNumber: 'شماره کارت نامعتبر است',
      invalidIBAN: 'شماره شبا نامعتبر است',
      invalidNumber: 'عدد وارد شده نامعتبر است',
      numberTooSmall: 'عدد باید حداقل {min} باشد',
      numberTooLarge: 'عدد نباید بیش از {max} باشد',
      invalidDate: 'تاریخ وارد شده نامعتبر است',
      invalidEmail: 'آدرس ایمیل نامعتبر است',
      textTooShort: 'متن باید حداقل {min} کاراکتر باشد',
      textTooLong: 'متن نباید بیش از {max} کاراکتر باشد',
      invalidFormat: 'فرمت وارد شده نامعتبر است',
      invalidOption: 'گزینه انتخاب شده نامعتبر است',
      addressRequired: 'انتخاب آدرس الزامی است',
      invalidAddress: 'آدرس انتخاب شده نامعتبر است',
      backendFieldInvalid: 'لطفا فیلد {field} را بررسی کنید و دوباره تلاش کنید'
    },

    address: {
      type: 'نوع آدرس',
      city: 'شهر',
      companyName: 'نام شرکت',
      fullAddress: 'آدرس کامل',
      types: {
        individual: 'شخص حقیقی',
        company: 'شرکت',
        home: 'خانه',
        business: 'کسب‌وکار',
        other: 'سایر'
      }
    },

    addresses: {
      nationalId: "کد ملی یا شناسه ملی",
      economicCode: "کد اقتصادی",
      registrationNumber: "شماره ثبت",
      vatPersonalHint: "برای صورتحساب رسمی، نام و نام خانوادگی کامل و کد ملی معتبر ۱۰ رقمی را وارد کنید.",
      vatCompanyHint: "برای صورتحساب رسمی، نام ثبت‌شده شرکت، شناسه ملی ۱۱ رقمی، کد اقتصادی و شماره ثبت را وارد کنید.",
      vatOptionalHint: "اطلاعات هویتی مالیاتی برای نشانی عادی اختیاری است. بررسی نهایی هنگام درخواست صورتحساب رسمی انجام می‌شود.",
      selectAddress: 'انتخاب آدرس',
      createAddress: 'ایجاد آدرس',
      createAddressTitle: 'ایجاد آدرس صورتحساب',
      createAddressDescription: 'یک آدرس صورتحساب برای این تیکت ذخیره کنید.',
      addressLabel: 'عنوان آدرس',
      addressLabelPlaceholder: 'آدرس اصلی صورتحساب',
      companyName: 'نام شرکت',
      fullAddress: 'آدرس کامل',
      city: 'شهر',
      state: 'استان',
      province: 'استان',
      chooseProvince: 'استان را انتخاب کنید',
      cityPlaceholder: 'شهر را انتخاب یا وارد کنید',
      fullAddressPlaceholder: 'خیابان، کوچه، پلاک، واحد',
      selectedFullAddress: 'آدرس کامل انتخاب‌ شده',
      quickSelect: 'انتخاب سریع',
      countryIran: 'ایران',
      postalCode: 'کد پستی',
      postalCodePlaceholder: '۱۰ رقم بدون خط تیره',
      postalCodeHint: 'کد پستی باید ۱۰ رقم باشد',
      country: 'کشور',
      phoneNumber: 'شماره تماس',
      emailAddress: 'ایمیل',
      defaultAddress: 'پیش‌فرض',
      setAsDefault: 'تنظیم به‌عنوان آدرس پیش‌فرض',
      defaultAddressHint: 'این آدرس جایگزین آدرس پیش‌فرض فعلی شما می‌شود.',
      defaultAddressLockedHint: 'اولین آدرس همیشه پیش‌فرض است. برای جایگزینی، آدرس دیگری را پیش‌فرض کنید.',
      saveAddress: 'ذخیره آدرس',
      addNewAddress: 'افزودن آدرس جدید',
      editAddress: 'ویرایش آدرس',
      editAddressDescription: 'آدرس انتخاب‌شده را برای این تیکت به‌روزرسانی کنید.',
      updateAddress: 'به‌روزرسانی آدرس',
      updateSuccess: 'آدرس به‌روزرسانی شد',
      updateFailed: 'به‌روزرسانی آدرس ناموفق بود',
      createSuccess: 'آدرس ذخیره شد',
      createFailed: 'ذخیره آدرس ناموفق بود',
      noAddresses: 'آدرسی یافت نشد',
      noAddressesDescription: 'قبل از ارسال تیکت‌های مربوط به فاکتور، یک آدرس صورتحساب ایجاد کنید.',
      types: {
        individual: 'شخص حقیقی',
        company: 'شرکت',
        home: 'خانه',
        business: 'کسب‌وکار',
        other: 'سایر'
      }
    },

    // Help section
    help: {
      beforeCreating: 'قبل از ایجاد تیکت',
      searchKnowledge: 'برای پاسخ سریع به سوالات رایج، پایگاه دانش ما را جستجو کنید.',
      tips: 'نکاتی برای پشتیبانی بهتر',
      tip1: 'در مورد مسئله خود دقیق باشید و جزئیات مربوطه را شامل کنید',
      tip2: 'تصاویر یا فایل‌هایی که به توضیح مسئله کمک می‌کنند، پیوست کنید',
      tip3: 'دسته‌بندی و اولویت صحیح را برای حل سریع‌تر انتخاب کنید',
      urgentIssues: 'مسائل فوری',
      urgentContact: 'برای مسائل بحرانی که نیاز به توجه فوری دارند، مستقیما با تیم پشتیبانی ما تماس بگیرید.',
      contactSupport: 'تماس با پشتیبانی'
    },

    // Stats for agent dashboard
    stats: {
      total: 'کل',
      unassigned: 'بدون مسئول',
      assignedToMe: 'اختصاص داده شده به من',
      open: 'باز',
      inProgress: 'در حال بررسی',
      overdue: 'عقب‌افتاده',
      unseen: 'دیده‌نشده',
      openTickets: 'تیکت‌های باز',
      resolutionRate: 'نرخ حل تیکت',
      filtersAria: 'فیلترهای آماری تیکت‌ها',
      aria: {
        total: '{count} تیکت در کل. نمایش همه تیکت‌ها',
        unassigned: '{count} تیکت بدون مسئول. فیلتر تیکت‌های بدون مسئول',
        assignedToMe: '{count} تیکت اختصاص داده شده به من. فیلتر تیکت‌های من',
        open: '{count} تیکت باز. فیلتر تیکت‌های باز',
        inProgress: '{count} تیکت در حال بررسی',
        overdue: '{count} تیکت عقب‌افتاده. فیلتر تیکت‌های عقب‌افتاده',
        unseen: '{count} تیکت در این صفحه که هنوز توسط هیچ پشتیبانی دیده نشده است. فیلتر تیکت‌های دیده‌نشده'
      }
    },

    // Agent Dashboard
    agentDashboard: {
      title: 'داشبورد پشتیبان',
      viewAllTickets: 'مشاهده همه تیکت‌ها',
      myQueue: 'صف من',
      unassignedQueue: 'صف بدون مسئول',
      ticketsNeedingAttention: 'تیکت‌های نیازمند توجه',
      responseQueue: 'صف پاسخ‌گویی',
      responseQueueHint: 'مشتریان را بر اساس وضعیت پاسخ و مدت انتظار اولویت‌بندی کنید.',
      openOldestFirst: 'نمایش قدیمی‌ترین انتظارها'
    },

    // Role labels
    roles: {
      agent: 'پشتیبان',
      admin: 'مدیر',
      user: 'کاربر'
    },

    // Access denied
    accessDenied: {
      title: 'دسترسی غیرمجاز',
      agentRequired: 'برای دسترسی به این صفحه نیاز به دسترسی پشتیبان یا مدیر دارید.'
    },

    // All Tickets view
    allTickets: 'همه تیکت‌ها',

    // Agent actions
    agentActions: {
      title: 'عملیات پشتیبان',
      noAgentsAvailable: 'پشتیبانی در دسترس نیست',
      assignToMe: 'اختصاص به من',
      unassign: 'لغو اختصاص'
    },

    // Bulk Actions
    bulkActions: {
      selectedCount: '{count} تیکت انتخاب شده',
      changeStatus: 'تغییر وضعیت',
      changePriority: 'تغییر اولویت',
      assign: 'اختصاص',
      unassign: 'لغو اختصاص',
      clearSelection: 'پاک کردن انتخاب',
      statusChangeSuccess: 'وضعیت {count} تیکت با موفقیت به‌روزرسانی شد',
      statusChangeFailed: 'خطا در به‌روزرسانی وضعیت تیکت‌ها',
      priorityChangeSuccess: 'اولویت {count} تیکت با موفقیت به‌روزرسانی شد',
      priorityChangeFailed: 'خطا در به‌روزرسانی اولویت تیکت‌ها',
      assignSuccess: '{count} تیکت با موفقیت اختصاص داده شد',
      unassignSuccess: 'اختصاص {count} تیکت با موفقیت لغو شد',
      assignFailed: 'خطا در اختصاص تیکت‌ها',
      // Loading messages
      updatingStatus: 'در حال به‌روزرسانی وضعیت تیکت...',
      updatingPriority: 'در حال به‌روزرسانی اولویت تیکت...',
      updatingAssignment: 'در حال به‌روزرسانی اختصاص تیکت...',
      processing: 'در حال پردازش...',
      selectTickets: 'عملیات جمعی',
      cancelSelect: 'لغو'
    },

    // Activity Timeline
    activity: {
      title: 'تاریخچه فعالیت‌ها',
      noActivity: 'هنوز فعالیتی ثبت نشده است',
      loadMore: 'بارگذاری بیشتر',
      loadFailedTitle: 'فعالیت‌ها بارگذاری نشدند',
      loadFailed: 'دوباره فعالیت‌ها را بارگذاری کنید.',
      refreshFailed: 'به‌روزرسانی فعالیت‌ها انجام نشد؛ فعالیت‌های قبلی نمایش داده می‌شوند.',
      loadMoreFailed: 'فعالیت‌های بیشتر بارگذاری نشدند؛ فعالیت‌های قبلی نمایش داده می‌شوند.',
      refreshing: 'در حال به‌روزرسانی فعالیت‌ها…',
      loadingMore: 'در حال بارگذاری فعالیت‌های بیشتر…',
      internal: 'داخلی',
      by: 'توسط',
      botUser: 'بات',
      systemUser: 'سیستم',
      types: {
        created: 'ایجاد شد',
        status_changed: 'وضعیت تغییر کرد',
        priority_changed: 'اولویت تغییر کرد',
        assigned: 'اختصاص داده شد',
        unassigned: 'لغو اختصاص شد',
        reply_added: 'پاسخ اضافه شد',
        internal_note: 'یادداشت داخلی',
        internal_note_added: 'یادداشت داخلی اضافه شد',
        attachment_added: 'فایل پیوست شد',
        reopened: 'بازگشایی شد',
        sla_breached: 'SLA نقض شد',
        escalated: 'تشدید شد',
        merged: 'ادغام شد',
        split: 'تقسیم شد',
        category_changed: 'دسته‌بندی تغییر کرد',
        custom_field_updated: 'فیلد سفارشی به‌روزرسانی شد'
      },
      messages: {
        created: 'تیکت ایجاد شد',
        status_changed: 'وضعیت از {oldValue} به {newValue} تغییر کرد',
        priority_changed: 'اولویت از {oldValue} به {newValue} تغییر کرد',
        assigned: 'تیکت اختصاص داده شد',
        unassigned: 'اختصاص تیکت لغو شد',
        reply_added: 'پاسخ اضافه شد',
        internal_note: 'یادداشت داخلی اضافه شد',
        attachment_added: 'فایل پیوست شد',
        reopened: 'تیکت بازگشایی شد',
        sla_breached: 'SLA نقض شد'
      },
      aiEvents: {
        ai_draft_created: {
          type: 'پیش‌نویس هوش مصنوعی',
          message: 'پیش‌نویس هوش مصنوعی آماده بررسی کارشناس است'
        },
        ai_reply_approved: {
          type: 'پاسخ هوش مصنوعی تأیید شد',
          message: 'کارشناس پاسخ هوش مصنوعی را تأیید و ارسال کرد'
        },
        ai_enrollment_declined: {
          type: 'پاسخ خودکار آغاز نشد',
          message: 'پاسخ خودکار آغاز نشد؛ این تیکت به پاسخ کارشناس نیاز دارد'
        }
      }
    },

    // Export
    export: {
      title: 'خروجی گرفتن از تیکت‌ها',
      button: 'خروجی',
      format: 'فرمت',
      csv: 'CSV',
      excel: 'اکسل',
      exporting: 'در حال خروجی گرفتن...',
      success: 'تیکت‌ها با موفقیت خروجی گرفته شد',
      failed: 'خطا در خروجی گرفتن از تیکت‌ها',
      noTickets: 'تیکتی برای خروجی وجود ندارد',
      json: 'JSON'
    },

    // Notification Preferences
    notifications: {
      title: 'تنظیمات اعلان‌ها',
      settings: 'تنظیمات اعلان‌ها',
      loadErrorTitle: 'خطا در بارگذاری تنظیمات',
      loadError: 'بارگذاری تنظیمات اعلان‌ها با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      saveSuccess: 'تنظیمات اعلان‌ها با موفقیت ذخیره شد',
      saveError: 'خطا در ذخیره تنظیمات اعلان‌ها',
      resetSuccess: 'تنظیمات اعلان‌ها به حالت پیش‌فرض بازگردانده شد',
      resetError: 'خطا در بازنشانی تنظیمات اعلان‌ها',
      enabledAll: 'همه اعلان‌ها فعال شد',
      disabledAll: 'همه اعلان‌ها غیرفعال شد',
      toggleError: 'خطا در تغییر وضعیت اعلان‌ها',
      enableAll: 'فعال کردن همه اعلان‌های ایمیل',
      enableAllDesc: 'تغییر وضعیت همه تنظیمات اعلان ایمیل به یکباره',
      quickToggleDesc: 'همه انواع اعلان ایمیلی را سریع فعال یا غیرفعال کنید.',
      toggleAll: 'تغییر وضعیت همه اعلان‌های ایمیلی',
      ticketUpdates: 'به‌روزرسانی‌های تیکت',
      slaAlerts: 'هشدارهای SLA و تشدید',
      important: 'مهم',
      critical: 'بحرانی',
      emailNotifications: 'اعلان‌های ایمیل',
      newTicket: 'تیکت جدید',
      newTicketDesc: 'هنگام ایجاد تیکت جدید ایمیل دریافت کنید',
      ticketAssigned: 'اختصاص تیکت',
      ticketAssignedDesc: 'هنگام اختصاص تیکت به شما ایمیل دریافت کنید',
      ticketReply: 'پاسخ تیکت',
      ticketReplyDesc: 'هنگام پاسخ دادن به تیکت شما ایمیل دریافت کنید',
      statusChange: 'تغییر وضعیت',
      statusChangeDesc: 'هنگام تغییر وضعیت تیکت ایمیل دریافت کنید',
      escalation: 'تشدید',
      escalationDesc: 'هنگام تشدید تیکت ایمیل دریافت کنید',
      slaWarning: 'هشدار SLA',
      slaWarningDesc: 'هنگام نزدیک شدن موعد SLA تیکت ایمیل دریافت کنید',
      slaBreach: 'نقض SLA',
      slaBreachDesc: 'هنگام نقض SLA تیکت ایمیل دریافت کنید',
      emailDigest: 'خلاصه ایمیل',
      digestFrequencyLabel: 'دوره ارسال خلاصه',
      digestFrequencyDesc: 'خلاصه فعالیت تیکت‌ها را دریافت کنید',
      selectFrequency: 'انتخاب دوره',
      digestFrequency: {
        none: 'هیچ',
        daily: 'روزانه',
        weekly: 'هفتگی'
      },
      inAppNotifications: 'اعلان‌های درون‌برنامه‌ای',
      enableInApp: 'فعال کردن اعلان‌های درون‌برنامه‌ای',
      enableInAppDesc: 'نمایش اعلان‌ها در داخل برنامه',
      resetDefaults: 'بازنشانی به پیش‌فرض',
      resetConfirmMessage: 'آیا مطمئن هستید که می‌خواهید همه تنظیمات اعلان را به پیش‌فرض بازنشانی کنید؟',
      saveChanges: 'ذخیره تغییرات'
    },

    // Time formatting
    listPage: {
      tagline: 'همه تیکت‌هایی که ثبت کرده‌اید، با وضعیت و آخرین پاسخ هر یک.',
      taglineAgent: 'تیکت‌هایی که به شما اختصاص داده شده‌اند، با وضعیت و آخرین پاسخ هر یک.',
      updatedAt: 'آخرین به‌روزرسانی',
      backToList: 'بازگشت به تیکت‌های من',
      createdNotice: 'تیکت {number} ثبت شد.',
      createdPending: 'چند لحظه دیگر در فهرست نمایش داده می‌شود.',
      createdInList: 'در فهرست زیر مشخص شده است.',
      openCreated: 'باز کردن تیکت',
      allPriorities: 'همه اولویت‌ها',
      activeFiltersLabel: 'فیلترهای فعال:',
      chip: '{label}: {value}',
      removeFilter: 'حذف فیلتر {label}',
      viewLabel: 'نمایش',
      resultsCount: '{count} تیکت',
      pageSummary: 'نمایش {from} تا {to} از {total} تیکت',
      perPage: '{count} در هر صفحه'
    },
    time: {
      justNow: 'همین الان',
      minutesAgo: '{count} دقیقه پیش',
      hoursAgo: '{count} ساعت پیش',
      daysAgo: '{count} روز پیش',
      weeksAgo: '{count} هفته پیش',
      monthsAgo: '{count} ماه پیش'
    }
  },
  models: {
    catalogPage: {
      tagline: 'همه مدل‌های پلتفرم را با نام، ارائه‌دهنده و قابلیت جست‌وجو کنید و جزئیات هر مدل را ببینید.',
      updatedAt: 'آخرین به‌روزرسانی',
      loading: 'در حال دریافت فهرست مدل‌ها',
      loadFailed: 'دریافت فهرست مدل‌ها انجام نشد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ فهرست قبلی نمایش داده می‌شود.',
      searchLabel: 'جست‌وجو',
      filtersLabel: 'فیلترها',
      showFilters: 'فیلترهای بیشتر',
      hideFilters: 'کمتر',
      anyOption: 'همه',
      filterCategory: 'دسته',
      filterProvider: 'ارائه‌دهنده',
      filterOwner: 'صاحب امتیاز',
      filterCapabilities: 'قابلیت‌ها',
      filterEndpoints: 'نقاط پایانی',
      filterTiers: 'سطح دسترسی',
      filterServiceTiers: 'سطح سرویس',
      priceRangeLabel: 'نرخ ورودی (واحد اعتبار به ازای هر یک میلیون توکن)',
      priceRangeValue: '{from} تا {to}',
      priceRangeOpenEnd: '{value} و بیشتر',
      onlyAccessible: 'فقط مدل‌های در دسترس من',
      resultsSummary: '{count} مدل',
      resultsFiltered: '{count} از {total} مدل',
      activeFilters: '{count} فیلتر فعال',
      sortLabel: 'مرتب‌سازی',
      sortAscending: 'صعودی',
      sortDescending: 'نزولی',
      viewLabel: 'نمایش',
      viewGrid: 'شبکه‌ای',
      viewList: 'فهرستی',
      viewCompact: 'فشرده',
      emptyTitle: 'مدلی با این فیلترها پیدا نشد.',
      emptyHint: 'عبارت جست‌وجو یا فیلترها را تغییر دهید.',
      openDetails: 'جزئیات مدل {name}',
      categoryCount: '{count} مدل',
      accessibleHint: 'در سطح دسترسی فعلی شما در دسترس است.',
      restrictedHint: 'برای این مدل به سطح دسترسی بالاتری نیاز دارید.',
      activeFiltersLabel: 'فیلترهای فعال:',
      tagSearch: 'جست‌وجو: {query}',
      tagPrice: 'نرخ: {from} تا {to}',
      tagOnlyAccessible: 'فقط در دسترس',
      tagSort: 'ترتیب: {sort} ({order})',
      clearAll: 'پاک کردن همه',
      removeFilter: 'حذف فیلتر {label}',
      capVision: 'بینایی',
      capFunctions: 'فراخوانی تابع',
      capAudio: 'صوت',
      capWebSearch: 'جست‌وجوی وب',
      capText: 'متن',
      capReasoning: 'استدلال',
      capSpeed: 'سرعت',
      title: 'مدل‌ها'
    },
    name: 'نام',
    provider: 'ارائه‌دهنده',
    tier: 'سطح',
    maxTokens: 'ظرفیت توکن',
    price: 'نرخ',
    costoptimizedModels: 'مدل‌های بهینه‌سازی شده از نظر هزینه',
    costoptimizedModelsDes: 'مدل‌های کوچک‌تر و سریع‌تر با هزینه اجرای کمتر',
    flagshipModels: 'مدل‌های پرچمدار',
    flagshipModelsDes: 'مدل‌های پرچمدار با عملکرد بالا و چندمنظوره',
    imageGeneration: 'تولید تصویر',
    imageGenerationDes: 'مدل‌هایی که از توضیحات متنی، تصاویر تولید می‌کنند',
    reasoningModels: 'مدل‌های استدلالی',
    reasoningModelsDes: 'مدل‌های پیشرفته‌ای که در وظایف پیچیده و چندمرحله‌ای عملکرد عالی دارند',
    embeddingModels: 'مدل‌های امبدینگ',
    embeddingModelsDes: 'مدل‌هایی که متن را به بردارهای امبدینگ تبدیل می‌کنند',
    stt: 'تبدیل گفتار به متن',
    sttDes: 'مدل‌هایی که گفتار را به متن تبدیل می‌کنند',
    tts: 'تبدیل متن به گفتار',
    ttsDes: 'مدل‌هایی که متن را به گفتار با صدای طبیعی تبدیل می‌کنند',
    visionModels: 'مدل‌های بینایی',
    visionModelsDes: 'مدل‌هایی که می‌توانند تصاویر را تحلیل و درک کنند',
    chatModels: 'مدل‌های گفت‌وگو',
    chatModelsDes: 'مدل‌های هوش مصنوعی گفت‌وگوی همه‌منظوره',
    multimodalModels: 'مدل‌های چندوجهی',
    multimodalModelsDes: 'مدل‌هایی که از انواع ورودی/خروجی (متن، تصویر، صدا، ویدیو) پشتیبانی می‌کنند',
    moderationModels: 'مدل‌های نظارتی',
    moderationModelsDes: 'مدل‌هایی که محتوای مضر یا نامناسب را شناسایی و فیلتر می‌کنند',
    codeModels: 'مدل‌های برنامه‌نویسی',
    codeModelsDes: 'مدل‌های تخصصی در تولید، تحلیل و تکمیل کد',
    noRateLimitReceived: 'داده‌ای برای محدودیت نرخ دریافت نشد',
    loadingModels: 'در حال بارگذاری مدل‌ها',
    featuredModels: 'مدل‌های ویژه',
    modelsFound: 'مدل یافت شد',
    searchByModel: 'جست‌وجوی مدل بر اساس نام، ارائه‌دهنده یا قابلیت',
    searchByModelDes: 'برترین مدل‌های موجود',
    filterModels: 'فیلتر مدل‌ها',
    quickFilters: 'فیلترهای سریع',
    myAccessibleModels: 'مدل‌های قابل دسترس من',
    accessibleModelsDes: 'مدل‌هایی که در سطح دسترسی من هستند',
    visionModelsTxt: 'مدل‌های بینایی',
    visionModelsDes2: 'مدل‌ها با قابلیت‌های تصویری',
    reasoningModelsTxt: 'مدل‌های استدلالی',
    reasoningModelsDes2: 'قابلیت‌های استدلال پیشرفته',
    costEffective: 'مقرون‌به‌صرفه',
    costEffectiveDes: 'گزینه‌های ارزان‌تر',
    providers: 'ارائه‌دهندگان',
    selectProviders: 'انتخاب ارائه‌دهندگان',
    capabilities: 'قابلیت‌ها',
    showMore: 'نمایش بیشتر',
    showLess: 'نمایش کمتر',
    more: 'بیشتر',
    selectCapabilities: 'انتخاب قابلیت‌ها',
    accessTiers: 'سطوح دسترسی',
    selectTiers: 'انتخاب سطوح',
    priceRange: 'محدوده قیمت (به ازای ۱ میلیون توکن)',
    sortBy: 'مرتب‌سازی بر اساس',
    newest: 'جدیدترین',
    new: 'جدید',
    onlyAccessible: 'فقط نمایش مدل‌های قابل دسترس من',
    of: 'از',
    models: 'مدل',
    filter: 'فیلتر',
    filters: 'فیلترها',
    active: 'فعال',
    applyFiltersClose: 'اعمال فیلترها و بستن',
    providersPlaceholder: 'ارائه‌دهندگان',
    capabilitiesPlaceholder: 'قابلیت‌ها',
    tiersPlaceholder: 'سطوح',
    categoryPlaceholder: 'دسته‌بندی',
    allCategories: 'همه دسته‌بندی‌ها',
    tierLabel: 'سطح {0}',
    clearFilters: 'پاک کردن فیلترها',
    categoryModelsCount: 'مدل',
    noModelsFound: 'هیچ مدلی یافت نشد',
    filtersActive: 'فیلتر فعال'
  },
  tooltip: {
    tpm: 'مقدار دسترسی توکن در دقیقه (TPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.',
    rpm: 'درخواست در دقیقه (RPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.',
    negativeBalance: 'موجودی منفی',
    negativeBalanceExplanation:
      'موجودی کیف پول شما منفی است، دلیل آن درخواست‌های موازی در تعداد بالا است زمانی که اعتبار باقی مانده نزدیک به صفر بوده.',
    negativeTotalBalance: 'جزئیات موجودی منفی',
    currentBalance: 'موجودی فعلی',
    pendingCharges: 'هزینه‌های بلاتکلیف',
    rechargeAdvice: 'جهت استفاده از خدمات لطفا موجودی حساب را شارژ نمایید.',
    remainingIRT: 'اعتبار تومانی. این مبلغ با نرخ روز در مجموع شما حساب می‌شود و درخواست‌ها می‌توانند مستقیم از آن برداشت کنند.',
    remainingUNIT: 'اعتبار واحدی، وابسته به تتر (USDT). این اعتباری است که به واحد خریده یا تبدیل کرده‌اید، نه معادلِ تبدیل‌شده موجودی تومانی.',
    imagePricingAlert:
      'محاسبه هزینه در مدل‌های تولید تصویر بر اساس نوع مدل، اندازه تصویر، کیفیت، و تعداد گام‌ها (در صورت پشتیبانی مدل از این قابلیت) انجام می‌شود. بنابراین، نرخ اعلام‌شده برای هر تصویر، یک نرخ متوسط تلقی می‌گردد. به جز مدل gpt-image-1، سایر مدل‌ها نرخ خروجی توکن ندارند و این مقدار صرفا جهت سازگاری با سیستم تخصیص داده می‌شود. به عنوان مثال، در فراخوانی مدل dall-e-3 با کیفیت HD و اندازه ۱۰۲۴ در ۱۰۲۴، مقدار توکن مصرفی ۱۰۰۰ در نظر گرفته می‌شود که با نرخ ۴۰ واحد به ازای هر یک میلیون توکن، معادل ۰.۰۴ واحد محاسبه خواهد شد. این مقدار در واقع نرخ پایه خروجی تصویر و معادل ۰.۰۴ واحد به ازای هر تصویر است.',
    remainingInUNIT:
      'کل کیف پول شما بر حسب واحد: اعتبار واحدی به‌علاوه اعتبار تومانی که با نرخ روز به واحد تبدیل شده است. هزینه درخواست‌ها بر حسب واحد از این مجموع کسر می‌شود؛ پس همین عدد تعیین می‌کند درخواست پذیرفته شود یا نه.',
    aboveTokensPricing:
      'هنگامی که مجموع توکن‌ها بالاتر از مقدار مشخص شده باشد، مبنای نرخ بر این اساس محاسبه می شود، در مواردی که مجموع توکن‌ها کمتر از این مقدار است، نرخ پایه مبنای محاسبه است، جهت کسب اطلاعات بیشتر به مستندات ارائه دهنده مراجعه نمایید.',
    endpointMightNotAvailable:
      'برخی از نقاط پایانی ممکن است در حال حاضر در AvalAI در دسترس نباشند. لطفا برای اطلاعات بیشتر به مستندات مراجعه کنید.',
    remainingCreditInIrtEquivalent:
      'مجموع اعتبار کیف پول شما به تومان. این موجودی شامل باقی مانده تومانی به علاوه باقی مانده «واحد» ضرب در نرخ لحظه‌‌ای است. به دلیل اینکه نرخ گذاری بسته‌های اعتباری بر اساس تومان است، درصورتی که موجودی کیف پول شما، دارای موجودی ارزی بر حسب «واحد» باشد، معادل آن به تومان بر اساس نرخ لحظه‌ای محاسبه می گردد.'
  },
  limits: {
    upgradeModal: {
      currentLabel: 'سطح فعلی',
      rateUnavailable: 'نرخ تبدیل هنوز دریافت نشده است؛ کمی بعد دوباره تلاش کنید.',
      openLabel: 'سطح دسترسی و ارتقا',
      ladderLabel: 'نردبان سطوح دسترسی',
      stepEmail: 'تایید ایمیل',
      stepPhone: 'تایید شماره تلفن',
      stepUnits: 'مجموع شارژ {units} واحد اعتبار',
      progressCaption: '{paid} از {required} واحد اعتبار برای {tier}',
      needMore: '{remaining} واحد اعتبار دیگر لازم است.',
      amountMet: 'شرط مبلغ {tier} برآورده شده است؛ شرط‌های دیگر آن را در فهرست زیر ببینید.',
      phoneTitle: 'تایید شماره تلفن',
      paidTitle: 'ارتقا با شارژ حساب',
      paidHint: 'مجموع شارژ حساب معیار سطح ۲ و بالاتر است. مبلغ به اعتبار شما اضافه می‌شود و ارتقا اعتباری مصرف نمی‌کند.',
      targetLabel: 'سطح هدف',
      targetOption: '{tier} · مجموع شارژ {units} واحد اعتبار',
      targetSelected: 'سطح انتخابی',
      targetNext: 'سطح بعدی',
      requirementsFor: 'شرط‌های رسیدن به {tier}',
      amountLabel: 'مبلغ شارژ (تومان)',
      amountSuggested: 'مبلغ پیشنهادی: {amount} تومان، شامل ۱٪ حاشیه برای تغییر نرخ.',
      amountMinimum: 'کمترین مبلغ: {amount} تومان',
      useSuggested: 'مبلغ پیشنهادی',
      plusPercent: '+{percent}٪',
      equivalent: '≈ {units} واحد اعتبار با نرخ {rate} تومان برای هر واحد',
      payAction: 'پرداخت {amount} تومان',
      phoneFirst: 'برای پرداخت ارتقا، ابتدا شماره تلفن خود را تایید کنید.',
      gatewayNote: 'پرداخت در درگاه بانکی و در پنجره جدید انجام می‌شود.',
      currentBenefits: 'امکانات سطح فعلی',
      howItWorks: 'ارتقای سطح چطور کار می‌کند؟'
    },
    limitsPage: {
      upgradePaymentFailed: 'ایجاد تراکنش ارتقا انجام نشد. دوباره تلاش کنید.',
      tagline: 'برای هر سطح دسترسی، مدل‌های در دسترس و سقف درخواست و توکن در دقیقه را ببینید.',
      updatedAt: 'آخرین به‌روزرسانی',
      loading: 'در حال دریافت جدول مدل‌ها',
      loadFailed: 'دریافت جدول مدل‌ها انجام نشد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ جدول قبلی نمایش داده می‌شود.',
      aboutLimits: 'محدودیت‌ها چگونه کار می‌کنند؟',
      aboutLimitsBody: 'هر مدل در هر سطح دسترسی دو سقف دارد: درخواست در دقیقه (RPM) و توکن در دقیقه (TPM). هرکدام زودتر پر شود، درخواست بعدی با خطای ۴۲۹ پاسخ می‌گیرد. نرخ‌ها به ازای هر یک میلیون توکن و بر پایه واحد اعتبار هستند.',
      guideLink: 'راهنمای سطوح دسترسی',
      yourTier: 'سطح دسترسی شما',
      viewingTier: 'در حال مشاهده',
      viewingOwnTier: 'سطح خودتان',
      modelsInTier: 'مدل در این سطح',
      tierPicker: 'سطح دسترسی جدول',
      tierYou: '(شما)',
      search: 'جست‌وجوی مدل',
      searchPlaceholder: 'نام مدل',
      filters: 'فیلترها',
      clearFilters: 'پاک کردن فیلترها',
      showFilters: 'فیلترهای بیشتر',
      hideFilters: 'کمتر',
      anyOwner: 'همه',
      columnInput: 'ورودی',
      columnOutput: 'خروجی',
      columnPriceHint: 'واحد اعتبار به ازای هر یک میلیون توکن',
      columnMaxOutput: 'سقف خروجی',
      columnMaxInput: 'سقف ورودی',
      columnMaxOutputHint: 'بیشترین تعداد توکن خروجی در یک پاسخ',
      columnMaxInputHint: 'بیشترین تعداد توکن ورودی در یک درخواست',
      columnRpm: 'RPM',
      columnTpm: 'TPM',
      columnRpmHint: 'سقف درخواست در دقیقه برای این مدل در سطح انتخاب‌شده',
      columnTpmHint: 'سقف توکن در دقیقه برای این مدل در سطح انتخاب‌شده',
      providerHint: 'برخی مدل‌ها را ارائه‌دهنده‌ای جز مالکشان عرضه می‌کند؛ نرخ یک مدل می‌تواند بین ارائه‌دهنده‌ها فرق داشته باشد.',
      unavailable: 'نامشخص',
      copyName: 'کپی نام مدل {name}',
      nameCopied: 'نام مدل کپی شد.',
      openDetails: 'جزئیات مدل {name}',
      noModels: 'در این سطح هنوز مدلی ثبت نشده است.',
      noMatches: 'مدلی با این فیلترها در این سطح پیدا نشد.',
      noMatchesHint: 'فیلترها را تغییر دهید یا سطح دیگری را ببینید.',
      matchesElsewhere: 'در سطوح دیگر:',
      matchCount: '{tier} ({count})',
      pageSummary: 'نمایش {from} تا {to} از {total} مدل',
      perPage: '{count} در هر صفحه',
      progressTitle: 'ارتقای سطح دسترسی',
      progressTagline: 'سطح دسترسی با تأیید حساب و مجموع شارژ بالا می‌رود؛ خودکار و بدون درخواست.',
      progressMaxTagline: 'شما در بالاترین سطح دسترسی هستید و همه مدل‌ها با بیشترین سقف‌ها در دسترس شما هستند.',
      currentTierLabel: 'سطح فعلی',
      nextTierLabel: 'سطح بعدی',
      totalPaidLabel: 'مجموع شارژ',
      totalPaidHint: 'مجموع پرداختی شما به واحد اعتبار، محاسبه‌شده با نرخ روز پرداخت. معیار ارتقا به سطح ۲ و بالاتر همین عدد است.',
      ladderLabel: 'نردبان سطوح دسترسی',
      requirementsTitle: 'برای رسیدن به {tier}',
      upgradeAction: 'ارتقای سطح',
      maxTierBadge: 'بالاترین سطح',
      snippetTitle: 'دریافت فهرست مدل‌ها از API',
      snippetHint: 'همین جدول را می‌توانید با یک درخواست به نقطه پایانی مدل‌ها بگیرید. به جای aa-** کلید خودتان را بگذارید.',
      snippetLanguage: 'زبان نمونه کد',
      copyCode: 'کپی کد',
      codeCopied: 'کپی شد'
    },
    selectModalities: 'وجه ادراک',
    selectEndpoints: 'نقاط پایانی',
    rateLimits: 'سطوح دسترسی',
    supported_endpoints: 'نقاط پایانی پشتیبانی شده',
    supports_parallel_function_calling: 'Parallel Function Calling',
    supports_web_search: 'پشتیبانی از جستجوی وب',
    max_images_per_prompt: 'حداکثر تعداد تصویر ورودی',
    max_videos_per_prompt: 'حداکثر تعداد ویدیو ورودی',
    max_video_length: 'حداکثر طول ویدیو',
    max_audio_length_hours: 'حداکثر زمان آوا (ساعت)',
    max_audio_per_prompt: 'حداکثر آوا در هر پرامپت',
    max_pdf_size_mb: 'حداکثر حجم PDF (مگابایت)',
    supported_modalities: 'وجه ادارک‌های پشتیبانی شده (Modalities)',
    supported_output_modalities: 'وجه ادارک‌های خروجی پشتیبانی شده (Modalities)',
    costPerOneMillionTokens: 'بر اساس هر ۱ میلیون توکن بر مبنای نرخ واحد (تتر)',
    details: 'جزئیات',
    name: 'مدل',
    max_tokens: 'حداکثر توان خروجی',
    max_input_tokens: 'حداکثر ورودی',
    max_requests_per_1_minute: 'RPM',
    max_tokens_per_1_minute: 'TPM',
    // Nested pricing fields
    pricing: {
      input_cost_per_token: 'هزینه ورودی هر یک توکن',
      output_cost_per_token: 'هزینه خروجی هر یک توکن',
      input_cost_per_page: 'هزینه هر یک صفحه یا تصویر',
      input_cost_per_query: 'هزینه هر یک مرتبه فراخوانی',
      kTokens: 'هزار توکن',
      input: 'نرخ توکن ورودی',
      output: 'نرخ توکن خروجی',
      cached_input: 'نرخ ورودی کش شده',
      cache_creation_input: 'نرخ تولید ورودی کش شده',
      audio_input: 'نرخ ورودی صوتی',
      audio_output: 'نرخ خروجی صوتی',
      audio_cached_input: 'نرخ ورودی صوتی کش شده',
      image_input: 'نرخ ورودی تصویر',
      image_output: 'نرخ خروجی تصویر',
      image_cached_input: 'نرخ ورودی تصویر کش شده',
      video_input: 'نرخ ورودی ویدیو',
      input_cost_per_character: 'نرخ ورودی کاراکتر',
      input_cost_per_second: 'نرخ ورودی ثانیه',
      output_cost_per_second: 'نرخ خروجی ثانیه',
      output_cost_per_image: 'نرخ تولید تصویر',
      output_cost_per_video_per_second: 'نرخ هر ثانیه ویدیو',
      input_cost_per_annotation_page: 'نرخ هر صفحه حاشیه‌نویسی',
      // قالب‌های عمومی برای پیشوندهای پویا (آستانه/ابعاد)
      aboveTemplate: '{base} بالاتر از {threshold} توکن',
      resolutionTemplate: '{base} ({resolution})',
      source: 'منبع'
    },
    outputVideo: 'خروجی ویدیو',
    outputImage: 'خروجی تصویر',
    perOneImage: 'به ازای هر تصویر',
    outputSeconds: 'ثانیه خروجی',
    perOneSecond: 'هر ثانیه',
    inputSeconds: 'ثانیه ورودی',
    perOneCharacterInput: 'هر عدد کاراکتر',
    characterInput: 'کاراکتر ورودی',
    modelCapabilities: 'قابلیت‌ها',
    maxTokens: 'حداکثر ظرفیت',
    maxInputTokens: 'حداکثر ورودی',
    maxOutputTokens: 'حداکثر توان خروجی',
    mode: 'حالت',
    source: 'منبع',
    supportsSystemMessages: 'پیغام سیستم',
    supportsFunctionCalling: 'Function Calling',
    supportsVision: 'Vision',
    supportsToolChoice: 'Tool Choice',
    supportsResponseSchema: 'Response Schema',
    supportsPromptCaching: 'Prompt Caching',
    supportsReasoning: 'استدلال',
    howToUseApi1: 'دریافت لیست مدل‌ها از طریق API',
    audioPerMinute: 'صوت در دقیقه',
    imagesPerMinute: 'تصویر در دقیقه',
    searchModel: 'جست‌وجوی مدل',
    selectOwner: 'فیلتر صاحب‌ امتیاز',
    owner: 'صاحب امتیاز',
    tier0: 'پایه',
    tier1: 'سطح ۱',
    tier2: 'سطح ۲',
    tier3: 'سطح ۳',
    tier4: 'سطح ۴',
    tier5: 'سطح ۵',
    audioInputTokens: 'توکن صوتی ورودی',
    audioOutputTokens: 'توکن صوتی خروجی',
    audioCachedInputTokens: 'توکن صوتی ورودی کش شده',
    minute: 'دقیقه',
    perMinute: 'در دقیقه',
    perOneMillionTokens: 'هر ۱ میلیون توکن',
    currency: 'ارز',
    costCalculator: 'محاسبه هزینه‌ها',
    inputTokens: 'توکن ورودی',
    cachedInputTokens: 'توکن ورودی کش شده',
    outputTokens: 'توکن خروجی',
    audioInputMinutes: 'دقایق ورودی',
    audioCachedInputMinutes: 'دقایق ورودی کش شده',
    audioOutputMinutes: 'دقایق خروجی',
    estimatedCost: 'هزینه تخمینی',
    tokenBasedPricing: 'نرخ بر اساس توکن',
    audioBasedPricing: 'نرخ بر اساس واحد صوت / دقیقه',
    modelDetails: 'جزئیات مدل',
    copyModelName: 'کپی نام مدل',
    openModelSource: 'باز کردن منبع مدل',
    openPricingSource: 'باز کردن منبع قیمت‌گذاری',
    noCapabilitiesAvailable: 'جزئیات قابلیتی برای این مدل منتشر نشده است.',
    supportedFeatures: 'قابلیت‌های پشتیبانی‌شده',
    simpleEstimate: 'برآورد سریع',
    openFullCalculator: 'باز کردن ماشین حساب کامل',
    openServiceTierDocs: 'باز کردن مستندات سطوح سرویس',
    actions: '',
    providerType: 'نوع ارائه‌دهنده',
    viewPricing: 'مشاهده نرخ‌ها',
    pricingDetails: 'جزئیات نرخ‌ها',
    pricingMarkupBadge: 'پردازش صورتحساب +{percent}٪',
    pricingProcessingLabel: 'پردازش صورتحساب',
    unknownBillingProvider: 'ارائه‌دهنده منتشر نشده',
    pricingMarkupHelp: 'توضیح کارمزد {percent}٪ پردازش صورتحساب مدل {model} با ارائه‌دهنده {provider}',
    pricingMarkupNotice:
      'برای مدل {model} که از طریق {provider} ارائه می‌شود، این {percent}٪ هزینه اضافه بابت پردازش صورتحساب بالادستی مدل و بر مبنای نرخ رسمی آن است. این هزینه کارمزد پلتفرم AvalAI نیست.',
    pricingProcessingExplanation: 'این {percent}٪ هزینه اضافه برای پردازش صورتحساب صاحب مدل، بر مبنای نرخ رسمی مدل است؛ نه کارمزد پلتفرم AvalAI.',
    pricingFeesIncluded: 'در نرخ‌های نمایش‌داده‌شده مدل لحاظ شده است؛ دوباره به برآورد شما اضافه نمی‌شود.',
    pricingUpdated: 'قیمت‌ها یا نرخ تبدیل تغییر کرده‌اند. پیش از انتخاب پیشنهاد، برآورد را دوباره محاسبه کنید.',
    avalaiFeeZero: 'کارمزد پلتفرم AvalAI در حال حاضر برای خدمات پایه 0٪ است.',
    avalaiFeeUnpublished: 'AvalAI: در حال حاضر 0٪ برای خدمات پایه؛ تفکیک کارمزد مدل منتشر نشده است.',
    pricingBillingOwner: 'صاحب صورتحساب مدل: {owner}. این کارمزد پردازش به صاحب مدل مربوط است، نه مسیر ارائه درخواست.',
    avalaiFeeBadge: 'پلتفرم AvalAI +{percent}٪',
    avalaiFeeLabel: 'پلتفرم AvalAI',
    avalaiFeeNotice: 'نرخ‌های این مدل شامل {percent}٪ کارمزد جداگانه پلتفرم AvalAI است.',
    // Service Tier Pricing
    serviceTier: 'سطح سرویس',
    serviceTiers: 'سطوح سرویس',
    selectServiceTiers: 'سطوح سرویس',
    serviceTierFilter: 'فیلتر سطح سرویس',
    serviceTierPricing: 'نرخ بر اساس سطح سرویس',
    standardTier: 'استاندارد',
    defaultTier: 'استاندارد',
    flexTier: 'منعطف',
    batchTier: 'عمده',
    priorityTier: 'اولویت‌دار',
    defaultTierDescription: 'سطح نرخ پیش‌ فرض',
    standardTierDescription: 'سطح نرخ پیش‌ فرض',
    flexTierDescription: 'هزینه کمتر، تاخیر متغیر',
    batchTierDescription: 'پردازش غیرهمزمان',
    priorityTierDescription: 'دسترسی سریع و اولویت‌دار',
    flexAvailable: 'منعطف در دسترس',
    supportsFlexPricing: 'پشتیبانی از نرخ منعطف',
    learnMoreAboutServiceTiers: 'اطلاعات بیشتر درباره سطوح سرویس',
    // Service Tier Explanation Modal
    serviceTierExplanation: {
      title: 'آشنایی با سطوح سرویس',
      overview:
        'سطوح سرویس به شما امکان می‌دهند استفاده از API را بر اساس نیازهای خاص خود بهینه‌سازی کنید. سطوح مختلف توازن‌های متفاوتی بین هزینه، تاخیر و دسترسی ارائه می‌دهند.',
      standardTitle: 'سطح استاندارد',
      standardDescription: 'سطح سرویس پیش‌فرض که عملکرد پایدار و قابل پیش‌بینی با قیمت‌گذاری استاندارد ارائه می‌دهد.',
      standardFeature1: 'زمان پاسخ‌دهی قابل پیش‌بینی',
      standardFeature2: 'محدودیت‌های نرخ استاندارد اعمال می‌شود',
      standardFeature3: 'بهترین گزینه برای بارهای کاری تولید که به تاخیر ثابت نیاز دارند',
      flexTitle: 'سطح منعطف',
      flexDescription:
        'سطح بهینه‌شده از نظر هزینه که صرفه‌جویی قابل توجهی در ازای تاخیر متغیر ارائه می‌دهد. مناسب برای بارهای کاری غیر حساس به زمان.',
      flexFeature1: 'تا ۵۰٪ کاهش هزینه نسبت به سطح استاندارد',
      flexFeature2: 'تاخیر متغیر - پاسخ‌ها ممکن است در زمان‌های اوج بیشتر طول بکشند',
      flexFeature3: 'ایده‌آل برای پردازش دسته‌ای، وظایف پس‌زمینه یا برنامه‌های حساس به هزینه',
      flexNote:
        'درخواست‌های سطح منعطف با اولویت پایین و زمانی که ظرفیت در دسترس است پردازش می‌شوند. زمان پاسخ‌دهی ممکن است بسته به تقاضا از چند ثانیه تا چند دقیقه متغیر باشد.',
      howToUseTitle: 'نحوه استفاده از سطوح سرویس',
      howToUseDescription: "برای استفاده از یک سطح سرویس خاص، پارامتر 'service_tier' را در درخواست API خود قرار دهید:",
      supportedModelsTitle: 'مدل‌های پشتیبانی‌شده',
      supportedModelsDescription:
        'در حال حاضر، فقط برخی از مدل‌های OpenAI از نرخ‌گذاری منعطف پشتیبانی می‌کنند. لیست مدل‌های پشتیبانی‌شده ممکن است در آینده افزایش یابد.',
      modelAliases: 'نام‌های جایگزین مدل',
      pricingTitle: 'مزایای قیمت‌گذاری',
      pricingDescription:
        'قیمت‌گذاری سطح منعطف معمولا ۵۰٪ کمتر از قیمت‌گذاری سطح استاندارد است. تخفیف دقیق بسته به مدل متفاوت است.',
      pricingExample:
        'مثال: اگر قیمت ورودی استاندارد ۲ دلار/۱ میلیون توکن باشد، قیمت منعطف حدود ۱ دلار/۱ میلیون توکن خواهد بود.',
      latencyTitle: 'ملاحظات تاخیر',
      latencyDescription:
        'سطح استاندارد پاسخ‌های ثابت با تاخیر کم ارائه می‌دهد که برای برنامه‌های بلادرنگ ایده‌آل است. سطح منعطف ممکن است تاخیر متغیری از چند ثانیه تا چند دقیقه داشته باشد، که آن را برای بارهای کاری ناهمزمان که پاسخ فوری حیاتی نیست مناسب می‌سازد.',
      creditPackageWarningTitle: 'مهم: بسته‌های اعتباری',
      creditPackageWarning:
        'استفاده از سطح منعطف توسط بسته‌های اعتباری پوشش داده نمی‌شود! اگر از بسته‌های اعتباری استفاده می‌کنید، فراخوانی‌های API با service_tier == flex از موجودی استاندارد شما کسر می‌شود نه از اعتبار بسته شما.'
    },
    inputPrice: 'نرخ ورودی',
    cachedInputPrice: 'نرخ ورودی کش شده',
    cacheCreationInputPrice: 'نرخ تولید ورودی کش شده',
    outputPrice: 'نرخ خروجی',
    audioInputPrice: 'نرخ صدای ورودی',
    audioOutputPrice: 'نرخ صدای تولید شده',
    noPricingAvailable: 'نرخ گذاری در دسترس نیست',
    shortDesc1: 'مشاهده و بررسی سطح دسترسی به مدل‌های مختلف',
    title: 'محدودیت‌های دسترسی',
    provider: 'ارائه‌دهنده',
    providerTooltip:
      'برخی مدل‌ها ممکن است ارائه‌دهندگان متفاوتی نسبت به مالک خود داشته باشند (مثلا deepseek.r1-v1:0 متعلق به DeepSeek است اما توسط AWS Bedrock ارائه می‌شود). همچنین مدل‌های یکسان در ارائه‌دهندگان مختلف ممکن است قیمت‌گذاری متفاوتی داشته باشند.',
    model: 'مدل',
    tpm: 'توکن در دقیقه (TPM)',
    rpm: 'درخواست در دقیقه (RPM)',
    info1:
      'سطوح دسترسی API منطبق با OpenAI تنظیم شده. دو نوع محدودیت اصلی شامل «توکن در دقیقه» به اختصار (TPM) و «درخواست در دقیقه یا روز» به اختصار (RPM/RPD) می‌شوند.',
    readDoc1: 'با مطالعه مستندات',
    readDoc2: 'راهنمای سطح دسترسی',
    readDoc3: 'میتوانید در مورد چگونگی آن اطلاعات بیشتری کسب نمایید.',
    usageTier: 'سطح دسترسی',
    noAccess: 'بدون دسترسی',
    free: 'پایه',
    tier: 'سطح',
    completed: 'تکمیل شده',
    current: 'فعلی',
    upcoming: 'بعدی',
    toIncreaseTier: 'برای ارتقا به سطح دسترسی بعد:',
    increaseYourLimits: 'ارتقای سطح دسترسی',
    youCurrentTier: 'حساب شما در',
    ast: 'قرار دارد',
    youWillmoveIf:
      'محدودیت‌های شما به صورت خودکار به سطح استفاده بعدی بر اساس معیارهای زیر افزایش خواهند یافت. برای کسب اطلاعات بیشتر به',
    toLearMore: 'درباره محدودیت‌های مرتبط با هر سطح استفاده مراجعه کنید.',
    tiers: {
      zero: {
        p1: 'برای فعال شدن دسترسی پایه API، ایمیل خود را تایید کنید.',
        p2: '',
        p3: '',
        p4: ''
      },
      tier0: {
        p1: 'سطح پایه برای کاربران با ایمیل تایید شده.',
        p2: 'با تایید شماره تلفن به سطح دسترسی ۱ ارتقا پیدا می‌کنید.',
        p3: '',
        p4: ''
      },
      tier1: {
        p1: 'شماره تلفن خود را تایید کنید. هیچ حداقل پرداختی لازم نیست.',
        monthlyLimit: 'سقف مصرف تا ۱۰۰ واحد در ماه.',
        p2: '',
        p3: '',
        p4: ''
      },
      tier2: {
        p1: 'دستکم ۱۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۵۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier3: {
        p1: 'دستکم ۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۱,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier4: {
        p1: 'دستکم ۲۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۵,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      },
      tier5: {
        p1: 'دستکم ۱,۰۰۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.',
        p2: '',
        monthlyLimit: 'سقف مصرف تا ۱۰,۰۰۰ واحد در ماه.',
        p3: '',
        p4: ''
      }
    },
    // Tier Upgrade System Localizations
    upgradeTitle: 'ارتقای سطح دسترسی',
    maxTierTitle: 'حداکثر سطح دسترسی',
    upgradeDescription:
      'با ارتقا به سطح بالاتر، قابلیت‌های دسترسی API خود را افزایش دهید. سطوح بالاتر امکان دسترسی به مدل‌های بیشتر، محدودیت‌های نرخ بالاتر (TPM/RPM) و ویژگی‌های مرتبط با سطح بعدی را فراهم می‌کنند.',
    maxTierDescription:
      'تبریک! شما به بالاترین سطح دسترسی رسیده‌اید و از حداکثر مزایا و دسترسی نامحدود به تمام ویژگی‌ها بهره‌مند هستید.',
    tierProgress: 'پیشرفت سطح دسترسی',
    howItWorks: 'نحوه عملکرد ارتقای سطح',
    importantNotes: 'اطلاعات مهم',
    currentTier: 'سطح فعلی',
    nextTier: 'سطح بعدی',
    progress: 'پیشرفت',
    totalPaid: 'مجموع پرداختی',
    required: 'مورد نیاز',
    remaining: 'باقی‌مانده',
    currentBenefits: 'مزایای فعلی',
    nextTierBenefits: 'مزایای سطح بعدی',
    upgradeNow: 'ارتقا دهید',
    maxTierReached: 'حداکثر سطح دسترسی!',
    upgradeToNextTier: 'ارتقا به سطح بعدی',
    unlockBenefits: 'دسترسی فوری به تمام امکانات ویژه',
    instantUpgrade: 'ارتقای فوری، بدون انتظار',

    // Step-by-step process
    step1Title: 'تایید تلفن یا شارژ حساب',
    step1Description:
      'تایید شماره تلفن، حساب دارای ایمیل تایید شده را بدون نیاز به حداقل پرداخت به سطح دسترسی ۱ ارتقا می‌دهد. برای رسیدن به سطح ۲ و بالاتر، حساب خود را شارژ کنید.',
    step2Title: 'محاسبه خودکار سطح',
    step2Description:
      'سیستم معادل واحد (UNIT) پرداخت تومان شما را در زمان پرداخت محاسبه می‌کند تا مجموع پرداختی را جهت ارتقای سطح محاسبه کند. ارتقای سطح ۲ و بالاتر بر اساس این مجموع ارزش مادام‌العمر به واحد انجام می‌شود.',
    step3Title: 'سقف‌های بالاتر، بلافاصله',
    step3Description:
      'بلافاصله پس از ارتقای سطح، به محدودیت‌های نرخ بالاتر، مدل‌های بیشتر و ویژگی‌های ویژه دسترسی پیدا کنید.',
    step4Title: 'اعتبار شما دست‌نخورده می‌ماند',
    step4Description:
      'همه اعتبار شارژشده برای استفاده از API در دسترس می‌ماند؛ ارتقای سطح اعتباری مصرف نمی‌کند.',
    step5Title: 'مزایای دائمی',
    step5Description: 'پس از ارتقا، مزایای سطح شما دائمی است و هرگز کاهش نخواهد یافت.',

    // Amount selection features
    selectAmount: 'انتخاب مبلغ شارژ',
    suggestedAmount: 'پیشنهادی',
    suggestedAmountTooltip: 'مبلغ توصیه شده با ۱٪ بافر برای محافظت در برابر نوسانات نرخ ارز',
    selectedAmount: 'مبلغ انتخابی',
    minimumRequired: 'حداقل مورد نیاز',
    exchangeRate: 'نرخ تبدیل',
    useSuggested: 'استفاده از پیشنهادی',

    // Tier selection features
    selectTargetTier: 'انتخاب سطح هدف',
    selectTierPlaceholder: 'سطح مورد نظر برای ارتقا را انتخاب کنید',
    selectedTier: 'سطح انتخابی',
    tier1PhoneVerificationUpgrade:
      'برای ارتقا به سطح دسترسی ۱، شماره تلفن خود را تایید کنید. هیچ پرداخت یا حداقل مجموع پرداختی لازم نیست.',
    activationGrantNewUser: 'با تایید شماره تلفن خود، {amount} تومان اعتبار رایگان دریافت کنید.',
    activationGrantTopup:
      'با افزودن شماره تلفن، {amount} تومان اعتبار دریافت کنید تا مجموع اعتبار فعال‌سازی شما به {total} تومان برسد.',
    activationGrantBadge: '+{amount} تومان',
    emailVerificationRequired: 'ایمیل تایید شده',
    emailVerified: 'ایمیل تایید شود',
    phoneVerified: 'شماره تلفن تایید شود',
    targetTierBenefits: 'مزایای سطح هدف',
    upgradeToSelectedTier: 'ارتقا به سطح انتخابی',
    resetToNext: 'بازگشت به بعدی',
    recommended: 'توصیه شده',
    cost: 'هزینه',

    // Important notes
    note1: 'سطح ۱ با تایید شماره تلفن به دست می‌آید؛ سطح ۲ و بالاتر بر پایه مجموع شارژ حساب محاسبه می‌شود.',
    note2: 'همه اعتبار شارژشده برای استفاده از API در دسترس می‌ماند.',
    note3: 'سطوح بالاتر مدل‌های بیشتر و سقف درخواست و توکن بالاتری در دسترس می‌گذارند.',

    // Tier Benefits
    benefits: {
      tier0: {
        basic: 'دسترسی پایه API با محدودیت‌های ابتدایی',
        limited: 'دسترسی فقط به مدل‌های ضروری'
      },
      tier1: {
        increased: 'محدودیت‌های نرخ و ظرفیت توکن افزایش یافته',
        priority: 'پشتیبانی اولویت‌دار و زمان پاسخ سریع‌تر',
        models: 'دسترسی به مدل‌های هوش مصنوعی اضافی'
      },
      tier2: {
        higher: 'محدودیت‌های استفاده ماهانه بالاتر (۵۰۰ واحد/ماه)',
        advanced: 'دسترسی به مدل‌های استدلالی پیشرفته',
        support: 'پشتیبانی بهبود یافته کاربران'
      },
      tier3: {
        premium: 'دسترسی ویژه با محدودیت ۱۰۰۰ واحد/ماه',
        enhanced: 'انتخاب مدل و قابلیت‌های بهبود یافته',
        features: 'دسترسی به ویژگی‌های آزمایشی و انتشارات جدید'
      },
      tier4: {
        enterprise: 'دسترسی سطح سازمانی (۵۰۰۰ واحد/ماه)',
        maximum: 'حداکثر محدودیت‌های نرخ و پردازش اولویت‌دار',
        dedicated: 'پشتیبانی اختصاصی و پیکربندی‌های سفارشی'
      },
      tier5: {
        unlimited: 'دسترسی نامحدود به تمام ویژگی‌ها و مدل‌ها',
        all: 'دسترسی به تمام مدل‌های هوش مصنوعی فعلی و آینده',
        priority: 'بالاترین اولویت پشتیبانی و راه‌حل‌های سفارشی'
      }
    },
    // Authentication and verification messages
    notLoggedIn: 'وارد نشده‌اید',
    loginRequired: 'لطفا برای دسترسی به مزایای سطح و گزینه‌های ارتقا وارد شوید.',
    loginNow: 'ورود',
    phoneNotVerified: 'تلفن تایید نشده است',
    phoneVerificationRequired: 'برای ارتقای سطح، ابتدا شماره تلفن خود را تایید کنید.',
    verifyPhone: 'تایید تلفن',
    notAuthenticated: 'احراز هویت مورد نیاز است',
    authenticationRequired: 'لطفا برای دسترسی به مزایای سطح خود، احراز هویت را کامل کنید.',
    authenticateNow: 'احراز هویت',
    accessRestricted: 'دسترسی محدود شده است',
    verificationRequired: 'لطفا برای دسترسی به مزایای سطح، تایید را کامل کنید.',
    getVerified: 'تایید شوید'
  },
  usage: {
    totalUsed: 'استفاده شده',
    totalAudio: 'مجموع آوا',
    audioInputSeconds: 'آوای ورودی',
    audioOutputSeconds: 'آوای خروجی',
    all: 'همه',
    success: 'موفق',
    pending: 'بلاتکلیف',
    failed: 'ناموفق',
    summary: 'خلاصه',
    download: 'بارگذاری',
    action: 'عملیات',
    status: 'وضعیت',
    expiresAt: 'تاریخ انقضا',
    generatedAt: 'تاریخ صدور',
    consumptionReport: 'گزارش مصارف',
    generateReport: 'صدور گزارش',
    timeFrame: 'بازه زمانی',
    meanExchangeRate: 'متوسط نرخ تبدیل',
    inputTokens: 'توکن وروردی',
    outputTokens: 'توکن خروجی',
    cachedTokens: 'توکن کش شده',
    request: 'درخواست',
    totalTokens: 'مجموع توکن‌ها',
    totalRequests: 'مجموع درخواست‌ها',
    costs: 'هزینه‌ها',
    cost: 'هزینه‌',
    tokens: 'توکن',
    requests: 'درخواست‌ها',
    title: 'مصارف',
    daily: 'روزانه',
    hourly: 'ساعتی',
    loading: 'در حال بارگذاری مصرف…',
    refreshing: 'در حال به‌روزرسانی…',
    loadErrorTitle: 'بارگذاری مصرف ناموفق بود',
    loadErrorDescription:
      'لطفا دوباره تلاش کنید. آخرین مصرف بارگذاری‌شده همچنان نمایش داده می‌شود و رکوردهای صورتحساب شما تغییری نکرده‌اند.',
    completeZero: 'در این بازه زمانی با پوشش کامل، مصرف API ثبت نشده است.',
    coveredDataUnavailable: 'هنوز در بخش پوشش‌داده‌شده این بازه، مصرفی در دسترس نیست.',
    noUsageAtPoint: 'در این بازه مصرفی ثبت نشده است.',
    unavailableAtPoint: 'اطلاعات مصرف این بازه در دسترس نیست.',
    overview: {
      cost: 'هزینه (UNIT)', requests: 'درخواست‌ها', total: 'مجموع توکن‌های گزارش‌شده',
      prompt: 'توکن‌های ورودی (شامل کش)', output: 'توکن‌های خروجی (شامل استدلال)',
      tokens: 'توکن', cached: 'توکن‌های ورودی کش‌شده', uncached: 'توکن‌های ورودی بدون کش',
      reasoning: 'توکن‌های استدلال', nonReasoning: 'توکن‌های خروجی غیر استدلالی',
      cache: 'کش', cacheRatio: 'نسبت کش توکن (کش به ورودی)', reasoningRatio: 'نسبت استدلال به خروجی',
      unavailable: 'در دسترس نیست', invalid: 'داده ناسازگار', notApplicable: 'قابل محاسبه نیست',
      discrepancyTitle: 'دسته‌بندی توکن‌ها با مجموع‌ها سازگار نیست',
      discrepancyDescription: 'مجموع‌های گزارش‌شده بدون تغییر حفظ شده‌اند. برخی جزئیات توکن با مجموع ورودی و خروجی یا حدود زیرمجموعه‌ها سازگار نیستند. این نقاط به‌جای تفکیک جزئی، مجموع کلی را نشان می‌دهند؛ توکن‌های کش یا استدلال دوباره جمع نمی‌شوند.',
      reportedUsage: 'مجموع دوره', reportedPartial: 'پوشش ناقص',
      details: 'مقدار جزئیات توکن و نسبت به مجموع والد', modelDetails: 'جزئیات مدل و نمودار زمانی',
      detailExplanation: 'جزئیات ممکن است هم‌پوشانی داشته باشند و نباید با هم جمع شوند. کش بخشی از ورودی و استدلال بخشی از خروجی است. جزئیات ارائه‌نشده در دسترس نیستند، نه صفر. مدت صوت برحسب ثانیه است و نسبت توکنی ندارد.',
      metric: 'معیار', amount: 'مقدار', parentRatio: 'نسبت به مجموع والد', seconds: 'ثانیه',
      promptAudio: 'صوت ورودی', promptText: 'متن ورودی', promptImage: 'تصویر ورودی',
      audioInputDuration: 'مدت صوت ورودی', outputAudio: 'صوت خروجی', outputText: 'متن خروجی',
      acceptedPrediction: 'پیش‌بینی پذیرفته‌شده', rejectedPrediction: 'پیش‌بینی ردشده', audioOutputDuration: 'مدت صوت خروجی',
      timeline: 'نمودار زمانی مصرف', table: 'نمایش جدول داده‌های بازه‌ها', timestamp: 'زمان',
      timelineExplanation: 'زمان‌ها بر اساس منطقه زمانی دستگاه شما نمایش داده می‌شوند و نام آن در عنوان جدول آمده است. هر ستون یک بازه گزارش‌شده را بدون درون‌یابی نشان می‌دهد. * نشانه بازه ناقص یا مرزی و ? نشانه نبود پوشش است. مقادیر ناقص ممکن است افزایش یابند؛ فاصله خالی به معنی صفر نیست. پوشش دقیق و مجموع‌ها در راهنما و جدول نمایش داده می‌شوند.',
      noTimeline: 'داده‌ای برای بازه‌های زمانی ارائه نشده است. مجموع دوره به‌صورت نقطه زمانی ساختگی رسم نمی‌شود.',
      coverage: 'پوشش', coverageDetails: 'جزئیات پوشش و تازگی داده', covered: 'پوشش‌داده‌شده', partial: 'پوشش ناقص',
      uncovered: 'بدون پوشش', unknownCoverage: 'پوشش اعلام نشده', boundaryBucket: 'بازه مرزی ناقص', visibleRange: 'بخش درخواستی بازه',
      inProgress: 'بازه جاری، هنوز در حال تکمیل', windowEdge: 'بریده‌شده با بازه زمانی', hatchLegend: 'ستون هاشورخورده: بازه جاری هنوز در حال تکمیل است یا بازه با مرز پنجره زمانی بریده شده است. مقدار آن نهایی نیست.', gapLegend: 'ستون خط‌چین: داده‌ای برای این بازه هنوز از سمت سرور موجود نیست. این مقدار صفر نیست.',
      computedThrough: 'پردازش‌شده تا', reportedLag: 'تأخیر گزارش‌شده پردازش', backfill: 'آماده‌سازی سابقه',
      complete: 'کامل', running: 'در حال انجام', not_started: 'شروع نشده', refreshing: 'در حال به‌روزرسانی؛ آخرین دوره موفق نمایش داده می‌شود…',
      models: 'مصرف به تفکیک مدل', searchModels: 'جست‌وجوی مدل‌ها',
      modelExplanation: 'مرتب‌شده بر اساس شاخص انتخابی. مجموع مدل‌ها از خلاصه دوره گرفته می‌شود، نه جمع بازه‌های نمودار. وقتی جزئیات مدل در دسترس نیست، جزئیات کلی به مدل‌ها نسبت داده نمی‌شود.',
      showAllFields: 'نمایش همه فیلدها', hideEmptyFields: 'پنهان‌کردن فیلدهای خالی',
      hiddenFields: 'فیلد خالی پنهان شده', emptyFields: 'هیچ فیلدی در این گروه مقداری گزارش نکرده است.',
      fieldPolicy: 'فیلدهایی که مقداری گزارش نمی‌کنند یا صفر ساده هستند پنهان می‌شوند. فیلدهای ناسازگار همیشه نمایش داده می‌شوند. هیچ داده‌ای حذف نمی‌شود؛ برای دیدن همه مقادیر گزارش‌شده «نمایش همه فیلدها» را انتخاب کنید.',
      comparison: 'مقایسه مدل‌ها', comparisonExplanation: 'مدل‌های برتر بر اساس شاخص انتخابی، از مجموع‌های خلاصه دوره. برای بازکردن هر مدل روی میله آن را انتخاب کنید. مدل‌هایی که این شاخص را گزارش نمی‌کنند به‌جای ترسیم به‌صورت صفر، «در دسترس نیست» فهرست می‌شوند.',
      showMoreModels: 'نمایش مدل‌های بیشتر', showFewerModels: 'نمایش مدل‌های کمتر', remainingModels: 'مدل دیگر نمایش داده نشده',
      metricUnavailable: 'شاخص انتخابی برای این بازه گزارش نشده است، بنابراین چیزی ترسیم نمی‌شود. این مقدار صفر نیست.',
      comparisonUnavailable: 'هیچ مدلی این شاخص را گزارش نمی‌کند. جزئیات توکن به‌ازای مدل برای این بازه از سوی API ارائه نشده است.',
      expandModel: 'نمایش جزئیات', collapseModel: 'پنهان‌کردن جزئیات',
      statusTitle: 'این بازه نیازمند تفسیر است', statusReasons: 'دلایل',
      unitLabel: 'واحد اعتبار', updatedAt: 'به‌روزرسانی', range24h: '۲۴ ساعت گذشته', range30d: '۳۰ روز گذشته',
      headline: 'خلاصه', headlineHint: 'مجموع‌های دوره از خلاصه گرفته می‌شود، نه از جمع بازه‌های نمودار. توکن‌های کش‌شده بخشی از توکن‌های ورودی و توکن‌های استدلال بخشی از خروجی هستند؛ بنابراین اجزا هیچ‌گاه به مجموع والد اضافه نمی‌شوند.',
      costPerKTokens: 'هزینه هر ۱هزار توکن', tokensPerRequest: 'توکن در هر درخواست',
      costPerKTokensHint: 'میانگین هزینه به واحد برای هر ۱٬۰۰۰ توکن در این دوره.', tokensPerRequestHint: 'میانگین مجموع توکن ورودی و خروجی هر فراخوانی در این دوره.',
      metricHint: 'شاخص نمودار', frameHint: 'اندازه بازه و پنجره زمانی',
      dataQuality: 'کیفیت داده', reasonsCount: 'نکته',
      rank: 'رتبه', share: 'سهم', model: 'مدل', modelsTitle: 'مدل‌ها', modelsCount: 'مدل', openModel: 'نمایش جزئیات',
      collapsedList: 'مرتب‌شده بر اساس شاخص انتخابی؛ مجموع‌ها از خلاصه دوره گرفته می‌شود. برای دیدن نمودار زمانی و جزئیات توکن، یک ردیف را انتخاب کنید.',
      shortUnitPerK: 'واحد / ۱هزار توکن', shortTokPerReq: 'توکن / درخواست',
      otherModels: 'مدل‌های دیگر', showAllModels: 'نمایش همه مدل‌ها', showTopModels: 'فقط مدل‌های برتر',
      tableView: 'داده‌های بازه‌ها', chartView: 'نمودار', closeDetails: 'بستن جزئیات', noMatch: 'مدلی با این جست‌وجو یافت نشد.',
      paidFrom: 'پرداخت‌شده از', fundingOrder: 'به ترتیب برداشت اعتبار: اول بسته‌ها، بعد اعتبار هدیه، بعد اعتبار واحدی و در آخر اعتبار تومانی.',
      fundCreditPackage: 'بسته‌های اعتباری', fundGrant: 'اعتبار هدیه', fundWalletUnit: 'اعتبار واحدی', fundWalletIrt: 'اعتبار تومانی', fundUnattributed: 'منبع ثبت‌نشده',
      fundUnattributedHint: 'مصرفی که پیش از ثبت منبع اعتبار گزارش شده است. در هزینه حساب می‌شود، اما به هیچ منبع اعتباری نسبت داده نشده است.',
      fundUnknown: 'منبع اعتبار به‌تفکیک مدل یا ارائه‌دهنده ثبت نمی‌شود؛ بنابراین این نمای فیلترشده نمی‌تواند نشان دهد هزینه از کدام اعتبار پرداخت شده است.',
      fundCorrectionHint: 'مبلغ منفی اصلاحیه‌ای است که به همان اعتبار برگشته است.',
      tomanSpent: 'تومان برداشت‌شده', tomanLabel: 'تومان', fundingBar: 'هزینه به‌تفکیک منبع اعتبار'
    },

    cache: {
      title: 'کش پرامپت',
      caption: 'توکن‌های پرامپت کش‌شده با کسری از قیمت ورودی تازه محاسبه می‌شوند — در بیشتر مدل‌های متنی تا ۱۰ برابر ارزان‌تر. پیشوند ثابت (پرامپت سیستم، ابزارها، سندها) را تکرار کنید تا ارائه‌دهنده آن را از کش پاسخ دهد.',
      hitRatio: 'نسبت برخورد کش',
      hitRatioHint: 'سهم توکن‌های پرامپت کش‌شده از همه توکن‌های پرامپت (ورودی) در این بازه، برای مدل‌هایی که شمار کش را گزارش می‌کنند.',
      realizedSavings: 'صرفه‌جویی با کش',
      realizedSavingsHint: 'توکن‌های کش‌شده × (نرخ ورودی تازه − نرخ ورودی کش‌شده) برای هر مدل، با نرخ‌های قابل پرداخت امروز کاتالوگ شامل کارمزدهای قابل اعمال. برآورد است، نه صورت‌حساب شما.',
      effectiveDiscount: 'تخفیف مؤثر ورودی',
      effectiveDiscountHint: 'صرفه‌جویی نسبت به هزینه‌ای که همه توکن‌های پرامپت بدون کش داشتند.',
      ofWithoutCache: 'از {amount} بدون کش',
      headroom: 'صرفه‌جویی ممکن',
      headroomHint: 'اگر توکن‌های پرامپت کش‌نشده هم از کش پاسخ می‌گرفتند، چقدر صرفه‌جویی می‌شد — سقف است، چون درخواست نخست هرگز از کش نمی‌آید. فقط مدل‌های متنی با پشتیبانی کش.',
      reasoning: 'توکن‌های استدلال',
      reasoningHint: 'توکن‌های استدلال (تفکر) زیرمجموعه توکن‌های خروجی هستند و با نرخ خروجی محاسبه می‌شوند.',
      reasoningShare: '{share} از خروجی',
      cacheWrites: 'نوشتن در کش',
      cacheWritesNotReported: 'هزینه اضافه نوشتن در کش (که برخی ارائه‌دهندگان در نخستین ذخیره پیشوند می‌گیرند) در این آمار گزارش نمی‌شود.',
      coverage: 'بر پایه {priced} از {models} مدل با شمار کش گزارش‌شده و قیمت در کاتالوگ',
      coverageUnreported: '{count} مدل در این بازه جزئیات کش ندارد',
      coverageUnpriced: '{count} مدل در کاتالوگ قیمت نیست',
      coverageNonText: '{count} مدل تصویری/صوتی از صرفه‌جویی ممکن کنار گذاشته شده است',
      promptShare: 'شامل {share} از توکن‌های پرامپت',
      perModel: 'به تفکیک مدل',
      perModelCaption: 'مرتب‌شده بر پایه صرفه‌جویی ممکن. برای دیدن ردیف مصرف، روی مدل کلیک کنید.',
      model: 'مدل',
      cached: 'کش‌شده',
      fresh: 'تازه',
      hit: 'نسبت برخورد',
      saved: 'صرفه‌جویی‌شده',
      potential: 'ممکن',
      discount: 'قیمت کش',
      discountValue: '{factor} ارزان‌تر',
      kind_text: 'متنی',
      kind_image: 'تصویری',
      kind_audio: 'صوتی',
      kind_video: 'ویدیویی',
      kind_embedding: 'بردار',
      kind_other: 'دیگر',
      status_unreported: 'بدون جزئیات کش',
      status_unpriced: 'بدون قیمت در کاتالوگ',
      status_unsupported: 'کش پشتیبانی نمی‌شود',
      band_none: 'بدون برخورد کش',
      band_low: 'نسبت برخورد کم',
      band_medium: 'نسبت برخورد متوسط',
      band_high: 'نسبت برخورد بالا',
      noReported: 'هیچ‌کدام از مدل‌های این بازه شمار کش را گزارش نمی‌کنند.',
      noCached: 'در این بازه هیچ توکن پرامپتی از کش پاسخ نگرفته است.',
      tipTitle: 'چگونه نسبت برخورد را بالا ببرید',
      tipPrefix: 'بخش‌هایی که بین فراخوانی‌ها تکرار می‌شوند — پرامپت سیستم، تعریف ابزارها، سندهای مرجع — را در آغاز بگذارید و بایت‌به‌بایت یکسان نگه دارید؛ هرچه پیش از نخستین توکن تغییریافته باشد کش‌پذیر است.',
      tipMinimum: 'بیشتر ارائه‌دهندگان فقط پیشوندهای بلندتر از یک حد کمینه (معمولاً ۱۰۲۴ توکن) را کش می‌کنند و پس از چند دقیقه بی‌کاری آن را پاک می‌کنند؛ فراخوانی‌های مرتبط را نزدیک به هم بفرستید.',
      tipModels: 'تخفیف در هر مدل متفاوت است ({examples})؛ برای زمینه‌های بلند و تکراری، مدل‌هایی با تخفیف عمیق ورودی کش‌شده را برگزینید.',
      unitLabel: 'واحد اعتبار',
      catalogueUnavailable: 'کاتالوگ قیمت مدل‌ها بارگذاری نشد؛ اکنون نمی‌توان صرفه‌جویی را برآورد کرد.',
      barTitle: 'هزینه پرامپت کجا صرف شده',
      seg_kept: 'حذف‌شده با کش',
      seg_open: 'با قیمت کامل پرداخت‌شده، ولی کش‌پذیر',
      seg_floor: 'قیمت کش (کمتر نمی‌شود)',
      seg_uncacheable: 'کش‌پذیر نیست',
      verdictMostlyOpen: 'کش بخشی از هزینه را حذف کرده است، اما حدود {times} برابر آن هنوز با نرخ تازه پرداخت می‌شود. تکرار یک پیشوند ثابت بزرگ‌ترین صرفه‌جویی در دسترس شماست.',
      verdictBalanced: 'کش اینجا کار واقعی می‌کند؛ پیشوند پایدارتر همچنان می‌تواند مقدار حذف‌شده را حدوداً دو برابر کند.',
      verdictMostlyKept: 'بیشتر آنچه کش می‌تواند حذف کند، حذف شده است. هزینه تازه باقی‌مانده کم است.',
      verdictNoneYet: 'هیچ‌کدام از این توکن‌های پرامپت از کش پاسخ نگرفته‌اند. همه بخش رنگی برای صرفه‌جویی در دسترس است.',
      verdictMaxed: 'در این بازه همه توکن‌های پرامپت کش‌پذیر از کش پاسخ گرفته‌اند.',
      verdictNothing: 'در این بازه هیچ توکن پرامپتی روی مدلی اجرا نشده که کش قیمتش را کم کند.',
      savedCaption: '{discount} از هزینه پرامپت با نسبت برخورد {hit}',
      hitOnly: '{hit} از توکن‌های پرامپت از کش آمده‌اند',
      headroomCaption: 'روی {tokens} توکن تازه که می‌توانستند از کش بیایند',
      fitTitle: 'کش کجا کمک می‌کند',
      fitNote: 'هر کاربردی کش‌پذیر نیست. برخورد کش وقتی رخ می‌دهد که آغاز پرامپت در فراخوانی‌های پیاپی بایت‌به‌بایت تکرار شود: ابزارهای کدنویسی (Codex، Claude Code و مانند آن‌ها)، دستیارهای گفت‌وگو و هر برنامه‌ای که پرامپت سیستم، تعریف ابزارها یا سندها را دوباره می‌فرستد می‌توانند به نسبت برخورد بالا برسند. اگر هر درخواست از همان ابتدا داده تازه دارد، این نسبت ممکن است هرگز بالا نرود و «صرفه‌جویی ممکن» سقف است، نه هدف.',
      docsLink: 'راهنمای کش پرامپت',
      docsUrl: 'https://docs.avalai.ir/fa/guides/prompt-caching'
    },
    filters: {
      title: 'فیلترها',
      custom: 'بازه دلخواه',
      customHint: 'تاریخ شروع و پایان را انتخاب کنید؛ تا هفت روز بازه‌ها ساعتی و پس از آن روزانه هستند',
      dateRange: 'بازه تاریخ',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      apply: 'اعمال',
      apiKey: 'کلید API',
      allKeys: 'همه کلیدها',
      unknownKey: 'کلیدی خارج از فهرست شما',
      keysFailed: 'دریافت کلیدها انجام نشد؛ فیلتر با شناسه کلید موجود در پیوند همچنان کار می‌کند.',
      provider: 'ارائه‌دهنده',
      allModels: 'همه مدل‌ها',
      allProviders: 'همه ارائه‌دهندگان',
      clear: 'پاک کردن فیلترها',
      applied: 'فیلترشده با {count} تنظیم',
      rangeIncomplete: 'شروع و پایان را هر دو انتخاب کنید.',
      rangeOrder: 'شروع باید پیش از پایان باشد.',
      rangeTooLong: 'بازه حداکثر می‌تواند ۳۶۵ روز باشد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ آخرین مصرف بارگذاری‌شده نمایش داده می‌شود.'
    },
    projection: {
      notStarted: {
        title: 'آمار مصرف در حال آماده‌سازی است',
        description: 'پردازش اولیه آمار هنوز کامل نشده است. مصرف ثبت‌نشده به‌اشتباه صفر نمایش داده نمی‌شود.'
      },
      backfilling: {
        title: 'سابقه مصرف در حال تکمیل است',
        description: 'مصرف اخیرِ پردازش‌شده نمایش داده می‌شود و با پیشرفت پردازش، سابقه قدیمی‌تر نیز اضافه خواهد شد.'
      },
      partial: {
        title: 'اطلاعات این بازه کامل نیست',
        description: 'مجموع‌ها و نمودارها فقط رکوردهای پردازش‌شده را نشان می‌دهند و پس از تکمیل پوشش ممکن است افزایش یابند.'
      },
      stale: {
        title: 'به‌روزرسانی آمار مصرف با تأخیر انجام شده است',
        description: 'آخرین رکوردهای پردازش‌شده نمایش داده می‌شوند، اما ممکن است مصرف جدیدتر هنوز لحاظ نشده باشد.'
      },
      error: {
        title: 'پردازش آمار مصرف نیاز به بررسی دارد',
        description:
          'آخرین رکوردهای پردازش‌شده در صورت وجود نمایش داده می‌شوند. پس از بازیابی پردازشگر، صفحه را تازه‌سازی کنید.'
      }
    },
    recommendations: {
      title: 'پیشنهادها',
      subtitle: 'بر پایهٔ مصرف API شما در ۳۰ روز گذشته، با نرخ‌های امروز کاتالوگ.',
      lead: 'تغییرهای زیر می‌تواند هزینهٔ ۳۰ روز شما را حدود {low} تا {high} {unit} کم کند؛ یعنی {lowShare} تا {highShare} از {spend} {unit} که خرج کرده‌اید.',
      leadCentral:
        'تغییرهای زیر می‌تواند هزینهٔ ۳۰ روز شما را حدود {central} {unit} کم کند؛ یعنی {share} از {spend} {unit} که خرج کرده‌اید.',
      leadNone: 'در ۳۰ روز گذشته نشانه‌ای از تغییری که هزینهٔ شما را به‌طور محسوس کم کند دیده نمی‌شود.',
      estimateNote:
        'برآوردها با نرخ‌های قابل پرداخت امروز کاتالوگ شامل کارمزدهای قابل اعمال و ترکیب توکن‌های خود شما حساب شده‌اند. برآورد است، نه صورت‌حساب شما.',
      stale: {
        evidence: '{share} از هزینهٔ شما ({spend} {unit}) هنوز روی مدل‌هایی می‌رود که نسخهٔ جدیدتر پیشنهادی دارند.'
      },
      urgent: {
        imminent: '{model} در {date} بازنشسته می‌شود. ترافیک این مدل را زودتر از بقیه منتقل کنید.',
        retired: '{model} در {date} بازنشسته شد. ممکن است درخواست‌ها به آن دیگر پاسخ نگیرند.'
      },
      empty: {
        title: 'در ۳۰ روز گذشته مصرف API نداشته‌اید',
        hint: 'پیشنهادها پس از ارسال درخواست با کلید API نمایش داده می‌شوند.',
        cta: 'یک مدل را در استودیو مدل امتحان کنید'
      },
      cache: {
        title: 'کش پرامپت',
        ratioLabel: 'نسبت برخورد کش',
        basis:
          'فقط پرامپت‌های مدل‌هایی که کش دارند حساب شده است؛ یعنی {share} از توکن‌های پرامپت متنی شما. صفحهٔ نمایش مصرف همهٔ مدل‌ها را حساب می‌کند، پس عددش ممکن است فرق کند.',
        trackLabel: 'نسبت برخورد کش {ratio}. مرحله: {stage}.',
        stagesLabel: 'مراحل کش',
        stages: {
          cold: 'سرد',
          warming: 'در حال گرم شدن',
          warm: 'گرم',
          hot: 'بیشینه'
        },
        stageRange: {
          first: 'کمتر از {to}',
          middle: '{from} تا {to}',
          last: '{from} و بیشتر'
        },
        trendUp: '{count} واحد درصد بیشتر از هفتهٔ قبل',
        trendDown: '{count} واحد درصد کمتر از هفتهٔ قبل',
        trendFlat: 'تقریباً مثل هفتهٔ قبل',
        reach:
          'اگر مدل‌های واجد شرایط شما به مرحلهٔ {stage} ({target}) برسند، در ۳۰ روز حدود {amount} {unit} صرفه‌جویی می‌کنید.',
        realized: 'کش در این بازه تاکنون حدود {amount} {unit} برای شما صرفه‌جویی کرده است.',
        nextStepTitle: 'قدم بعدی شما',
        nextStep: {
          cold: 'بخش‌هایی را که بین درخواست‌ها تکرار می‌شوند، مثل پرامپت سیستم، تعریف ابزارها و اسناد مرجع، اول بیاورید و داده‌های مخصوص هر درخواست را به انتها منتقل کنید.',
          warming:
            'در مدل‌های OpenAI برای هر کاربر یا گفت‌وگو یک prompt_cache_key ثابت بفرستید تا درخواست‌های مرتبط به همان کش برسند.',
          warm: 'اگر مدل پشتیبانی می‌کند، prompt_cache_retention را روی 24h بگذارید تا پیشوندهای کش‌شده در ساعت‌های کم‌کار هم بمانند.',
          hot: 'کش شما خوب کار می‌کند. هنگام ویرایش پرامپت‌ها، پیشوند و ترتیب ابزارها را ثابت نگه دارید.'
        },
        breakersTitle: 'چه چیزهایی معمولاً برخورد کش را از بین می‌برند',
        breakers: {
          timestamps: 'زمان، شناسهٔ درخواست یا نام کاربر در ابتدای پرامپت',
          tools: 'تعریف ابزارها با ترتیبی متفاوت در هر درخواست',
          settings: 'تغییر تنظیمات استدلال یا ابزارها در میانهٔ گفت‌وگو',
          models: 'عوض کردن مدل در میانهٔ گفت‌وگو؛ هر مدل کش خودش را دارد'
        },
        states: {
          noUsage: 'در ۳۰ روز گذشته پرامپت متنی نداشته‌اید، پس هنوز نسبت برخورد کشی برای نمایش نیست.',
          notEligible:
            'فقط {share} از توکن‌های پرامپت متنی شما روی مدل‌های دارای کش و در درخواست‌های به‌اندازهٔ کافی بلند بوده است، پس کش جای زیادی برای کار ندارد.',
          unreported:
            'مدل‌هایی که استفاده می‌کنید توکن‌های کش‌شده را گزارش نمی‌کنند، پس نسبت برخورد کش قابل اندازه‌گیری نیست.'
        },
        minimum: 'کش از {tokens} توکن پرامپت در هر درخواست شروع می‌شود.',
        asideTitle: 'جایی که کش بیشترین صرفه‌جویی را دارد',
        asideCaption: 'برآورد ۳۰ روز در {target}',
        asideLink: 'همهٔ مدل‌ها را در صفحهٔ نمایش مصرف ببینید'
      },
      savings: {
        title: 'راه‌های کم کردن هزینه',
        switchTitle: '{model} را به {target} منتقل کنید',
        flexTitle: 'برای {model} از نرخ منعطف استفاده کنید',
        share: '{low} تا {high} از هزینهٔ {model}',
        shareCentral: 'حدود {share} از هزینهٔ {model}',
        empty: 'گزینهٔ ارزان‌تری که روی مدل‌های شما صرفه‌جویی محسوسی داشته باشد پیدا نشد.',
        showMore: '{count} مورد دیگر',
        showFewer: 'نمایش کمتر'
      },
      lifecycle: {
        title: 'مدل‌های جدیدتر و در حال بازنشستگی',
        retireTitle: '{model} را پیش از {date} کنار بگذارید',
        retiredTitle: '{model} را کنار بگذارید؛ در {date} بازنشسته شد',
        upgradeTitle: '{successor} را به جای {model} امتحان کنید',
        daysLeft: '{count} روز مانده',
        retired: 'بازنشسته',
        costsLess: '{successor} برای ترکیب مصرف شما {percent} ارزان‌تر است',
        costsMore: '{successor} برای ترکیب مصرف شما {percent} گران‌تر است',
        costsSame: 'هزینهٔ {successor} برای ترکیب مصرف شما تقریباً همان است',
        replacement: 'جایگزین پیشنهادی: {successor}',
        noSuccessor: 'جایگزین مستقیمی در کاتالوگ نیست. اطلاعیهٔ ارائه‌دهنده را برای این مدل ببینید.',
        empty: 'هیچ‌کدام از مدل‌های شما در حال بازنشستگی نیست و نسخهٔ جدیدتری هم که ارزش امتحان داشته باشد ندارد.'
      },
      caveats: {
        longContext:
          'میانگین پرامپت شما {average} توکن است، نزدیک یا بیشتر از {threshold}؛ از آنجا {model} نرخ بالاتر زمینهٔ طولانی را حساب می‌کند.',
        smallerContext: 'سقف ورودی {model} ({max} توکن) از {from} ({current} توکن) کمتر است.',
        missingCapabilities: '{model} این قابلیت‌ها را ندارد: {capabilities}.',
        narrowerEndpoints: '{model} روی {endpoints} در دسترس نیست.',
        cacheUnreported:
          '{model} توکن‌های کش‌شده را گزارش نمی‌کند، پس این برآورد همهٔ توکن‌های پرامپت را تازه فرض می‌کند.',
        crossFamily: '{model} از خانوادهٔ دیگری است، پس پاسخ‌ها ممکن است بیشتر از تفاوت دو نسخهٔ یک مدل تغییر کنند.',
        successorRetires: 'خود {model} هم قرار است در {date} بازنشسته شود.',
        flexTradeoffs:
          'درخواست‌های منعطف در صف با کمترین اولویت می‌مانند، دوباره تلاش نمی‌شوند و مسیر جایگزین ندارند. از آن برای کارهای دسته‌ای یا پس‌زمینه‌ای که می‌توانند صبر کنند استفاده کنید.',
        untested:
          'ما قیمت‌ها را مقایسه می‌کنیم، نه کیفیت پاسخ‌ها را. پیش از انتقال ترافیک اصلی، ارزیابی‌های خودتان را اجرا کنید.'
      },
      capabilities: {
        vision: 'ورودی تصویر',
        audioInput: 'ورودی صدا',
        audioOutput: 'خروجی صدا',
        reasoning: 'استدلال',
        functionCalling: 'فراخوانی تابع',
        promptCaching: 'کش پرامپت',
        responseSchema: 'خروجی ساختاریافته',
        webSearch: 'جست‌وجوی وب'
      },
      progress: {
        doneTag: 'منتقل شده',
        done: 'در ۷ روز گذشته همهٔ این ترافیک روی {target} اجرا شده است.',
        inProgress: 'در ۷ روز گذشته بخشی از این ترافیک روی {target} اجرا شده است.'
      },
      details: {
        why: 'چرا این را می‌بینید',
        switchWhy:
          '{model} در ۳۰ روز گذشته {cost} {unit} برای شما هزینه داشت. با نرخ‌های فهرست، همین توکن‌ها روی {target} به جای {current} {unit}، {candidate} {unit} می‌شد.',
        flexWhy:
          '{model} در ۳۰ روز گذشته {cost} {unit} برای شما هزینه داشت. با service_tier برابر flex، همین توکن‌ها به جای {current} {unit}، {candidate} {unit} می‌شد.',
        retireWhy: '{model} در {date} بازنشسته می‌شود. پس از این تاریخ ارائه‌دهنده آن را ارائه نمی‌کند.',
        retiredWhy: '{model} در {date} بازنشسته شد. ارائه‌دهنده دیگر پاسخ‌گویی آن را تضمین نمی‌کند.',
        upgradeWhy: '{successor} مدل جدیدتر در همان خانوادهٔ {model} است.',
        promotedWhy: 'برای ترافیکی که روی {model} اجرا می‌شود، {successor} را پیشنهاد می‌کنیم.',
        labels: 'در مصرف شما با این نام‌ها ثبت شده است: {labels}.',
        mix: 'یک درخواست میانگین {input} توکن ورودی تازه، {cached} توکن ورودی کش‌شده و {output} توکن خروجی داشت.',
        pricesCaption: 'نرخ‌های فهرست به ازای ۱ میلیون توکن، به {unit}',
        price: 'نرخ',
        input: 'ورودی',
        cachedInput: 'ورودی کش‌شده',
        output: 'خروجی',
        notListed: 'ثبت نشده',
        flexColumn: '{model} با نرخ منعطف',
        thingsToCheck: 'پیش از انتقال'
      },
      actions: {
        snooze: 'تعویق',
        snoozeFor: 'برای {count} روز',
        dismiss: 'رد کردن',
        restore: 'بازگرداندن',
        tryInStudio: '{model} را در استودیو مدل امتحان کنید',
        openCalculator: 'باز کردن در ماشین حساب',
        seeAccessLevels: 'دیدن سطح‌های دسترسی',
        openOverview: 'باز کردن نمایش مصرف'
      },
      toasts: {
        snoozed: 'برای {count} روز به تعویق افتاد',
        dismissed: 'رد شد',
        restored: 'بازگردانده شد'
      },
      hidden: {
        title: 'پیشنهادهای پنهان ({count})',
        snoozedUntil: 'به تعویق افتاده تا {date}',
        dismissed: 'رد شده. اگر صرفه‌جویی نصف بیشتر شود یا تاریخ بازنشستگی نزدیک شود، دوباره نمایش داده می‌شود.'
      },
      notes: {
        unresolved: 'در کاتالوگ مدل‌ها نیست، پس پیشنهادی برایش نداریم: {labels}.',
        fallbackCatalogue: 'نرخ‌ها از فهرست پشتیبان مدل‌ها آمده‌اند، پس ممکن است برخی جزئیات نباشد.',
        catalogueFailed:
          'کاتالوگ نرخ مدل‌ها بارگیری نشد، پس صرفه‌جویی قابل برآورد نیست. چند لحظهٔ دیگر دوباره تلاش کنید.',
        tierTag: 'نیازمند {tier}'
      },
      flexDocsLink: 'نرخ منعطف چطور کار می‌کند',
      flexDocsUrl: 'https://docs.avalai.ir/fa/service-tiers'
    }
  },
  feedback: {
    sendFeedback: 'ثبت بازخورد',
    description: 'نظر خود را با ما در میان بگذارید',
    title: 'عنوان',
    titleInputPlaceHolder: 'چه موضوعی مد نظر شماست؟',
    body: 'بازخورد',
    bodyInputPlaceHolder: 'بازخورد شما، هر آنچه که میخواهید با ما در میان بگذارید.',
    footerDescription:
      'ارائه بازخورد می‌تواند به ما کمک کند تا سیستم خود را بهبود بخشیم و تجربه کاربری را برای همه بهتر کنیم.',
    sendButton: 'ارسال',
    thankYouTitle: 'متشکریم!',
    thankYouMessage:
      'ما بازخورد شما را دریافت کردیم. معمولا دو روز طول می‌کشد تا پاسخی از ما دریافت کنید، اما گاهی اوقات زودتر.',

    okayButton: 'باشه',
    sendFailed: 'ارسال بازخورد با خطا مواجه شد',
    sendSuccess: 'بازخورد ثبت شد',
    bodyCantBeEmpty: 'متن بازخورد نمیتواند خالی باشد',
    bodyTooShort: 'متن بازخورد نباید کمتر از ۲۰ کاراکتر باشد'
  },
  languages: {
    'fa-IR': 'فارسی',
    'en-US': 'انگلیسی'
    // Add other languages as needed
  },
  paymentStatus: {
    success: 'موفق',
    pending: 'در انتظار',
    failed: 'ناموفق',
    processing: 'در حال پردازش'
  },
  status: {
    pending: 'در انتظار',
    completed: 'تکمیل شده',
    failed: 'ناموفق'
  },
  reports: {
    reportGenerationSubmitted:
      'درخواست گزارش ثبت شد. وضعیت آن را در فهرست زیر دنبال کنید؛ آماده‌سازی برخی گزارش‌ها تا ۶۰ دقیقه طول می‌کشد.',
    downloadFailed: 'دریافت گزارش انجام نشد. وضعیت و تاریخ انقضای آن را بررسی کنید و دوباره تلاش کنید.',
    fetchFailed: 'فهرست گزارش‌ها بارگذاری نشد. صفحه را به‌روزرسانی کنید و دوباره تلاش کنید.',
    generatedSuccessfully: 'گزارش با موفقیت صادر و دریافت شد.',
    generationFailed: 'صدور گزارش انجام نشد. کمی بعد دوباره تلاش کنید.',
    linkedReportUnavailable: 'گزارش موردنظر در دسترس نیست؛ ممکن است منقضی شده باشد یا به این حساب تعلق نداشته باشد.',
    workspace: {
      subtitle: 'برای کل حساب، یک بسته اعتباری خریداری‌شده یا اعتبار هدیه، گزارش مصرف قابل استناد صادر کنید.',
      builderTitle: 'صدور گزارش مستند',
      builderDescription: 'منبع اعتبار و بازه زمانی را انتخاب کنید؛ فایل PDF و بسته اسناد ZIP همان بازه را پوشش می‌دهند.',
      notAvailable: 'در دسترس نیست',
      retry: 'تلاش دوباره',
      loading: 'در حال بارگذاری گزارش‌ها…',
      language: 'زبان گزارش',
      privacyNote: 'در هر ردیف، نشانی IP درخواست و نام پوشیده کلید API ثبت‌شده درج می‌شود.',
      submitted: 'درخواست گزارش شما ثبت شد. وضعیت لحظه‌ای آن در فهرست زیر نمایش داده می‌شود.',
      subject: {
        label: 'موضوع گزارش',
        user: 'کل حساب',
        creditPackage: 'بسته اعتباری',
        grant: 'اعتبار هدیه'
      },
      source: {
        label: 'منبع اعتبار',
        packagePlaceholder: 'یکی از بسته‌های اعتباری خود را انتخاب کنید',
        grantPlaceholder: 'یکی از اعتبارهای هدیه خود را انتخاب کنید',
        empty: 'برای این نوع گزارش، منبع اعتباری متعلق به شما یافت نشد.'
      },
      period: {
        label: 'بازه گزارش',
        preset: 'بازه آماده',
        custom: 'بازه دلخواه',
        dateRange: 'زمان شروع و پایان',
        startDate: 'تاریخ شروع',
        endDate: 'تاریخ پایان'
      },
      proofTitle: 'اسناد قابل راستی‌آزمایی',
      proofDescription: 'در هر گزارش تکمیل‌شده، موضوع، بازه زمانی و وضعیت اسناد یکجا نگه داشته می‌شود.',
      proofStatus: 'قابل حسابرسی',
      proofItems: {
        scopeLabel: 'دامنه',
        scope: 'مشخص می‌کند گزارش کدام حساب، بسته اعتباری یا اعتبار هدیه را پوشش می‌دهد.',
        evidenceLabel: 'پوشش',
        evidence: 'تراکنش‌های دارای تخصیص دقیق را از مصرف قدیمی تخصیص‌نیافته جدا می‌کند.',
        artifactsLabel: 'فایل‌ها',
        artifacts: 'فایل PDF و بسته اسناد ZIP شناسه گزارش یکسان و کد SHA-256 دارند.',
        privacyLabel: 'حریم خصوصی',
        privacy: 'نشانی IP و برچسب ماسک‌شده کلید API درج می‌شود، نه مقدار محرمانه کلید.'
      },
      history: {
        title: 'تاریخچه گزارش‌ها',
        description: 'وضعیت صدور گزارش‌ها را دنبال کنید و فایل‌های اسناد را دریافت کنید.',
        total: 'تعداد گزارش‌ها:',
        empty: 'تا کنون گزارشی صادر نشده است.',
        emptyHint: 'پس از صدور، وضعیت گزارش همین‌جا نمایش داده می‌شود.',
        updatedAt: 'آخرین به‌روزرسانی',
        refreshFailed: 'تازه‌سازی انجام نشد؛ فهرست قبلی نمایش داده می‌شود.',
        pageSummary: 'نمایش {from} تا {to} از {total} گزارش',
        perPage: '{count} در هر صفحه'
      },
      columns: {
        generatedAt: 'زمان صدور',
        scope: 'موضوع',
        period: 'بازه زمانی',
        evidence: 'اسناد',
        status: 'وضعیت',
        actions: 'فایل‌ها'
      },
      evidence: {
        title: 'پوشش مستندات',
        coverage: 'درصد پوشش',
        exact: 'تراکنش‌های دارای تخصیص دقیق',
        legacy: 'تراکنش‌های قدیمی تخصیص‌نیافته',
        caveat: 'مبالغ تراکنش‌های قدیمی تخصیص‌نیافته در محاسبه صرفه‌جویی تأییدشده لحاظ نمی‌شود.'
      },
      financial: {
        title: 'اسناد مالی',
        purchaseDiscount: 'تخفیف خرید',
        consumedPackage: 'اعتبار مصرف‌شده از بسته',
        effectivePaidRate: 'نرخ مؤثر پرداخت',
        realizedSavings: 'صرفه‌جویی محقق‌شده',
        sponsoredCredit: 'اعتبار هدیه مصرف‌شده'
      },
      artifacts: {
        title: 'فایل‌های گزارش',
        pdf: 'خلاصه PDF',
        csv: 'اسناد CSV قدیمی',
        evidenceZip: 'بسته اسناد ZIP',
        legacyCsv: 'اسناد CSV قدیمی',
        pdfDescription: 'خلاصه تحلیلی و خوانا از مصرف، توکن‌ها، تفکیک هزینه‌ها و اسناد مالی.',
        evidenceDescription:
          'اسناد CSV فشرده، شامل نشانی IP هر درخواست، برچسب ماسک‌شده کلید API، فایل مانیفست برای راستی‌آزمایی و راهنما.',
        legacyCsvDescription: 'فایل اسناد سازگار با نسخه‌های پیشین سامانه.',
        filename: 'نام فایل',
        compressedSize: 'حجم فشرده',
        schemaVersion: 'نسخه ساختار',
        digest: 'SHA-256',
        archiveContents: 'محتویات بسته',
        archiveContentsValue: 'فایل‌های اسناد CSV، فایل manifest.json و راهنمای فارسی',
        zip: 'گزارش ZIP قدیمی',
        legacy: 'این گزارش از قالب دریافت یکپارچه نسخه‌های پیشین استفاده می‌کند.',
        download: 'دریافت',
        downloadPDF: 'دریافت خلاصه PDF',
        downloadCSV: 'دریافت اسناد CSV قدیمی',
        downloadEvidenceZip: 'دریافت بسته اسناد ZIP',
        downloadLegacyCsv: 'دریافت اسناد CSV قدیمی',
        downloadZip: 'دریافت گزارش ZIP قدیمی',
        invalidFormat: 'فایل دریافت‌شده با قالب مورد انتظار گزارش مطابقت ندارد.',
        downloadFailed: 'دریافت فایل گزارش انجام نشد. فهرست را به‌روزرسانی کنید و دوباره تلاش کنید.',
        pending: 'این فایل هنوز در حال آماده‌سازی است.',
        failed: 'آماده‌سازی این فایل انجام نشد.',
        missing: 'پیوند امضاشده‌ای برای دریافت این فایل وجود ندارد.',
        expired: 'پیوند دریافت منقضی شده است. برای ساخت پیوند تازه، فهرست را به‌روزرسانی کنید.',
        unavailable: 'این فایل در دسترس نیست.'
      },
      summary: {
        title: 'جزئیات مستندات گزارش',
        open: 'مشاهده جزئیات'
      },
      failure: {
        generationFailed: 'صدور گزارش انجام نشد. دوباره تلاش کنید.',
        unknownFailure: 'گزارش تکمیل نشد. جزئیات فنی سامانه نمایش داده نمی‌شود.'
      },
      errors: {
        unauthenticated: 'برای دسترسی به گزارش‌ها دوباره وارد حساب خود شوید.',
        rate_limited: 'سقف صدور گزارش برای این بازه تکمیل شده است. کمی بعد دوباره تلاش کنید.',
        server_error: 'سرویس گزارش موقتا در دسترس نیست.',
        network_error: 'ارتباط با سرویس گزارش برقرار نشد. اتصال اینترنت خود را بررسی کنید و دوباره تلاش کنید.',
        invalidSelection: 'پیش از صدور گزارش، منبع اعتبار و بازه زمانی معتبری انتخاب کنید.'
      }
    },
    title: 'گزارش مصرف API',
    timeFrame: 'بازه زمانی',
    generateReport: 'صدور گزارش',
    lastHour: 'یک ساعت گذشته',
    last6Hours: '۶ ساعت گذشته',
    last12Hours: '۱۲ ساعت گذشته',
    lastDay: '۲۴ ساعت گذشته',
    last2Days: '۴۸ ساعت گذشته',
    last3Days: '۷۲ ساعت گذشته',
    lastWeek: 'هفته گذشته',
    last28Days: '۲۸ روز گذشته',
    lastMonth: 'ماه گذشته',
    last3Months: '۳ ماه گذشته',
    columns: {
      origin: 'منشأ'
    },
    origin: {
      selfService: 'صدور توسط کاربر',
      support: 'پشتیبانی'
    }
  },
  billing: {
    addresses: {
      title: 'آدرس‌های صورتحساب',
      subtitle: 'آدرس‌هایی که برای رسید، صورتحساب رسمی و درخواست‌های پشتیبانی استفاده می‌شوند.',
      add: 'افزودن آدرس',
      addFirst: 'افزودن اولین آدرس',
      total: 'آدرس‌های ذخیره‌شده',
      currentDefault: 'آدرس پیش‌فرض فعلی',
      historyProtection: 'سوابق تاریخی',
      historyProtectionValue: 'محافظت‌شده',
      none: 'بدون آدرس',
      noName: 'بدون عنوان',
      default: 'پیش‌فرض',
      makeDefault: 'تنظیم به‌عنوان پیش‌فرض',
      edit: 'ویرایش',
      delete: 'حذف',
      deleteAll: 'حذف همه آدرس‌ها',
      searchPlaceholder: 'جستجوی عنوان، شهر، آدرس یا کد پستی',
      empty: 'آدرس صورتحسابی ذخیره نشده است',
      noResults: 'آدرسی مطابق جستجوی شما یافت نشد',
      loadFailed: 'دریافت آدرس‌ها با خطا مواجه شد.',
      retry: 'تلاش دوباره',
      defaultSuccess: 'آدرس پیش‌فرض به‌روزرسانی شد',
      defaultFailed: 'به‌روزرسانی آدرس پیش‌فرض ناموفق بود',
      deleteSuccess: 'آدرس حذف شد',
      deleteFailed: 'حذف آدرس ناموفق بود',
      defaultDeleteBlocked: 'پیش از حذف این آدرس، آدرس دیگری را پیش‌فرض کنید.',
      inUseDeleteBlocked: 'این آدرس در سابقه پرداخت، صورتحساب یا درخواست پشتیبانی استفاده شده است.',
      deleteConfirm: 'آدرس {name} حذف شود؟ این آدرس از دفترچه آدرس فعال شما خارج می‌شود.',
      deleteConfirmAction: 'حذف آدرس',
      deleteAllConfirmTitle: 'همه آدرس‌های ذخیره‌شده حذف شوند؟',
      deleteAllConfirmDescription:
        'تمام آدرس‌ها، از جمله آدرس پیش‌فرض، از دفترچه آدرس فعال حذف می‌شوند. سوابق مالی گذشته بدون تغییر باقی می‌مانند.',
      deleteAllConfirmAction: 'حذف همه',
      deleteAllSuccess: '{count} آدرس حذف شد',
      deleteAllFailed: 'حذف دفترچه آدرس ناموفق بود',
      summaryLabel: 'خلاصه آدرس‌ها',
      statusRegion: 'وضعیت دفترچه آدرس',
      loadingLabel: 'در حال بارگذاری آدرس‌های شما',
      updatedAt: 'به‌روزرسانی',
      refreshFailed: 'تازه‌سازی انجام نشد؛ آخرین فهرست دریافت‌شده نمایش داده می‌شود.',
      toolbarLabel: 'جست‌وجو و مدیریت آدرس‌ها',
      emptyHint: 'آدرس صورتحساب برای صدور رسید و صورتحساب رسمی و برای درخواست‌های پشتیبانی استفاده می‌شود.',
      noResultsHint: 'عبارت دیگری را جست‌وجو کنید یا جست‌وجو را پاک کنید.',
      clearSearch: 'پاک کردن جست‌وجو'
    },
    invoices: {
      buyerReview: {
        action: "بررسی اطلاعات صورتحساب",
        title: "بررسی اطلاعات صورتحساب",
        description: "این مورد را در اطلاعات صورتحساب بررسی کنید، سپس درخواست بررسی دوباره بدهید.",
        history: "تغییرات، اطلاعات فعلی صورتحساب شما را برای استفاده‌های بعدی و بررسی پشتیبانی به‌روز می‌کند و صورتحساب موجود را تغییر نمی‌دهد.",
        reviewDetails: "مشاهده یا ویرایش اطلاعات صورتحساب",
        finishDetails: "بررسی اطلاعات تمام شد",
        chooseAddress: "نشانی موردنظر را برای مشاهده یا ویرایش انتخاب کنید.",
        currentAddressOnly: 'انتخاب نشانی در این بخش، نشانی این پرداخت را جایگزین نمی‌کند. برای استفاده از نشانی دیگری، در تیکت به پشتیبانی اطلاع دهید.',
        accountMobileHint: 'شماره همراه از اطلاعات حساب شما گرفته می‌شود. آن را در اطلاعات حساب بررسی کنید یا از پشتیبانی کمک بگیرید. تغییر تلفن نشانی صورتحساب، شماره همراه حساب یا صورتحساب موجود را تغییر نمی‌دهد.',
        requestSupport: "تماس با پشتیبانی",
        requestAgain: "درخواست بررسی دوباره",
        requested: "درخواست بررسی شما ثبت شد",
        pending: "تیکت شما همراه با اطلاعات پرداخت و کد پیگیری ثبت شده است. ادامه بررسی و توضیحات بیشتر را در تیکت دنبال کنید.",
        pendingWithoutTicket: 'درخواست بررسی قبلا ثبت شده است. برای پیگیری، تیکت‌های پشتیبانی خود را باز کنید.',
        followReview: "پیگیری بررسی صورتحساب",
        openTicket: "مشاهده تیکت پشتیبانی",
        findTicket: "مشاهده تیکت‌های من",
        ticketNumber: "شماره تیکت:",
        opensNewTab: "صفحه پشتیبانی در زبانه جدید باز می‌شود و این صفحه باز می‌ماند.",
        detailsSaved: "اطلاعات صورتحساب ذخیره شد",
        savedNextStep: "اکنون درخواست بررسی دوباره بدهید تا پشتیبانی اطلاعات به‌روز شما را برای این صورتحساب بررسی کند.",
        savedWithTicket: "اطلاعات شما ذخیره شد. تغییرات را در تیکت قبلی به پشتیبانی اطلاع دهید تا بررسی ادامه پیدا کند.",
        shareChanges: "اطلاع تغییرات در تیکت پشتیبانی",
        manualReviewHint: "برای بررسی توسط پشتیبانی، یک تیکت ایجاد می‌شود. تغییر این صورتحساب نیاز به بررسی پشتیبانی دارد.",
        assertion: "پشتیبانی چه موردی را بررسی کند؟",
        details_updated: "اطلاعات صورتحساب را به‌روز کردم",
        details_already_correct: "اطلاعات صورتحساب من صحیح است",
        need_help: "برای بررسی اطلاعات به کمک نیاز دارم",
        failed: 'درخواست بررسی ثبت نشد. لطفا دوباره تلاش کنید.',
        fieldIssue: "{field}: {issue}",
        fields: {
          details: "اطلاعات صورتحساب",
          type: "نوع خریدار",
          name: "نام و نام خانوادگی",
          company_name: "نام شرکت",
          national_id: "کد ملی یا شناسه ملی",
          tax_id: "کد اقتصادی",
          registration_number: "شماره ثبت",
          postal_code: "کد پستی",
          address: "نشانی",
          phone: "شماره تلفن",
          mobile: "شماره همراه",
          email: "نشانی ایمیل",
          contact: "اطلاعات تماس"
        },
        issues: {
          required: "الزامی است",
          invalid: "این مقدار را بررسی کنید",
          too_long: "این مقدار بیش از حد طولانی است"
        }
      },
      title: 'صورتحساب‌ها و رسیدها',
      subtitle: 'رسیدها و صورتحساب‌های رسمی پرداخت‌های تاییدشده شما.',
      total: 'مجموع اسناد',
      filters: 'فیلترها',
      allTypes: 'همه انواع سند',
      allStatuses: 'همه وضعیت‌ها',
      standard: 'رسید پرداخت',
      vat: 'ارزش افزوده',
      type: 'نوع سند',
      status: 'وضعیت',
      dateRange: 'تاریخ پرداخت',
      startDate: 'از تاریخ',
      endDate: 'تا تاریخ',
      payment: 'پرداخت',
      paymentPlaceholder: 'شناسه تراکنش پرداخت',
      invalidPaymentId: 'شناسه تراکنش پرداخت باید یک UUID معتبر باشد.',
      invalidDateRange: 'تاریخ شروع باید قبل از تاریخ پایان یا برابر با آن باشد.',
      apply: 'اعمال فیلتر',
      reset: 'پاک کردن',
      refresh: 'تازه‌سازی',
      tableDate: 'تاریخ',
      tableType: 'نوع سند',
      tablePayment: 'پرداخت',
      tableAmount: 'مبلغ پرداختی',
      tableStatus: 'وضعیت',
      tableDocument: 'اسناد',
      actions: 'عملیات',
      receipt: 'رسید',
      vatInvoice: 'صورتحساب ارزش افزوده',
      downloadReceipt: 'دریافت رسید',
      downloadVat: 'دریافت صورتحساب ارزش افزوده',
      resendEmail: 'ارسال دوباره با ایمیل',
      requestDocuments: 'درخواست تولید اسناد',
      requestReceipt: 'درخواست رسید',
      requestVat: 'درخواست صورتحساب ارزش افزوده',
      openInvoice: 'مشاهده صورتحساب',
      loadFailed: 'دریافت صورتحساب‌ها با خطا مواجه شد.',
      refreshFailed: 'تازه‌سازی صورتحساب‌ها انجام نشد. نتایج فعلی همچنان در دسترس هستند.',
      downloadFailed: 'دریافت سند با خطا مواجه شد.',
      downloadSuccess: 'سند دریافت شد.',
      resendFailed: 'درخواست ارسال ایمیل ثبت نشد.',
      resendQueued: 'ارسال ایمیل صورتحساب در صف قرار گرفت.',
      requestFailed: 'درخواست تولید سند ثبت نشد.',
      requestQueued: 'تولید اسناد در صف قرار گرفت.',
      requestAlreadyAvailable: 'سند از قبل آماده و در دسترس است.',
      requestAlreadyProcessing: 'تولید سند از قبل در حال انجام است.',
      empty: 'صورتحسابی یافت نشد',
      emptyDescription: 'سند پرداختی با این فیلترها وجود ندارد.',
      updatedAt: 'به‌روزرسانی',
      loading: 'در حال دریافت اسناد',
      refreshing: 'در حال تازه‌سازی…',
      onThisPage: 'در این صفحه',
      vatOnThisPage: 'صورتحساب رسمی در این صفحه',
      noDocuments: 'هنوز سندی صادر نشده است.',
      noDocumentsHint: 'برای هر پرداخت تاییدشده، رسید یا صورتحساب رسمی همین‌جا فهرست می‌شود.',
      pageSummary: '{from} تا {to} از {total} سند',
      toman: 'تومان',
      taxRegistration: {
        system: 'سامانه مودیان',
        helpLabel: 'درباره ثبت در سامانه مودیان',
        help: 'شناسه مالیاتی معمولا ظرف ۵ روز در دسترس قرار می‌گیرد و مهلت قانونی ۱۴ روز از تاریخ صدور صورتحساب است. این شناسه اثبات‌کننده ارسال یا پذیرش صورتحساب در سامانه مودیان نیست.',
        notice:
          'شناسه مالیاتی معمولا ظرف ۵ روز در دسترس قرار می‌گیرد. مهلت قانونی ۱۴ روز از تاریخ صدور صورتحساب است. نمایش شناسه به معنای ارسال یا پذیرش در سامانه مودیان نیست.',
        pending: 'در حال انجام',
        identifier: 'شناسه مالیاتی',
        notApplicable: 'مشمول نیست',
        copy: 'کپی شناسه مالیاتی',
        copySuccess: 'شناسه مالیاتی کپی شد.',
        copyFailed: 'کپی شناسه مالیاتی انجام نشد.',
        overdue: 'مهلت قانونی ثبت گذشته است و شناسه مالیاتی هنوز در دسترس نیست.',
        contactSupport: 'تماس با پشتیبانی',
        supportRequested: 'درخواست پشتیبانی ثبت شد.',
        supportFailed: 'ثبت درخواست پشتیبانی انجام نشد. دوباره تلاش کنید.',
        ticketNumber: 'شماره تیکت:',
        viewTicket: 'مشاهده تیکت پشتیبانی'
      },
      categories: {
        subscription: 'اشتراک',
        credit_topup: 'افزایش اعتبار',
        credit_package: 'بسته اعتباری'
      },
      documentStatuses: {
        generating: 'در حال آماده‌سازی',
        receiptGenerating: 'رسید پرداخت در حال آماده‌سازی است',
        vatGenerating: 'صورتحساب رسمی مهرشده در حال آماده‌سازی است',
        available: 'در دسترس',
        unavailable: 'در دسترس نیست'
      }
    },
    noCreditPackages: 'بسته اعتباری فعال نیست',
    creditPage: {
      tagline: 'کیف پول شما، اعتبارات، و بسته‌های اعتباری.',
      updatedAt: 'به‌روزرسانی',
      walletTitle: 'کیف پول',
      totalLabel: 'مجموع اعتبار قابل استفاده',
      totalUnitEquivalent: 'معادل واحد اعتبار',
      totalHint: 'کیف پول شما دو نوع اعتبار دارد: اعتبار واحدی (بر پایه تتر) و اعتبار تومانی. این عدد مجموع هر دو بر حسب واحد اعتبار است: اعتبار واحدی، به‌علاوه اعتبار تومانی تقسیم بر نرخ تبدیل امروز.',
      totalHint2: 'هزینه هر درخواست بر حسب واحد اعتبار محاسبه و از همین مجموع کسر می‌شود؛ بنابراین همین عدد است که تعیین می‌کند درخواست شما پذیرفته شود یا نه. با تغییر نرخ تبدیل، معادل واحدیِ بخش تومانی هم تغییر می‌کند.',
      unitCredit: 'اعتبار واحدی',
      unitCreditHint: 'اعتبار واحدی بر پایه تتر (USDT) است و با تغییر نرخ دلار کم و زیاد نمی‌شود. از تبدیل اعتبار تومانی یا از اعتبارهای هدیه واحدی به دست می‌آید.',
      tomanCredit: 'اعتبار تومانی',
      tomanCreditHint: 'اعتبار تومانی با پرداخت بانکی اضافه می‌شود و مستقیم قابل مصرف است. در مجموع بالا با نرخ تبدیل امروز به واحد اعتبار محاسبه شده است.',
      approxInUnits: 'واحد اعتبار',
      oneUnitEquals: 'هر واحد اعتبار =',
      rateLine: 'نرخ تبدیل امروز',
      inconsistent: 'مجموع اعلام‌شده با جمع دو نوع اعتبار برابر نیست. مقدار اعلام‌شده توسط سرویس نمایش داده می‌شود.',
      negativeTitle: 'موجودی منفی است.',
      negativeHint: 'چند درخواست هم‌زمان بیش از موجودی برداشت کرده‌اند. برای فعال شدن دوباره سرویس، اعتبار خود را افزایش دهید.',
      emptyTitle: 'موجودی شما صفر است.',
      emptyHint: 'تا زمان افزایش اعتبار، درخواست‌ها پذیرفته نمی‌شوند.',
      loadFailed: 'دریافت موجودی با خطا مواجه شد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ آخرین موجودی دریافت‌شده نمایش داده می‌شود.',
      alertsLoadFailed: 'تنظیمات اعلان دریافت نشد.',
      convert: 'تبدیل اعتبار',
      convertHint: 'اعتبار خود را بین تومان و واحد اعتبار جابه‌جا کنید. کارمزد تبدیل پیش از تایید نمایش داده می‌شود: ۳٪ برای تبدیل تومان به واحد و ۶٪ برای تبدیل واحد به تومان.',
      convertUnavailable: 'برای تبدیل، ابتدا باید اعتباری در کیف پول داشته باشید.',
      sourcesTitle: 'بسته‌ها و اعتبارهای هدیه',
      sourcesHint: 'اعتبار بسته‌ها و هدیه‌ها پیش از کیف پول و فقط برای مدل‌های تحت پوشش مصرف می‌شود؛ باقی هزینه از کیف پول کسر می‌شود. نوار هر ردیف نشان می‌دهد چقدر از آن منبع باقی مانده است.',
      activeSources: 'فعال',
      inactiveHidden: '{count} منبع منقضی یا تمام‌شده در این فهرست نیست.',
      nextExpiry: 'نزدیک‌ترین انقضا',
      daysLeft: 'روز مانده',
      endsToday: 'امروز به پایان می‌رسد',
      noEndDate: 'بدون تاریخ پایان',
      remainingPercent: 'باقی‌مانده',
      noSources: 'بسته یا اعتبار هدیه فعالی ندارید.',
      noSourcesHint: 'بسته‌های اعتباری برای مدل‌های مشخص، اعتبار با تخفیف می‌دهند و پیش از کیف پول مصرف می‌شوند.',
      browsePackages: 'مشاهده بسته‌ها',
      manageSources: 'مدیریت',
      grant: 'هدیه',
      package: 'بسته',
      untitledGrant: 'اعتبار هدیه',
      untitledPackage: 'بسته اعتباری',
      notificationsTitle: 'اعلان موجودی',
      apiTitle: 'دریافت موجودی از API',
      apiHint: 'همین ارقام را می‌توانید با یک درخواست GET احرازشده دریافت کنید. برای اینکه بدانید درخواست پذیرفته می‌شود یا نه، total_unit را ملاک بگیرید.',
      apiLanguage: 'زبان نمونه کد',
      sampleResponse: 'نمونه پاسخ',
      copy: 'کپی',
      copied: 'کپی شد',
      field_remaining_irt: 'اعتبار تومانی',
      field_remaining_unit: 'اعتبار واحدی',
      field_exchange_rate: 'نرخ تبدیل امروز؛ تومان به ازای هر واحد اعتبار',
      field_total_unit: 'مجموع کیف پول بر حسب واحد اعتبار: remaining_unit + remaining_irt ÷ exchange_rate. پذیرش درخواست‌ها بر اساس این عدد است.',
      field_limit: 'سقف اعتبار تعیین‌شده برای حساب؛ در صورت نداشتن سقف، ۰.',
      tierMax: 'بالاترین سطح'
    },
    historyPage: {
      tagline: 'همه پرداخت‌های بانکی شما، با وضعیت، کد رهگیری و سند هر پرداخت.',
      updatedAt: 'به‌روزرسانی',
      loading: 'در حال دریافت تاریخچه پرداخت',
      filters: 'فیلترهای تاریخچه پرداخت',
      lookup: 'جست‌وجوی پرداخت',
      clearFilters: 'پاک کردن فیلترها',
      download: 'دریافت فهرست',
      downloadHint: 'همین فهرست فیلترشده را به صورت CSV یا Excel دریافت کنید.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ آخرین فهرست دریافت‌شده نمایش داده می‌شود.',
      noPayments: 'هنوز پرداختی ثبت نشده است.',
      noPaymentsHint: 'پس از اولین افزایش اعتبار، پرداخت‌ها با وضعیت و کد رهگیری اینجا فهرست می‌شوند.',
      noMatches: 'پرداختی با این فیلترها پیدا نشد.',
      noMatchesHint: 'فیلترها را پاک کنید یا شناسه دیگری را جست‌وجو کنید.',
      pageSummary: '{from} تا {to} از {total} پرداخت'
    },
    manageCreditPackages: 'مدیریت بسته‌های اعتباری',
    packagesTotalUnit: 'مجموع بسته‌های اعتباری معادل واحد',
    expirationTimeline: 'تاریخ انقضای بسته‌های اعتباری',
    creditBreakdown: 'بسته‌های اعتباری',
    unnamedPackage: 'بسته اعتباری',
    sortOptions: {
      featured: 'ویژه',
      price: 'قیمت (کم به زیاد)',
      valueRatio: 'نسبت ارزش',
      newest: 'جدیدترین',
      oldest: 'قدیمی‌ترین',
      expiration: 'زمان انقضا'
    },
    packages: {
      myPackages: 'بسته‌های من',
      myPackagesSubtitle: 'بسته‌ها و منابع اعتبار خود را مشاهده و مدیریت کنید',
      promotional: 'فروش ویژه',
      summary: {
        total: 'کل بسته‌ها',
        active: 'بسته‌های فعال',
        usage: 'میانگین استفاده',
        remaining: 'اعتبار باقی‌مانده',
        totalSources: 'کل منابع اعتبار',
        packages: 'بسته‌های اعتباری',
        grants: 'اعتبارهای هدیه',
        totalBalance: 'کل موجودی'
      },
      cancellation: {
        title: 'لغو بسته',
        openFor: 'لغو بسته {name}',
        reviewFor: 'بررسی شرایط لغو {name}',
        walletOnly:
          'هر مبلغ واجد بازگشت فقط به اعتبار عادی باقی‌مانده کیف پول شما افزوده می‌شود و هرگز بازپرداخت بانکی نیست.',
        windowPolicy: 'از زمان خرید باید کمتر از ۲۴ ساعت گذشته باشد.',
        usagePolicy: 'مصرف بسته باید حداکثر ۵٫۰۰ درصد، با احتساب خود این مقدار، باشد.',
        paymentPolicy: 'وجود پرداخت تاییدشده مرتبط با مبلغ پرداختی مثبت الزامی است.',
        otpPolicy: 'لغو با کد پیامکی انجام می‌شود؛ فقط اگر پیامک در دسترس نباشد از ایمیل تاییدشده استفاده می‌شود.',
        returnMathTitle: 'محاسبه بازگشت به کیف پول',
        technicalDetails: 'اسناد فنی و شناسه‌ها',
        usage: 'مصرف',
        sendCode: 'ارسال کد تایید',
        otpLabel: 'کد تایید شش‌رقمی',
        confirm: 'تایید لغو',
        receipt: 'رسید لغو',
        serverTime: 'زمان سرور',
        advisory: 'پیش‌نمایش اطلاع‌رسانی',
        lockedRevalidation: 'نیازمند بازبینی قفل‌شده',
        returnDestination: 'مقصد بازگشت',
        bankRefund: 'بازپرداخت بانکی',
        deadline: 'مهلت لغو',
        deadlineRemaining: 'زمان باقی‌مانده',
        usageLimit: 'سقف مصرف',
        faceCredit: 'اعتبار اولیه بسته',
        remainingCredit: 'اعتبار باقی‌مانده بسته',
        consumedCredit: 'اعتبار مصرف‌شده بسته',
        allocatedPaid: 'مبلغ پرداخت تخصیص‌یافته',
        walletReturn: 'بازگشت به کیف پول',
        eligible: 'این بسته برای لغو واجد شرایط است. شرایط نهایی پیش از تکمیل دوباره بررسی می‌شود.',
        channel: 'کانال تایید',
        challengeId: 'شناسه چالش',
        sentAt: 'زمان ارسال',
        expiresAt: 'زمان انقضا',
        challengeExpires: 'انقضای کد تا',
        maxAttempts: 'حداکثر تلاش',
        otpHelp: 'دقیقا شش رقم ASCII وارد کنید. کد پس از بستن این گفت‌وگو نگهداری نمی‌شود.',
        cancellationId: 'شناسه لغو',
        packageId: 'شناسه بسته',
        allocationId: 'شناسه تخصیص',
        paymentId: 'شناسه پرداخت',
        walletBefore: 'موجودی کیف پول پیش از لغو',
        walletAfter: 'موجودی کیف پول پس از لغو',
        completedAt: 'زمان تکمیل',
        receiptHash: 'هش رسید',
        reasons: {
          feature_disabled: 'لغو در دسترس نیست.',
          package_inactive: 'این بسته فعال نیست.',
          cancellation_window_elapsed: 'مهلت ۲۴ ساعته پایان یافته است.',
          invalid_package_amounts: 'مقادیر بسته قابل تایید نیستند.',
          usage_limit_exceeded: 'مصرف از سقف ۵٫۰۰٪ بیشتر است.',
          missing_purchase_allocation: 'تخصیص خرید در دسترس نیست.',
          payment_not_confirmed: 'پرداخت تایید نشده است.',
          paid_amount_unavailable: 'مبلغ پرداخت در دسترس نیست.',
          allocation_amount_unavailable: 'مبلغ تخصیص در دسترس نیست.',
          wallet_return_nonpositive: 'بازگشت کیف پولی وجود ندارد.',
          already_cancelled: 'این بسته قبلا لغو شده است.',
          authority_mismatch: 'تازه‌سازی و تلاش مجدد کنید.',
          verified_destination_unavailable: 'مقصد تاییدشده در دسترس نیست.',
          cancellation_ineligible: 'بسته واجد شرایط نیست.',
          challenge_context_changed: 'شرایط تغییر کرده است. پیش‌نمایش تازه را مرور کنید.',
          malformed_otp: 'شش رقم ASCII وارد کنید.',
          malformed_challenge: 'چالش نامعتبر است.',
          challenge_mismatch: 'چالش مطابقت ندارد.',
          challenge_consumed: 'چالش استفاده شده است.',
          challenge_not_delivered: 'کد تایید هنوز در حال ارسال است. کمی صبر کنید و دوباره تلاش کنید.',
          challenge_not_active: 'چالش فعال نیست.',
          challenge_expired: 'چالش منقضی شده است.',
          challenge_attempts_exhausted: 'تلاش‌ها تمام شده است.',
          challenge_binding_mismatch: 'زمینه تغییر کرده است.',
          consumption_evidence_mismatch: 'مصرف تغییر کرده است. پیش‌نمایش تازه را مرور کنید.',
          otp_invalid: 'کد نادرست است.',
          not_found: 'لغو در دسترس نیست.',
          rate_limited: 'تلاش زیاد است. بعدا دوباره تلاش کنید.',
          network_error: 'اتصال ناموفق بود. دوباره تلاش کنید.',
          unknown_error: 'لغو کامل نشد.'
        }
      },
      tabs: {
        overview: 'نمای کلی',
        usage: 'تحلیل استفاده',
        expiration: 'جدول زمانی انقضا'
      },
      analytics: {
        title: 'تحلیل منبع اعتبار',
        loading: 'در حال بارگذاری تحلیل منبع…',
        loadingTransactions: 'در حال بارگذاری تراکنش‌ها…',
        loadingMoreTransactions: 'در حال بارگذاری صفحه درخواستی تراکنش‌ها…',
        expand: 'مشاهده تحلیل',
        collapse: 'بستن تحلیل',
        expandFor: 'مشاهده تحلیل {name}',
        collapseFor: 'بستن تحلیل {name}',
        retry: 'تلاش دوباره',
        period: 'بازه',
        notAvailable: 'در دسترس نیست',
        consumedIrt: 'تومان مصرف‌شده',
        remainingIrt: 'تومان باقی‌مانده',
        utilization: 'میزان مصرف',
        remainingDays: 'روزهای باقی‌مانده',
        expiresAt: 'زمان انقضا',
        burnRate: 'تومان تخصیص دقیق روزانه',
        projectedExhaustion: 'زمان پیش‌بینی‌شده پایان اعتبار',
        creditOverviewTitle: 'سلامت اعتبار',
        usageTotalsTitle: 'مجموع مصرف منتسب‌شده',
        requestCount: 'درخواست‌ها',
        totalTokens: 'کل توکن‌ها',
        modelCostUnit: 'هزینه مدل (UNIT)',
        inputTokens: 'توکن‌های ورودی',
        outputTokens: 'توکن‌های خروجی',
        reasoningTokens: 'توکن‌های استدلال',
        cachedTokens: 'توکن‌های کش‌شده',
        cacheRatio: 'نسبت کش',
        timelineTitle: 'تاریخچه روزانه',
        metricSelector: 'معیار تاریخچه روزانه',
        noTimeline: 'در این بازه مصرف مرتبطی وجود ندارد.',
        chartDescription: '{metric} روزانه از {start} تا {end}. جدول همه مقادیر را نشان می‌دهد.',
        chartDescriptionEmpty: 'داده روزانه‌ای برای {metric} موجود نیست.',
        timelineTable: 'همه مقادیر جدول زمانی روزانه',
        date: 'تاریخ',
        compositionTitle: 'ترکیب مصرف',
        noBreakdown: 'مصرف مرتبطی برای این دسته وجود ندارد.',
        transactionsTitle: 'تراکنش‌ها',
        noTransactions: 'در این بازه تراکنش مرتبطی وجود ندارد.',
        transactionsCaption: 'تراکنش‌های منبع با حفظ حریم خصوصی',
        transactionId: 'شناسه عمومی تراکنش',
        createdAt: 'زمان ایجاد',
        requestedAt: 'زمان درخواست',
        model: 'مدل',
        provider: 'ارائه‌دهنده',
        serviceTier: 'سطح سرویس',
        statusCode: 'وضعیت',
        stream: 'جریانی',
        tokenComposition: 'کل توکن‌ها (ورودی/خروجی/استدلال/کش)',
        allocation: 'تخصیص',
        allocatedIrt: 'تومان تخصیص‌یافته دقیق',
        sharedFunding: 'تامین مالی مشترک',
        pagination: 'صفحه‌های تراکنش',
        previous: 'قبلی',
        next: 'بعدی',
        page: 'صفحه {page}',
        projection: {
          not_started: {
            title: 'تحلیل مصرف در حال آماده‌سازی است',
            description: 'تا پایان نخستین محاسبه آمار، مجموع‌ها، نمودارها، پوشش اسناد و تراکنش‌ها ممکن است کامل نباشند.'
          },
          backfilling: {
            title: 'سوابق مصرف در حال پردازش است',
            description: 'مقادیر نمایش‌داده‌شده شامل رکوردهایی است که تاکنون محاسبه شده‌اند.'
          },
          stale: {
            title: 'تحلیل مصرف با تأخیر به‌روزرسانی می‌شود',
            description:
              'مصرف جدید حدود {lagSeconds} ثانیه تأخیر دارد. داده‌های محاسبه‌شده تا {computedThrough} نمایش داده می‌شوند.'
          },
          retention_limited: {
            title: 'بخشی از بازه‌های تاریخی برای همیشه در دسترس نیست',
            description:
              '{count} بازه درخواستی از {start} تا {end} خارج از دوره نگهداری داده‌های دقیقه‌ای است و قابل بازسازی نیست. مقادیر نمایش‌داده‌شده این بازه‌ها را شامل نمی‌شوند.'
          },
          raw_tail_overflow: {
            title: 'مصرف خام اخیر عمدا کنار گذاشته شد',
            description:
              'دنباله پردازش‌نشده از سقف امن {rowLimit} ردیف بیشتر بود و کنار گذاشته شد. مقادیر نمایش‌داده‌شده این مصرف اخیر را شامل نمی‌شوند.'
          }
        },
        metrics: {
          cost_unit: 'هزینه مدل (UNIT)',
          requests: 'درخواست‌ها',
          tokens: 'توکن‌ها',
          allocated_irt: 'تومان تخصیص‌یافته دقیق'
        },
        breakdowns: { model: 'مدل‌ها', provider: 'ارائه‌دهندگان', service_tier: 'سطوح سرویس' },
        tokens: { input: 'ورودی', output: 'خروجی', reasoning: 'استدلال', cached: 'کش‌شده' },
        evidence: {
          title: 'پوشش دقیق',
          counts: '{exact} از {total} ردیف مصرف مرتبط، اسناد تخصیص دقیق دارد.',
          complete: 'تمام مصرف مرتبط در این بازه اسناد تخصیص دقیق دارد.',
          incomplete: 'بخشی از مصرف مرتبط پیش از ثبت اسناد تخصیص دقیق ایجاد شده است.',
          legacyCaveat:
            '{count} ردیف legacy_unallocated تومان دقیق منبع را ندارد؛ مبلغ آن تخمین زده یا صفر نمایش داده نمی‌شود.'
        },
        allocationStatus: { exact: 'دقیق', legacy_unallocated: 'قدیمی — تخصیص‌نیافته' },
        boolean: { yes: 'بله', no: 'خیر' },
        errors: {
          invalid_request: 'درخواست تحلیل نامعتبر است.',
          not_found: 'این منبع اعتبار دیگر در دسترس نیست.',
          rate_limited: 'تعداد درخواست‌ها زیاد است. کمی صبر کنید و دوباره تلاش کنید.',
          network_error: 'اتصال ناموفق بود. دوباره تلاش کنید.',
          unknown_error: 'بارگذاری این بخش تحلیل ممکن نبود.'
        },
        status: {
          active: 'فعال',
          expired: 'منقضی',
          exhausted: 'تمام‌شده',
          inactive: 'غیرفعال',
          revoked: 'باطل‌شده',
          suspended: 'معلق'
        }
      },
      otp: {
        title: 'تایید خرید به مبلغ {amount}',
        description: 'لطفا کد تایید ۶ رقمی ارسال شده به تلفن همراه خود را برای تکمیل خرید وارد کنید.',
        invalidLength: 'طول کد تایید نامعتبر است',
        send: 'ارسال کد',
        resent: 'کد تایید مجددا ارسال شد',
        expiresIn: 'کد در {time} منقضی می‌شود',
        expired: 'کد تایید منقضی شده است',
        cancel: 'لغو',
        verify: 'تایید کد',
        resend: 'ارسال کد جدید',
        processing: 'پرداخت شما در حال پردازش است. لطفا چند لحظه صبر کنید و برای بررسی وضعیت، همان کد را دوباره ارسال کنید.',
        startNewPurchase: 'شروع خرید جدید',
        attemptsRemaining: '({count} تلاش باقی‌مانده)',
        restartRequired: 'این تایید دیگر قابل تکمیل نیست. لطفا خرید جدیدی را شروع کنید.'
      },
      timeline: {
        expired: 'منقضی شده',
        thisMonth: 'این ماه',
        nextMonth: 'ماه آینده',
        noExpiration: 'هیچ بسته‌ای تاریخ انقضا ندارد',
        expiredCount: 'بسته‌های منقضی شده',
        expiringThisWeek: 'این هفته منقضی می‌شوند',
        expiringThisMonth: 'این ماه منقضی می‌شوند',
        safePeriod: 'دوره امن (بیش از ۳۰ روز)',
        summary: 'خلاصه',
        later: 'بعدا',
        remaining: 'باقی مانده'
      },
      filters: {
        title: 'فیلترها',
        reset: 'بازنشانی فیلترها',
        allServices: 'تمام سرویس‌ها',
        serviceType: 'نوع سرویس',
        apiOnly: 'فقط API',
        subscriptionOnly: 'فقط اشتراک',
        showPromotional: 'نمایش بسته‌های تبلیغاتی',
        priceRange: 'محدوده قیمت',
        subServices: 'زیر سرویس‌ها',
        modelFamilies: 'خانواده مدل‌ها',
        subscriptionTiers: 'سطوح اشتراک'
      },
      authRequired: {
        title: 'ورود به حساب کاربری، ضروری است.',
        description: 'لطفا وارد حساب کاربری خود شوید تا بسته‌های خریداری شده و میزان استفاده از آن‌ها را مشاهده کنید.'
      },
      paymentMethods: {
        bankCard: 'کارت بانکی',
        creditBalance: 'موجودی اعتباری'
      },
      status: {
        all: 'همه',
        active: 'فعال',
        expired: 'منقضی‌شده',
        exhausted: 'تمام‌شده',
        inactive: 'غیرفعال',
        revoked: 'باطل‌شده',
        suspended: 'معلق'
      },
      totalAmountBePaid: 'مبلغ کل پرداختی',
      totalCreditsReceiving: 'کل اعتبارات دریافتی',
      empty: 'هیچ بسته‌ای موجود نیست',
      emptyDescription: 'در حال حاضر هیچ بسته اعتباری برای خرید موجود نیست',
      allServices: 'تمام سرویس‌ها',
      noExpiration: 'بدون انقضا',
      creditPackages: 'بسته‌های اعتباری',
      ownedSources: 'منابع اعتباری',
      grantCredits: 'اعتبارات هدیه',
      generalBalance: 'موجودی کیف پول',
      generalBalanceDescription: 'موجودی اصلی کیف پول شما که در همه سرویس‌ها قابل استفاده است',
      creditsPerToman: 'اعتبار بیشتر',
      expired: 'منقضی شده',
      expirestoday: 'امروز منقضی می‌شود',
      expiresTomorrow: 'فردا منقضی می‌شود',
      expiresInDays: '{days} روز دیگر',
      expiresInWeeks: '{weeks} هفته دیگر منقضی می‌شود',
      expiresOn: 'در تاریخ {date} منقضی می‌شود',
      redirectingToPayment: 'در حال انتقال به درگاه پرداخت',
      purchaseComplete: 'خرید با موفقیت تکمیل شد',
      purchaseSuccessMessage:
        'بسته اعتباری شما خریداری و به حساب شما اضافه شده است. اکنون می‌توانید آن را در بخش بسته‌های من مشاهده و مدیریت کنید.',
      goToMyPackages: 'رفتن به بسته‌های من',
      purchaseFailed: 'خرید ناموفق بود. لطفا دوباره تلاش کنید.',
      insufficientCredit: 'موجودی اعتبار ناکافی',
      insufficientCreditMessage:
        'موجودی اعتبار شما برای تکمیل این خرید کافی نیست. شما به {shortfall} تومان دیگر نیاز دارید.',
      choosePaymentOption: 'یک گزینه پرداخت انتخاب کنید:',
      useDirectPayment: 'پرداخت مستقیم بانکی',
      topUpCredit: 'افزایش اعتبار کیف پول',
      otpFailed: 'تایید کد ناموفق بود',
      paymentCheckFailed: 'بررسی وضعیت پرداخت ناموفق بود. لطفا دوباره تلاش کنید.',
      openPaymentPage: 'بازگشت به صفحه پرداخت',
      paymentPending: 'تراکنش هنوز تکمیل نشده است، لطفا پرداخت را تکمیل یا مجدد وضعیت تراکنش را بررسی نمایید.',
      paymentNotFound: 'تراکنش یافت نشد! لطفا دوباره تلاش کنید.',
      clearFilters: 'پاک کردن فیلترها',
      browse: 'فروشگاه بسته‌های اعتباری',
      title: 'بسته‌های اعتباری',
      description: 'با خرید بسته‌های اعتباری، در هزینه‌ها صرفه جویی و موجودی حساب خود را مدیریت کنید.',
      workspace: {
        intro: 'پوشش، قیمت و برآورد مصرف سطح استاندارد هر بسته را پیش از پرداخت مقایسه کنید.',
        filtersTitle: 'فیلترهای فروشگاه',
        searchLabel: 'جستجوی بسته‌ها',
        searchPlaceholder: 'جستجو در نام، مدل، ارائه‌دهنده، شناسه یا برچسب',
        serviceLabel: 'سرویس',
        allServices: 'همه سرویس‌ها',
        apiService: 'خدمات API',
        subscriptionService: 'اشتراک گفتگوها',
        modelsLabel: 'مدل‌های تحت پوشش',
        providersLabel: 'ارائه‌دهندگان تحت پوشش',
        minPrice: 'حداقل قیمت',
        maxPrice: 'حداکثر قیمت',
        sortLabel: 'مرتب‌سازی بسته‌ها',
        loadFailed: 'بارگذاری بسته‌ها ممکن نشد. دوباره تلاش کنید.',
        catalogUnavailable: 'فهرست عمومی مدل‌ها در دسترس نیست؛ فیلتر مدل و برآورد ممکن است محدود باشد.',
        results: 'بسته‌های منطبق',
        moreFilters: 'فیلترها و مرتب‌سازی بیشتر',
        selectPackage: 'انتخاب {name}',
        selectAction: 'انتخاب',
        reviewForecast: 'مرور برآورد',
        changePackage: 'تغییر بسته',
        packageDetails: 'تخفیف‌ها، اعتبار زمانی و سقف‌ها',
        available: 'در دسترس',
        unavailableValue: 'ناموجود',
        unlimited: 'بدون محدودیت',
        faceCredit: 'اعتبار اسمی',
        currentPrice: 'قیمت فعلی بسته',
        templateDiscount: 'تخفیف پایه بسته',
        seasonalDiscount: 'تخفیف فصلی',
        validity: 'اعتبار زمانی',
        days: 'روز',
        perUserLimit: 'سقف برای هر کاربر',
        totalLimit: 'سقف کل',
        coveredModelsCount: 'مدل تحت پوشش',
        coveredModelsAll: 'همه مدل‌های استاندارد',
        coveredModelsNone: 'بدون پوشش مدل در سطح استاندارد',
        seeAllModels: 'نمایش هر {count} مدل',
        showLessModels: 'نمایش کمتر',
        moreModels: '+{count} مدل دیگر',
        copyModel: 'کپی {model}',
        modelCopied: '{model} کپی شد',
        modelFamilies: 'خانواده‌های مدل',
        subscriptionTiers: 'سطوح اشتراک',
        services: 'سرویس‌ها',
        scopeFullDetails: 'جزئیات کامل دامنه',
        scopeEmpty: 'بدون محدودیت دامنه',
        noActiveOffer: 'پیشنهاد فوق‌العاده فعالی وجود ندارد',
        offerRemaining: '{time} باقی‌مانده (شمارش سرور)',
        selectedPackage: 'بسته انتخاب‌شده',
        standardOnlyNotice:
          'برآورد از نرخ قابل پرداخت توکن در سطح استاندارد، شامل کارمزد پردازش صورتحساب قابل اعمال، استفاده می‌کند. سطح فلکس و سرویس‌های پشتیبانی‌نشده کنار گذاشته می‌شوند.',
        quickMode: 'سریع',
        advancedMode: 'پیشرفته',
        forecastModels: 'مدل‌های برآورد',
        quickPreset: 'الگوی مصرف',
        presetLight: 'سبک',
        presetBalanced: 'متعادل',
        presetScale: 'بالا',
        requestsPerDay: 'درخواست در روز',
        averageInputTokens: 'میانگین توکن ورودی',
        averageOutputTokens: 'میانگین توکن خروجی',
        cacheRatio: 'نسبت ورودی کش‌شده (درصد)',
        uncertainty: 'عدم قطعیت (درصد)',
        allocation: 'سهم (درصد)',
        loadingPricing: 'در حال بارگذاری قیمت عمومی مدل‌ها و نرخ تبدیل…',
        dailyLow: 'هزینه روزانه پایین (تومان)',
        dailyExpected: 'هزینه روزانه مورد انتظار (تومان)',
        dailyHigh: 'هزینه روزانه بالا (تومان)',
        durationExpected: 'مدت مورد انتظار (روز)',
        durationBounds: 'بازه مدت (روز)',
        zeroWorkload: 'هزینه روزانه این مصرف صفر است؛ بنابراین مدت محدود نمایش داده نمی‌شود.',
        unboundedDuration: 'در عدم قطعیت انتخاب‌شده، کران بالای مدت نامحدود است.',
        dailySpend: 'مصرف روزانه مورد انتظار (تومان)',
        allocatedCredit: 'اعتبار اسمی تخصیص‌یافته (تومان)',
        inputEquivalent: 'معادل توکن ورودی',
        outputEquivalent: 'معادل توکن خروجی',
        cachedEquivalent: 'معادل توکن ورودی کش‌شده',
        unsupportedModel: 'در سطح استاندارد تحت پوشش نیست',
        checkoutRefreshNotice: 'این قیمت فعلی بسته است. قیمت پیش از پرداخت در تسویه‌حساب تازه‌سازی می‌شود.',
        selectPrompt: 'برای مشاهده برآورد، یک بسته انتخاب کنید.',
        unbounded: 'نامحدود',
        reasons: {
          missingModel: 'حداقل یک مدل انتخاب کنید.',
          duplicateModel: 'هر مدل فقط یک بار قابل انتخاب است.',
          invalidWorkload: 'مقدار مصرف نامنفی و معتبر وارد کنید.',
          invalidCacheRatio: 'نسبت کش باید بین صفر و صد باشد.',
          invalidUncertainty: 'عدم قطعیت باید بین صفر و صد باشد.',
          invalidAllocation: 'سهم هر مدل باید نامنفی باشد.',
          invalidAllocationTotal: 'مجموع سهم مدل‌ها باید صد درصد باشد.',
          exchangeRateUnavailable: 'نرخ تبدیل واحد به تومان در دسترس نیست.',
          modelNotCovered: 'یک یا چند مدل انتخاب‌شده خارج از پوشش این بسته است.',
          standardTierNotSupported: 'یک یا چند مدل انتخاب‌شده از سطح استاندارد پشتیبانی نمی‌کند.',
          missingTokenRates: 'قیمت مثبت توکن ورودی و خروجی در دسترس نیست.',
          faceCreditUnavailable: 'اعتبار اسمی بسته در دسترس نیست.',
          finalPriceUnavailable: 'قیمت فعلی بسته در دسترس نیست.'
        }
      },
      wizard: {
        open: 'راهنمای انتخاب بسته',
        eyebrow: 'پیشنهاد بسته',
        title: 'بسته اعتباری مناسب را پیدا کنید',
        progressLabel: 'مراحل پیشنهاد بسته',
        currentStep: 'مرحله {current} از {total}: {label}',
        close: 'بستن',
        back: 'بازگشت',
        continue: 'ادامه',
        steps: {
          models: 'مدل‌ها و کاربرد',
          budget: 'بودجه',
          workload: 'مدت و میزان مصرف',
          review: 'مرور و نتایج'
        },
        modelsTitle: 'مدل‌ها و کاربرد را انتخاب کنید',
        modelsHelp: 'یک یا چند مدل عمومی با پشتیبانی سطح استاندارد را انتخاب کنید.',
        modelsLabel: 'مدل‌ها',
        modelsPlaceholder: 'جستجوی مدل بر اساس نام، ارائه‌دهنده یا مالک',
        modelsAvailable: 'نمایش {shown} مدل از {total} مدل سطح استاندارد.',
        noModelsForProvider: 'هیچ مدل سطح استانداردی با ارائه‌دهندگان انتخابی مطابقت ندارد.',
        providerFilterLabel: 'فیلتر بر اساس ارائه‌دهنده',
        providerFilterPlaceholder: 'همه ارائه‌دهندگان',
        unknownProvider: 'ارائه‌دهنده نامشخص',
        useCaseLabel: 'کاربرد',
        useCaseNotice: 'کاربرد فقط الگوی مصرف را تعیین می‌کند و هرگز مدل‌های انتخابی یا پوشش بسته را تغییر نمی‌دهد.',
        useCases: {
          general: 'عمومی / گفتگو',
          coding: 'برنامه‌نویسی',
          reasoning: 'استدلال',
          media: 'رسانه'
        },
        budgetTitle: 'بودجه اختیاری خرید را تعیین کنید',
        budgetLabel: 'حداکثر قیمت فعلی خرید (تومان)',
        noBudget: 'بدون سقف قیمت خرید',
        budgetNotice:
          'این مقدار قیمت فعلی بسته را فیلتر می‌کند و قیمت قطعی نیست؛ قیمت تازه‌شده در تسویه‌حساب معتبر است.',
        workloadTitle: 'مدت و میزان مصرف را تعیین کنید',
        durationLabel: 'مدت هدف (روز)',
        reviewTitle: 'ورودی‌ها را مرور و محاسبه کنید',
        calculate: 'یافتن بسته‌های منطبق',
        calculationFailed: 'محاسبه پیشنهاد ممکن نشد. ورودی‌ها را بررسی کرده و دوباره تلاش کنید.',
        resultsTitle: 'بسته‌های پیشنهادی',
        recalculate: 'محاسبه مجدد',
        inputsSummary: 'ورودی‌های شما',
        outcome: {
          recommendations: 'بسته‌های پیشنهادی برای میزان مصرف شما',
          partial: 'فقط تطبیق‌های جزئی',
          noMatch: 'هیچ بسته منطبقی یافت نشد',
          error: 'محاسبه ناموفق بود'
        },
        fullCoverage: 'پوشش کامل',
        allModelsCovered: 'هر {count} مدل انتخابی را در سطح استاندارد پوشش می‌دهد.',
        applyRecommendation: 'انتخاب این پیشنهاد',
        partialNotice:
          'هیچ بسته‌ای همه مدل‌های انتخابی را پوشش نمی‌دهد. این‌ها تطبیق‌های جزئی رتبه‌بندی‌شده‌اند و راهنما بسته‌ها را ترکیب نمی‌کند.',
        partialMatch: 'تطبیق جزئی — نه پیشنهاد',
        supportedModels: 'مدل‌های انتخابی تحت پوشش',
        unsupportedModels: 'مدل‌های پشتیبانی‌نشده و دلیل آن',
        partialConfirmation: 'می‌دانم که این بسته همه مدل‌های انتخابی را پوشش نمی‌دهد.',
        selectPartial: 'انتخاب این تطبیق جزئی',
        noMatch: 'برای این ورودی‌ها تطبیق معتبری وجود ندارد.',
        summary: {
          averageInputTokens: 'میانگین توکن ورودی',
          averageOutputTokens: 'میانگین توکن خروجی',
          uncertainty: 'عدم قطعیت',
          allocation: 'سهم'
        },
        slots: {
          bestFit: 'مناسب‌ترین',
          bestValue: 'بهترین ارزش خرید',
          lowerCommitment: 'تعهد مالی کمتر'
        },
        explanations: {
          closestDuration: 'در میان بسته‌های واجد پوشش کامل، مدت مورد انتظار آن به مدت هدف شما نزدیک‌تر است.',
          highestValue: 'در میان بسته‌های واجد پوشش کامل، بیشترین اعتبار اسمی به ازای قیمت فعلی خرید را دارد.',
          lowestPrice: 'در میان بسته‌های واجد پوشش کامل، کمترین قیمت فعلی خرید را دارد.'
        },
        errors: {
          modelsRequired: 'حداقل یک مدل عمومی با سطح استاندارد انتخاب کنید.',
          invalidBudget: 'بودجه صحیح و نامنفی به تومان وارد کنید یا آن را خالی بگذارید.',
          positiveDuration: 'مدت هدف باید بیشتر از صفر روز باشد.'
        },
        coverageReasons: {
          apiServiceNotSupported: 'سرویس API پشتیبانی نمی‌شود.',
          apiScopeUnavailable: 'محدوده معتبر مدل‌های API در دسترس نیست.',
          modelNotInScope: 'این مدل در محدوده API بسته قرار ندارد.',
          standardTierNotSupported: 'این مدل از سطح استاندارد پشتیبانی نمی‌کند.'
        },
        noMatchReasons: {
          inventoryEmpty: 'در فهرست فیلترشده، بسته در دسترس فعلی باقی نمانده است.',
          outsideBudget: 'قیمت بسته‌های دارای پوشش کامل از سقف خرید انتخابی بیشتر است.',
          finalPriceUnavailable: 'قیمت فعلی بسته در دسترس نیست و امکان بررسی بودجه وجود ندارد.',
          exchangeRateUnavailable: 'نرخ تبدیل فعلی در دسترس نیست و مدت قابل برآورد نیست.',
          unforecastable: 'با قیمت‌گذاری یا مصرف فعلی نمی‌توان بسته‌های دارای پوشش کامل را برآورد کرد.'
        }
      },
      marketplace: 'فروشگاه',
      purchaseTitle: 'خرید بسته اعتباری',
      quoteReview: {
        eyebrow: 'پیش‌فاکتور معتبر پرداخت',
        title: 'قیمت را پیش از پرداخت مرور کنید',
        requestQuote: 'مرور پیش‌فاکتور',
        refreshQuote: 'تازه‌سازی پیش‌فاکتور',
        loadFailed: 'دریافت پیش‌فاکتور تازه ممکن نشد. دوباره تلاش کنید.',
        invalid: 'پاسخ پیش‌فاکتور نامعتبر است و قابل استفاده نیست. پیش‌فاکتور تازه‌ای بگیرید.',
        refreshRequired: 'پیش از خرید به یک پیش‌فاکتور تازه نیاز است.',
        priceChangedRestart:
          'قیمت یا شرایط بسته تغییر کرده است. بسته را دوباره بررسی و فرایند خرید را از ابتدا آغاز کنید.',
        unavailable: 'این بسته اکنون برای خرید در دسترس نیست.',
        priceUpdated: 'قیمت به‌روزرسانی شد',
        priceUpdatedDetail: 'پیش‌فاکتور معتبر با انتخاب فروشگاه تفاوت دارد. پیش از ادامه همه مقادیر را مرور کنید.',
        acceptUpdatedTotal: 'مبلغ تازه {total} تومان را تأیید می‌کنم.',
        faceCreditPerPackage: 'اعتبار اسمی هر بسته',
        totalFaceCredit: 'مجموع اعتبار اسمی',
        templatePrice: 'قیمت پایه بسته',
        templateDiscount: 'تخفیف پایه بسته',
        seasonalDiscount: 'تخفیف فصلی',
        activeOffer: 'پیشنهاد فوق‌العاده فعال و زمان پایان',
        finalUnitPrice: 'قیمت نهایی هر بسته',
        marketplaceSelectedTotal: 'مبلغ انتخاب‌شده در فروشگاه',
        quotedTotal: 'مبلغ معتبر کل خرید',
        validity: 'اعتبار زمانی بسته',
        availability: 'وضعیت امکان خرید',
        purchaseQuotedTotal: 'خرید با مبلغ پیش‌فاکتور',
        reviewTerms: 'مرور شرایط و سیاست لغو'
      },
      quantity: 'تعداد',
      packages: 'بسته',
      paymentMethod: 'روش پرداخت',
      unitPrice: 'قیمت واحد',
      toman: 'تومان',
      totalAmount: 'مبلغ کل',
      totalCredits: 'کل اعتبارات',
      cancel: 'لغو',
      confirmPurchase: 'تایید خرید',
      processingPayment: 'در حال پردازش پرداخت...',
      noPackagesFound: 'بسته‌ای یافت نشد',
      owned: {
        activeCredit: 'اعتبار بسته‌های فعال',
        activeCreditHint: 'اعتبار باقی‌مانده بسته‌ها و اعتبارهای هدیه فعال شما. منابع منقضی یا تمام‌شده شمرده نمی‌شوند.',
        activeSources: 'منابع فعال',
        nextExpiry: 'نزدیک‌ترین انقضا',
        noExpiry: 'انقضایی در پیش نیست',
        expiringSoon: 'مورد تا یک هفته دیگر منقضی می‌شود',
        walletTitle: 'کیف پول',
        walletHint: 'موجودی عمومی فقط پس از مصرف اعتبار بسته‌ای که درخواست را پوشش می‌دهد برداشت می‌شود. برای فعال ماندن کلیدهای API، موجودی کیف پول باید مثبت باشد.',
        walletUnit: 'واحد اعتبار',
        walletTotalUnit: 'مجموع اعتبار به واحد',
        filterHint: 'فیلتر بر اساس وضعیت',
        columnSource: 'منبع',
        columnRemaining: 'باقی‌مانده',
        columnExpiry: 'انقضا',
        columnScope: 'محدوده',
        allModels: 'همه مدل‌ها',
        modelsCount: '{count} مدل',
        subscriptionScope: 'اشتراک',
        daysLeft: 'روز مانده',
        endedOn: 'پایان',
        noEndDate: 'بدون تاریخ پایان',
        unlimited: 'نامحدود',
        details: 'جزئیات',
        hideDetails: 'بستن جزئیات',
        purchased: 'خرید',
        ends: 'پایان',
        lifetime: 'زمان باقی‌مانده',
        inactiveHidden: 'منبع منقضی یا تمام‌شده با این فیلتر پنهان است',
        noMatch: 'منبعی با این وضعیت یافت نشد.',
        showAll: 'نمایش همه',
        updatedAt: 'به‌روزرسانی'
      },
      purchasedOn: 'خریداری شده در {date}',
      usage: 'استفاده',
      remaining: 'باقی‌مانده',
      used: 'استفاده شده',
      viewDetails: 'مشاهده جزئیات',
      viewDetailsTooltip: 'برای مشاهده آمار تفصیلی استفاده کلیک کنید',
      featured: 'ویژه',
      apiService: 'سرویس API',
      subscriptionService: 'سرویس اشتراک',
      scope: 'محدوده مجاز',
      validFor: 'معتبر برای {days} روز',
      maxPerUser: 'حداکثر {count} بسته به ازای هر کاربر',
      unavailable: 'در دسترس نیست',
      noDiscount: 'ندارد',
      purchase: 'خرید',
      browsePackages: 'رفتن به فروشگاه بسته‌ها',
      noPackages: 'هنوز بسته اعتباری‌ای ندارید',
      package: 'بسته',
      availableModels: 'مدل‌های در دسترس',
      balance: 'موجودی',
      grant: 'گرنت',
      maxQuantity: 'حداکثر تعداد مجاز',
      packageScope: 'محدوده پوشش بسته',
      valueRatioTooltip: 'به نسبت مبلغی که پرداخت می نمایید اعتبار بیشتری دریافت می کنید',
      packageScopeTooltip:
        'لیست خدمات مجاز تحت پوشش بسته اعتباری ممکن است شامل مدل‌ها یا سرویس‌های مشخصی باشد. این بسته صرفا برای استفاده از خدمات و مدل‌های ذکر شده در لیست محدوده پوشش مجاز که در توضیحات بسته آمده است، طراحی شده است. با خرید این بسته، امکان استفاده از تخفیف برای سایر مدل‌ها یا خدماتی که خارج از محدوده پوشش هستند وجود ندارد. در صورت استفاده از خدماتی که تحت پوشش بسته نیستند، هزینه بر اساس نرخ آزاد محاسبه خواهد شد',
      agreements: {
        eyebrow: 'مرحله نهایی خرید',
        title: 'قرارداد خرید',
        quoteSummary: 'پیش‌فاکتور معتبر شما',
        description: 'لطفا جهت ادامه خرید، شرایط و ضوابط زیر را مطالعه و تایید نمایید:',
        balanceRequirement:
          'جهت بهره‌مندی موثر از بسته‌های اعتباری، ضروری است که موجودی کلی حساب شما مثبت باشد. در صورت صفر یا منفی شدن موجودی کلی، سرویس‌های API به طور خودکار غیرفعال خواهند شد. توصیه می‌شود حداقل مبلغ ۱۰۰,۰۰۰ تومان در موجودی کلی حساب خود حفظ نمایید تا ارائه سرویس بدون وقفه ادامه یابد.',
        expirationPolicy:
          'بسته‌های اعتباری دارای تاریخ انقضای ثابت و غیرقابل تمدید هستند. پس از انقضای تاریخ مذکور، بسته‌ها، صرف‌ نظر از اعتبارات استفاده نشده باقی‌مانده، قابل تجدید یا بازیابی نخواهند بود.',
        serviceCoverage:
          'هر بسته اعتباری منحصرا برای سرویس‌ها و مدل‌های مشخص‌ شده در توضیحات همان بسته قابل استفاده است. اعتبارات مذکور قابل انتقال یا استفاده برای سرویس‌ها، مدل‌ها یا ویژگی‌های دیگری که صراحتا در شرایط بسته گنجانده نشده‌اند، نمی‌باشند.',
        acceptTerms: 'تمام شرایط و ضوابط فوق را مطالعه کرده و می‌پذیرم.',
        mustAcceptTerms: 'جهت ادامه خرید، پذیرش شرایط و ضوابط الزامی است.',
        balanceRequirementTitle: 'الزامات موجودی حساب',
        expirationPolicyTitle: 'سیاست انقضای بسته',
        serviceCoverageTitle: 'محدودیت پوشش سرویس',
        serviceTierLimitationTitle: 'محدودیت سطح سرویس',
        serviceTierLimitation:
          "بسته‌های اعتباری فقط درخواست‌های API که با سطح سرویس پیش‌فرض 'استاندارد' ارسال می‌شوند را پوشش می‌دهند. اگر از سطح سرویس 'منعطف' استفاده کنید (با تنظیم service_tier=flex در درخواست‌های API)، این هزینه‌ها از اعتبار بسته کسر نخواهد شد و در عوض از موجودی کلی حساب شما کسر می‌شوند.",
        cancellationPolicyTitle: 'لغو و بازگشت به کیف پول',
        cancellationPolicy:
          'لغو فقط تا پیش از گذشت ۲۴ ساعت از خرید، با مصرف حداکثر ۵٫۰۰ درصد و در صورت وجود پرداخت تاییدشده مرتبط با مبلغ مثبت امکان‌پذیر است. تایید ابتدا با پیامک و فقط در نبود پیامک با ایمیل تاییدشده انجام می‌شود. مبلغ محاسبه‌شده فقط به اعتبار عادی باقی‌مانده کیف پول افزوده می‌شود و هیچ بازپرداخت بانکی انجام نمی‌شود.'
      },
      walletGate: {
        checking: 'در حال بررسی موجودی کیف پول…',
        unavailable: 'موجودی کیف پول شما بررسی نشد. خرید بسته همچنان ممکن است، اما برای استفاده از آن موجودی کیف پول باید مثبت باشد.',
        debtTitle: 'کیف پول شما بدهی دارد',
        debtSummary:
          'درخواست‌هایی که هنگام پایان اعتبار هنوز در حال اجرا بودند، {debtUnit} واحد اعتبار بیش از موجودی شما هزینه داشتند؛ به همین دلیل موجودی کیف پول شما {unitCredit} واحد اعتبار است.',
        debtDetail: 'تسویه این بدهی با نرخ امروز دقیقا {debtIrt} تومان است.',
        debtUnpriced: 'نرخ تبدیل در حال حاضر در دسترس نیست و مبلغ تومانی بدهی هنوز محاسبه نمی‌شود.',
        debtPlan:
          'پیشنهاد می‌کنیم {suggested} تومان شارژ کنید: {debtIrt} تومان بدهی را تسویه می‌کند و حدود {remainder} تومان برای استفاده از API در کیف پول شما می‌ماند.',
        debtAfter: 'پس از تایید پرداخت، به همین صفحه برگردید و بسته را بخرید.',
        debtBlocked: 'تا زمانی که موجودی کیف پول منفی است، خرید بسته اعتباری ممکن نیست. ابتدا کیف پول را شارژ کنید و دوباره تلاش کنید.',
        emptyTitle: 'موجودی کیف پول شما صفر است',
        emptySummary:
          'می‌توانید بسته بخرید، اما اعتبار بسته فقط زمانی مصرف می‌شود که موجودی کیف پول مثبت باشد؛ با موجودی صفر، کلیدهای API شما غیرفعال می‌مانند.',
        emptyAdvice: 'دست‌کم {adviceUnit} واحد اعتبار (حدود {adviceIrt} تومان) یا {buffer} تومان در کیف پول نگه دارید.',
        emptyAdviceNoRate: 'دست‌کم {adviceUnit} واحد اعتبار یا {buffer} تومان در کیف پول نگه دارید.',
        emptyTiming: 'شارژ کیف پول را می‌توانید پیش یا پس از خرید بسته انجام دهید.',
        topUpAmount: 'شارژ {amount} تومان',
        topUp: 'شارژ کیف پول',
        openWallet: 'مشاهده کیف پول',
        walletLine: 'موجودی کیف پول',
        unitDebt: 'مصرف تسویه‌نشده',
        walletTotal: 'مجموع کیف پول (معادل واحد اعتبار)',
        rateLine: '۱ واحد اعتبار = {rate} تومان'
      }
    },
    notificationWillBe: 'اعلان‌ها به {list} هم ارسال می‌شوند.',
    thresholdsMustBeDivisibleByFive: 'سطح آستانه باید مضربی از ۵ باشد (به‌جز ۱).',
    thresholdsMustBeLeast: 'سطح آستانه باید دست‌کم ۱ واحد اعتبار باشد.',
    creditNotificationSaved: 'تنظیمات اعلان ذخیره شد.',
    additionalRecipientsDescription:
      'اعلان‌ها به ایمیل و شماره تلفن ثبت‌شده در حساب شما ارسال می‌شوند. اگر می‌خواهید به افراد دیگری هم برسد، ایمیل یا شماره آن‌ها را اینجا اضافه کنید.',
    notificationRecipientEmails: '{count} ایمیل دیگر',
    notificationRecipientPhones: '{count} شماره تلفن دیگر',
    thresholdAtLeastOne: 'دست‌کم یک سطح آستانه لازم است.',
    invalidEmailRecipients: 'یک یا چند آدرس ایمیل معتبر نیست.',
    invalidPhoneRecipients: 'یک یا چند شماره تلفن معتبر نیست. شماره را با ۱۰ تا ۱۵ رقم وارد کنید.',
    thresholdPlaceholder: 'مقدار آستانه',
    addUpToTwoEmailsAndPhones: 'تا ۲ ایمیل و ۲ شماره تلفن دیگر می‌توانید اضافه کنید.',
    additionalRecipients: 'گیرندگان دیگر',
    notificationThresholds: 'سطوح آستانه اعلان',
    receiveAlertsWhen: 'هر بار که موجودی به یکی از سطوح آستانه برسد، به شما اطلاع می‌دهیم.',
    creditNotificationSettings: 'تنظیمات اعلان موجودی',
    topUpDebt: {
      title: 'موجودی کیف پول شما منفی است',
      summary:
        'درخواست‌هایی که هنگام پایان اعتبار هنوز در حال اجرا بودند بیش از موجودی شما هزینه داشتند؛ موجودی کیف پول شما اکنون {unitCredit} واحد اعتبار است. هر مبلغی که اکنون بپردازید ابتدا برای تسویه این بدهی مصرف می‌شود و فقط باقی‌مانده به اعتبار قابل استفاده تبدیل می‌شود.',
      exact: 'تسویه این بدهی با نرخ امروز دقیقا {debtIrt} تومان است.',
      unpriced: 'نرخ تبدیل در حال حاضر در دسترس نیست و مبلغ تومانی بدهی هنوز محاسبه نمی‌شود.',
      suggestedChip: 'پیشنهادی',
      outcomePartial: 'با {amount} تومان همچنان {shortfall} تومان بدهکار می‌مانید و کلیدهای API شما غیرفعال می‌مانند.',
      outcomeExact:
        '{amount} تومان بدهی را دقیقا تسویه می‌کند؛ موجودی کیف پول صفر می‌شود و کلیدهای API تا افزایش اعتبار بیشتر غیرفعال می‌مانند.',
      outcomeCovers: '{amount} تومان بدهی را تسویه می‌کند و حدود {remainder} تومان اعتبار قابل استفاده باقی می‌گذارد.'
    },
    packageBalanceWarning: {
      title: 'هشدار موجودی کیف پول',
      message:
        'بسته اعتباری فعال دارید، اما موجودی کیف پول شما صفر یا منفی است. تا زمانی که کیف پول را شارژ نکنید، سرویس‌های API به‌طور خودکار غیرفعال می‌مانند.',
      requirement: 'برای استفاده از بسته‌های اعتباری و فعال ماندن کلیدهای API، موجودی کیف پول باید مثبت باشد.',
      action: 'برای فعال‌سازی مجدد سرویس‌های API، همین حالا کیف پول خود را شارژ کنید.',
      rechargeButton: 'شارژ کیف پول'
    },
    loadingCreditNotificationSettings: 'در حال دریافت تنظیمات',
    creditNotificationDisabled: 'اعلان موجودی غیرفعال است. برای فعال کردن، «مدیریت» را بزنید.',
    creditNotificationAt: 'وقتی موجودی به این سطوح برسد، اعلان می‌گیرید:',
    creditNotification: 'اعلانات اعتبار',
    rateExpired: 'تراکنش دیگر معتبر نیست',
    clickRefreshToUpdate: 'لطفا دوباره تلاش کنید',
    refreshRate: 'تازه‌سازی',
    amountMustBePositive: 'مقدار ورودی نمیتواند منفی باشد',
    invalidExchangeAmount: 'مقادیر ورودی معتبر نمی باشند',
    invalidExchangeParameters: 'موارد مورد تبدیل نامعتبر هستند',
    exchangeReviewFailed: 'خطایی رخ داد، لطفا دوباره تلاش کنید',
    error: 'خطا',
    exchangeSuccessful: 'تبدیل با موفقیت انجام شد',
    exchangeFailedUnknown: 'تراکنش با خطا مواجه شد',
    exchangeValidationFailed: 'صحت تراکنش تایید نشد',
    unauthorizedExchange: 'تراکنش رد شد',
    tooManyRequests: 'تعداد درخواست بیش از حد مجاز، لطفا چند لحظه بعد تلاش کنید',
    tooManyRequestsDesc: '',
    exchangeFailed: 'تراکنش ناموفق',
    refreshDataFailed: 'اطلاعات دریافت نشد',
    totalPaidInUnitTooltip:
      'نمایش مجموع کل اعتبارات افزایش یافته از طریق پرداخت بانکی به حساب کاربری (بر حسب UNIT)  از زمان ایجاد آن. محاسبه هر بار شارژ بر مبنای نرخ تبدیل در زمان خرید انجام شده است، نه نرخ تبدیل کنونی.',
    totalPaidInUnit: 'مجموع پرداختی معادل واحد',
    historyAmount: 'مبلغ پرداختی',
    paymentId: 'شناسه',
    trackingCode: 'کد رهگیری',
    paymentStatusFailed: 'بررسی وضعیت تراکنش با خطا مواجه شد',
    paymentHistorySearchPlaceholder: 'کد رهگیری، شناسه تراکنش یا شناسه پرداخت',
    // پیام‌های نتیجه‌ی لینک مستقیم (?txid= / ?id= / ?tracking=) وقتی پرداخت در
    // فهرست بارگذاری‌شده نیست. خودِ شناسه جداگانه و داخل <bdi> نمایش داده می‌شود
    // تا ترتیب ارقام لاتین در متن راست‌به‌چپ به‌هم نریزد.
    deepLinkPending:
      'این پرداخت ثبت شده است اما هنوز در تاریخچه‌ی شما قرار نگرفته؛ بانک نتیجه‌ای اعلام نکرده است. لحظه‌ای بعد بازخوانی کنید.',
    deepLinkMissing: 'پرداختی با این شناسه در حساب شما یافت نشد.',
    deepLinkUnavailable: 'در این لحظه امکان بررسی این پرداخت وجود ندارد. کمی بعد دوباره تلاش کنید.',
    paymentTracking: {
      processingTitle: 'در انتظار پرداخت',
      processingDescription:
        'درگاه بانکی را در یک تب جدید باز کردیم. پرداخت را همان‌جا کامل کنید و به این صفحه برگردید؛ نتیجه به‌صورت خودکار بررسی می‌شود.',
      pendingTitle: 'پرداخت هنوز در انتظار تایید است',
      pendingDescription:
        'بانک هنوز پرداخت شما را تایید نکرده است. اگر پرداخت را انجام داده‌اید، کمی صبر کنید و دوباره بررسی کنید، یا با استفاده از کد رهگیری در تاریخچه پرداخت‌ها آن را پیدا کنید.',
      successTitle: 'پرداخت تایید شد',
      successDescription: 'پرداخت شما دریافت شد و اعتبار حساب به‌روزرسانی شد.',
      failedTitle: 'پرداخت قابل تایید نبود',
      failedDescription:
        'نتوانستیم این پرداخت را تایید کنیم. اگر فکر می‌کنید مبلغی از حساب شما کسر شده است، با استفاده از کد رهگیری در تاریخچه پرداخت‌ها آن را بررسی کنید یا با پشتیبانی تماس بگیرید.',
      viewPaymentHistory: 'جستجو در تاریخچه پرداخت‌ها',
      copyTrackingCode: 'کپی کد رهگیری',
      keepThisCode: 'این کد رهگیری را نگه دارید؛ بعدا می‌توانید با آن این پرداخت را پیدا کنید.',
      closeGuardTitle: 'قبل از تایید پرداخت خارج می‌شوید؟',
      closeGuardDescription:
        'پرداخت شما هنوز در حال پردازش است. اگر الان خارج شوید، کد رهگیری را کپی کنید تا بعدا بتوانید نتیجه را در تاریخچه پرداخت‌ها بررسی کنید.',
      closeGuardConfirm: 'ادامه پیگیری',
      closeGuardLeave: 'خروج'
    },
    paymentStatusUpdated: 'وضعیت تراکنش بررسی شد',
    totalAmount: 'مبلغ کل',
    pendingTransactions: 'تراکنش‌های درحال تایید',
    confirmedTransactions: 'تراکنش‌های تایید شده',
    selectStatus: 'انتخاب وضعیت',
    selectItemType: 'انتخاب نوع تراکنش',
    paymentHistory: 'تاریخچه پرداخت',
    paymentHistoryLoadFailed: 'دریافت تاریخچه پرداخت با خطا مواجه شد. دوباره تلاش کنید.',
    totalTransactions: 'مجموع تراکنش‌ها',
    purchaseItem: 'نوع',
    subscription: 'اشتراک',
    credit: 'اعتبار',
    confirmationDate: 'تاریخ تایید',
    paidAmount: 'مبلغ پرداختی',
    discount: 'تخفیف',
    howToUseApi1: 'دریافت مانده اعتبار از طریق API',
    sampleOutput: 'پاسخ نمونه:',
    howToUseApi2:
      'توضیحات: remaining_irt معادل «باقی مانده اعتبار تومانی» و remaining_unit معادل «باقی مانده اعتبار تبدیل شده به واحد (نرخ تتر)» و exchange_rate نرخ تبدیل لحظه‌ای و در نهایت total_unit معادل تمام اعتبارها از جمله اعتبار افزایش یافته از طریق پرداخت بانکی، اعتبار هدیه، گرنت و ... بر مبنای نرخ تبدیل لحظه‌ای است. مقدار total_unit ملاک سنجش است.',
    exhausted: 'مصرف شده',
    remainingDays: 'روزهای باقی‌ مانده',
    remainingHours: 'ساعات باقی مانده',
    remainingMinutes: 'دقایق باقی مانده',
    remaining: 'باقی مانده',
    expiration: 'انقضا',
    grantsTotalUnit: 'مجموع اعتبار هدیه معادل واحد',
    unnamedGrant: 'بدون عنوان',
    grants: 'اعتبار هدیه',
    exchangeRateUSDT: 'نرخ مبادله تتر',
    fee: 'کارمزد',
    timesUp: 'تراکنش دیگر معتبر نیست.',
    reviewValidTill: 'مقادیر پیش نمایش تا',
    secondsValidAst: 'ثانیه دیگر معتبر است.',
    exchangeTo: 'مقدار نهایی',
    exchangeFrom: 'تبدیل از',
    exchangeRate: 'نرخ تبدیل',
    feeAmount: 'کارمزد',
    shortDesc1: 'مدیریت و بررسی جزئیات اعتبار حساب کاربری.',
    title: 'مدیریت مالی',
    topup: 'افزایش اعتبار',
    minAmount: 'حداقل',
    maxAmount: 'حداکثر',
    IRI: 'ریال',
    IRT: 'تومان',
    UNIT: 'واحد اعتبار',
    total: 'مجموع اعتبار به واحد',
    recharge: 'افزایش اعتبار',
    confirm: 'تایید',
    and: 'و',
    pay: 'پرداخت',
    remaningCredit: 'اعتبار باقی مانده',
    zero: 'صفر',
    remainingCredit: 'اعتبار باقی مانده',
    remainingCreditTotalUnit: 'مجموع اعتبار باقی‌ مانده معادل واحد',
    noCredits: 'بدون اعتبار',
    sourceAmount: 'از',
    targetAmount: 'به مبلغ',
    amount: 'مبلغ',
    exchange: 'تبدیل',
    exchangeTitle: 'تبدیل اعتبار',
    confirmAndExchange: 'تایید و تبدیل',
    close: 'بازگشت',
    exchangeConfirmFailed: 'تبدیل با خطا مواجه شد.',
    exchangeConfirmed: 'تبدیل با موفقیت انجام شد',
    totalCost: 'هزینه کل',
    loginToViewCredit: 'برای مشاهده موجودی واقعی اعتبار و تاریخچه تراکنش‌ها وارد شوید',
    phoneVerification: {
      title: 'اتصال شماره تلفن برای ادامه پرداخت',
      description:
        'پیرو دستور پلیس فتا و برای جلوگیری از سوءاستفاده، پرداخت بیش از {amount} تومان در هفته نیازمند داشتن شماره تلفن تاییدشده در حساب کاربری است.',
      weeklyLimitAmount: '۵ میلیون',
      infoBanner:
        'این محدودیت برای مجموع پرداخت‌های ۷ روز اخیر شما اعمال می‌شود. شماره تلفن خود را همین‌جا وارد و تایید کنید؛ پس از تایید، محدودیت برداشته می‌شود و می‌توانید پرداخت را دوباره انجام دهید.',
      verifyHere: 'شماره تلفن خود را در ادامه وارد و تایید کنید',
      alternativeNote:
        'در صورت عدم تمایل به اتصال شماره تلفن، می‌توانید مبلغ پرداخت را کاهش دهید یا تا خارج شدن پرداخت‌های قبلی از بازه ۷ روزه صبر کنید.',
      backToPayment: 'بازگشت به صفحه پرداخت'
    }
  },
  // descriptionXs:
  //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش بسته «پلاس» و ۱ درصد از هزینه‌های api را دریافت نمایید!',
  // descriptionXs:
  //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید! همچنین دوستان شما در اولین خرید ۱۵ درصد تخفیف خواهند گرفت!',
  affiliate: {
    affiliatePage: {
      unavailable: 'نامشخص',
      tagline: 'دوستان خود را با لینک دعوت به AvalAI بیاورید و از خرید اشتراک آن‌ها سهم بگیرید.',
      updatedAt: 'آخرین به‌روزرسانی',
      loading: 'در حال دریافت آمار دعوت‌ها',
      loadFailed: 'دریافت آمار دعوت‌ها انجام نشد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ آمار قبلی نمایش داده می‌شود.',
      linkTitle: 'لینک دعوت شما',
      linkHint: 'تا یک سال پس از ثبت‌نام هر دعوت‌شده، ۱۰٪ از خرید اشتراک «پلاس» او به شما می‌رسد.',
      copyLink: 'کپی لینک',
      linkCopied: 'کپی شد',
      linkUnavailable: 'کد دعوت شما هنوز صادر نشده است. صفحه را تازه‌سازی کنید یا بعدا سر بزنید.',
      guestTitle: 'برای دریافت لینک دعوت وارد شوید',
      guestBody: 'لینک دعوت به حساب شما وابسته است. پس از ورود، لینک و آمار دعوت‌ها همین‌جا نمایش داده می‌شود.',
      signIn: 'ورود به حساب',
      tileReferrals: 'دعوت‌ها',
      tileReferralsThisMonth: 'دعوت‌های این ماه',
      thisMonthHint: 'دعوت‌شدگانی که در ماه جاری ثبت‌نام کرده‌اند. ماه بر پایه تقویم زبان صفحه است.',
      tileConfirmed: 'درآمد تاییدشده',
      confirmedHint: 'کمیسیونی که پس از تسویه خرید دعوت‌شدگان قطعی شده است.',
      tilePending: 'در انتظار تایید',
      pendingHint: 'کمیسیون خریدهایی که هنوز تسویه نشده‌اند.',
      tableTitle: 'دعوت‌شدگان',
      columnUser: 'کاربر',
      columnJoined: 'تاریخ ثبت‌نام',
      columnLastPurchase: 'آخرین خرید',
      columnPending: 'در انتظار',
      columnConfirmed: 'تاییدشده',
      noPurchaseYet: 'هنوز خریدی نداشته',
      pageSummary: 'نمایش {from} تا {to} از {total} دعوت‌شده',
      perPage: '{count} در هر صفحه',
      emptyTitle: 'هنوز کسی با لینک شما ثبت‌نام نکرده است.',
      emptyHint: 'لینک را برای دوستان و همکاران بفرستید؛ آمار و درآمد همین‌جا نمایش داده می‌شود.',
      howItWorks: 'چطور کار می‌کند؟',
      step1: 'لینک دعوت خود را کپی کنید و برای دوستان بفرستید.',
      step2: 'آن‌ها با همان لینک در AvalAI ثبت‌نام می‌کنند.',
      step3: 'تا یک سال، ۱۰٪ از هر خرید اشتراک «پلاس» آن‌ها به عنوان کمیسیون به شما می‌رسد و همین‌جا دیده می‌شود.'
    },
    stepsTitle: 'همکاری در فروش خود را همین حالا شروع کنید',
    stepsDescription: 'این مراحل ساده را دنبال کنید تا شروع به کسب درآمد کنید',
    step1Title: 'کد دعوت خود را دریافت کنید',
    step1Description: 'کد دعوت ویژه شما آماده اشتراک‌گذاری است',
    step1Description2: 'برای دریافت کد خود وارد شوید',
    step2Title: 'دوستان را دعوت کنید',
    step2Description: 'کد دعوت خود را با دوستان و همکاران به اشتراک بگذارید',
    step2Description2: 'وقتی آنها با استفاده از کد شما ثبت‌نام می‌کنند، هر دوی شما مزایا دریافت می‌کنید!',
    step3Title: 'پاداش کسب کنید',
    step3Description: 'برای هر تراکنشی که دعوت‌شدگان شما انجام می‌دهند، کمیسیون دریافت کنید',
    step3Description2: 'درآمد خود را همین‌جا در این صفحه پیگیری کنید!',
    title: 'همکاری در فروش',
    descriptionLg:
      'با همکاری در بازاریابی و معرفی AvalAI به دوستان خود از طریق لینک مقابل، در درآمد فروش سهیم شده و کسب درآمد کنید.',
    descriptionXs: 'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید!',
    totalUsers: 'مجموع دعوت‌ها',
    usersAddedThisMonth: 'دعوت‌های این ماه',
    totalIncomeThisMonth: 'درآمد این ماه',
    totalIncomeConfirmed: 'درآمد کل',
    totalIncomePending: 'در حال تایید',
    inWithdrawalProcess: 'در حال برداشت',
    lastSettledIncome: 'آخرین برداشت',
    usersInMonth: 'دعوت در ماه',
    username: 'نام کاربری',
    registrationDate: 'تاریخ ثبت نام',
    lastTransactionDate: 'آخرین تراکنش',
    confirmedCommission: 'تایید شده',
    pendingCommission: 'در حال تایید',
    netIncome: 'درآمد کل',
    transactions: 'تراکنش‌ها',
    noTransaction: 'ندارد'
  },
  api: {
    couldNotFetchShowingCatched: 'دریافت تنظیمات کلید با خطا مواجه شد، در حال مشاهد اطلاعات پیشین هستید.',
    loadingKeyData: 'در حال دریافت تنظیمات',
    keyNotFound: 'کلید API یافت نشد، درصورت بروز مشکل لطفا یک مرتبه صفحه را رفرش نمایید.',
    maxApiKeysReached:
      'حداکثر سقف مجاز تعداد کلید‌های API تکمیل شده است، لطفا پیش از ایجاد کلید جدید، کلید‌های قبلی را حذف نمایید.',
    invalidRequest: 'درخواست نامعتبر است. لطفا اطلاعات کلید را بررسی و دوباره تلاش کنید.',
    noPermission:
      'شما دسترسی انجام این عملیات را ندارید. لطفا از ورود به حساب کاربری اطمینان حاصل نمایید و درصورت پابرجا بودن مشکل با پشتیبانی تماس بگیرید.',
    tooManyRequests: 'تعداد درخواست‌ها زیاد است. لطفا کمی صبر کنید و دوباره تلاش کنید.',
    keyCreateFailed: 'ایجاد کلید API انجام نشد. لطفا دوباره تلاش کنید.',
    keyEditFailed: 'ذخیره تغییرات کلید API انجام نشد. لطفا دوباره تلاش کنید.',
    endpointAccess: 'نقاط دسترسی',
    allowedEndpoints: 'نقاط دسترسی مجاز',
    allowedIntents: 'مقاصد مجاز',
    allEndpointsAllowed: 'تمام نقاط دسترسی‌ها مجاز است',
    allIntentsAllowed: 'تمام مقاصد مجاز است',
    noEndpointsAvailable: 'نقاط دسترسی موجود نیست',
    noIntentsAvailable: 'مقاصد موجود نیست',
    ipFormatHelp: 'فرمت‌های پشتیبانی شده: IPv4 (مثال: 192.168.1.1)، IPv6 و نشانه‌گذاری CIDR (مثال: 192.168.1.0/24)',
    invalidCIDRFormat: 'فرمت CIDR نامعتبر',
    invalidCIDRRange: 'محدوده CIDR نامعتبر (0-128)',
    invalidIPv4CIDRRange: 'محدوده CIDR برای IPv4 نامعتبر (0-32)',
    invalidIPv4Address: 'آدرس IPv4 نامعتبر',
    invalidIPv6Address: 'آدرس IPv6 نامعتبر',
    ipExamples: 'مثال‌ها',
    max256IpsWarning: 'حداکثر تا ۲۵۶ عدد آی‌پی مجاز است، تعدادی نادیده گرفته شد',
    noUsage: 'ندارد',
    budgetUsed: 'مصرف',
    keyModified: 'کلید با موفقیت ویرایش شد',
    apiV4RangeNumebrs: 'آدرس آی‌پی باید بین ۰ تا ۲۵۵ باشد',
    noModelsAvailable: 'فهرست مدل‌ها در دسترس نیست',
    allModelsAllowed: 'برای دسترسی به تمامی مدل‌ها این قسمت را خالی بگذارید',
    allowedModels: 'مدل‌های مجاز',
    forever: 'همیشه',
    keyExpirationDay: 'مدت زمان اعتبار (روز)',
    iPRestrictions: 'محدودیت‌های دسترسی IP',
    pleaseEnterValidIp: 'نشانی را به‌صورت صحیح وارد کنید',
    neverExpires: 'هیچ وقت',
    keyExpiration: 'تاریخ انقضا',
    totalBudget: 'بودجه کل (واحد)',
    noLimit: 'بدون محدودیت',
    monthlyBudget: 'بودجه ماهانه (واحد)',
    usageLimits: 'محدودیت‌های استفاده',
    ipAddressInfoFooter:
      'برای لغو محدودیت دسترسی IP، لیست را خالی بگذارید، درصورت تمایل به ایجاد محدودیت، آدرس IPv4 یا IPv6 و یا CIDR را وارد نمایید.',
    enterIpAddress: 'آدرس IP را وارد نمایید',
    uploadIpTips: 'بارگذاری .txt یا .csv',
    importIPs: 'درون‌ریزی IPها',
    securitySettings: 'تنظیمات امنیتی',
    advancedSettings: 'تنظیمات پیشرفته',
    deleteAllIps: 'حذف همه IPها',
    shortDesc1: 'مدیریت ایمن کلید‌های دسترسی به سرویس‌های API',
    noName: 'بدون نام',
    showOnce: 'کلید خصوصی تنها همین یک مرتبه نمایش داده می‌شود؛ پیش از بستن صفحه آن را ذخیره نمایید.',
    secretKey: 'کلید خصوصی',
    copyManualHint: 'کپی خودکار در این مرورگر ممکن نیست. کلید انتخاب شده است، آن را دستی کپی کنید.',
    allIpsCleared: 'همه آدرس‌های آی‌پی پاک شدند',
    ipFileReadError: 'خواندن فایل بارگذاری‌شده ممکن نبود',
    keyEnabledHint: 'این کلید می‌تواند برای درخواست‌های API استفاده شود.',
    keyDisabledHint: 'تا زمانی که این کلید غیرفعال است، درخواست‌های آن رد می‌شود.',
    close: 'بازگشت',
    api: 'API',
    confirmRevoke: 'کلید حذف شود؟',
    removeConfirmYes: 'حذف کن',
    removeConfirmNo: 'منصرف شدم',
    remove: 'حذف',
    edit: 'ویرایش',
    update: 'به‌روزرسانی',
    guardrail: {
      performanceImpact: 'تاثیر بر عملکرد',
      howActivated: 'روش‌های فعال‌سازی گاردریل',
      recommendation: 'توصیه ما',
      futureDevelopment: 'برنامه‌های توسعه آینده',
      securityNotice: 'هشدارهای امنیتی',

      // Recommendation section
      recommended: 'توصیه شده',
      recommendationDesc:
        'ما قویا فعال‌سازی گاردریل‌ها را برای افزایش امنیت توصیه می‌کنیم. اگرچه این ویژگی تاخیر کمی اضافه می‌کند، اما محافظتی که ارائه می‌دهد برای اکثر کاربردها ارزشمند است. با این حال، اگر برنامه شما نیاز به حداقل تاخیر دارد و از نحوه مدیریت داده‌های خود اطمینان دارید، می‌توانید این ویژگی را غیرفعال کنید.',

      // Performance impact section
      latencyImpact:
        'فعال‌سازی گاردریل‌ها یک مرحله پیش‌پردازش اضافه می‌کند که بسته به حجم و پیچیدگی داده‌های ورودی، تاخیر درخواست را حدود ۲۰۰ تا ۳۰۰۰ میلی‌ثانیه افزایش می‌دهد.',
      latencyTooltip: 'تاثیر تاخیر بر اساس اندازه و پیچیدگی درخواست متغیر است',
      disableForLowLatency:
        'اگر برنامه شما نیاز به حداقل تاخیر دارد و اطمینان دارید که هیچ داده حساسی ارسال نمی‌شود، می‌توانید این ویژگی را برای کاهش سربار غیرفعال کنید.',

      detectSecrets: 'detect-secrets',
      title: 'تنظیمات گاردریل',
      description: 'محافظت از درخواست‌های API با سیستم گاردریل',
      enabled: 'گاردریل فعال است',
      disabled: 'گاردریل غیرفعال است',
      explanation: 'توضیحات گاردریل',
      explanationTitle: 'نحوه محافظت گاردریل‌ها',
      explanationContent:
        'گاردریل‌ها از درخواست‌های API شما با شناسایی و پاکسازی اطلاعات حساس مانند کلیدهای API و توکن‌ها محافظت می‌کنند. هنگامی که این سیستم فعال باشد، تمامی درخواست‌های API پیش از رسیدن به مدل‌های LLM، توسط سیستم detect-secrets بررسی شده و اطلاعات حساس با عبارت [REDACTED] جایگزین می‌شوند.',

      currentImplementation: 'پیاده‌سازی فعلی',
      implementationDetails:
        'در حال حاضر، سیستم گاردریل ما از <strong>{0}</strong> بهره می‌برد که بر مبنای پروژه متن‌باز <a href="{1}" target="_blank" rel="noopener">Yelp/detect-secrets</a> طراحی شده است. این سیستم برای شناسایی و پاکسازی داده‌های حساس مانند کلیدهای API و توکن‌ها در درخواست‌های شما استفاده می‌شود.',
      redactionProcess:
        'زمانی که گاردریل اطلاعات حساس را تشخیص می‌دهد، به صورت خودکار آن‌ها را با عبارت <code>[REDACTED]</code> جایگزین می‌کند. این فرآیند پیش از رسیدن درخواست به مدل‌های LLM انجام می‌شود و هیچ اثری از داده‌های حساس باقی نمی‌گذارد، که این امر لایه امنیتی اضافی برای محافظت از اطلاعات شما فراهم می‌کند.',

      userLevelTitle: 'فعال‌سازی در سطح حساب کاربری',
      userLevelDesc:
        'با فعال‌سازی گاردریل در تنظیمات حساب کاربری، تمامی درخواست‌های API شما به طور خودکار اسکن و محافظت خواهند شد',
      perRequestTitle: 'فعال‌سازی برای درخواست‌های خاص',
      perRequestDesc:
        'با قرار دادن <code>guardrails: ["hide-secrets"]</code> در داده‌های درخواست API، می‌توانید گاردریل را برای همان درخواست فعال کنید، حتی اگر در تنظیمات حساب کاربری غیرفعال باشد',

      futureDesc:
        'در حال حاضر، امکان تعریف گاردریل‌های سفارشی برای کاربران وجود ندارد. با این حال، ما در نظر داریم در به‌روزرسانی‌های آینده، این سیستم را با ویژگی‌های امنیتی پیشرفته‌تر و گزینه‌های شخصی‌سازی بیشتر، ارتقا دهیم.',

      securityDesc:
        'هرچند سیستم گاردریل یک لایه امنیتی اضافی برای محافظت از داده‌های شما فراهم می‌کند، اما تضمینی برای شناسایی تمامی اطلاعات حساس وجود ندارد. کارایی این سیستم به قابلیت‌های پروژه detect-secrets بستگی دارد. توصیه می‌کنیم همچنان اصول امنیتی را رعایت کرده و تا حد امکان، از ارسال اطلاعات حساس در درخواست‌های API خود خودداری نمایید.'
    },
    editSecretKey: 'ذخیره تنظیمات',
    editingSecretKey: 'در حال ویرایش کلید API',
    cancel: 'لغو',
    createNewSecret: 'ایجاد کلید جدید',
    cName: 'نام',
    cSecret: 'کلید رمز',
    cCreated: 'تاریخ ایجاد',
    cLastUsed: 'آخرین استفاده',
    cActions: 'عملیات',
    title: 'کلیدهای دسترسی API',
    editKey: 'ویرایش کلید',
    createKey: 'ساخت کلید API',
    keyName: 'نام',
    keyNamePlaceholder: 'کلید آزمایشی',
    createNewKey: 'ایجاد کلید جدید',
    maskedKeysShown: 'کلیدهای API شما در زیر فهرست شده‌اند.',
    howToUse1:
      'برای استفاده در بسته‌های رسمی OpenAI کافیست base_url را به مقدار https://api.avalai.ir/v1 تنظیم نمایید. ',
    howToUse2: 'راهنمای استفاده از کلید‌های API پلتفرم AvalAI',
    konid: 'مراجعه کنید.',
    info2:
      'کلید API خود را با دیگران به اشتراک نگذارید، برای حفظ امنیت، کلید‌های جدید تنها یک مرتبه نمایش داده می‌شوند.',
    howToUse3:
      'از کتابخانه‌ها/چهارچوب‌های رسمی OpenAI استفاده کنید، یا در صورت استفاده از درخواست‌های HTTP، ساختار OpenAI را رعایت نمایید.',
    propagatingKey: 'در حال انتشار در شبکه',
    propagationMessage: 'کلید API در حال انتشار در شبکه است، معمولا کمتر از ۳۰ ثانیه طول می‌کشد.',
    propagationStatus: 'همگام‌سازی در شبکه…',
    keysPage: {
      tagline: 'کلیدهایی که برنامه‌های شما با آن‌ها به API وصل می‌شوند را بسازید، محدود کنید و در صورت نیاز حذف کنید.',
      updatedAt: 'آخرین به‌روزرسانی',
      loading: 'در حال دریافت کلیدها',
      loadFailed: 'دریافت کلیدها انجام نشد.',
      refreshFailed: 'تازه‌سازی انجام نشد؛ فهرست قبلی نمایش داده می‌شود.',
      totalKeys: 'همه کلیدها',
      activeKeys: 'فعال',
      disabledKeys: 'غیرفعال',
      usedThroughKeys: 'مصرف کلیدها',
      usedThroughKeysHint: 'مجموع واحدهای اعتباری که با این کلیدها مصرف شده است. کلیدهایی که مصرفشان گزارش نشده در جمع نیستند.',
      unavailable: 'نامشخص',
      neverUsed: 'استفاده نشده',
      usageColumn: 'مصرف (واحد اعتبار)',
      unitLabelShort: 'واحد اعتبار',
      search: 'جست‌وجو',
      searchPlaceholder: 'نام یا بخش نمایان کلید',
      clearFilters: 'پاک کردن فیلترها',
      noKeys: 'هنوز کلیدی نساخته‌اید.',
      noKeysHint: 'برای فراخوانی API یک کلید بسازید. کلید کامل تنها همان لحظه نمایش داده می‌شود.',
      noMatches: 'کلیدی با این فیلترها پیدا نشد.',
      noMatchesHint: 'عبارت جست‌وجو یا فیلتر وضعیت را تغییر دهید.',
      pageSummary: 'نمایش {from} تا {to} از {total} کلید',
      perPage: '{count} در هر صفحه',
      helpLabel: 'راهنمای استفاده از کلیدها',
      howToUseTitle: 'استفاده از کلید',
      howToUse: 'در SDK رسمی OpenAI مقدار base_url را روی نشانی زیر بگذارید و کلید را به جای کلید OpenAI بدهید.',
      keepSecretTitle: 'نگهداری کلید',
      keepSecret: 'کلید را در کد سمت کاربر یا مخزن عمومی قرار ندهید. اگر کلیدی لو رفت، همین‌جا آن را حذف کنید و کلید جدیدی بسازید.',
      baseUrlLabel: 'نشانی پایه',
      copyBaseUrl: 'کپی نشانی',
      editKey: 'ویرایش کلید {key}',
      deleteKey: 'حذف کلید {key}',
      deleteTitle: 'این کلید حذف شود؟',
      deleteBody: 'برنامه‌هایی که از این کلید استفاده می‌کنند بلافاصله با خطای احراز هویت متوقف می‌شوند. این کار قابل بازگشت نیست.',
      deleteConfirm: 'حذف کلید',
      deleted: 'کلید حذف شد.',
      deleteFailed: 'حذف کلید انجام نشد. دوباره تلاش کنید.',
      guardrailSection: 'گاردریل',
      guardrailLoadFailed: 'دریافت وضعیت گاردریل انجام نشد.',
      guardrailSaveFailed: 'تغییر وضعیت گاردریل انجام نشد.',
      guardrailAbout: 'گاردریل چگونه کار می‌کند؟',
      usage: {
        column: '۷ روز گذشته',
        columnHint: 'مصرف ثبت‌شده با هر کلید در هفت روز گذشته، هر ستون یک روز. برای دیدن جزئیات کامل روی نمودار کلید کلیک کنید.',
        metricCost: 'هزینه',
        metricRequests: 'فراخوانی‌ها',
        metricTokens: 'توکن‌ها',
        metric: 'سنجه نمودار',
        metricHint: 'سنجه‌ای که در نمودارهای کوچک و ستون «۷ روز گذشته» نمایش داده می‌شود',
        sparklineLabel: '{metric} کلید {key} در ۷ روز گذشته: {total}، روند {trend}',
        sparklineEmpty: 'در ۷ روز گذشته مصرفی با کلید {key} ثبت نشده است',
        sparklineGap: 'مصرف کلید {key} در ۷ روز گذشته هنوز به‌طور کامل در دسترس نیست',
        trendUp: 'افزایشی',
        trendDown: 'کاهشی',
        trendFlat: 'ثابت',
        trendUnknown: 'نامشخص',
        partialHint: 'بخشی از این بازه هنوز در گزارش مصرف پوشش داده نشده است؛ نمودار ممکن است ناقص باشد.',
        loadFailed: 'دریافت مصرف کلیدها انجام نشد؛ فهرست بدون نمودار نمایش داده می‌شود.',
        expand: 'نمایش جزئیات مصرف کلید {key}',
        collapse: 'پنهان کردن جزئیات مصرف کلید {key}',
        detailLabel: 'مصرف کلید {key}',
        window24h: '۲۴ ساعت',
        window7d: '۷ روز',
        window30d: '۳۰ روز',
        windowHint: 'بازه زمانی این کلید',
        modelsTitle: 'مدل‌های استفاده‌شده با این کلید',
        noActivity: 'در این بازه هیچ فراخوانی با این کلید ثبت نشده است.',
        openInOverview: 'مشاهده در نمای کلی مصرف',
        activeShare: 'سهم از مصرف حساب در ۷ روز گذشته',
        topKey: 'پرمصرف‌ترین کلید',
        topKeyHint: 'کلیدی که در سنجه انتخاب‌شده بیشترین مصرف را در هفت روز گذشته داشته است.',
        usedKeys: 'کلیدهای استفاده‌شده',
        usedKeysHint: 'کلیدهایی که در هفت روز گذشته دست‌کم یک فراخوانی ثبت‌شده دارند.',
        groupAccount: 'کلیدهای شما',
        groupAccountCaption: 'همه کلیدهای حساب، مستقل از فیلترهای زیر',
        groupWeek: '۷ روز گذشته',
        groupWeekCaption: 'بر پایه {metric}، از آمار مصرف هر کلید',
        groupWeekPending: 'مصرف کلیدها در حال دریافت است',
        windowTotal: 'مجموع {metric}',
        windowTotalHint: 'مجموع سنجه انتخاب‌شده برای همه کلیدها در هفت روز گذشته. روز جاری هنوز در حال تکمیل است.',
        ofKeys: 'از {total} کلید',
        shareOfTotal: '{share} از کل',
        noKeyUsed: 'در این بازه از هیچ کلیدی استفاده نشده است',
        revealKey: 'نمایش ردیف کلید {key}'
      }
    }
  },
  summary: {
    requests: 'فراخوانی‌ها',
    noUsageDataTooltip: 'هیچ داده‌ای برای نمایش موجود نیست. به محض ثبت داده‌ها، در اینجا نمایش داده خواهند شد',
    remainingCredit: 'اعتبار باقی‌مانده',
    totalTokens: 'مجموع توکن‌ها',
    totalRequests: 'مجموع درخواست‌ها',
    remainingCreditUnit: 'باقی‌مانده (واحد)',
    remainingCreditIrt: 'باقی‌مانده (تومان)',
    usageTrends: 'روند مصرف',
    last7Days: '۷ روز گذشته',
    last28Days: '۲۸ روز گذشته',
    modelTokenDistribution: 'توزیع توکن مدل',
    dailyRequests: 'درخواست‌های روزانه',
    topModelsUsage: 'مدل‌های پر استفاده',
    hourlyUsageTokens: 'میزان توکن ساعتی',
    hourlyUsageRequests: 'درخواست‌های ساعتی',
    period1Hour: 'ساعت گذشته',
    period6Hours: '۶ ساعت گذشته',
    period12Hours: '۱۲ ساعت گذشته',
    period24Hours: '۲۴ ساعت گذشته',
    cost: 'هزینه',
    inputTokens: 'توکن‌های ورودی',
    outputTokens: 'توکن‌های خروجی',
    activeGrants: 'گرنت‌های فعال',
    expiresIn: 'منقضی می‌شود تا',
    days: 'روز دیگر',
    recentTransactions: 'تراکنش‌های اخیر',
    currency: 'واحد پول',
    modelTokenUsage: 'استفاده توکن مدل',
    last1Hour: '۱ ساعت گذشته',
    last6Hours: '۶ ساعت گذشته',
    last12Hours: '۱۲ ساعت گذشته',
    last24Hours: '۲۴ ساعت گذشته',
    dailyTrendNotAvailable: 'نمودار روند مصرف روزانه برای دوره‌های ۷ روزه و ۲۸ روزه در دسترس است.',
    totalCost: 'هزینه کل'
  },
  error: { fetchFailed: 'دریافت ناموفق بود' },
  system: {
    title: 'AvalAI'
  },
  common: {
    to: 'به',
    input: 'ورودی',
    output: 'خروجی',
    remainingTime: 'زمان باقی مانده',
    at: 'در',
    allTiers: 'تمام سطوح',
    allModels: 'تمام مدل‌ها',
    outof: 'از',
    days: 'روز',
    hours: 'ساعت',
    minutes: 'دقیقه',
    moreItems: 'مورد دیگر',
    tiers: 'سطوح دسترسی',
    models: 'مدل‌',
    discountOff: 'ارزان‌تر',
    discount: 'تخفیف',
    fetchFailed: 'دریافت اطلاعات ناموفق بود',
    sort: 'مرتب‌سازی',
    tier: 'سطح',
    copy: 'کپی',
    projectUpdates: 'آخرین تغییرات',
    viewAll: 'مشاهده همه',
    readMore: 'مشاهده',
    loadMore: 'نمایش بیشتر',
    noResults: 'چیزی پیدا نشد',
    resultsFoundInOtherTabs: 'نتیجه در سربرگ‌های دیگر یافت شد',
    noResultsInCurrentTab: 'نتیجه‌ای در این سربرگ پیدا نشد',
    and: 'و',
    additionalPersianOnly: 'دیگر',
    additionalEnglishOnly: '',
    additional: 'دیگر',
    emailAddress: 'آدرس ایمیل',
    phoneNumber: 'شماره تلفن',
    fetchError: 'دریافت اطلاعات با خطا مواجه شد',
    tier1AndAbove: 'سطح ۱ به بالا',
    tier3AndAvove: 'سطح ۳ به بالا',
    tier5Only: 'سطح کاربری ۵',
    requiresTier1: 'این قابلیت در سطح کاربری ۱ به بالا در دسترس است',
    requiresTier3: 'تعریف سطح آستانه سفارشی در سطح کاربری ۳ به بالا در دسترس است',
    requiresTier5: 'تعریف دریافت کنندگان بیشتر، تنها در سطح کاربری ۵ در دسترس است',
    fixErrorsBeforeSaving: 'قبل از ذخیره سازی لطفا خطاها را رفع کنید',
    failedToSaveSettingsTryAgain: 'ذخیره تغییرات با خطا مواجه شد، لطفا دوباره تلاش کنید',
    equivalent: 'معادل',
    manage: 'مدیریت',
    threshold: 'آستانه',
    saveChanges: 'ذخیره تغییرات',
    saving: 'در حال ذخیره',
    phone: 'شماره تلفن',
    email: 'آدرس ایمیل',
    recipients: 'گیرندگان',
    thresholds: 'سطوح آستانه',
    custom: 'سفارشی',
    default: 'پیش‌فرض',
    retry: 'تلاش مجدد',
    pageLoading: 'در حال بارگذاری صفحه...',
    pageLoadError: 'خطا در بارگذاری صفحه',
    pageLoadErrorDesc: 'هنگام بارگذاری این صفحه خطایی رخ داد. لطفا دوباره تلاش کنید.',
    useInApi: 'استفاده از API',
    seconds: 'ثانیه',
    docs: 'مستندات',
    learnMore: 'بیشتر بیاموزید',
    save: 'ذخیره',
    select: 'انتخاب',
    comingSoon: 'به زودی',
    attach: 'ضمیمه',
    back: 'بازگشت',
    clickToCopy: 'کپی کنید',
    disabled: 'غیرفعال',
    enabled: 'فعال',
    hide: 'مخفی کردن',
    configure: 'تنظیم کردن',
    show: 'نمایش',
    systemStatus: 'وضعیت سرویس',
    page: 'صفحه',
    total: 'تعداد کل',
    showLess: 'نمایش نده',
    showMore: 'نمایش بیشتر',
    // noDataToDownload: 'اطلاعاتی وحود ',
    downloadError: 'بارگذاری با خطا مواجه شد',
    downloadSuccess: 'بارگذاری انجام شد',
    downloadCSV: 'فایل CSV',
    downloadExcel: 'فایل Excel',
    download: 'بارگذاری',
    api: 'API',
    credit: 'اعتبار',
    subscription: 'اشتراک',
    recheck: 'بررسی',
    nothingFound: 'چیزی یافت نشد',
    time: 'زمان',
    date: 'تاریخ',
    somethingWentWrongRefreshPage: 'خطایی رخ داد، لطفا پس از چند لحظه مجدد تلاش کنید',
    shortCuts: 'میانبرها',
    phoneAlreadyVerified: 'شماره تلفن با موفقیت تایید شده، بروزرسانی خودکار صفحه تا چند لحظه دیگر',
    phoneVerificationRequired: 'جهت دسترسی به سرویس‌ها، نیاز به ثبت شماره تلفن است، لطفا شماره تلفن خود را تایید کنید.',
    backToChat: 'صفحه گفتگوها',
    copied: 'کپی شد',
    copyFailed: 'خطایی رخ داد',
    optional: 'اختیاری',
    action: 'عملیات',
    add: 'افزودن',
    addSuccess: 'افزودن با موفقیت انجام شد',
    backToHome: 'بازگشت به خانه',
    batchDelete: 'حذف دسته جمعی',
    cancel: 'لغو',
    close: 'بستن',
    check: 'بررسی',
    columnSetting: 'تنظیمات ستون',
    config: 'پیکربندی',
    confirm: 'تایید',
    delete: 'حذف',
    deleteSuccess: 'حذف با موفقیت انجام شد',
    confirmDelete: 'می خواهید حذف کنید؟',
    edit: 'ویرایش',
    index: 'فهرست',
    keywordSearch: 'لطفا کلیدواژه را وارد کنید',
    logout: 'خروج',
    logoutConfirm: 'می خواهید از حساب کاربری خارج شوید؟',
    lookForward: 'به زودی',
    modify: 'تغییر دادن',
    modifySuccess: 'تغییر با موفقیت انجام شد',
    noData: 'بدون داده',
    operate: 'عملیات',
    pleaseCheckValue: 'لطفا مقدار را بررسی کنید',
    refresh: 'تازه‌سازی',
    reset: 'تنظیم مجدد',
    search: 'جستجو',
    switch: 'تغییر',
    tip: 'نکته',
    trigger: 'رونده',
    update: 'بروزرسانی',
    updateSuccess: 'بروزرسانی با موفقیت انجام شد',
    userCenter: 'مرکز کاربری',
    yesOrNo: {
      yes: 'بله',
      no: 'خیر'
    },
    newsCategories: {
      announcement: 'اعلان',
      api: 'API',
      models: 'مدل‌ها',
      performance: 'عملکرد',
      billing: 'صورتحساب',
      security: 'امنیت',
      feature: 'قابلیت',
      documentation: 'مستندات',
      tutorial: 'آموزش',
      release: 'انتشار'
    },
    next: 'بعدی',
    noUpdates: 'هیچ به‌روزرسانی موجود نیست'
  },
  request: {
    logout: 'کاربر بعد از درخواست ناموفق خارج شود',
    logoutMsg: 'وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید',
    logoutWithModal: 'پنجره بازشو بعد از درخواست ناموفق ظاهر شود و سپس کاربر خارج شود',
    logoutWithModalMsg: 'وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید',
    refreshToken: 'توکن درخواست شده منقضی شده است، توکن را تازه کنید',
    tokenExpired: 'توکن درخواست شده منقضی شده است'
  },
  theme: {
    themeSchema: {
      title: 'طرح تم',
      light: 'روشن',
      dark: 'تیره',
      auto: 'بر اساس  سیستم'
    },
    layoutMode: {
      title: 'حالت چیدمان',
      vertical: 'حالت منوی عمودی',
      horizontal: 'حالت منوی افقی',
      'vertical-mix': 'حالت منوی عمودی مخلوط',
      'horizontal-mix': 'حالت منوی افقی مخلوط'
    },
    themeColor: {
      title: 'رنگ تم',
      primary: 'اصلی',
      info: 'اطلاعات',
      success: 'موفقیت',
      warning: 'هشدار',
      error: 'خطا',
      followPrimary: 'دنبال کردن رنگ اصلی'
    },
    scrollMode: {
      title: 'حالت پیمایش',
      wrapper: 'پوشش',
      content: 'محتوا'
    },
    page: {
      animate: 'انیمیشن صفحه',
      mode: {
        title: 'حالت انیمیشن صفحه',
        fade: 'محو شدن',
        'fade-slide': 'کشیدن',
        'fade-bottom': 'محو زوم',
        'fade-scale': 'مقیاس محو',
        'zoom-fade': 'محو زوم',
        'zoom-out': 'زوم خروج',
        none: 'هیچ'
      }
    },
    fixedHeaderAndTab: 'سربرگ و تب ثابت',
    header: {
      height: 'ارتفاع سربرگ',
      breadcrumb: {
        visible: 'نمایش خرده نان',
        showIcon: 'نمایش آیکون خرده نان'
      }
    },
    tab: {
      visible: 'نمایش برگه',
      cache: 'کش برگه',
      height: 'ارتفاع برگه',
      mode: {
        title: 'حالت برگه',
        chrome: 'کروم',
        button: 'دکمه'
      }
    },
    sider: {
      inverted: 'کناری تیره',
      width: 'عرض کناری',
      collapsedWidth: 'عرض کناری فشرده',
      mixWidth: 'عرض کناری مخلوط',
      mixCollapsedWidth: 'عرض کناری فشرده مخلوط',
      mixChildMenuWidth: 'عرض منوی فرزند مخلوط'
    },
    footer: {
      visible: 'پاورقی نمایش داده شده',
      fixed: 'پاورقی ثابت',
      height: 'ارتفاع پاورقی',
      right: 'پاورقی سمت راست'
    },
    themeDrawerTitle: 'پیکربندی تم',
    pageFunTitle: 'کارکرد صفحه',
    configOperation: {
      copyConfig: 'کپی پیکربندی',
      copySuccessMsg: 'کپی موفق، لطفا متغیر themeSettings را در src/theme/settings.ts جایگزین کنید',
      resetConfig: 'تنظیم مجدد پیکربندی',
      resetSuccessMsg: 'تنظیم مجدد موفق'
    }
  },
  sponsorship: {
    common: {
      irt: 'تومان',
      notAvailable: 'ثبت نشده',
      seconds: '{count} ثانیه'
    },
    programs: {
      startups: {
        name: 'برنامه حمایت از استارتاپ‌های AvalAI',
        description: 'اعتبار مرحله‌ای API برای استارتاپ‌های واجد شرایط، با مسیر روشن تایید و رشد.'
      },
      unknown: {
        name: 'برنامه حمایت AvalAI',
        description: 'جزئیات این برنامه در حال حاضر در دسترس نیست.'
      }
    },
    actions: {
      application_create: {
        label: 'شروع درخواست',
        description: 'درخواست حمایت را ایجاد کنید و با اطلاعات شرکت ادامه دهید.'
      },
      application_reapply: {
        label: 'درخواست دوباره',
        description: 'اکنون که بازه درخواست مجدد باز است، درخواست تازه‌ای شروع کنید.'
      },
      application_update_company: {
        label: 'به‌روزرسانی اطلاعات شرکت',
        description: 'اطلاعات شرکت خواسته‌شده برای این درخواست را بازبینی و ذخیره کنید.'
      },
      application_update_identity: {
        label: 'به‌روزرسانی اطلاعات نماینده',
        description: 'اطلاعات نماینده قانونی را در گام امن هویت دوباره وارد کنید.'
      },
      verification_retry: {
        label: 'تلاش دوباره برای تایید هویت',
        description: 'اطلاعات نماینده را بررسی و تلاش تازه‌ای برای تایید هویت آغاز کنید.'
      },
      verification_start: {
        label: 'تایید هویت',
        description: 'اطلاعات نماینده را ذخیره و فرایند تایید هویت را آغاز کنید.'
      },
      application_submit: {
        label: 'ارسال درخواست',
        description: 'اطلاعات ذخیره‌شده را بازبینی و درخواست را برای AvalAI ارسال کنید.'
      },
      application_step_submit: { label: 'ذخیره این شرط', description: 'این شرط را با تعریف فعلی برنامه ارسال کنید.' },
      level_continue: { label: 'ادامه مسیر سطح', description: 'الزام دقیق و در دسترس سطح فعلی حمایت را باز کنید.' },
      application_withdraw: {
        label: 'لغو درخواست',
        description: 'پس از تایید تغییر غیرقابل‌بازگشت وضعیت، درخواست فعلی را لغو کنید.'
      },
      status_view: {
        label: 'مشاهده وضعیت درخواست',
        description: 'تصمیم فعلی، تاریخچه اسناد و گام بعدی در دسترس را ببینید.'
      }
    },
    nextEvents: {
      application_not_started: 'هر زمان آماده بودید درخواست را آغاز کنید.',
      applicant_company_details_required: 'اطلاعات شرکت گام الزامی بعدی است.',
      applicant_identity_required: 'اطلاعات نماینده قانونی در گام بعد لازم است.',
      identity_verification_required: 'پس از بازبینی اطلاعات نماینده، تایید هویت را آغاز کنید.',
      identity_verification_queued: 'تایید هویت در صف ارائه‌دهنده قرار دارد.',
      identity_verification_running: 'ارائه‌دهنده در حال بررسی هویت نماینده است.',
      identity_verification_failed: 'تایید هویت موفق نبود. پیش از تلاش دوباره اطلاعات را بازبینی کنید.',
      identity_verification_retry_available: 'تلاش تازه برای تایید هویت در دسترس است.',
      application_submission_required: 'درخواست ذخیره‌شده را بازبینی و برای ارزیابی ارسال کنید.',
      applicant_step_unavailable: 'این شرط در حال حاضر فقط خواندنی است و از اینجا قابل ارسال نیست.',
      application_review_pending: 'درخواست در انتظار بررسی تیم AvalAI است.',
      application_modification_required: 'فقط فیلدهای مشخص‌شده در آخرین بازخورد بررسی‌کننده را اصلاح کنید.',
      application_cooldown_active: 'پس از پایان مهلت سیاست، درخواست مجدد در دسترس می‌شود.',
      application_reapply_available: 'بازه درخواست مجدد باز است.',
      credit_grant_pending: 'اعتبار حمایتی تاییدشده در انتظار فعال‌سازی اپراتور است.',
      credit_active: 'اعتبار فعلی تا تاریخ انقضای نمایش‌داده‌شده در دسترس است.',
      next_level_available: 'سطح بعدی حمایت آماده ادامه است.',
      next_level_manual_gate: 'سطح بعدی در انتظار بررسی دستی AvalAI است.',
      application_complete: 'مسیر این درخواست حمایت کامل شده است.'
    },
    timing: {
      applicant_controlled: 'زمان تکمیل این گام در اختیار شماست.',
      provider_controlled: 'زمان پردازش در اختیار ارائه‌دهنده تایید هویت است.',
      reviewer_controlled: 'زمان بررسی در اختیار تیم بررسی AvalAI است.',
      policy_deadline: 'این مهلت سیاست به‌صورت خودکار اجرا می‌شود.',
      operator_controlled: 'یک اپراتور مجاز AvalAI این گام را تکمیل می‌کند.',
      credit_deadline: 'تاریخ انقضای نمایش‌داده‌شده اعتبار معتبر است.',
      complete: 'رویداد زمان‌بندی‌شده دیگری باقی نمانده است.'
    },
    errors: {
      validation_failed: 'بخشی از اطلاعات معتبر نیست. فیلدهای مشخص‌شده را بازبینی و دوباره تلاش کنید.',
      authentication_required: 'نشست شما منقضی شد. برای ادامه امن، شماره تلفن را تایید کنید.',
      action_forbidden: 'حساب شما اجازه انجام این عملیات حمایت را ندارد.',
      resource_not_found: 'این برنامه یا درخواست حمایت دیگر در دسترس نیست.',
      revision_conflict: 'درخواست در نشست دیگری تغییر کرده است. پیش از ادامه، آخرین نسخه ذخیره‌شده را بازبینی کنید.',
      idempotency_conflict: 'این شناسه درخواست برای عملیات دیگری استفاده شده است. عملیات تازه‌ای آغاز کنید.',
      action_not_available: 'این عملیات دیگر در دسترس نیست. گام بعدی فعلی را دنبال کنید.',
      workspace_v2_not_enabled: 'فضای کار حمایت برای این حساب فعال نیست. هیچ تغییری ارسال نشد.',
      cooldown_active: 'درخواست مجدد تا پایان مهلت نمایش‌داده‌شده همچنان مسدود است.',
      schema_revision_conflict: 'الزامات فرم تغییر کرده است. گام فعلی را دوباره بارگذاری و پیش‌نویس را بازبینی کنید.',
      rate_limited: 'درخواست‌های زیادی ارسال شده است. تا پایان زمان انتظار نمایش‌داده‌شده صبر کنید.',
      verification_unavailable: 'تایید هویت موقتا در دسترس نیست. درخواست شما بدون تغییر باقی مانده است.',
      temporary_unavailable: 'سرویس حمایت موقتا در دسترس نیست. با اطمینان دوباره تلاش کنید.'
    },
    operations: {
      queued: 'تایید هویت در صف است.',
      running: 'تایید هویت در حال انجام است.',
      failed: 'تایید هویت ناموفق بود.',
      retryable_error: 'تایید هویت کامل نشد و امکان تلاش دوباره وجود دارد.',
      passed: 'تایید هویت موفق بود.',
      cancelled: 'تایید هویت لغو شد.',
      manual_override: 'تایید هویت توسط بررسی‌کننده مجاز AvalAI تکمیل شد.',
      unknown: 'وضعیت تایید هویت در دسترس نیست. پیش از عملیات دیگر تازه‌سازی کنید.'
    },
    recovery: {
      sessionExpiredTitle: 'تایید نشست',
      sessionExpiredDescription: 'نشست شما منقضی شد. تایید تلفن را کامل کنید تا فضای کار فعلی دوباره بارگذاری شود.',
      sessionExpiredAction: 'تایید و بارگذاری دوباره',
      conflictTitle: 'نسخه جدیدتری از درخواست موجود است',
      conflictDescription: 'پیش از تایید یا ورود دوباره تغییرات، آخرین مقادیر ذخیره‌شده را بازبینی کنید.',
      conflictAction: 'بازبینی آخرین نسخه',
      ambiguousWrite: 'نتیجه ذخیره نامشخص است. هنگام بازیابی رسید، عملیات را تکرار نکنید.',
      receiptPending: 'رسید عملیات هنوز در حال بررسی است.',
      rateLimited: 'پیش از تلاش دوباره برای این درخواست حمایت، {seconds} ثانیه صبر کنید.',
      rateLimitedSingular: 'پیش از تلاش دوباره برای این درخواست حمایت، ۱ ثانیه صبر کنید.'
    },
    privacy: {
      identity: 'شناسه‌های هویتی، تایید تلفن و جزئیات ارائه‌دهنده هرگز در پیش‌نویس مرورگر ذخیره نمی‌شوند.',
      draftStorage: 'فقط فیلدهای غیرحساس شرکت حداکثر تا ۴۸ ساعت به‌صورت محلی ذخیره می‌شوند.',
      documentDisabled: 'بارگذاری مدرک غیرفعال است. AvalAI اسناد پشتیبان را در فرایند بررسی دستی درخواست می‌کند.',
      unknownFallback: 'این وضعیت در نسخه فعلی پشتیبانی نمی‌شود. پیش از ادامه فضای کار معتبر را تازه‌سازی کنید.'
    },
    evidence: {
      submit: 'ذخیره شرط',
      saved: 'شرط ذخیره شد.',
      definitionChanged: 'این شرط تغییر کرده است. پیش از تلاش دوباره، فیلدهای به‌روز را بررسی کنید.',
      fieldFallback: 'فیلد درخواست {index}',
      formError: 'فیلدهای مشخص‌شده را بررسی و دوباره تلاش کنید.',
      reviewUpdatedDefinition: 'شرط به‌روز را بررسی کردم.',
      fields: {
        demo_url: 'نشانی دموی محصول',
        demo_notes: 'توضیحات دموی محصول',
        market_summary: 'خلاصه بازار',
        users_count: 'تعداد کاربران',
        traction_summary: 'خلاصه کشش بازار',
        revenue_summary: 'خلاصه درآمد',
        monthly_revenue_irt: 'درآمد ماهانه (تومان)'
      }
    },
    status: {
      draft: 'پیش‌نویس',
      submitted: 'ارسال‌شده',
      under_review: 'در حال بررسی',
      needs_modification: 'نیازمند اصلاح',
      approved: 'تاییدشده',
      rejected: 'ردشده',
      active: 'فعال',
      cooldown: 'دوره انتظار',
      completed: 'تکمیل‌شده',
      withdrawn: 'لغوشده',
      locked: 'قفل',
      available: 'در دسترس',
      in_progress: 'در حال انجام',
      credit_granted: 'اعتبار اعطا شد',
      level_active: 'سطح فعال',
      level_completed: 'سطح تکمیل‌شده',
      next_level_locked: 'سطح بعدی قفل است',
      pending: 'در انتظار',
      passed: 'تایید شد',
      failed: 'ناموفق',
      manual_override: 'تایید دستی',
      unknown: 'وضعیت نامشخص',
      applicationSummary: 'خلاصه درخواست',
      title: 'وضعیت درخواست',
      none: 'هنوز درخواستی ثبت نکرده‌اید.',
      cooldownUntil: 'امکان درخواست مجدد از',
      creditUsage: 'مصرف اعتبار',
      grantedAmount: 'مبلغ اعطاشده',
      remaining: 'مانده',
      expiresOn: 'تاریخ انقضا',
      submissions: 'مراحل ارسال‌شده',
      withdraw: 'لغو درخواست',
      withdrawTitle: 'لغو درخواست؟',
      withdrawConfirm:
        'با لغو درخواست فعلی، درخواست شما بسته می‌شود. هر زمان آماده بودید می‌توانید درخواست جدیدی شروع کنید.',
      withdrawSuccess: 'درخواست لغو شد.',
      withdrawFailed: 'لغو درخواست انجام نشد. لطفا دوباره تلاش کنید.',
      startNewApplication: 'شروع درخواست جدید',
      needsModificationTitle: 'نیازمند اصلاح',
      needsModificationHint:
        'تیم بررسی درخواست اصلاح در درخواست شما کرده است. لطفا بازخورد را بررسی و مجددا ارسال کنید.',
      editAndResubmit: 'ویرایش و ارسال مجدد',
      expiresIn: 'انقضا تا',
      daysLeft: '{days} روز باقی‌مانده',
      expired: 'منقضی‌شده',
      consumed: 'مصرف‌شده',
      submittedOn: 'تاریخ ارسال',
      updatedOn: 'آخرین به‌روزرسانی',
      highestLevel: 'بالاترین سطح طی‌شده',
      sectionCompany: 'شرکت',
      sectionRepresentative: 'نماینده قانونی',
      sectionTimeline: 'زمان‌بندی',
      nextStep: 'گام بعدی',
      narrative: {
        generic:
          'وضعیت درخواست حمایت شما به‌روزرسانی شده است. جزئیات را در ادامه بررسی و گام بعدی موجود را دنبال کنید.',
        draft: 'درخواست شما پیش‌نویس است. مراحل باقی‌مانده را تکمیل و برای بررسی ارسال کنید.',
        submitted: 'درخواست شما ارسال شد. تیم AvalAI به‌زودی آن را بررسی می‌کند.',
        under_review: 'تیم AvalAI در حال بررسی درخواست شماست. پس از هر به‌روزرسانی به شما اطلاع می‌دهیم.',
        needs_modification: 'تیم بررسی درخواست اصلاح کرده است. موارد مشخص‌شده را به‌روزرسانی و مجددا ارسال کنید.',
        approved: 'درخواست شما تایید شد. اعتبار حمایتی شما در حال فعال‌سازی است.',
        credit_granted: 'اعتبار حمایتی شما اعطا شده و آماده استفاده است.',
        rejected: 'این درخواست تایید نشد. پس از دوره انتظار می‌توانید مجددا درخواست دهید.',
        active: 'حمایت شما فعال است. مصرف اعتبار و پیشرفت سطوح خود را در ادامه دنبال کنید.',
        level_active: 'سطح حمایتی شما فعال است. مصرف اعتبار و پیشرفت سطوح خود را در ادامه دنبال کنید.',
        cooldown: 'در دوره انتظار هستید. پس از پایان آن می‌توانید مجددا درخواست دهید.',
        completed:
          'برنامه حمایت را تکمیل کرده‌اید. اگر می‌خواهید دوباره اقدام کنید، می‌توانید درخواست جدیدی شروع کنید.',
        level_completed: 'این سطح را تکمیل کردید. برای ادامه، الزامات سطح بعدی را بررسی کنید.',
        next_level_locked: 'سطح حمایتی بعدی تا تکمیل مراحل لازم قفل می‌ماند.',
        withdrawn: 'این درخواست را لغو کردید. هر زمان آماده بودید می‌توانید درخواست جدیدی شروع کنید.'
      }
    },
    levels: {
      journeyTitle: 'نمای کلی سطوح',
      journeyLead: 'هر سطح حمایت، الزامات آن و وضعیت باز شدن سطح برای شما را مرور کنید.',
      levelOf: 'سطح {level} از {total}',
      stepsProgress: '{done}/{total} مرحله انجام شد',
      currentLevel: 'شما اینجا هستید',
      locked: 'قفل',
      unlockAfter: 'پس از کامل‌شدن سطح {level} باز می‌شود',
      autoUnlock: 'با کامل‌شدن سطح قبلی، به‌صورت خودکار باز می‌شود',
      manualReview: 'بررسی AvalAI',
      manualReviewHint: 'بررسی و تایید توسط تیم AvalAI',
      awaitingReview: 'در انتظار بررسی AvalAI',
      needsModificationHint: 'اصلاحات درخواست شده است. بازخورد را بررسی و این سطح را دوباره ارسال کنید.',
      approvedHint: 'تایید شد. اعتبار این سطح در حال آماده‌سازی است.',
      rejectedHint: 'این سطح رد شد. پیش از درخواست دوباره، بازخورد را بررسی کنید.',
      completed: 'تکمیل‌شده',
      completionReasons: {
        exhausted: 'اعتبار مصرف شد',
        expired: 'بسته منقضی شد',
        manual: 'تکمیل دستی'
      },
      requiredStep: 'الزامی',
      optionalStep: 'اختیاری',
      reviewerNotes: 'یادداشت‌های بررسی‌کننده',
      documentUploadDeferred:
        'بارگذاری مدرک هنوز در این بخش فعال نیست. AvalAI مدارک پشتیبان را هنگام بررسی دستی درخواست می‌کند.',
      previewSteps: 'مشاهده شرط‌ها',
      hideSteps: 'پنهان‌کردن شرط‌ها',
      noProgress: 'برای شروع مسیر سطح‌ها، درخواست دهید.',
      unknownName: 'سطح حمایت',
      unknownDescription: 'جزئیات این سطح حمایت در دسترس نیست.'
    },
    levelNames: {
      '1': 'سطح ۱ — شروع',
      '2': 'سطح ۲ — تایید محصول',
      '3': 'سطح ۳ — MVP / بازار',
      '4': 'سطح ۴ — رشد اثبات‌شده',
      '5': 'سطح ۵ — مقیاس'
    },
    levelDescriptions: {
      '1': 'اعتبار آغازین شما. اطلاعات شرکت را ثبت و نماینده قانونی را تایید کنید تا فعال شود.',
      '2': 'پس از مصرف یا انقضای اعتبار سطح ۱ باز می‌شود. نمایشی از محصول ارائه دهید تا محصول شما تایید شود.',
      '3': 'برای استارتاپ‌های در مرحله MVP یا حاضر در بازار. AvalAI حضور در بازار و نشانه‌های جذب کاربر را پیش از تایید بررسی می‌کند.',
      '4': 'برای استارتاپ‌هایی با رشد قابل مشاهده. AvalAI نشانه‌های رشد و جذب کاربر را پیش از تایید بررسی می‌کند.',
      '5': 'برای استارتاپ‌های دارای درآمد و تناسب محصول-بازار. نیازمند بررسی نهایی دستی توسط تیم AvalAI است.'
    },
    stepDescriptions: {
      company_form: 'اطلاعات شرکت ثبت‌شده خود را ارائه دهید.',
      identity_check: 'نماینده قانونی کد ملی و شماره تماس خود را برای تایید ارائه می‌کند.',
      product_demo:
        'وقتی AvalAI بررسی این سطح را درخواست کرد، لینک نمایش محصول یا توضیح کوتاهی درباره محصول خود ثبت کنید.',
      market_evidence: 'خلاصه‌ای از MVP یا حضور در بازار را برای بررسی AvalAI ثبت کنید.',
      traction_docs: 'خلاصه‌ای از رشد و جذب کاربر را برای بررسی AvalAI ثبت کنید.',
      revenue_proof: 'خلاصه‌ای از درآمد و نشانه‌های تناسب محصول-بازار را برای بررسی AvalAI ثبت کنید.',
      manual_review: 'بررسی نهایی دستی توسط تیم AvalAI.',
      unknown: 'جزئیات این الزام حمایت در دسترس نیست.'
    },
    steps: {
      company_form: 'اطلاعات شرکت',
      identity_check: 'تایید هویت',
      product_demo: 'نمایش محصول',
      market_evidence: 'بازار و جذب کاربر',
      traction_docs: 'بررسی رشد',
      revenue_proof: 'بررسی درآمد و تناسب محصول-بازار',
      manual_review: 'بررسی دستی',
      unknown: 'الزام حمایت'
    },
    apply: {
      title: 'ثبت‌نام در برنامه حمایت از استارتاپ‌ها',
      introLead:
        'برای استارتاپ خود اعتبار API دریافت کنید. یک فرم کوتاه را تکمیل کنید؛ با رشد شما سطوح بالاتر باز می‌شوند.',
      start: 'شروع درخواست',
      stepIntro: 'معرفی',
      stepAuth: 'تایید شماره',
      stepCompany: 'شرکت',
      stepIdentity: 'هویت',
      stepReview: 'بازبینی',
      verifyIdentity: 'تایید هویت',
      editIdentity: 'ویرایش اطلاعات هویتی',
      reviewLead: 'اطلاعات خود را بازبینی و سپس برای بررسی ارسال کنید.',
      submit: 'ارسال درخواست',
      submitted: 'درخواست برای بررسی ارسال شد.',
      saveFailed: 'ذخیره اطلاعات انجام نشد. لطفا دوباره تلاش کنید.',
      stepFailed: 'ثبت این مرحله با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      fixFieldErrors: 'لطفا فیلدهای مشخص‌شده را اصلاح کنید.',
      onFile: 'قبلا ثبت شده — برای حفظ مقدار خالی بگذارید',
      loadFailed: 'بارگذاری برنامه با خطا مواجه شد. لطفا دوباره تلاش کنید.',
      loadDescription: 'آخرین اطلاعات حمایت بارگذاری نشد. لطفا پیش از ادامه دوباره تلاش کنید.',
      serverLoadFailed:
        'سرویس حمایت در حال حاضر در دسترس نیست. لطفا کمی بعد دوباره تلاش کنید یا در صورت ادامه مشکل با پشتیبانی تماس بگیرید.',
      rateLimited: 'در مدت کوتاه درخواست‌های زیادی برای بخش حمایت ارسال شده است. لطفا چند لحظه بعد دوباره تلاش کنید.',
      retry: 'تلاش مجدد',
      reset: 'پاک‌کردن فرم',
      resetTitle: 'فرم پاک شود؟',
      resetConfirm: 'اطلاعات شرکت و هویتی که وارد کرده‌اید پاک می‌شود. این عمل قابل بازگشت نیست.',
      draftRestored: 'اطلاعات ذخیره‌شده شما بازیابی شد.',
      conflictCompanyChangesDescription: 'اطلاعات ذخیره‌شده شرکت هنگام ویرایش شما تغییر کرده است.',
      conflictCompanyChangesDetail: 'مقادیر ذخیره‌شده و پیش‌نویس شرکت را پیش از تایید این تغییر بازبینی کنید.',
      conflictCompanyUnchangedDescription: 'وضعیت درخواست هنگام ویرایش شما تغییر کرده است.',
      conflictCompanyUnchangedDetail:
        'فیلد امن متفاوتی از شرکت وجود ندارد، اما وضعیت درخواست جدیدتر است. پیش از ادامه، گام بعدی فعلی را بازبینی کنید.',
      conflictIdentityDescription: 'اطلاعات هویتی هنگام ویرایش شما تغییر کرده است.',
      conflictIdentityDetail: 'برای حفظ امنیت شما، اطلاعات هویتی حساس پاک شد. پیش از ادامه آن‌ها را دوباره وارد کنید.',
      conflictGenericDescription: 'درخواست هنگام تکمیل این عملیات تغییر کرده است.',
      conflictGenericDetail: 'پیش از ادامه، آخرین وضعیت درخواست و گام بعدی فعلی آن را بازبینی کنید.',
      draftSaved: 'ذخیره شد'
    },
    fields: {
      companyName: 'نام شرکت',
      companyRegisterId: 'شناسه ثبت شرکت',
      companyNationalId: 'شناسه ملی شرکت',
      website: 'وب‌سایت',
      domain: 'دامنه',
      legalRepName: 'نام نماینده قانونی',
      legalRepNationalId: 'کد ملی نماینده قانونی',
      contactPhone: 'تلفن تماس',
      verification: 'تایید هویت'
    },
    validation: {
      required: '{field} الزامی است.',
      companyName: 'نام ثبت‌شده شرکت را وارد کنید.',
      companyRegisterId: 'شناسه ثبت شرکت را وارد کنید.',
      companyNationalId: 'شناسه ملی شرکت باید ۱۱ رقم باشد.',
      website: 'یک آدرس وب‌سایت HTTPS معتبر وارد کنید.',
      domain: 'نام دامنه را بدون پروتکل و به‌صورت معتبر وارد کنید.',
      legalRepName: 'نام کامل نماینده قانونی را وارد کنید.',
      legalRepNationalId: 'یک کد ملی معتبر وارد کنید.',
      contactPhone: 'یک شماره موبایل معتبر وارد کنید.',
      otp: 'کد تایید معتبر ارسال‌شده به تلفن را وارد کنید.'
    },
    auth: {
      phoneHint:
        'شماره تلفن خود را وارد کنید؛ کد تایید ارسال می‌شود. در صورت نبود حساب، به‌صورت خودکار حساب ساخته می‌شود.',
      phoneInputLabel: 'شماره تلفن',
      codeInputLabel: 'کد تایید',
      sendCode: 'ارسال کد',
      resend: 'ارسال مجدد کد',
      resendIn: 'ارسال مجدد در {time} ثانیه',
      verifyAndContinue: 'تایید و ادامه',
      codeSent: 'کد تایید ارسال شد.',
      applyingAsPrefix: 'ثبت‌نام با شماره',
      continue: 'ادامه',
      useDifferentNumber: 'استفاده از شماره دیگر',
      welcomeNew: 'خوش آمدید! حساب شما ساخته شد.',
      welcomeBack: 'خوش بازگشتید!',
      codeInvalid: 'کد نامعتبر یا منقضی شده است.',
      sendFailed: 'ارسال کد ناموفق بود. دوباره تلاش کنید.',
      tooManyRequests: 'درخواست‌های زیاد. کمی بعد دوباره تلاش کنید.',
      forbidden: 'این عملیات مجاز نیست.',
      userNotFound: 'حسابی برای این شماره یافت نشد.',
      phoneConflict: 'این شماره قبلا به حساب دیگری متصل شده است.'
    },
    verification: {
      pendingTitle: 'تایید هویت در حال انجام است',
      pendingHint: 'تایید هویت در حال انجام است. پس از تکمیل، درخواست شما به‌روزرسانی می‌شود.',
      passedHint: 'هویت شما تایید شد.',
      failedHint: 'تایید هویت ناموفق بود. لطفا اطلاعات را بررسی و دوباره تلاش کنید.',
      manual_overrideHint: 'هویت شما توسط تیم بررسی AvalAI تایید شد.',
      stillPending:
        'تایید هنوز در حال انجام است. می‌توانید این صفحه را ترک کنید؛ وضعیت به‌صورت خودکار به‌روزرسانی می‌شود.'
    },
    hub: {
      memberTitle: 'حمایت شما',
      memberLead: 'مزایا، مصرف اعتبار و پیشرفت سطح خود را دنبال کنید.',
      prospectTitle: 'استارتاپ خود را با اعتبار حمایتی API رشد دهید',
      prospectLead:
        'با پیوستن به برنامه حمایت از استارتاپ‌ها، همگام با رشد شرکت خود در پنج سطح اعتبار API دریافت کنید.',
      pendingTitle: 'درخواست شما در حال بررسی است',
      pendingLead: 'شما را در جریان می‌گذاریم. می‌توانید درخواست خود را در ادامه بررسی یا تکمیل کنید.',
      nextLevelActionTitle: 'سطح بعدی شما آماده است',
      nextLevelActionLead: 'الزامات سطح تازه بازشده را از مسیر سطح‌ها تکمیل کنید.',
      currentLevel: 'سطح فعلی',
      yourBenefits: 'مزایای شما',
      benefitCredit: 'اعتبار حمایتی API برای استارتاپ شما',
      benefitModels: 'دسترسی به مدل‌های هوش مصنوعی ویژه',
      benefitSupport: 'پشتیبانی اولویت‌دار',
      benefitGrowth: 'با رشد شما سطوح بالاتر باز می‌شوند',
      nextLevel: 'سطح بعدی',
      nextLevelHint: 'برای باز شدن سطح بعد، سطح فعلی را کامل کنید.',
      viewStatus: 'مشاهده وضعیت',
      viewLevels: 'مشاهده سطوح',
      continueApplication: 'ادامه درخواست',
      continueLevelJourney: 'ادامه مسیر سطح',
      applyNow: 'همین حالا درخواست دهید',
      plansTitle: 'طرح‌های حمایت استارتاپی',
      plansLead: 'پنج سطح اعتبار API که همگام با رشد استارتاپ شما باز می‌شوند.',
      howItWorks: 'چطور کار می‌کند',
      step1Title: 'درخواست',
      step1Desc: 'شماره خود را تایید و اطلاعات شرکت را در یک فرم کوتاه ارسال کنید.',
      step2Title: 'تایید',
      step2Desc: 'هویت شما را تایید و درخواستتان را بررسی می‌کنیم.',
      step3Title: 'دریافت اعتبار',
      step3Desc: 'پس از تایید، اعتبار حمایتی به حساب شما اعطا می‌شود.',
      step4Title: 'رشد و ارتقا',
      step4Desc: 'از اعتبار خود استفاده کنید؛ با تحقق اهداف، سطوح بالاتر باز می‌شوند.',
      eligibilityTitle: 'چه کسانی می‌توانند درخواست دهند',
      eligibilityItem1: 'استارتاپ‌های ثبت‌شده در داخل کشور',
      eligibilityItem2: 'هویت قابل‌تایید نماینده قانونی',
      eligibilityItem3: 'محصول یا MVP برای سطوح بالاتر',
      cooldownNotice: 'پس از پایان دوره انتظار می‌توانید مجددا درخواست دهید.',
      programFallbackNotice:
        'داده زنده برنامه موقتا در دسترس نیست. همچنان می‌توانید سطوح حمایت را ببینید؛ پیش از ارسال درخواست دوباره تلاش کنید.',
      badge: 'برنامه حمایت از استارتاپ‌ها',
      heroStatCredit: '۱۰۰M+',
      heroStatCreditLabel: 'تومان اعتبار',
      heroStatLevels: '۵',
      heroStatLevelsLabel: 'سطح رشد',
      heroStatFree: '۰',
      heroStatFreeLabel: 'هزینه اولیه',
      secondaryCta: 'مشاهده طرح‌ها',
      planLevel: 'سطح {level}',
      planUpTo: 'تا',
      planSelect: 'شروع کنید',
      ctaBandTitle: 'آماده شتاب‌دهی به استارتاپتان هستید؟',
      ctaBandSubtitle:
        'در چند دقیقه درخواست دهید. شماره را تایید کنید، اطلاعات شرکت را وارد کنید و نخستین اعتبار خود را دریافت کنید.',
      trustLine: 'بدون کارت بانکی. بدون هزینه اولیه. اعتبار پس از تایید اعطا می‌شود.',
      faqTitle: 'پرسش‌های پرتکرار',
      faq1Q: 'هزینه آن چقدر است؟',
      faq1A: 'هیچ هزینه اولیه‌ای ندارد. اعتبار حمایتی به‌صورت رایگان به استارتاپ‌های تاییدشده اعطا می‌شود.',
      faq2Q: 'چگونه به سطح بالاتر می‌روم؟',
      faq2A: 'با مصرف اعتبار فعلی و اثبات اهدافی مانند نمایش محصول، جذب کاربر یا درآمد، سطوح بالاتر باز می‌شوند.',
      faq3Q: 'تایید چقدر طول می‌کشد؟',
      faq3A: 'پس از ارسال، تیم ما درخواست شما را بررسی و نتیجه را اعلام می‌کند.'
    }
  },

  modelStudio: {
    runCompleted: 'تکمیل شد',
    runIncomplete: 'ناقص',
    runCanceled: 'لغو شد',
    runFailed: 'ناموفق',
    sanitizedRequestNotice: 'این پیکربندی پالایش‌شده است، نه بدنه دقیق ارسال‌شده. بدنه درخواست خام ذخیره نمی‌شود؛ پیش از اجرای مجدد بدنه را وارد کنید.',
    requestConfiguration: 'پیکربندی ارسال‌شده',
    requestUrl: 'نشانی درخواست',
    requestIncompleteReason: 'دلیل ناقص بودن',
    title: 'استودیو مدل',
    timeZoneLabel: 'منطقه زمانی:',
    overviewTitle: 'نمای کلی',
    overviewSubtitle: 'کار اخیر را ادامه دهید یا یک کار متمرکز مدل آغاز کنید.',
    overviewConnectionTitle: 'راه‌اندازی اتصال',
    overviewConnectionDescription: 'هر زمان آماده اجرا بودید، در محیط آزمایش یک کلید انتخاب یا ایجاد کنید.',
    overviewConnectionAction: 'باز کردن محیط آزمایش',
    overviewResumeEyebrow: 'ادامه از آخرین فعالیت',
    overviewFactMode: 'حالت',
    overviewFactMessages: 'پیام',
    overviewFactModel: 'مدل',
    overviewFactModels: '{count} مدل',
    overviewFactSpend: 'خرج تا اینجا (برآورد)',
    overviewFactKey: 'کلید API',
    overviewFactUpdated: 'آخرین فعالیت',
    overviewResumeStartFresh: 'به‌جای آن، چت تازه‌ای شروع کنید',
    overviewModePathsTitle: 'با یک کار شروع کنید',
    overviewModePathsSubtitle: 'هر کارت محیط آزمایش را در همان حالت با یک نمونهٔ آماده باز می‌کند. هزینهٔ هر اجرا همان لحظه نشان داده می‌شود.',
    overviewPathChatSummary: 'پرسیدن، نوشتن متن، استخراج داده، فراخوانی ابزار — با فایل و تصویر پیوست‌شده.',
    overviewPathChatExample: '«این PDF را در پنج نکته خلاصه کن و سؤال‌های باز را فهرست کن.»',
    overviewPathImagesSummary: 'توصیف را به تصویر تبدیل کنید؛ اندازه، کیفیت و قالب را خودتان انتخاب کنید.',
    overviewPathImagesExample: '«عکس محصول تمیز از یک ماگ سرامیکی روی میز سفید، نور روز نرم.»',
    overviewPathAudioSummary: 'متن را با صدای انتخابی بخوانید، یا یک فایل صوتی را رونویسی و ترجمه کنید.',
    overviewPathAudioExample: 'یک جلسهٔ ۳ دقیقه‌ای را بارگذاری کنید و رونوشت زمان‌دار بگیرید.',
    overviewPathEmbeddingsSummary: 'متن را به بردار تبدیل کنید برای جست‌وجو، خوشه‌بندی و «موارد مشابه».',
    overviewPathEmbeddingsExample: '۲۰۰ تیکت پشتیبانی را بردار کنید، بعد نزدیک‌ترین‌ها به یک تیکت تازه را پیدا کنید.',
    overviewPathRawSummary: 'هر بدنهٔ درخواستی را به هر نقطهٔ پایانی بفرستید و پاسخ را به‌صورت JSON بخوانید.',
    overviewPathRawExample: 'POST /v1/responses با JSON خودتان، یا GET /v1/models.',
    overviewBillingTokens: 'محاسبه بر پایهٔ توکن',
    overviewBillingPerImage: 'محاسبه به ازای هر تصویر',
    overviewBillingPerMinute: 'محاسبه به ازای دقیقه یا نویسه',
    overviewBillingPerRequest: 'محاسبه بر پایهٔ نقطهٔ پایانی',
    overviewDigestTitle: 'فعالیت اخیر شما',
    overviewDigestSubtitle: 'از {count} اجرای آخر ثبت‌شده در این مرورگر',
    overviewDigestEmpty: 'اجراهایی که در محیط آزمایش انجام می‌دهید اینجا با هزینه و مدلشان ثبت می‌شوند.',
    overviewDigestSpend: 'خرج‌شده (برآورد)',
    overviewDigestSpendHint: 'بر پایهٔ قیمت مدل. جزئیات هر درخواست پس از تأیید صورت‌حساب رقم قطعی را نشان می‌دهد.',
    overviewDigestNoEstimate: '—',
    overviewDigestTokens: 'توکن',
    overviewDigestOutcome: 'موفق',
    overviewDigestFailed: '{count} ناموفق — برای دیدن علت، درخواست را باز کنید',
    overviewDigestAllGood: 'بدون خطا',
    overviewDigestModels: 'مدل‌هایی که استفاده کردید',
    overviewDigestModelRuns: '{count} اجرا',
    overviewDigestMoreModels: '+{count} مدل دیگر',
    overviewDigestBillable: '{count} از {total} شناسهٔ درخواست دارند و هزینهٔ قطعی‌شان قابل استعلام است',
    overviewDigestOpenUsage: 'مصرف حساب',
    overviewDigestSpan: '{first} ← {last}',
    overviewDevTitle: 'برای توسعه‌دهندگان',
    overviewDevSubtitle: 'هر چیزی که اینجا اجرا می‌کنید یک فراخوانی سادهٔ API است — با خودتان ببرید.',
    overviewDevDocs: 'مرجع API',
    overviewDevDocsDescription: 'نقاط پایانی، پارامترها و شکل پاسخ‌ها در docs.avalai.ir.',
    overviewDevRequests: 'گزارش درخواست‌ها و خروجی',
    overviewDevRequestsDescription: 'همهٔ اجراهای ثبت‌شده با بدنهٔ درخواست، پاسخ، توکن و هزینه. خروجی JSON.',
    overviewDevChatTip: 'اشکال‌زدایی با پلتفرم چت',
    overviewDevChatTipDescription: 'نشانی یک صفحهٔ مستندات را در پرامپت بچسبانید؛ مدل هنگام کمک آن را می‌خواند.',
    overviewResumeWorkflowDescription: 'گردش‌کار ذخیره‌شده',
    overviewResumeRequestDescription: 'درخواست ثبت‌شده',
    overviewResumeEmptyTitle: 'نخستین اجرا را آغاز کنید',
    overviewResumeEmptyDescription: 'برای ساخت و اجرای درخواست مدل، محیط آزمایش را باز کنید.',
    overviewStartFirstRun: 'شروع در محیط آزمایش',
    overviewConnectionReadyTitle: 'اتصال آماده است',
    overviewConnectionReadyDashboard: 'کلید پیشخان برای این نشست بارگذاری شده است؛ می‌توانید بلافاصله اجرا کنید.',
    overviewConnectionReadyCustom: 'اتصال از طریق {label} برقرار است؛ می‌توانید بلافاصله اجرا کنید.',
    overviewResumeDraftDescription: 'پیش‌نویس ارسال‌نشده در محیط آزمایش',
    overviewResumeConversationDescription: 'گفتگوی باز · {count} پیام',
    overviewResumeInputDescription: 'ورودی {mode} در محیط آزمایش منتظر است',
    overviewResumeSession: 'ادامه در محیط آزمایش',
    requestsSelect: 'انتخاب',
    requestsSelectDone: 'پایان',
    requestsSelectAll: 'انتخاب همه موارد نمایش‌داده‌شده',
    requestsSelectedCount: '{count} مورد انتخاب شده',
    requestSelectRow: 'انتخاب {name}',
    requestsBulkActions: 'درخواست‌های انتخاب‌شده',
    requestsExport: 'خروجی JSON',
    requestsExportSelected: 'خروجی موارد انتخاب‌شده',
    requestsExported: '{count} درخواست خروجی گرفته شد.',
    requestsDeleteSelected: 'حذف موارد انتخاب‌شده',
    requestsDeleteSelectedConfirm: 'حذف {count} مورد',
    requestsDeleteSelectedDescription: '{count} درخواست ثبت‌شده از این مرورگر حذف می‌شود و قابل بازگشت نیست.',
    requestsDeletedCount: '{count} درخواست حذف شد.',
    requestReplayGuardTitle: 'گفتگوی فعلی جایگزین شود؟',
    requestReplayGuardDescription:
      'در محیط آزمایش یک پیش‌نویس ارسال‌نشده یا گفتگوی باز وجود دارد. بازپخش این درخواست آن را جایگزین می‌کند.',
    requestReplayGuardConfirm: 'جایگزینی و بازپخش',
    workflowAllModes: 'همه حالت‌ها',
    workflowModeFilter: 'فیلتر بر پایه حالت',
    promptShortcutsHint: 'کلیدهای میانبر: {save} ذخیره می‌کند، {open} در محیط آزمایش باز می‌کند.',
    moreActions: 'اقدام‌های بیشتر',
    connectionPillLabel: 'اتصال: {provider}، {state}. راه‌اندازی را باز می‌کند.',
    connectionPillLoading: 'در حال اتصال…',
    dashboardKeyRevealedLabel: 'کلید API پیشخان، نمایش کامل',
    dashboardKeyMaskedLabel: 'کلید API پیشخان، پوشیده',
    revealKey: 'نمایش',
    hideKey: 'پنهان کردن',
    copyKey: 'کپی کلید',
    copyKeyAction: 'کپی کلید API پیشخان در کلیپ‌بورد',
    keyCopied: 'کپی شد',
    copyKeyFailed: 'کپی انجام نشد. کلید را نمایش دهید و دستی کپی کنید.',
    rotateKey: 'نوسازی',
    rotateKeyAction: 'صدور کلید پیشخان جدید؛ کلید فعلی بلافاصله از کار می‌افتد',
    keyRotated: 'کلید پیشخان جدید صادر شد. فعال شدن آن ممکن است تا یک دقیقه زمان ببرد.',
    dashboardKeyExpires: 'نوسازی خودکار {when}',
    dashboardKeyProductionNote:
      'این کلید برای پیشخان و استودیو است. برای محیط عملیاتی، در صفحه کلیدهای API یک کلید بسازید: فقط یک بار نمایش داده می‌شود، دوباره قابل خواندن نیست و محدودیت‌های پیشرفته را پشتیبانی می‌کند.',
    openApiKeysPage: 'باز کردن کلیدهای API',
    codeIncludeDashboardKey: 'کلید پیشخان من را در کد قرار بده',
    codeIncludeDashboardKeyWarning:
      'اکنون کلید پیشخان شما در این کد قرار دارد. با احتیاط به اشتراک بگذارید و اگر لو رفت نوسازی کنید. این کلید هر ۲۴ ساعت خودکار نوسازی می‌شود و کد کپی‌شده پس از آن کار نمی‌کند — برای محیط عملیاتی از کلید صفحهٔ کلیدهای API استفاده کنید.',
    modelDefault: 'پیش‌فرض مدل',
    samplingDefaultsNote:
      'دما، top-p و میزان پرگویی روی «پیش‌فرض مدل» شروع می‌شوند و تا وقتی مقداری تعیین نکنید در درخواست نمی‌آیند — با حرکت لغزنده یا نوشتن عدد، برای هر مدلی ارسال می‌شوند.',
    maxOutputHelp:
      'سقف توکن‌های تولیدشده شامل توکن‌های استدلال (max_output_tokens در Responses API). برای پیش‌فرض مدل خالی بگذارید؛ استودیو سقفی از خود تعیین نمی‌کند.',
    maxOutputModelLimitTip: 'این مدل تا {limit} توکن خروجی در هر پاسخ اعلام کرده است.',
    maxOutputAboveModelLimitTip:
      'بیش از {limit} توکن خروجی اعلام‌شده برای این مدل است — ارائه‌دهنده ممکن است آن را کاهش دهد یا رد کند. همان‌طور که هست ارسال می‌شود.',
    reasoningTokensCountTip: 'توکن‌های استدلال در حداکثر خروجی حساب می‌شوند و مانند توکن خروجی هزینه دارند.',
    reasoningNotAdvertisedTip:
      'این مدل کنترل استدلال را اعلام نکرده است؛ درخواست همان‌طور که هست ارسال می‌شود و ارائه‌دهنده تصمیم می‌گیرد.',
    reasoningSummary: 'خلاصهٔ استدلال',
    maxEffort: 'بیشینه',
    concise: 'کوتاه',
    detailed: 'مفصل',
    errorDebugPanel: 'جزئیات خطا و ابزارهای اشکال‌زدایی',
    errorFacts: 'مشخصات خطا',
    errorFactStatus: 'وضعیت HTTP',
    errorFactType: 'نوع خطا',
    errorFactCode: 'کد خطا',
    errorFactParam: 'پارامتر',
    errorFactRequestId: 'شناسهٔ درخواست',
    errorFactEndpoint: 'نقطهٔ پایانی',
    errorFactAttempt: 'تلاش',
    errorFactLatency: 'مدت',
    errorProviderMessage: 'پیام API',
    errorProviderSuggestion: 'پیشنهاد سرویس API',
    errorNoOptionalParams: 'بدون پارامتر اختیاری',
    showErrorDetails: 'نمایش جزئیات',
    hideErrorDetails: 'پنهان‌کردن جزئیات',
    copyRequestId: 'کپی شناسهٔ درخواست',
    copyRequestIdAction: 'کپی شناسهٔ درخواست {id}',
    copyDebugReport: 'کپی گزارش اشکال‌زدایی',
    copyDebugReportAction: 'کپی گزارش متنی شامل وضعیت، شناسهٔ درخواست، درخواست پاک‌سازی‌شده و خطای خام',
    supportTicketWhen:
      'این مورد به سرویس API AvalAI مربوط است (قطعی یا پاسخ غیرمنتظرهٔ درگاه). یک تیکت پشتیبانی بسازید — گزارش زیر خودکار پیوست می‌شود.',
    supportCreateTicket: 'ایجاد تیکت پشتیبانی',
    supportCreateTicketAction: 'باز کردن فرم پشتیبانی با این گزارش خطا از پیش پرشده',
    supportWaitNote: 'هنوز چیزی برای گزارش نیست: این وضعیت موقتی است و استودیو خودش آن را مدیریت می‌کند. اگر بیش از چند دقیقه ادامه یافت، جزئیات زیر همان چیزی است که پشتیبانی نیاز دارد.',
    supportDocsFirst:
      'این مورد به خودِ درخواست مربوط است. مرجع API و راهنماها آن را پوشش می‌دهند؛ پشتیبانی AvalAI کد شما را اشکال‌زدایی یا مستقر نمی‌کند، پس تیکت فقط به همین‌جا ارجاع می‌شود.',
    supportOpenDocs: 'باز کردن مستندات',
    supportCopyDocsUrl: 'کپی لینک مستندات',
    supportCopyDocsUrlAction: 'کپی نشانی مستندات برای چسباندن در پلتفرم چت',
    supportOpenChatPlatform: 'باز کردن پلتفرم چت',
    supportProTipLabel: 'نکتهٔ حرفه‌ای:',
    supportProTip:
      'یک لینک docs.avalai.ir را در پرامپت پلتفرم چت بچسبانید — مدل‌ها صفحه را می‌خوانند و می‌توانند بر اساس مستندات واقعی همراه شما اشکال‌زدایی یا توسعه کنند.',
    supportTicketScopeNote:
      'تیکت پشتیبانی را فقط برای خودِ سرویس API باز کنید: قطعی‌ها، یا فراخوانی‌هایی که رفتارشان با مستندات فرق دارد.',
    costPanel: 'توکن‌ها و هزینه',
    costTokens: 'مصرف توکن',
    costTokensTotal: 'کل توکن‌ها',
    costTokensInput: 'توکن ورودی',
    costTokensOutput: 'توکن خروجی',
    costTokensCached: 'توکن ورودی کش‌شده',
    costTokensReasoning: 'توکن استدلال',
    costEstimate: 'هزینهٔ تخمینی',
    costExact: 'هزینهٔ قطعی صورت‌حساب',
    messageCostFromUnitBalance: 'از اعتبار واحدی',
    messageCostFromTomanBalance: 'از اعتبار تومانی ({value} تومان با نرخ امروز)',
    messageCostFromTomanBalanceNoAmount: 'از اعتبار تومانی، با نرخ امروز',
    messageCostPaidByPackageUnnamed: 'پوشش‌داده با بستهٔ اعتباری ({value} تومان)',
    messageCostPaidByGrantNamed: 'پوشش‌داده با اعتبار هدیهٔ «{name}» ({value} تومان)',
    messageCostSourceUnknown: 'منبع: {source}',
    creditUnitCreditShort: 'اعتبار واحدی',
    creditUnitCredit: 'اعتبار واحدی',
    creditTomanCredit: 'اعتبار تومانی',
    creditTotalEquivalent: 'کل کیف پول، به واحد',
    creditTotalHint: 'هزینهٔ درخواست‌ها به واحد اعتبار محاسبه و با همین مجموع سنجیده می‌شود. اعتبار تومانی مستقیم خرج می‌شود — سامانه آن را با نرخ امروز تبدیل می‌کند — پس لازم نیست از قبل تبدیل کنید.',
    creditWalletEmpty: 'اعتباری نمانده — تا شارژ نکنید درخواست‌ها پذیرفته نمی‌شوند.',
    creditWalletNegative: 'موجودی منفی است — برای اجرای دوبارهٔ درخواست‌ها شارژ کنید.',
    creditSessionFromUnitBalance: 'از اعتبار واحدی: {value}',
    creditSessionFromTomanBalance: 'از اعتبار تومانی: {value} ({irt} تومان)',
    creditSessionFromPackages: 'پوشش‌داده با بسته‌های اعتباری: {value}',
    creditSessionFromGrants: 'پوشش‌داده با اعتبار هدیه: {value}',
    creditUnit: 'واحد اعتبار',
    irt: 'تومان',
    creditExchangeRateValue: '{rate} تومان برای هر واحد اعتبار',
    remainingCredit: 'اعتبار باقی‌مانده',
    creditPillLabel: 'اعتبار باقی‌مانده: جمعاً {total} — {unit} اعتبار واحدی، {irt} اعتبار تومانی',
    creditExchangeRate: 'نرخ تبدیل',
    creditTier: 'سطح حساب',
    creditSourceUserApi: 'از دید حساب کلید API',
    creditSourceDashboard: 'از پیشخان',
    creditJustNow: 'همین حالا به‌روز شد',
    creditSecondsAgo: '{seconds} ثانیه پیش به‌روز شد',
    creditUnauthorized: 'این کلید نمی‌تواند موجودی حساب را بخواند. کلید پیشخان می‌تواند.',
    creditRateLimited: 'سقف درخواست موجودی پر شده — کمی بعد دوباره تلاش می‌شود.',
    creditError: 'الان نمی‌شود موجودی را خواند.',
    creditUnavailable: 'اعتبار باقی‌مانده برای اتصال‌های AvalAI نمایش داده می‌شود.',
    creditPendingRuns: '{count} درخواست در انتظار صورت‌حساب',
    creditPendingNote: '{count} درخواست هنوز در صورت‌حساب تأیید نشده — معمولاً ۳۰ تا ۶۰ ثانیه. تا آن زمان جمع‌ها بر پایهٔ برآورد است.',
    creditSessionTitle: 'این نشست',
    creditSessionRuns: '{count} درخواست',
    creditSessionAllBilled: 'همه در صورت‌حساب تأیید شده',
    creditSessionAllEstimated: 'برآورد بر پایهٔ قیمت مدل',
    creditSessionPartlyBilled: '{billed} از {total} در صورت‌حساب تأیید شده',
    creditSessionEmpty: 'در این نشست هنوز چیزی خرج نشده است.',
    creditSourcesForModel: 'اعتباری که هزینهٔ {model} را می‌دهد',
    creditNoSourceForModel: 'هیچ بسته یا اعتبار هدیه‌ای این مدل را پوشش نمی‌دهد — از اعتبار واحدی یا تومانی شما کسر می‌شود.',
    creditOtherSources: '{count} بسته / اعتبار هدیهٔ دیگر',
    creditExpired: 'منقضی',
    creditDaysLeft: '{days} روز مانده',
    creditRefresh: 'به‌روزرسانی موجودی',
    creditCheckCosts: 'بررسی هزینه‌های در انتظار',
    messageCostEstimate: 'برآورد',
    messageCostEstimatePending: 'برآورد · صورت‌حساب',
    messageCostPending: 'در انتظار صورت‌حساب',
    messageCostBilled: 'صورت‌حساب‌شده',
    messageCostTokens: '{value} توکن',
    messageCostPaidFromBalance: '{value} تومان از اعتبار تومانی',
    messageCostPaidByPackage: 'پوشش‌داده با «{name}» ({value} تومان)',
    messageCostPaidByGrant: 'پوشش‌داده با اعتبار هدیه ({value} تومان)',
    messageCostFree: 'بدون هزینه',
    costSessionTotal: 'جمع نشست',
    costPaidIrt: 'تبدیل‌شده از اعتبار تومانی: {value} تومان',
    costPaidGrantIrt: 'پوشش‌داده با بسته/اعتبار هدیه: {value} تومان',
    costPackagesUsed: 'بسته‌ها: {names}',
    costApiKey: 'کلید API …{suffix}',
    costSourceUnitCredit: 'اعتبار واحدی',
    costSourceTomanCredit: 'اعتبار تومانی',
    costSourceCreditPackage: 'بستهٔ اعتباری',
    costSourceGrant: 'اعتبار هدیه',
    costCheckExact: 'بررسی هزینهٔ قطعی',
    costCheckExactAction: 'جست‌وجوی این درخواست در صورت‌حساب با شناسهٔ درخواست (POST /user/v1/transactions/lookup)',
    costLookupBusy: 'در حال بررسی صورت‌حساب…',
    costLookupStopAction: 'توقف بررسی صورت‌حساب برای این درخواست',
    costLookupHint:
      'هزینهٔ قطعی ۳۰ تا ۶۰ ثانیه پس از درخواست در صورت‌حساب ثبت می‌شود. مبلغ بالا تخمین محلی است.',
    costLookupTooEarly: 'صورت‌حساب پس از درخواست کمی زمان می‌خواهد — بررسی تا {seconds} ثانیه دیگر.',
    costLookupChecking: 'در حال پرسش از صورت‌حساب…',
    costLookupPending: 'هنوز پردازش نشده — بررسی دوباره تا {seconds} ثانیه دیگر.',
    costLookupStillPending: 'صورت‌حساب هنوز این درخواست را پردازش نکرده است. یک دقیقه بعد دوباره بررسی کنید.',
    costLookupRateLimited: 'به سقف نرخ صورت‌حساب رسیدید — تلاش دوباره تا {seconds} ثانیه دیگر.',
    costLookupUnauthorized: 'این کلید اجازهٔ خواندن صورت‌حساب حساب را ندارد. از کلید پیشخان یا کلیدی با دامنهٔ حساب استفاده کنید.',
    costLookupError: 'دسترسی به صورت‌حساب ممکن نشد. چند لحظه بعد دوباره تلاش کنید.',
    costLookupUnavailable: 'هزینهٔ قطعی برای درخواست‌های درگاه AvalAI که شناسهٔ درخواست برگردانده‌اند در دسترس است.',
    audioPromptLabel: 'راهنمایی برای مدل (اختیاری)',
    audioPromptHint:
      'نام‌ها، سرواژه‌ها و املایی که باید حفظ شود، یا سبک نقطه‌گذاری دلخواه. این راهنمایی برای متن پیاده‌شده است، نه متنی برای خواندن.',
    audioLanguageLabel: 'زبان',
    audioLanguagePlaceholder: 'خودکار · fa · en',
    audioFormatMp3: 'MP3 — کم‌حجم، همه‌جا پخش می‌شود',
    audioFormatOpus: 'Opus — جریانی، تأخیر کم',
    audioFormatAac: 'AAC — دستگاه‌های اپل',
    audioFormatFlac: 'FLAC — بی‌افت',
    audioFormatWav: 'WAV — بدون فشرده‌سازی',
    audioFormatPcm: 'PCM — نمونه‌های خام (فقط دانلود)',
    audioFormatJson: 'JSON — متن',
    audioFormatText: 'متن ساده',
    audioFormatSrt: 'زیرنویس SRT',
    audioFormatVerboseJson: 'JSON با زمان‌بندی',
    audioFormatVtt: 'زیرنویس WebVTT',
    audioFormatDiarizedJson: 'JSON با گویندگان',
    voicePlaceholder: 'یک صدا انتخاب یا شناسهٔ صدا را بنویسید',
    voiceHint: 'صداهای داخلی برای مدل‌های گفتار OpenAI فهرست شده‌اند؛ ارائه‌دهندگان دیگر شناسهٔ صدای خودشان را می‌پذیرند.',
    speechSpeed: 'سرعت',
    speechInstructions: 'دستور اجرا',
    speechInstructionsPlaceholder: 'مثلاً: آرام و مانند یک راوی صمیمی بخوان.',
    imagePortrait: '(عمودی)',
    imageLandscape: '(افقی)',
    imageOutputFormat: 'قالب فایل',
    imageCount: 'تعداد تصویر',
    imageCountHint: 'هر تصویر جدا محاسبه می‌شود.',
    backgroundHint: 'پس‌زمینهٔ شفاف به PNG یا WebP و یک مدل GPT-image نیاز دارد.',
    embeddingsBatch: 'چند ورودی (با یک خط خالی جدا کنید)',
    embeddingsBatchHint: 'یک درخواست، یک بردار برای هر پاراگراف — همان روشی که برای جست‌وجو در سندها به کار می‌رود.',
    resultStale: 'نتیجهٔ قبلی — برای به‌روزرسانی دوباره اجرا کنید',
    generatedImagesCount: '{count} تصویر | {count} تصویر',
    rawHistoryLoadedKeepBody: '{name} بارگذاری شد — نقطهٔ پایانی و مدل بازیابی شدند؛ بدنهٔ فعلی درخواست شما حفظ شد (تاریخچه هرگز بدنه را ذخیره نمی‌کند).',
    codeStatusNeedsFix: 'نیاز به اصلاح',
    codeRunHintNode: 'با نام main.mjs ذخیره کنید، کلید را در ترمینال تنظیم کنید و اجرا کنید: node main.mjs (Node 20+).',
    codeRunHintBrowser: 'برای وب‌اپ باندل‌شده (Vite، Next…). هرگز کلید بلندمدت را در کد مرورگر قرار ندهید — از بک‌اند خودتان عبور دهید.',
    codeRunHintPython: 'با نام main.py ذخیره کنید، کلید را در ترمینال تنظیم کنید و اجرا کنید: python main.py (Python 3.9+).',
    codeRunHintCurl: 'در ترمینال بچسبانید. مستقیم در Postman، Insomnia، n8n و Make هم وارد می‌شود.',
    codeRunHintJson: 'دقیقاً همان بدنهٔ درخواستی که استودیو می‌فرستد. در حالت Raw API یا هر کلاینت HTTP بچسبانید.',
    codeAttachmentNoteJson: 'پیوست‌ها اینجا به‌صورت جای‌نگهدار data:…;base64,<نام فایل> نشان داده می‌شوند؛ درخواست واقعی بایت‌های کامل را می‌فرستد.',
    codeAttachmentNoteFiles: 'فایل‌های پیوست با نام از دیسک خوانده می‌شوند — پیش از اجرا آن‌ها را کنار اسکریپت بگذارید.',
    rawMethod: 'متد HTTP',
    rawNoBodyForMethod: 'درخواست‌های {method} بدنه ندارند — فقط نقطهٔ پایانی بالا استفاده می‌شود.',
    rawStarterImages: 'تولید تصویر',
    rawStarterImagesPrompt: 'پوستری مینیمال از یک فانوس دریایی در سپیده‌دم',
    rawStarterSpeech: 'متن به گفتار',
    rawStarterSpeechInput: 'سلام از استودیوی مدل.',
    rawStarterModels: 'فهرست مدل‌ها',
    rawTemplateReplaceTitle: 'بدنهٔ درخواست جایگزین شود؟',
    rawTemplateReplaceBody: 'الگو آنچه در JSON درخواست نوشته‌اید را بازنویسی می‌کند. اگر می‌خواهید نگهش دارید، اول کپی کنید.',
    rawTemplateReplaceConfirm: 'جایگزین کن',
    repairJson: 'اصلاح JSON',
    repairJsonAction: 'اصلاح نقل‌قول‌ها، ویرگول‌های اضافی، کامنت‌ها و کلیدهای بدون نقل‌قول و سپس قالب‌بندی',
    jsonErrorAt: 'در خط {line}، ستون {column}.',
    jsonHint_single_quotes: 'JSON به نقل‌قول دوتایی نیاز دارد — نقل‌قول تکی مجاز نیست.',
    jsonHint_trailing_comma: 'پس از آخرین مورد ویرگول اضافی هست.',
    jsonHint_comment: 'کامنت (// یا /* */) در JSON مجاز نیست.',
    jsonHint_unquoted_key: 'کلیدها باید در نقل‌قول دوتایی باشند، مثل "model".',
    jsonHint_smart_quotes: 'نقل‌قول‌های خمیده (“ ”) از یک ویرایشگر متن آمده‌اند — از نقل‌قول ساده (") استفاده کنید.',
    jsonHint_not_an_object: "بدنه باید یک آبجکت JSON باشد: {'{'} … {'}'}.",
    editAsRaw: 'ویرایش به‌صورت درخواست خام',
    editAsRawAction: 'باز کردن همین بدنهٔ درخواست در حالت Raw API برای ویرایش دستی هر فیلد',
    editAsRawLoaded: 'در حالت Raw API بارگذاری شد — هر فیلدی را ویرایش و بعد اجرا کنید.',
    editAsRawLoadedWithAttachments: 'در حالت Raw API بارگذاری شد — {count} پیوست به‌صورت data:…;base64,<نام فایل> نمایش داده می‌شود و هنگام اجرا کامل ارسال می‌شود.',
    rawAttachmentsLoaded: '{count} جای‌نگهدار پیوست هنگام اجرا از فایل‌های بارشده پر می‌شود: {names}.',
    rawAttachmentsMissing: 'برای این موارد فایلی بار نشده است: {names}. آن را در چت ← پیوست‌ها دوباره پیوست کنید و دوباره «ویرایش به‌صورت Raw» را بزنید، یا جای‌نگهدار را با data URL جایگزین کنید.',
    audioPcmDownloadOnly: 'PCM خام در مرورگر پخش نمی‌شود — آن را دانلود کنید و در یک ابزار صوتی باز کنید (۱۶ بیت، ۲۴ کیلوهرتز، مونو).',
    vectorExplainer: 'یک امبدینگ فهرستی از {dimensions} عدد است که معنای متن شما را نمایندگی می‌کند. بردارها را (با شباهت کسینوسی) مقایسه کنید تا متن‌های مرتبط را پیدا کنید، خوشه‌بندی کنید یا جست‌وجو کنید.',
    vectorExplainerBatch: '{count} امبدینگ، هر یک با {dimensions} عدد — یکی برای هر پاراگراف، به همان ترتیبی که نوشتید.',
    vectorActions: 'کارهای بردار',
    copyFullVector: 'کپی بردار کامل',
    copyFullVectorAction: 'کپی امبدینگ کامل به‌صورت آرایهٔ JSON',
    downloadVectorJson: 'دانلود JSON',
    downloadVectorCsv: 'دانلود CSV',
    openImage: 'باز کردن',
    openImageWithIndex: 'باز کردن تصویر {index} در برگهٔ جدید',
    revisedPrompt: 'مدل پرامپت شما را به این شکل بازنویسی کرد:',
    attachmentReadFailed: 'خواندن {names} ممکن نشد. فایل ممکن است جابه‌جا یا قفل شده باشد — دوباره انتخابش کنید.',
    attachmentWarning_large: 'حجیم — با هر پیام به‌صورت درون‌خطی ارسال می‌شود',
    attachmentWarning_too_large: 'برای ارسال درون‌خطی بسیار بزرگ است',
    attachmentWarning_pdf_unsupported: 'این مدل PDF نمی‌خواند',
    attachmentWarning_text_as_file: 'نکته: متن را به‌جای فایل در پرامپت بچسبانید',
    attachmentOverPdfLimit: 'بیش از سقف {limit} مگابایتی PDF این مدل',
    openInspector: 'باز کردن بازبین',
    rawErrorBody: 'خطای خام (JSON)',
    rawErrorBodyUnavailable: 'ارائه‌دهنده بدنهٔ خطایی برنگرداند (خطای شبکه، مسدودشدن CORS یا قطع جریان).',
    requestSent: 'درخواست ارسال‌شده (پاک‌سازی‌شده)',
    retryWithoutOptionalParams: 'تلاش دوباره بدون پارامترهای اختیاری',
    retryWithoutOptionalParamsAction: 'ارسال دوبارهٔ همان درخواست بدون: {params}',
    errorCauseKeyProvisioningTitle: 'کلید هنوز فعال می‌شود',
    errorCauseKeyProvisioningWhy:
      'کلید پیشخان لحظاتی پیش صادر شده است. سرویس API از یک نسخهٔ لحظه‌ای مجوز می‌دهد که هر ۳۰ تا ۶۰ ثانیه تازه می‌شود؛ پس هنوز این کلید را نمی‌شناسد.',
    errorCauseKeyProvisioningFix: 'نیازی به تغییر نیست — استودیو خودکار دوباره تلاش می‌کند. اگر می‌خواهید دستی منتظر بمانید، شمارش را متوقف کنید.',
    errorCauseKeyRejectedTitle: 'کلید API رد شد',
    errorCauseKeyRejectedWhy: 'سرویس API این کلید را نمی‌پذیرد: ممکن است باطل، منقضی، اشتباه تایپ‌شده یا متعلق به محیط دیگری باشد.',
    errorCauseKeyRejectedFix: 'پنل راه‌اندازی استودیو را باز کنید و کلید پیشخان را نوسازی یا کلید دیگری انتخاب کنید، بعد دوباره اجرا کنید.',
    errorCauseEndpointRestrictedTitle: 'کلید برای این نقطهٔ پایانی مجاز نیست',
    errorCauseEndpointRestrictedWhy: 'این کلید با محدودیت نقطهٔ پایانی یا هدف ساخته شده که {model} را در این مسیر شامل نمی‌شود.',
    errorCauseEndpointRestrictedFix: 'از کلید پیشخان (دامنهٔ کامل کاربر) استفاده کنید یا مجوزهای کلید را در صفحهٔ کلیدهای API گسترش دهید.',
    errorCauseInsufficientCreditTitle: 'اعتبار یا سهمیهٔ ناکافی',
    errorCauseInsufficientCreditWhy: 'حساب یا این کلید اعتباری باقی ندارد یا به سقف بودجه/سهمیه رسیده است.',
    errorCauseInsufficientCreditFix: 'اعتبار را افزایش دهید یا بودجهٔ کلید را بالا ببرید و دوباره تلاش کنید.',
    errorCauseUnsupportedParameterTitle: 'یکی از پارامترها را این مدل نمی‌پذیرد',
    errorCauseUnsupportedParameterWhy:
      '{model} یکی از فیلدهای اختیاری درخواست را رد کرد. فیلدهای ارسال‌شده‌ای که مدل‌ها بیشتر رد می‌کنند: {params}.',
    errorCauseUnsupportedParameterFix:
      'بدون پارامترهای اختیاری دوباره تلاش کنید یا همان کنترل را به «پیش‌فرض مدل» برگردانید. برای ارسال دقیق بدنهٔ دلخواه از حالت Raw API استفاده کنید.',
    errorCauseModelNotFoundTitle: 'مدل پیدا نشد',
    errorCauseModelNotFoundWhy: '{model} در این نقطهٔ پایانی در دسترس نیست یا نامش متفاوت است.',
    errorCauseModelNotFoundFix: 'مدلی را از فهرست انتخاب کنید (اطلاعات از حساب شما می‌آید) یا شناسهٔ دقیق مدل را بررسی کنید.',
    errorCauseContextLengthTitle: 'درخواست برای مدل بسیار طولانی است',
    errorCauseContextLengthWhy: 'ورودی به‌همراه خروجی خواسته‌شده از پنجرهٔ زمینهٔ مدل بیشتر است.',
    errorCauseContextLengthFix: 'پرامپت یا پیوست‌ها را کوتاه کنید یا حداکثر خروجی را کم کنید.',
    errorCauseContentFilterTitle: 'توسط فیلتر محتوا مسدود شد',
    errorCauseContentFilterWhy: 'سامانهٔ ایمنی ارائه‌دهنده این ورودی یا خروجی را نپذیرفت.',
    errorCauseContentFilterFix: 'درخواست را بازنویسی کنید یا محتوای علامت‌خورده را حذف کنید.',
    errorCauseInvalidRequestTitle: 'درخواست نامعتبر رد شد',
    errorCauseInvalidRequestWhy: 'ارائه‌دهنده درخواست را ناقص یا ناسازگار تشخیص داد (پیام و خطای خام را پایین ببینید).',
    errorCauseInvalidRequestFix: 'بدنهٔ «درخواست ارسال‌شده» را با مرجع API مقایسه کنید؛ حالت Raw API کنترل کامل بدنه را می‌دهد.',
    errorCauseRateLimitTitle: 'محدودیت نرخ',
    errorCauseRateLimitWhy: 'تعداد درخواست یا توکن در دقیقه برای این کلید یا مدل بیش از حد است.',
    errorCauseRateLimitFix: 'تا پایان شمارش صبر کنید و دوباره تلاش کنید، یا درخواست‌ها را پراکنده‌تر بفرستید.',
    errorCauseNetworkTitle: 'مشکل شبکه',
    errorCauseNetworkWhy: 'مرورگر نتوانست اتصال به سرویس API را کامل کند.',
    errorCauseNetworkFix: 'اتصال و نشانی پایه را بررسی کنید و دوباره تلاش کنید.',
    errorCauseCorsOrBlockedTitle: 'درخواست پیش از رسیدن به API مسدود شد',
    errorCauseCorsOrBlockedWhy:
      'هیچ پاسخ HTTP نرسید — نشانهٔ رایج رد CORS، مسدودشدن preflight، قاعدهٔ پراکسی/مسدودکنندهٔ تبلیغ یا نشانی پایهٔ دست‌نیافتنی.',
    errorCauseCorsOrBlockedFix:
      'مطمئن شوید نشانی پایه درست و از این مرورگر در دسترس است؛ در محیط توسعه، سرویس API باید با CORS فعال برای این مبدأ اجرا شود.',
    errorCauseProviderUnavailableTitle: 'ارائه‌دهنده در دسترس نیست',
    errorCauseProviderUnavailableWhy: 'سرویس API یا ارائه‌دهندهٔ بالادستی خطای سرور برگرداند یا زمانش تمام شد.',
    errorCauseProviderUnavailableFix: 'چند لحظه بعد دوباره تلاش کنید؛ اگر ادامه داشت، گزارش اشکال‌زدایی را برای پشتیبانی بفرستید.',
    errorCauseUnknownTitle: 'درخواست ناموفق بود',
    errorCauseUnknownWhy: 'این خطا با الگوی شناخته‌شده‌ای مطابقت نداشت.',
    errorCauseUnknownFix: 'خطای خام را پایین بخوانید؛ شناسهٔ درخواست به پشتیبانی امکان پیگیری می‌دهد.',
    overviewQuickActions: 'شروع سریع',
    overviewOpenPlayground: 'باز کردن محیط آزمایش',
    overviewOpenPlaygroundDescription: 'با وضعیت محلی فعلی استودیو ادامه دهید.',
    overviewBrowsePrompts: 'مرور پرامپت‌ها',
    overviewBrowsePromptsDescription: 'پیکربندی‌های ذخیره‌شده و تنظیمات قابل استفاده مجدد را باز کنید.',
    overviewCompareModels: 'مقایسه مدل‌ها',
    overviewCompareModelsDescription: 'یک پرامپت را با دو مدل ارزیابی کنید.',
    overviewCreateWorkflow: 'ساخت گردش‌کار',
    overviewCreateWorkflowDescription: 'یک پیکربندی خالی و قابل استفاده مجدد آغاز کنید.',
    overviewRecentWorkflows: 'گردش‌کارهای اخیر',
    overviewRecentRequests: 'درخواست‌های اخیر',
    overviewViewAll: 'مشاهده همه',
    overviewNoWorkflows: 'هنوز گردش‌کاری ذخیره نشده است.',
    overviewNoRequests: 'هنوز درخواستی ثبت نشده است.',
    overviewOpenWorkflow: 'باز کردن گردش‌کار: {name}',
    overviewInspectRequest: 'بررسی درخواست: {name}',
    overviewTokens: '{count} توکن',
    overviewLatency: '{count} میلی‌ثانیه',
    promptsTitle: 'کتابخانه پرامپت‌ها',
    promptsSubtitle: 'پیکربندی‌های کامل محیط آزمایش را ذخیره، سازمان‌دهی و دوباره استفاده کنید.',
    promptsEmptyDescription: 'یک پیکربندی قابل استفاده مجدد از محیط آزمایش ذخیره کنید یا اینجا پرامپت بسازید.',
    createPrompt: 'ساخت پرامپت',
    newPrompt: 'پرامپت جدید',
    openPlayground: 'باز کردن محیط آزمایش',
    promptBack: 'بازگشت',
    promptSearchPlaceholder: 'جستجوی پرامپت‌ها',
    promptClearFilters: 'پاک کردن فیلترها',
    promptsFilteredEmpty: 'پرامپتی با این فیلترها پیدا نشد.',
    promptMode: 'حالت',
    promptModel: 'مدل',
    promptName: 'نام',
    promptDescription: 'توضیحات',
    promptTags: 'برچسب‌ها',
    promptAddTag: 'افزودن برچسب',
    promptPin: 'سنجاق کردن پرامپت',
    promptUnpin: 'برداشتن سنجاق پرامپت',
    promptDuplicate: 'تکثیر پرامپت',
    promptDelete: 'حذف پرامپت',
    promptOpenInPlayground: 'باز کردن در محیط آزمایش',
    promptActions: 'عملیات پرامپت',
    promptStatusDirty: 'تغییرات ذخیره‌نشده',
    promptStatusNew: 'پرامپت جدید',
    promptStatusSaved: 'پرامپت ذخیره‌شده',
    promptRequiresReattachment: 'فایل لازم است',
    promptNameRequired: 'نام پرامپت را وارد کنید.',
    promptNameTooLong: 'حداکثر 60 نویسه وارد کنید.',
    promptNameDuplicate: 'یک پرامپت ذخیره‌شده از این نام استفاده می‌کند.',
    promptDescriptionTooLong: 'حداکثر 240 نویسه وارد کنید.',
    promptTooManyTags: 'حداکثر هشت برچسب وارد کنید.',
    promptTagTooLong: 'هر برچسب باید حداکثر 24 نویسه باشد.',
    promptUpdate: 'به‌روزرسانی پرامپت',
    promptSaveAsNew: 'ذخیره به‌عنوان مورد جدید',
    promptSaveToLibrary: 'ذخیره در کتابخانه',
    promptSaveDialogTitle: 'ذخیره پرامپت در کتابخانه',
    promptSaveAsNewDialogTitle: 'ذخیره پرامپت به‌عنوان مورد جدید',
    promptPersistenceUnavailable: 'فضای ذخیره‌سازی پرامپت در دسترس نیست.',
    promptHandoffNotFound: 'آن پرامپت ذخیره‌شده دیگر در دسترس نیست.',
    promptLoaded: 'پرامپت {name} به‌عنوان نسخه کاری بارگذاری شد.',
    promptReattachFile: 'پیوست دوباره فایل',
    promptAudioReattachmentHelp: 'پیش از اجرای پرامپت صوتی، این فایل را دوباره انتخاب کنید.',
    promptListLabel: 'پرامپت‌های ذخیره‌شده',
    promptSelectLabel: 'ویرایش پرامپت: {name}',
    promptEditorNewTitle: 'ساخت پرامپت',
    promptEditorSavedTitle: 'ویرایش پرامپت',
    promptStorageReadOnly:
      'فضای ذخیره‌سازی مرورگر در دسترس نیست. می‌توانید پرامپت را بررسی یا باز کنید، اما تغییرات ذخیره نمی‌شوند.',
    promptConfiguration: 'پیکربندی پرامپت',
    promptSystemPrompt: 'پرامپت سامانه',
    promptMessages: 'پیام‌ها',
    promptMessageRole: 'نقش پیام',
    promptMessageContent: 'محتوای پیام',
    promptAddMessage: 'افزودن پیام',
    promptRemoveMessage: 'حذف پیام',
    promptVariables: 'متغیرها',
    promptAddVariable: 'افزودن متغیر',
    promptRemoveVariable: 'حذف متغیر',
    promptOutputFormat: 'قالب خروجی',
    promptFunctions: 'تعریف توابع',
    promptAddFunction: 'افزودن تابع',
    promptRemoveFunction: 'حذف تابع',
    promptMcpServers: 'تعریف سرورهای MCP',
    promptAddMcpServer: 'افزودن سرور MCP',
    promptRemoveMcpServer: 'حذف سرور MCP',
    promptAttachmentPlaceholder: 'پیش از اجرای این پرامپت، فایل‌های ذخیره‌شده را دوباره پیوست کنید.',
    promptAudioFilePlaceholder: 'پیش از اجرای این پرامپت صوتی، {name} را دوباره پیوست کنید.',
    promptRoleSystem: 'سامانه',
    promptRoleUser: 'کاربر',
    promptRoleAssistant: 'دستیار',
    promptRoleDeveloper: 'توسعه‌دهنده',
    promptUnsavedTitle: 'تغییرات ذخیره‌نشده کنار گذاشته شوند؟',
    promptUnsavedDescription: 'با ادامه دادن، تغییرات این ویرایشگر پرامپت از بین می‌روند.',
    promptDiscardChanges: 'کنار گذاشتن تغییرات',
    promptDeleteTitle: 'پرامپت حذف شود؟',
    promptDeleteDescription: 'پرامپت {name} حذف شود؟ این کار قابل بازگشت نیست.',
    promptDeleteConfirm: 'حذف پرامپت',
    promptMalformedTitle: 'برخی پرامپت‌ها قابل خواندن نبودند',
    promptMalformedDescription: '{count} رکورد نامعتبر بدون تغییر نگه داشته شد.',
    promptStorageUnsupportedTitle: 'داده پرامپت مربوط به نسخه جدیدتری است',
    promptStorageUnsupportedDescription: 'نسخه فعلی استودیو مدل نمی‌تواند این داده مرورگر را با اطمینان ویرایش کند.',
    promptStorageWriteFailedTitle: 'تغییرات پرامپت ذخیره نشد',
    promptStorageWriteFailedDescription:
      'پرامپت‌های بارگذاری‌شده همچنان نمایش داده می‌شوند، اما برای حفاظت از داده محلی امکان تغییر بیشتر غیرفعال شده است.',
    promptModelMetadataNotice: 'فراداده مدل موقتا در دسترس نیست. مدل ذخیره‌شده همچنان قابل انتخاب است.',
    promptFilterModes: 'فیلتر بر پایه حالت',
    promptFilterTags: 'فیلتر بر پایه برچسب',
    promptSortLabel: 'مرتب‌سازی پرامپت‌ها',
    promptPinnedOnly: 'فقط سنجاق‌شده‌ها',
    promptSelected: 'پرامپت {name} انتخاب شد.',
    promptMissing: 'این پرامپت دیگر در دسترس نیست.',
    promptCreated: 'پرامپت {name} ساخته شد.',
    promptUpdated: 'پرامپت {name} به‌روزرسانی شد.',
    promptSavedAsNew: 'پرامپت {name} به‌عنوان مورد جدید ذخیره شد.',
    promptDuplicated: 'پرامپت {name} تکثیر شد.',
    promptPinned: 'پرامپت سنجاق شد.',
    promptUnpinned: 'سنجاق پرامپت برداشته شد.',
    promptDeleted: 'پرامپت {name} حذف شد.',
    workflowsTitle: 'گردش‌کارها',
    workflowsSubtitle: 'پیکربندی‌های مدل را برای کارهای تکرارشونده توسعه دوباره استفاده کنید.',
    newWorkflow: 'گردش‌کار جدید',
    workflowTemplates: 'گردش‌کارهای آماده',
    workflowSearchPlaceholder: 'جستجوی گردش‌کارها',
    workflowsPinnedOnly: 'فقط سنجاق‌شده‌ها',
    workflowsEmpty: 'گردش‌کاری با این فیلتر پیدا نشد.',
    workflowsFirstUse: 'هنوز گردش‌کاری ذخیره نشده است. از الگوهای بالا شروع کنید یا یک پیکربندی را در محیط آزمایش ذخیره کنید.',
    workflowOpenInPlayground: 'باز کردن',
    workflowPin: 'سنجاق',
    workflowUnpin: 'برداشتن سنجاق',
    workflowRename: 'تغییر نام',
    workflowActions: 'عملیات گردش‌کار',
    workflowDuplicate: 'تکثیر',
    workflowDelete: 'حذف',
    workflowDeleteConfirm: 'این گردش‌کار حذف شود؟',
    workflowRenameTitle: 'تغییر نام گردش‌کار',
    workflowSave: 'ذخیره',
    workflowRenamed: 'نام گردش‌کار تغییر کرد.',
    workflowDuplicated: 'گردش‌کار تکثیر شد.',
    workflowDeleted: 'گردش‌کار حذف شد.',
    workflowSortLabel: 'مرتب‌سازی گردش‌کارها',
    workflowSortUpdated: 'آخرین به‌روزرسانی',
    workflowSortName: 'نام',
    workflowSortMode: 'حالت',
    workflowTemplateStructuredTitle: 'استخراج ساختاریافته',
    workflowTemplateStructuredDescription: 'خروجی JSON معتبر از سند یا متن دریافت کنید.',
    workflowTemplateSupportTitle: 'دستیار پشتیبانی',
    workflowTemplateSupportDescription: 'یک گفت‌وگوی پشتیبانی آماده ابزار آغاز کنید.',
    workflowTemplateImageTitle: 'شرح تصویر',
    workflowTemplateImageDescription: 'تنظیمات تصویر و ابعاد خروجی را دوباره استفاده کنید.',
    compareTitle: 'مقایسه',
    compareSubtitle: 'پاسخ مدل‌ها را با یک درخواست مشترک کنار هم ارزیابی کنید.',
    compareConnect: 'اتصال',
    runBoth: 'اجرای هر دو',
    comparePromptPlaceholder: 'یک پرامپت برای هر دو مدل وارد کنید',
    compareModelA: 'انتخاب مدل الف',
    compareModelB: 'انتخاب مدل ب',
    compareResults: 'نتایج مقایسه',
    comparePromptRequired: 'پیش از مقایسه مدل‌ها یک پرامپت وارد کنید.',
    compareConnectRequired: 'پیش از اجرای مقایسه یک کلید API متصل کنید.',
    compareComplete: 'کامل',
    comparePreferred: 'ترجیحی',
    compareMarkPreferred: 'انتخاب به‌عنوان پاسخ ترجیحی',
    compareOutdated: 'قدیمی‌شده',
    compareFaster: 'سریع‌تر',
    compareFewerTokens: 'توکن کمتر',
    compareLowerCost: 'هزینه کمتر',
    comparePreferredTabLabel: '{model}، ترجیحی',
    compareFailed: 'ناموفق',
    compareResultEmpty: 'برای دیدن پاسخ، مقایسه را اجرا کنید.',
    compareLatency: 'تاخیر',
    compareTokens: 'توکن‌ها',
    compareCost: 'هزینه برآوردی',
    compareRerun: 'اجرای دوباره',
    copyResponse: 'کپی',
    compareCopied: 'پاسخ کپی شد.',
    compareCopyFailed: 'کپی پاسخ ممکن نبود.',
    openInPlayground: 'باز کردن در محیط آزمایش',
    requestsTitle: 'درخواست‌ها',
    requestsSubtitle: 'فراخوانی‌های مدل ثبت‌شده در مرورگر را بررسی، بازپخش و عیب‌یابی کنید.',
    requestsSearch: 'جستجوی درخواست یا مدل',
    requestsAllModes: 'همه حالت‌ها',
    requestsAllStatuses: 'همه وضعیت‌ها',
    requestsEmpty: 'درخواستی با این فیلتر پیدا نشد.',
    requestsFirstUse: 'هنوز درخواستی ثبت نشده است. یک مدل را در محیط آزمایش اجرا کنید تا درخواست و نتیجه‌اش اینجا نمایش داده شود.',
    requestsBack: 'بازگشت',
    requestDetails: 'جزئیات درخواست',
    requestReplay: 'بازپخش',
    requestError: 'خطا',
    requestsFilters: 'فیلترها',
    requestsAnyTime: 'هر زمان',
    requestsPastHour: 'یک ساعت گذشته',
    requestsPastDay: 'یک روز گذشته',
    requestsPastWeek: 'یک هفته گذشته',
    requestsPastMonth: 'یک ماه گذشته',
    requestModeFilter: 'فیلتر بر اساس حالت',
    requestStatusFilter: 'فیلتر بر اساس وضعیت',
    requestTimeFilter: 'فیلتر بر اساس زمان',
    requestMinimumTokens: 'حداقل توکن‌ها',
    requestMaximumCost: 'حداکثر هزینه (واحد اعتبار)',
    requestModel: 'مدل',
    requestMode: 'حالت',
    requestResponse: 'پاسخ',
    requestCode: 'کد درخواست',
    requestCodeCopied: 'کد درخواست کپی شد.',
    requestCodeCopyFailed: 'کپی کد درخواست ممکن نبود.',
    requestDelete: 'حذف درخواست',
    requestDeleted: 'درخواست حذف شد.',
    requestDeleteConfirm: 'این درخواست حذف شود؟',
    historyCleared: 'تاریخچه درخواست‌ها پاک شد.',
    storageUnavailableTitle: 'ذخیره محلی در دسترس نیست',
    storageUnavailable:
      'تغییرات در این نشست در دسترس می‌مانند، اما مرورگر نتوانست آن‌ها را به‌صورت محلی ذخیره کند. داده ذخیره‌شده موجود حذف نشده است.',
    handoffNotFound: 'این گردش‌کار یا درخواست ذخیره‌شده دیگر در دسترس نیست.',
    workflowTemplateStructuredPrompt: 'واقعیت‌های کلیدی را استخراج کن و JSON معتبر برگردان.',
    workflowTemplateSupportPrompt: 'به مشتری برای حل این درخواست پشتیبانی کمک کن.',
    workflowTemplateImagePrompt: 'یک طرح محصول تمیز روی پس‌زمینه خنثی بساز.',
    setup: 'راه‌اندازی',
    controls: 'کنترل‌ها',
    configure: 'پیکربندی',
    studioSetup: 'راه‌اندازی استودیو',
    studioControls: 'کنترل‌های استودیو',
    setupRail: 'پنل راه‌اندازی',
    controlsRail: 'پنل کنترل‌ها',
    railOpen: 'باز',
    railClosed: 'بسته',
    openStudioSetup: 'باز کردن پنل راه‌اندازی استودیو',
    openStudioControls: 'باز کردن پنل کنترل‌های استودیو',
    closeStudioSetup: 'بستن پنل راه‌اندازی استودیو',
    closeStudioControls: 'بستن پنل کنترل‌های استودیو',
    openAttachments: 'باز کردن پیوست‌های چت',
    focusWorkspace: 'تمرکز',
    focusWorkspaceAction: 'تمرکز روی فضای کار',
    focusComposerAction: 'تمرکز روی کادر پیام چت',
    restoreWorkspace: 'بازگردانی',
    restoreWorkspaceAction: 'بازگردانی پنل‌های کناری',
    expandRail: 'باز کردن پنل',
    collapseRail: 'بستن پنل',
    connection: 'اتصال',
    connectionDetails: 'جزئیات اتصال',
    manageConnection: 'مدیریت اتصال',
    hideConnectionDetails: 'پنهان کردن جزئیات اتصال',
    avalai: 'AvalAI',
    custom: 'سفارشی',
    dashboardApiKey: 'کلید API پیشخان',
    dashboardApiKeySelect: 'انتخاب کلید API موجود',
    keySetupPaths: 'مسیرهای راه‌اندازی کلید API',
    recommended: 'توصیه شده',
    browserKeyPath: 'ساخت کلید مرورگر',
    browserKeyPathDescription: 'یک کلید مخصوص پیشخان برای همین نشست استودیو بسازید.',
    existingKeyPath: 'استفاده از کلید موجود',
    existingKeyPathDescription: 'کلیدهای API پیشخان را بارگذاری کنید و یکی را برای فراخوانی SDK مرورگر انتخاب کنید.',
    dashboardApiKeySelectPlaceholder: 'یک کلید API پیشخان انتخاب کنید',
    loadApiKeys: 'بارگذاری کلیدها',
    loadApiKeysAction: 'بارگذاری کلیدهای API موجود پیشخان',
    refreshApiKeys: 'نوسازی کلیدها',
    refreshApiKeysAction: 'نوسازی کلیدهای API موجود پیشخان',
    noApiKeysFound: 'کلید API پیدا نشد.',
    apiKeysFetchError: 'بارگذاری کلیدهای API با خطا مواجه شد.',
    selectedApiKeyFetchError: 'دریافت کلید API انتخاب‌شده با خطا مواجه شد.',
    selectedApiKeySecretUnavailable:
      'مقدار محرمانه کلید انتخاب‌شده در دسترس نیست. برای فراخوانی مرورگر، کلید پیشخان بسازید.',
    selectedApiKeyReady: 'کلید API انتخاب‌شده برای فراخوانی SDK مرورگر آماده است.',
    dashboardKeyReady: 'برای فراخوانی SDK در مرورگر آماده است.',
    dashboardKeyMissing: 'کلید پیشخان بارگذاری نشده است.',
    ready: 'آماده',
    needed: 'نیازمند',
    keyReady: 'کلید آماده است',
    keyNeeded: 'کلید لازم است',
    connectionInvalid: 'اتصال نامعتبر',
    dashboardEnvironmentLocal: 'محیط توسعه محلی',
    dashboardEnvironmentProduction: 'AvalAI',
    dashboardIssuerUnsupported:
      'این محیط پیشخان شناخته‌شده نیست؛ بنابراین استفاده امن از کلیدهای پیشخان ممکن نیست.',
    dashboardIssuerPolicyBlocked:
      'درگاه محلی پیشخان فقط با سیاست حلقه محلی محیط توسعه در دسترس است.',
    freshKeyNotice: 'یک کلید تازه برای پیشخان ساخته شد. ممکن است کمی زمان ببرد تا فعال شود.',
    signInForDashboardKey: 'برای دریافت کلید API پیشخان وارد شوید.',
    dashboardKeyFetchError: 'دریافت کلید API پیشخان با خطا مواجه شد.',
    selectOrGenerateKeyError: 'پیش از اجرای درخواست، یک کلید API انتخاب یا ایجاد کنید.',
    runUnavailable: 'پیش از اجرا، یک کلید API انتخاب کنید و ورودی لازم را کامل کنید.',
    requestInProgress: 'درخواست در حال اجراست. پیش از تغییر تنظیمات آن را متوقف کنید.',
    dashboardKeyRequestInProgress:
      'درخواست کلید API پیشخان در حال اجراست. پیش از تغییر تنظیمات کلید منتظر پایان آن بمانید.',
    chatMessageRequired: 'پیش از اجرا، یک پیام چت وارد یا اضافه کنید.',
    chatNothingToClear: 'چت از قبل خالی است.',
    imagePromptRequired: 'پیش از تولید تصویر، پرامپت تصویر را وارد کنید.',
    speechInputRequired: 'پیش از اجرای گفتار، متن موردنظر را وارد کنید.',
    embeddingInputRequired: 'پیش از ساخت بردار، متن ورودی را وارد کنید.',
    requestJsonRequired: 'پیش از اجرا، JSON درخواست را وارد کنید.',
    resetParameters: 'بازنشانی پارامترها',
    resetSettings: 'بازنشانی تنظیمات',
    selectAudioFileError: 'پیش از اجرای رونویسی یا ترجمه، یک فایل صوتی انتخاب کنید.',
    requestFailed: 'درخواست پیش از دریافت پاسخ ناموفق بود.',
    providerKeyProvisioning:
      'کلید تازه پیشخان هنوز در سرویس API فعال نشده است (معمولا ۳۰ تا ۶۰ ثانیه زمان می‌برد). کلید را نگه دارید و چند لحظه بعد دوباره تلاش کنید.',
    providerAuthenticationFailed:
      'کلید API رد شد یا برای این درخواست مجوز ندارد. پنل راه‌اندازی استودیو را باز کنید، کلید را نوسازی یا جایگزین کنید و دوباره تلاش کنید.',
    providerRateLimited: 'ارائه‌دهنده تعداد درخواست‌ها را محدود کرده است. کمی صبر کنید و دوباره تلاش کنید.',
    providerNetworkError: 'اتصال به ارائه‌دهنده برقرار نشد. اتصال شبکه را بررسی کنید و دوباره تلاش کنید.',
    providerRequestRejected:
      'ارائه‌دهنده این درخواست را رد کرد. مدل و پارامترهای انتخاب‌شده را بررسی کنید و دوباره تلاش کنید.',
    providerUnavailable: 'ارائه‌دهنده موقتا در دسترس نیست. کمی صبر کنید و دوباره تلاش کنید.',
    modelMetadataError: 'بارگذاری فراداده مدل‌ها با خطا مواجه شد.',
    generateApiKey: 'ساخت کلید API',
    generateDashboardKeyAction: 'ساخت کلید API پیشخان برای فراخوانی‌های مرورگری Model Studio',
    refreshDashboardKey: 'نوسازی کلید پیشخان',
    refreshDashboardKeyAction: 'نوسازی کلید API پیشخان تولیدشده برای فراخوانی‌های مرورگری Model Studio',
    customProvider: 'ارائه‌دهنده سفارشی',
    providerLabel: 'نام ارائه‌دهنده',
    customBaseUrl: 'نشانی پایه API',
    customBaseUrlPlaceholder: 'https://api.example.com/v1',
    customBaseUrlInvalid: 'پیش از اجرای درخواست‌ها، یک نشانی پایه HTTP(S) معتبر وارد کنید.',
    customBaseUrlHttpsRequired:
      'از نشانی پایه HTTPS استفاده کنید. در محیط توسعه، HTTP فقط برای نشانی‌های حلقه محلی localhost مجاز است.',
    audioTranslationProviderUnavailable:
      'ترجمه صوتی در نشانی API تولید AvalAI در دسترس نیست.',
    customApiKey: 'کلید API',
    customKeyPlaceholder: 'کلید API را برای همین نشست وارد کنید',
    customKeyNotice: 'کلیدهای سفارشی فقط در حافظه همین نشست می‌مانند و ذخیره نمی‌شوند.',
    clearCustomKey: 'پاک کردن کلید',
    clearCustomKeyAction: 'پاک کردن کلید API سفارشی از این نشست',
    roleUser: 'کاربر',
    roleAssistant: 'دستیار',
    viewRawResponse: 'نمایش متن خام پاسخ',
    viewFormattedResponse: 'نمایش پاسخ قالب‌بندی‌شده',
    rawResponseSource: 'متن خام پاسخ',
    roleSystem: 'سیستم',
    roleDeveloper: 'توسعه‌دهنده',
    prompt: 'پرامپت',
    savePreset: 'ذخیره تنظیم',
    applyPreset: 'اعمال',
    applyPresetWithName: 'اعمال تنظیم {name}',
    removePresetWithName: 'حذف تنظیم {name}',
    history: 'اجراهای اخیر',
    noLocalHistory: 'هنوز اجرای اخیر ندارید.',
    applyHistory: 'بازیابی',
    applyHistoryWithName: 'بازیابی اجرای اخیر {name}',
    removeHistoryWithName: 'حذف اجرای اخیر {name}',
    clearHistory: 'پاک کردن',
    clearHistoryConfirm: 'همه اجراهای اخیر پاک شوند؟',
    clearHistoryConfirmPositive: 'پاک کردن',
    clearHistoryConfirmNegative: 'انصراف',
    clearHistoryAction: 'پاک کردن همه اجراهای اخیر Model Studio',
    removePresetConfirm: 'این تنظیم ذخیره‌شده حذف شود؟',
    removePresetConfirmPositive: 'حذف',
    removePresetConfirmNegative: 'انصراف',
    presetNamePlaceholder: 'نام این تنظیم',
    presetName: 'تنظیم استودیو',
    workflows: 'گردش‌کارها',
    openWorkflows: 'باز کردن گردش‌کارهای ذخیره‌شده و اخیر',
    closeWorkflows: 'بستن گردش‌کارها',
    saveCurrentWorkflow: 'ذخیره تنظیم فعلی',
    recentWorkflows: 'اجراهای اخیر',
    savedWorkflows: 'ذخیره‌شده‌ها',
    manageWorkflowsInSetup: 'مدیریت همه در راه‌اندازی',
    loadWorkflowWithName: 'بازیابی گردش‌کار {name}',
    workflowLoaded: 'گردش‌کار {name} بازیابی شد. هر زمان آماده بودید اجرا را بزنید.',
    workflowLoadFailed: 'بازیابی گردش‌کار {name} انجام نشد. تنظیم فعلی اجرا نشده است.',
    workflowSaved: 'گردش‌کار {name} در این مرورگر ذخیره شد.',
    workflowSavedForSession: 'گردش‌کار {name} فقط در این نشست در دسترس است و ممکن است پس از بازخوانی باقی نماند.',
    workflowName: 'نام گردش‌کار',
    workflowNamePlaceholder: 'برای این گردش‌کار نامی بنویسید',
    workflowNameRequired: 'نام گردش‌کار را وارد کنید.',
    workflowNameTooLong: 'نام باید حداکثر 60 نویسه باشد.',
    workflowNameDuplicate: 'گردش‌کاری با این نام از قبل ذخیره شده است.',
    copyNameSuffix: 'کپی',
    workflowMutationLocked: 'برای تغییر گردش‌کارها، اجرای فعال را متوقف کنید یا منتظر پایان آن بمانید.',
    recentWorkflowsEmpty: 'پس از تکمیل اجرا، تنظیم آن برای استفاده دوباره اینجا نمایش داده می‌شود.',
    savedWorkflowsEmpty: 'تنظیم فعلی را ذخیره کنید تا بعدا دوباره از آن استفاده کنید.',
    workflowPersistenceUnavailable: 'ذخیره‌سازی مرورگر در دسترس نیست؛ تغییرها ممکن است پس از بازخوانی باقی نمانند.',
    modePromptInCanvas: 'پرامپت یا ورودی این حالت را در بوم میانی ویرایش کنید.',
    variables: 'متغیرها',
    addVariable: 'افزودن متغیر',
    variableName: 'نام متغیر',
    variableValue: 'مقدار متغیر',
    variableNamePlaceholder: 'customer_name',
    variableValuePlaceholder: 'مقداری که برای این متغیر استفاده می‌شود',
    removeVariable: 'حذف متغیر {name}',
    noPromptVariables: 'هنوز متغیر پرامپت ندارید.',
    systemInstructions: 'دستورهای سیستم',
    attachments: 'پیوست‌ها',
    attachFiles: 'فایل، تصویر یا صوت را برای مدل‌های پشتیبانی‌شده پیوست کنید.',
    attachmentTypeFile: 'فایل',
    attachmentTypeImage: 'تصویر',
    attachmentTypeAudio: 'صوت',
    messageSentWithAttachments: 'همراه با {count} پیوست ارسال می‌شود: {names}',
    attachmentIgnored: 'این مدل نادیده می‌گیرد',
    unsupportedAttachmentsIgnored:
      '{count} پیوست به دلیل پشتیبانی نشدن نوع ورودی توسط مدل انتخاب‌شده نادیده گرفته می‌شود.',
    removeAttachment: 'حذف {name}',
    remove: 'حذف',
    presets: 'تنظیم‌های ذخیره‌شده',
    noLocalPresets: 'هنوز تنظیم محلی ندارید.',
    compare: 'مقایسه',
    exitCompare: 'خروج از مقایسه',
    compareUnavailable:
      'مقایسه برای حالت‌های چت و تصویر در دسترس است، به شرطی که مدل انتخاب‌شده قابلیت فعال را پشتیبانی کند.',
    stop: 'توقف',
    run: 'اجرا',
    rerun: 'اجرای دوباره',
    chat: 'چت',
    images: 'تصویر',
    imageGeneration: 'تولید تصویر',
    imageGenerationUnavailableReason: 'فراداده مدل انتخاب‌شده تولید تصویر را اعلام نکرده است.',
    audio: 'صوت',
    embeddings: 'بردارسازی',
    rawApi: 'API خام',
    compactConfigure: 'تنظیم',
    compactCode: 'کد',
    compactInspector: 'بازرسی',
    askAnything: 'هر چیزی بپرسید. پیوست‌ها و تنظیمات از پنل‌ها اعمال می‌شوند.',
    streamEvents: '{count} رویداد جریان',
    returningChatTitle: 'درخواست تازه‌ای آغاز کنید',
    returningChatDescription: 'هر زمان آماده بودید، درخواست خود را در کادر پیام پایین بنویسید.',
    firstRunConnectTitle: 'برای اجرای نخستین درخواست متصل شوید',
    firstRunConnectDescription: 'یک کلید موقت پیشخان بسازید یا اتصال دیگری را در راه‌اندازی تنظیم کنید.',
    firstRunPromptTitle: 'چه چیزی را می‌خواهید آزمایش کنید؟',
    firstRunPromptDescription: 'پرامپت خود را پایین بنویسید یا با یک نمونه آغاز کنید.',
    firstRunExamplesLabel: 'شروع با یک نمونه',
    firstRunGenerateDashboardKey: 'ساخت کلید پیشخان',
    firstRunGeneratingDashboardKey: 'در حال ساخت کلید پیشخان',
    firstRunRetry: 'تلاش دوباره برای ساخت کلید',
    firstRunPathConnect: 'اتصال',
    firstRunPathModel: 'مدل',
    firstRunPathModelHint: 'یک مدل انتخاب کنید',
    firstRunPathModelChange: 'تغییر مدل در کنترل‌ها',
    firstRunPathRun: 'اجرا',
    firstRunPathRunHint: 'یک پرامپت بفرستید یا یک نمونه انتخاب کنید',
    starterPrompts: 'پرامپت‌های آماده',
    starterSummarize: 'این یادداشت انتشار را برای تیم پشتیبانی فنی خلاصه کن.',
    starterStructuredOutput: 'یک آبجکت JSON با title، summary، risks و next_steps برگردان.',
    starterToolPlanning: 'ابزارها و پارامترهای لازم برای پاسخ به پرسش صورتحساب مشتری را برنامه‌ریزی کن.',
    imageStarterProduct: 'یک عکس محصول تمیز از خزانه شیشه‌ای توکن API روی میز سفید.',
    imageStarterDiagram: 'یک دیاگرام ایزومتریک شفاف از پرامپت کاربر، درگاه API، مدل و پاسخ.',
    imageStarterScene:
      'یک فضای کاری سینمایی که توسعه‌دهندگان خروجی دو مدل هوش مصنوعی را روی نمایشگرهای بزرگ مقایسه می‌کنند.',
    audioStarterSupport:
      'سلام، از تماس شما با پشتیبانی AvalAI سپاسگزاریم. می‌توانم برای چرخش کلید API راهنمایی‌تان کنم.',
    audioStarterProductUpdate:
      'Model Studio اکنون به شما کمک می‌کند پرامپت‌ها را آزمایش کنید، مدل‌ها را مقایسه کنید و کد خروجی بگیرید.',
    audioStarterNarration: 'در این راهنما، یک کلید API وصل می‌کنیم، مدل را انتخاب می‌کنیم و درخواست را اجرا می‌کنیم.',
    embeddingStarterSearch: 'ابزار جست‌وجوی وبی جستجو: بهترین روش‌های چرخش کلیدهای API در محیط استقرار',
    embeddingStarterClassification: 'این تیکت پشتیبانی را دسته‌بندی کن: مشتری کلید API تولیدشده را پیدا نمی‌کند.',
    embeddingStarterSimilarity: 'شباهت معنایی بین اختلاف فاکتور، پرسش صورتحساب و درخواست بازپرداخت را مقایسه کن.',
    streamingResponse: 'در حال دریافت پاسخ...',
    imagePrompt: 'پرامپت تصویر',
    imagePromptPlaceholder: 'تصویری را که می‌خواهید بسازید یا ویرایش کنید توصیف کنید.',
    generatedImageAltWithIndex: 'تصویر تولیدشده {index}',
    generatedCompareImageAlt: 'تصویر تولیدشده {index} از لاین {label}',
    downloadImageWithIndex: 'دانلود تصویر {index}',
    downloadCompareLaneImage: 'دانلود تصویر {index} از لاین {label}',
    downloadAudioOutput: 'دانلود صدای تولیدشده: {fileName}',
    imageOutput: 'خروجی تصویر',
    generatedImagesEmpty: 'تصاویر تولیدشده اینجا نمایش داده می‌شوند.',
    imageGenerationWaiting: 'در حال تولید تصاویر. این کار ممکن است کمی زمان ببرد.',
    generateImage: 'تولید تصویر',
    audioTask: 'وظیفه صوتی',
    speech: 'تبدیل متن به گفتار',
    transcription: 'رونویسی',
    translation: 'ترجمه',
    speechInputPlaceholder: 'متن موردنظر برای تبدیل به گفتار را وارد کنید.',
    audioContextPlaceholder: 'پرامپت یا زمینه اختیاری برای این صوت.',
    selectAudioFile: 'انتخاب فایل صوتی',
    removeAudioFile: 'حذف {name}',
    selectedAudioFileHelp: 'این فایل مستقیم از طریق SDK مرورگر OpenAI ارسال می‌شود.',
    audioFileRequiredHelp: 'برای رونویسی و ترجمه صوتی لازم است.',
    output: 'خروجی',
    audioOutputEmpty: 'رونوشت‌ها یا پاسخ‌های صوتی اینجا نمایش داده می‌شوند.',
    audioResponseReturned: 'پاسخ صوتی برگشت داده شد. پاسخ خام را در پنل کنترل‌ها ببینید.',
    runAudio: 'اجرای صوت',
    embeddingInput: 'ورودی بردارسازی',
    embeddingInputPlaceholder: 'متنی را برای بردارسازی وارد کنید.',
    vectorPreview: 'پیش‌نمایش بردار',
    vectorPreviewEmpty: 'اولین مقدارهای بردار اینجا نمایش داده می‌شوند.',
    createEmbedding: 'ساخت بردار',
    rawEndpoint: 'نقطه پایانی',
    rawEndpointPlaceholder: '/v1/responses',
    rawEndpointInvalid: 'یک مسیر نسبی API مانند /responses یا /chat/completions وارد کنید.',
    rawRequestSummary: 'نقطه پایانی درخواست کد تولیدشده را هدایت می‌کند',
    rawControlsNote:
      'نقطه پایانی API خام و JSON درخواست در بوم میانی ویرایش می‌شوند. قطعه‌کدهای زیر بر اساس همان درخواست ساخته می‌شوند.',
    formatJson: 'قالب‌بندی JSON',
    formatJsonRequiresJson: 'پیش از قالب‌بندی، JSON درخواست را وارد کنید.',
    formatJsonSchemaRequiresJson: 'پیش از قالب‌بندی، اسکیما JSON را وارد کنید.',
    formatFunctionParametersRequiresJson: 'پیش از قالب‌بندی، JSON پارامترهای تابع را وارد کنید.',
    rawRequestTemplates: 'قالب‌های درخواست',
    rawStarterResponses: 'Responses',
    rawStarterChat: 'Chat completions',
    rawStarterEmbeddings: 'Embeddings',
    rawStarterResponsesInput: 'یک به‌روزرسانی کوتاه محصول برای کاربران API بنویس.',
    rawStarterChatSystem: 'تو یک دستیار فنی مختصر و دقیق هستی.',
    rawStarterChatUser: 'توضیح بده چطور کلیدهای API را به‌صورت ایمن بچرخانیم.',
    rawStarterEmbeddingsInput: 'چک‌لیست چرخش کلید API برای سرویس‌های عملیاتی.',
    useStarterPrompt: 'استفاده از پرامپت آماده: {prompt}',
    useRequestTemplate: 'استفاده از قالب درخواست: {template}',
    requestJson: 'JSON درخواست',
    rawJsonPlaceholder: '{\'{"model":"gpt-6-luna","input":"Hello"}\'}',
    rawJsonInvalid: 'پیش از اجرای درخواست خام، یک آبجکت JSON معتبر وارد کنید.',
    jsonSchemaInvalid: 'برای اسکیما خروجی ساختاریافته، یک آبجکت JSON معتبر وارد کنید.',
    functionParametersInvalid: 'برای پارامترهای تابع، یک آبجکت JSON معتبر وارد کنید.',
    response: 'پاسخ',
    rawResponseEmpty: 'خروجی پاسخ خام اینجا نمایش داده می‌شود.',
    runRawRequest: 'اجرای درخواست خام',
    model: 'مدل',
    selectModel: 'انتخاب مدل',
    modelCapabilities: 'قابلیت‌های مدل',
    capabilitiesAvailable: '{count} در دسترس',
    vision: 'بینایی',
    tools: 'ابزارها',
    capabilityAvailable: '{label} در دسترس است',
    capabilityUnavailable: '{label} در دسترس نیست',
    unsupportedBySelectedModel: 'مدل انتخاب‌شده پشتیبانی نمی‌کند',
    capabilityUnavailableReason: 'فراداده مدل انتخاب‌شده این قابلیت را اعلام نکرده است.',
    visionUnavailableReason: 'نقطه پایانی تصویر یا بینایی اعلام نشده است.',
    parameters: 'پارامترها',
    temperature: 'دما',
    temp: 'دما',
    topP: 'Top P',
    max: 'حداکثر',
    maxOutput: 'حداکثر خروجی',
    reasoningEffort: 'سطح استدلال',
    verbosity: 'جزئیات پاسخ',
    serviceTier: 'سطح سرویس',
    none: 'هیچ‌کدام',
    minimal: 'حداقلی',
    low: 'کم',
    medium: 'متوسط',
    high: 'زیاد',
    xhigh: 'خیلی زیاد',
    auto: 'خودکار',
    default: 'پیش‌فرض',
    flex: 'انعطاف‌پذیر',
    priority: 'اولویت‌دار',
    text: 'متن',
    jsonMode: 'حالت JSON',
    jsonSchema: 'اسکیما JSON',
    structuredOutput: 'خروجی ساختاریافته',
    structuredOutputUnavailableReason: 'فراداده مدل انتخاب‌شده خروجی ساختاریافته را اعلام نکرده است.',
    systemMessages: 'پیام‌های سیستم',
    systemMessagesUnavailableReason: 'فراداده مدل انتخاب‌شده پیام‌های سیستم را اعلام نکرده است.',
    webSearch: 'جست‌وجوی وب',
    webSearchUnavailableReason: 'فراداده مدل انتخاب‌شده جست‌وجوی وب را اعلام نکرده است.',
    vectorStoreIds: 'شناسه‌های Vector Store',
    fileSearchUnavailableReason: 'فراداده مدل انتخاب‌شده جست‌وجوی فایل را اعلام نکرده است.',
    functionName: 'نام تابع',
    functionDescription: 'توضیح تابع',
    functionCallingUnavailableReason: 'فراداده مدل انتخاب‌شده فراخوانی تابع را اعلام نکرده است.',
    mcpServerLabel: 'نام سرور MCP',
    mcpServerUrl: 'نشانی سرور MCP',
    mcpApproval: 'تایید MCP',
    mcpApprovalAlways: 'همیشه تایید لازم است',
    mcpApprovalNever: 'تایید لازم نیست',
    mcpToolsUnavailableReason: 'فراداده مدل انتخاب‌شده پشتیبانی ابزار برای سرورهای MCP را اعلام نکرده است.',
    mcpServerInvalid: 'نام سرور MCP و یک نشانی معتبر HTTP(S) را وارد کنید.',
    modeSettings: 'تنظیمات حالت',
    modeNavigation: 'حالت‌های Model Studio',
    mode: 'حالت',
    imageSize: 'اندازه تصویر',
    quality: 'کیفیت',
    background: 'پس‌زمینه',
    transparent: 'شفاف',
    opaque: 'مات',
    voice: 'صدا',
    format: 'فرمت',
    dimensions: 'ابعاد',
    code: 'کد',
    codeLanguageNavigation: 'زبان‌های کد تولیدشده',
    codeContextMode: 'کد تولیدشده از تنظیمات فعلی {mode} پیروی می‌کند.',
    codeContextCompare: 'کد تولیدشده از لاین مقایسه فعال پیروی می‌کند: {lane}.',
    codeCapabilityWarning:
      'فراداده مدل انتخاب‌شده پشتیبانی از {mode} را نشان نمی‌دهد. پیش از استفاده از این کد، مدل یا حالت را تغییر دهید.',
    codeSampleInputNotice: 'تا وقتی ورودی را در بوم وارد کنید، این قطعه‌کدها از ورودی نمونه استفاده می‌کنند.',
    codeStatusModelMismatch: 'عدم تطابق مدل',
    codeStatusSampleInput: 'ورودی نمونه',
    copy: 'کپی',
    copySnippet: 'کپی قطعه کد {language}',
    codeActions: 'کارهای کد',
    codeModalHint: 'شماره خط‌ها در انتخاب شما نمی‌آیند: «انتخاب همه»، Ctrl/⌘+A یا سه‌بار کلیک، کد تمیز کپی می‌کند. Esc می‌بندد.',
    codeExpand: 'باز کردن کد {language} در اندازهٔ کامل',
    codeExpandShort: 'بزرگ‌نمایی',
    codeWrapLines: 'شکستن خط‌های بلند',
    codeUnwrapLines: 'برگرداندن خط‌ها',
    codeSelectAll: 'انتخاب همه',
    codeResizeHandle: 'برای تغییر ارتفاع ناحیهٔ کد بکشید (کلیدهای جهت‌دار کم‌وزیاد می‌کنند، Enter بازنشانی می‌کند)',
    copyMessage: 'کپی پیام',
    copyMessageWithContext: 'کپی پیام {role}: {preview}',
    copied: 'کپی شد',
    copyMessageFailed: 'امکان کپی پیام وجود ندارد. متن پیام انتخاب شده است تا بتوانید آن را دستی کپی کنید.',
    removeMessage: 'حذف پیام',
    removeMessageWithContext: 'حذف پیام {role}: {preview}',
    copyFailed: 'امکان کپی قطعه کد وجود ندارد. متن قطعه انتخاب شده است تا بتوانید آن را دستی کپی کنید.',
    download: 'دانلود',
    downloadSnippet: 'دانلود قطعه کد {language}',
    downloaded: 'دانلود قطعه کد شروع شد',
    downloadFailed: 'امکان دانلود قطعه کد وجود ندارد',
    lines: '{count} خط',
    inspector: 'بازرسی',
    inspectorEmpty: 'برای مشاهده پاسخ خام، یک درخواست اجرا کنید.',
    latency: 'تاخیر: {value} میلی‌ثانیه',
    latencyValue: '{value} میلی‌ثانیه',
    retryRun: 'تلاش دوباره',
    retryInSeconds: 'تلاش دوباره تا {seconds} ثانیه دیگر',
    retryWaitHint: 'ارائه‌دهنده خواسته است پیش از تلاش بعدی کمی صبر کنید.',
    autoRetryingIn: 'تلاش خودکار تا {seconds} ثانیه دیگر (تلاش {attempt})',
    stopAutoRetry: 'توقف',
    stopAutoRetryAction: 'توقف تلاش خودکار و نگه‌داشتن نتیجهٔ فعلی',
    retryNow: 'همین حالا تلاش کن',
    runPhasePreparing: 'در انتظار مدل · {elapsed}',
    runPhaseStreaming: 'در حال دریافت · {count} نویسه · {elapsed}',
    runStoppedAfter: 'شما پس از {count} نویسه اجرا را متوقف کردید؛ پاسخ ناتمام بالا نگه داشته شده است.',
    runStoppedBeforeOutput: 'پیش از پاسخ مدل متوقف شد.',
    parametersSummary: '{temperatureLabel}: {temperature} / {topPLabel}: {topP}',
    usage: 'مصرف: {value}',
    inspectorUsageTotal: 'کل توکن‌ها: {value}',
    inspectorUsageInput: 'توکن‌های ورودی: {value}',
    inspectorUsageOutput: 'توکن‌های خروجی: {value}',
    notRun: 'اجرا نشده',
    compareChatResponses: 'مقایسه پاسخ‌های چت',
    compareImageGenerations: 'مقایسه تولید تصویر',
    compareContextHelp:
      'لاین اصلی و جایگزین زمینه پرامپت مشترک دارند. یک لاین را انتخاب کنید تا کد تولیدشده از همان تنظیمات ساخته شود.',
    compareLaneCapabilityUnavailable: 'لاین {label} از مدل {model} استفاده می‌کند که این حالت را پشتیبانی نمی‌کند.',
    sharedChatPlaceholder: 'یک پیام چت مشترک برای هر دو لاین اضافه کنید.',
    messagesInContext: '{count} پیام در زمینه مشترک',
    addMessage: 'افزودن پیام',
    clearChat: 'پاک کردن چت',
    sharedImagePromptPlaceholder: 'پرامپت تصویر مشترک هر دو لاین را توصیف کنید.',
    primary: 'اصلی',
    variant: 'جایگزین',
    useForCode: 'استفاده برای کد',
    usingForCode: 'در کد استفاده می‌شود',
    useLaneForCode: 'استفاده از {label} برای کد',
    usingLaneForCode: '{label} در کد استفاده می‌شود',
    responseWillAppear: 'پاسخ اینجا نمایش داده می‌شود.',
    imageDataWillAppear: 'داده تصویر تولیدشده اینجا نمایش داده می‌شود.',
    runLane: 'اجرای {label}',
    runPrimary: 'اجرای اصلی',
    runVariant: 'اجرای جایگزین'
  },
  route: {
    projects: 'سازمان‌ها و پروژه‌ها',
    sponsorship: 'استارتاپ‌ها',
    sponsorship_home: 'نمای کلی',
    sponsorship_apply: 'درخواست حمایت استارتاپی',
    sponsorship_status: 'وضعیت عضویت',
    sponsorship_levels: 'سطح عضویت',
    'support_knowledge-base': 'پایگاه دانش',
    support: 'پشتیبانی',
    support_dashboard: 'داشبورد',
    'support_create-ticket': 'ایجاد تیکت',
    'support_my-tickets': 'تیکت‌های من',
    'support_all-tickets': 'همه تیکت‌ها',
    'support_ai-operations': 'عملیات هوش مصنوعی',
    agentOnlyBadge: 'پشتیبان',
    agentOnlyBadgeTooltip: 'فقط برای کارشناسان و مدیران پشتیبانی نمایش داده می‌شود',
    // "support_ticket-details": "جزئیات تیکت",
    models: 'مدل‌ها',
    'model-studio': 'استودیو مدل',
    'model-studio_overview': 'نمای کلی',
    'model-studio_playground': 'محیط آزمایش',
    'model-studio_prompts': 'پرامپت‌ها',
    'model-studio_workflows': 'گردش‌کارها',
    'model-studio_compare': 'مقایسه',
    'model-studio_requests': 'درخواست‌ها',
    'cost-tools': 'ابزارهای هزینه',
    'cost-tools_calculator': 'ماشین حساب',
    'cost-tools_tokenizer': 'توکن‌پرداز',
    calculator: 'ماشین حساب هزینه',
    tokenizer: 'توکن‌پرداز',
    // assistants: "دستیارها",
    // storage: "فضای ذخیره‌سازی",
    billing_addresses: 'آدرس‌ها',
    billing_history: 'تاریخچه',
    billing_invoices: 'صورتحساب‌ها',
    usage_reports: 'گزارش‌ها',
    usage_overview: 'نمایش',
    usage_recommendations: 'پیشنهادها',
    billing_credit: 'اعتبار',
    billing_packages: 'بسته‌ها',
    affiliate: 'کسب درآمد',
    usage: 'مصارف',
    limits: 'سطح دسترسی',
    billing: 'مالی',
    'api-keys': 'کلیدهای API',
    login: 'ورود',
    403: 'بدون اجازه',
    404: 'صفحه یافت نشد',
    500: 'خطای سرور',
    home: 'پیشخان',
    // docs: 'مستندات',
    // "docs_whats-new": "تازه‌های سیستم",
    // docs_vision: "بینایی ماشین",
    // "docs_text-to-speech": "تبدیل متن به گفتار",
    // "docs_text-generation": "تولید متن",
    // "docs_structured-outputs": "خروجی‌های ساختاریافته",
    // "docs_speech-to-text": "تبدیل گفتار به متن",
    // "docs_safety-best-practices": "بهترین شیوه‌های امنیتی",
    // docs_reasoning: "استدلال و منطق",
    // "docs_release-notes": "یادداشت‌های انتشار",
    // "docs_realtime-websocket": "یکپارچه‌سازی وب‌سوکت",
    // "docs_realtime-webrtc": "یکپارچه‌سازی WebRTC",
    // "docs_realtime-model-capabilities": "قابلیت‌های مدل بلادرنگ",
    // docs_realtime: "ویژگی‌های بلادرنگ",
    // "docs_rate-limits": "محدودیت‌های نرخ درخواست",
    // docs_quickstart: "راهنمای شروع سریع",
    // "docs_prompt-generation": "تولید پرامپت",
    // "docs_prompt-examples": "نمونه‌های پرامپت",
    // "docs_prompt-engineering": "مهندسی پرامپت",
    // "docs_prompt-caching": "کش‌کردن پرامپت",
    // "docs_production-best-practices": "بهترین شیوه‌های تولید",
    // "docs_predicted-outputs": "خروجی‌های پیش‌بینی شده",
    // docs_overview: "نمای کلی",
    // "docs_optimizing-llm-accuracy": "بهینه‌سازی دقت LLM",
    // docs_moderation: "نظارت بر محتوا",
    // docs_models: "مدل‌ها",
    // "docs_model-selection": "راهنمای انتخاب مدل",
    // docs_libraries: "کتابخانه‌ها و SDK‌ها",
    // "docs_latency-optimization": "بهینه‌سازی تاخیر",
    // "docs_image-generation": "تولید تصویر",
    // "docs_function-calling": "فراخوانی توابع",
    // "docs_fine-tuning": "تنظیم دقیق مدل‌ها",
    // docs_evals: "ارزیابی مدل‌ها",
    // "docs_error-codes": "کدهای خطا",
    // docs_distillation: "تقطیر مدل",
    // docs_embeddings: "جاسازی‌ها",
    // docs_deprecations: "اعلان‌های منسوخ شدگی",
    // "docs_deep-dive": "بررسی عمیق فنی",
    // docs_changelog: "تاریخچه تغییرات",
    // docs_batch: "پردازش دسته‌ای",
    // docs_assistant_usage: "راهنمای استفاده از دستیار",
    // docs_assistant_tools: "ابزارهای دستیار",
    // docs_assistant_quickstart: "شروع سریع دستیار",
    // "docs_audio-generation": "تولید صدا",
    // "docs_assistant_whats-new": "به‌روزرسانی‌های دستیار",
    // docs_assistant_overview: "نمای کلی دستیار",
    // docs_assistant_tools_overview: "نمای کلی ابزارها",
    // "docs_assistant_tools_function-calling": "ابزارهای فراخوانی توابع",
    // "docs_assistant_tools_file-search": "ابزارهای جستجوی فایل",
    // "docs_assistant_tools_code-interpreter": "مفسر کد",
    // docs_assistant_migration: "راهنمای مهاجرت دستیار",
    // docs_assistant: "دستیار هوش مصنوعی",
    // "docs_assistant_deep-dive": "جزئیات فنی دستیار",
    // "docs_advanced-usage": "استفاده پیشرفته",
    // "docs_actions_sending-files": "ارسال فایل با اکشن‌ها",
    // docs_actions_production: "اکشن‌ها در محیط استقرار",
    // docs_actions_introduction: "معرفی اکشن‌ها",
    // docs: "مستندات",
    // "docs_accuracy-optimization": "بهینه‌سازی دقت",
    // docs_actions: "اکشن‌ها",
    // "docs_actions_actions-library": "کتابخانه اکشن‌ها",
    // "docs_actions_data-retrieval": "اکشن‌های بازیابی داده",
    // docs_actions_authentication: "احراز هویت اکشن‌ها",
    // "docs_actions_getting-started": "شروع کار با اکشن‌ها",
    // 'user-center': 'مرکز کاربری',
    // about: 'درباره',
    // function: 'کارکرد سیستم',
    // function_tab: 'برگه',
    // 'function_multi-tab': 'برگه چندگانه',
    // 'function_hide-child': 'پنهان کردن فرزند',
    // 'function_hide-child_one': 'پنهان کردن فرزند',
    // 'function_hide-child_two': 'دو',
    // 'function_hide-child_three': 'سه',
    // function_request: 'درخواست',
    // 'function_toggle-auth': 'تغییر مجوز',
    // 'function_super-page': 'قابل مشاهده مدیر فوق العاده',
    // manage: 'مدیریت سیستم',
    // manage_user: 'مدیریت کاربر',
    // 'manage_user-detail': 'جزئیات کاربر',
    // manage_role: 'مدیریت نقش',
    // manage_menu: 'مدیریت منو',
    // 'multi-menu': 'منوی چندگانه',
    // 'multi-menu_first': 'منوی یک',
    // 'multi-menu_first_child': 'فرزند منوی یک',
    // 'multi-menu_second': 'منوی دو',
    // 'multi-menu_second_child': 'فرزند منوی دو',
    // 'multi-menu_second_child_home': 'خانه فرزند منوی دو',
    exception: 'استثنا',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500'
  },
  page: {
    login: {
      common: {
        // visitAsGuest: 'ورود بصورت مهمان',
        login: 'ورود به حساب کاربری',
        needLogin: 'برای دسترسی به این صفحه نیاز است ابتدا وارد شوید',
        continueAsGuest: 'ادامه به عنوان مهمان',
        loginBenefits: 'برای دسترسی کامل به داشبورد خود وارد شوید',
        unlockFeatures: 'با ورود به حساب کاربری دسترسی پیدا کنید:',
        grantHeroTitle: '{amount} تومان اعتبار رایگان دریافت کنید',
        grantHeroSubtitle:
          'ثبت‌نام کنید، اعتبار هدیه‌تان را بگیرید و همین حالا استفاده از API را شروع کنید. اعتبار به‌صورت خودکار به حساب شما اضافه می‌شود.',
        grantCtaPrimary: 'ثبت‌نام و دریافت اعتبار',
        grantEmailTopupNote:
          'قبلا با ایمیل ثبت‌نام کرده‌اید؟ با تایید شماره تلفن، {amount} تومان دیگر دریافت کنید تا مجموع اعتبار شما به {total} تومان برسد.',
        loginRequired: 'برای دسترسی کامل به داشبورد خود وارد شوید',
        loginOrRegister: 'ورود / ثبت نام',
        userNamePlaceholder: 'لطفا نام کاربری را وارد کنید',
        phonePlaceholder: 'لطفا شماره تلفن را وارد کنید',
        codePlaceholder: 'لطفا کد تایید را وارد کنید',
        passwordPlaceholder: 'لطفا رمز عبور را وارد کنید',
        confirmPasswordPlaceholder: 'لطفا رمز عبور را دوباره وارد کنید',
        codeLogin: 'ورود با کد تایید',
        confirm: 'تایید',
        back: 'بازگشت',
        validateSuccess: 'تایید موفق',
        loginSuccess: 'ورود موفقیت آمیز',
        welcomeBack: 'خوش آمدید, {userName} !',
        benefits: {
          'api-keys': {
            a: 'ایجاد و مدیریت کلیدهای API',
            b: 'نظارت بر استفاده و هزینه‌های API',
            c: 'تنظیم محدودیت‌های نرخ و مجوزها'
          },
          billing: {
            a: 'مشاهده تاریخچه تفصیلی صورتحساب',
            b: 'افزودن اعتبار به حساب کاربری',
            c: 'دانلود فاکتورها و رسیدها'
          },
          packages: {
            a: 'مشاهده و مدیریت بسته‌های اعتبار',
            b: 'خرید بسته‌های اعتباری جدید',
            c: 'مشاهده تاریخچه بسته‌های اعتباری خریداری شده'
          },
          home: {
            a: 'دسترسی به داشبورد شخصی‌سازی شده',
            b: 'مشاهده داده‌های استفاده در زمان واقعی',
            c: 'سفارشی‌سازی تنظیمات و ترجیحات'
          },
          models: {
            a: 'دسترسی به تمام مدل‌های موجود',
            b: 'مشاهده اطلاعات تفصیلی مدل‌ها',
            c: 'مقایسه قابلیت‌های مدل‌ها'
          },
          usage: {
            a: 'تجزیه و تحلیل تفصیلی استفاده',
            b: 'صادرات گزارش‌های استفاده',
            c: 'پیگیری هزینه‌ها در طول زمان'
          },
          affiliate: {
            a: 'کسب درآمد از طریق معرفی',
            b: 'مشاهده کاربران معرفی شده و درآمد',
            c: 'برداشت درآمدهای کسب شده'
          },
          support: {
            a: 'ایجاد و پیگیری تیکت‌های پشتیبانی خود',
            b: 'پاسخ به کارشناسان و دنبال کردن گفتگوها',
            c: 'دریافت پشتیبانی برای حساب کاربری'
          }
        }
      },
      pwdLogin: {
        title: 'ورود با رمز عبور',
        rememberMe: 'مرا به خاطر بسپار',
        forgetPassword: 'رمز عبور را فراموش کرده اید؟',
        register: 'ثبت نام',
        otherAccountLogin: 'ورود با حساب کاربری دیگر',
        otherLoginMode: 'حالت ورود دیگر',
        superAdmin: 'مدیر فوق العاده',
        admin: 'مدیر',
        user: 'کاربر'
      },
      codeLogin: {
        title: 'ورود با کد تایید',
        getCode: 'دریافت کد تایید',
        sendFailed: 'ارسال کد تایید با خطا مواجه شد، لطفا دوباره تلاش کنید',
        reGetCode: 'دریافت مجدد پس از {time} ثانیه',
        sendCodeSuccess: 'کد تایید با موفقیت ارسال شد',
        sendCodeSuccessViaFallback: 'کد تایید از طریق {provider} ارسال شد',
        imageCodePlaceholder: 'لطفا کد تایید تصویری را وارد کنید',
        codeNotValid: 'کد صحیح نیست و یا منقضی شده',
        phoneAlreadyAssociated: 'این شماره تلفن قبلا به حساب کاربری دیگری متصل شده است.',
        phoneAlreadyAssociatedHelp:
          'چنانچه مالک این شماره تلفن هستید، ابتدا حساب مرتبط با این شماره تلفن را از صفحه حذف حساب کاربری حذف نمایید تا شماره آزاد شود، سپس مجدد تلاش کنید.',
        deleteLinkedAccount: 'باز کردن صفحه حذف حساب کاربری',
        fallbackProvider: {
          bale: 'پیام رسان بله'
        },
        fallbackProviderLink: {
          bale: 'https://web.bale.ai/'
        },
        openFallbackProvider: 'باز کردن {provider}',
        fallbackOtpTitle: 'روش تایید جایگزین',
        fallbackOtpWhyTitle: 'چرا این را می‌بینم؟',
        fallbackOtpWhyDescription:
          'ما سعی کردیم کد تایید را از طریق پیامک برای شما ارسال کنیم، اما سرویس پیامک ما موقتا در دسترس نیست. برای اطمینان از اینکه همچنان می‌توانید به طور ایمن به حساب خود دسترسی داشته باشید، کد تایید شما را از طریق کانال جایگزین ارسال کرده‌ایم.',
        fallbackOtpSmsNotResponding:
          'سرویس پیامک در حال حاضر پاسخگو نیست. کد شما به صورت امن از طریق {provider} ارسال شده است.',
        fallbackOtpStep1: 'ما سعی کردیم پیامک ارسال کنیم اما سرویس در دسترس نبود',
        fallbackOtpStep2: 'کد تایید شما به صورت امن به {provider} ارسال شده است',
        fallbackOtpStep3: 'کدی که دریافت کرده‌اید را وارد کنید تا تایید کامل شود',
        fallbackOtpAlternativeTitle: 'ترجیح می‌دهید پیامک دریافت کنید؟',
        fallbackOtpAlternativeDescription:
          'اگر ترجیح می‌دهید کد تایید را از طریق پیامک دریافت کنید، می‌توانید چند دقیقه صبر کنید و دوباره امتحان کنید. سیستم ما همیشه ابتدا سعی می‌کند پیامک ارسال کند و سپس از روش‌های جایگزین استفاده می‌کند.',
        fallbackOtpRetryLater:
          'لطفا چند دقیقه صبر کنید و دوباره امتحان کنید. سرویس پیامک ممکن است به زودی در دسترس قرار گیرد.',
        fallbackOtpInfoButton: 'چرا این روش؟'
      },
      register: {
        title: 'ثبت نام',
        agreement: 'من خوانده ام و موافقت می کنم با',
        protocol: '《توافق نامه کاربر》',
        policy: '《سیاست حفظ حریم خصوصی》'
      },
      resetPwd: {
        title: 'بازنشانی رمز عبور'
      },
      bindWeChat: {
        title: 'پیوستن به WeChat'
      },
      guestMode: {
        message: 'شما به عنوان مهمان در حال مشاهده هستید. برای دسترسی کامل، لطفا وارد شوید.',
        timeRemaining: 'جلسه مهمان در {time} منقضی می‌شود',
        upgradePrompt: 'از پلتفرم لذت می‌برید؟ حساب کاربری بسازید تا پیشرفت خود را ذخیره کنید.'
      },
      benefits: {
        createApiKeys: '[REDACTED]',
        manageKeys: 'قابلیت‌های کامل مدیریت کلید',
        viewUsage: 'تحلیل‌های دقیق استفاده',
        viewBilling: 'دسترسی به تاریخچه صورتحساب',
        addCredits: 'افزودن اعتبار و مدیریت پرداخت‌ها',
        downloadInvoices: 'دانلود فاکتور و رسید',
        personalizedDashboard: 'تجربه داشبورد شخصی‌سازی شده',
        realTimeData: 'داده‌ها و اعلان‌های لحظه‌ای',
        customSettings: 'تنظیمات و ترجیحات سفارشی'
      }
    },
    about: {
      title: 'درباره',
      introduction:
        'Soybean Admin یک قالب مدیریتی زیبا و قدرتمند است که بر اساس آخرین تکنولوژی های فرانت اند ایجاد شده است، از جمله Vue3, Vite5, TypeScript, Pinia و UnoCSS. این قالب دارای پیکربندی تم غنی و اجزا ساخته شده است، مشخصات کد سختگیرانه، و سیستم مسیریابی فایل خودکار. علاوه بر این، از راه حل داده های mock آنلاین بر اساس ApiFox استفاده می کند. Soybean Admin یک راه حل مدیریتی یکپارچه برای شما فراهم می کند، بدون هیچ پیکربندی اضافی، و آماده برای استفاده. همچنین این یک روش بهترین عملکرد برای یادگیری سریع تکنولوژی های جدید است.',
      projectInfo: {
        title: 'اطلاعات پروژه',
        version: 'نسخه',
        latestBuildTime: 'آخرین زمان ساخت',
        githubLink: 'لینک Github',
        previewLink: 'لینک پیش نمایش'
      },
      prdDep: 'وابستگی تولید',
      devDep: 'وابستگی توسعه'
    },
    home: {
      offer1: '۳۵۰ میلیون تومان',
      offer2: '۵۵۰ میلیون تومان',
      offer3: '۱ میلیارد تومان',
      offer1Benefit: '۵۰ میلیون تومان',
      offer2Benefit: '۱۰۰ میلیون تومان',
      offer3Benefit: '۲۰۰ میلیون تومان',
      specialOffer: 'پیشنهاد ویژه: اعتبار رایگان تا ۲۰۰ میلیون تومان!',
      inChargeMoreGetMore:
        'با شارژ حساب خود، اعتبار رایگان دریافت کنید. هر چه بیشتر شارژ کنید، اعتبار بیشتری می‌گیرید!',
      offerExpiresIn: 'این پیشنهاد تا ۳۱ شهریور معتبر است. اعتبار دریافتی تا ۶۰ روز قابل استفاده می‌باشد.',
      shortDesc1: 'پلتفرم AvalAI ارائه‌دهنده API مدل‌های هوش مصنوعی',
      // desc1Title: 'دسترسی راحت',
      desc1:
        'با ایجاد تنها یک حساب کاربری توسعه‌دهنده در پلتفرم هوش مصنوعی AvalAI، به دنیایی از امکانات بی‌پایان و دسترسی نامحدود به تمامی خدمات پیشرو هوش مصنوعی از جمله OpenAI، Anthropic، Meta، Mistral AI، Cohere، Google (Gemini) و Deepseek بر اساس تعرفه‌های رسمی ارائه‌دهندگان دست خواهید یافت.',
      desc2:
        'دسترسی آسان به AvalAI، بدون مواجهه با محدودیت‌های ناخواسته مانند محدودیت‌های جغرافیایی، پرداخت‌های امن ریالی بدون کارمزد اضافی، فعال‌سازی فوری حساب‌های کاربری، و پایداری حداکثری زیرساخت‌های ما، همگی تضمین‌کننده تجربه‌ای لذت‌بخش برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها می‌باشد. با استفاده از پلتفرم هوش مصنوعی AvalAI، شما به راحتی می‌توانید از قابلیت‌های برترین مدل‌های هوش مصنوعی برای رشد و توسعه پروژه‌ها و ایده‌های خود بهره‌مند شوید.',
      desc3:
        'ما در AvalAI به ارائه تجربه‌ای لذت‌ بخش و کارآمد برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها متعهد هستیم. از قابلیت‌های بی نظیر AI برای ارتقای پروژه‌ها و ایده‌های خود به سطوح جدید استفاده کنید. به جمع ما در AvalAI بپیوندید و از همین امروز آینده را شکل دهید.',
      greeting: 'خوش آمدید',
      weatherDesc: 'امروز ابری تا صاف است, 20℃ - 25℃!',
      projectCount: 'تعداد پروژه',
      todo: 'کار های برنامه ریزی شده',
      message: 'پیام',
      downloadCount: 'تعداد دانلود',
      registerCount: 'تعداد ثبت نام',
      schedule: 'برنامه کار و استراحت',
      study: 'مطالعه',
      work: 'کار',
      rest: 'استراحت',
      entertainment: 'سرگرمی',
      visitCount: 'تعداد بازدید',
      turnover: 'دوران سرمایه',
      dealCount: 'تعداد معاملات',
      projectNews: {
        title: 'اخبار پروژه',
        moreNews: 'اخبار بیشتر',
        desc1: 'Soybean در 28 می 2021 پروژه متن باز soybean-admin را ایجاد کرد!',
        desc2: 'یانبوو یک باگ به soybean-admin ارسال کرد، نوار multi-tab تنظیم نمی شود.',
        desc3: 'Soybean در حال آماده سازی کافی برای انتشار soybean-admin است!',
        desc4: 'Soybean در حال نوشتن مستندات پروژه برای soybean-admin است!',
        desc5: 'Soybean فقط برخی از صفحات کارگاه را به صورت تصادفی نوشت، و این کافی بود تا ببیند!'
      },
      creativity: 'خلاقیت',
      dashboard: {
        tagline: 'موجودی، مصرف و مدل‌های شما در یک نگاه.',
        greeting_morning: 'صبح بخیر',
        greeting_afternoon: 'ظهر بخیر',
        greeting_evening: 'عصر بخیر',
        greeting_night: 'خوش برگشتید',
        unavailable: '—',
        of: 'از',
        days: 'روز',
        lessThanADay: 'کمتر از یک روز',
        availableBalance: 'مجموع اعتبار قابل استفاده',
        availableBalance_hint: 'کیف پول شما دو نوع اعتبار دارد: اعتبار واحدی (بر پایه تتر) و اعتبار تومانی. این عدد مجموع هر دو بر حسب واحد اعتبار است: اعتبار واحدی، به‌علاوه اعتبار تومانی تقسیم بر نرخ تبدیل امروز.',
        availableBalance_hint2: 'هزینه هر درخواست بر حسب واحد اعتبار محاسبه و از همین مجموع کسر می‌شود؛ بنابراین همین عدد است که تعیین می‌کند درخواست شما پذیرفته شود یا نه. با تغییر نرخ تبدیل، معادل واحدیِ بخش تومانی هم تغییر می‌کند.',
        unitEquivalent: 'معادل واحد اعتبار',
        balanceUnavailable: 'دریافت موجودی با خطا مواجه شد. برای تلاش دوباره، تازه‌سازی کنید.',
        tomanCredit: 'اعتبار تومانی',
        unitCredit: 'اعتبار واحدی',
        unitCredit_hint: 'اعتبار واحدی بر پایه تتر (USDT) است و با تغییر نرخ دلار کم و زیاد نمی‌شود. اعتبار تومانی کنار آن با معادل واحدی‌اش به نرخ امروز نشان داده می‌شود تا این دو با هم مقایسه‌پذیر باشند.',
        approxInUnits: 'واحد اعتبار',
        rateLine: 'نرخ تبدیل امروز',
        oneUnitEquals: 'هر واحد اعتبار =',
        convertCredit: 'تبدیل اعتبار',
        convertCredit_hint: 'در صفحه اعتبار می‌توانید اعتبار خود را بین تومان و واحد اعتبار جابه‌جا کنید. کارمزد تبدیل پیش از تایید نمایش داده می‌شود؛ مجموع بالا با نرخ خالص و بدون کارمزد محاسبه شده است.',
        walletInconsistent: 'مجموع اعلام‌شده با جمع دو نوع اعتبار برابر نیست. مقدار اعلام‌شده توسط سرویس نمایش داده می‌شود.',
        balanceNegative: 'موجودی منفی است.',
        balanceNegativeHint: 'چند درخواست هم‌زمان بیش از موجودی برداشت کرده‌اند. برای فعال شدن دوباره سرویس، اعتبار خود را افزایش دهید.',
        runway: 'دوام موجودی',
        runwayHint: 'با سرعت مصرف',
        runsOutAround: 'حدودا تا',
        runwayMeasuredOver: 'بر اساس',
        hoursOfData: 'ساعت مصرف ثبت‌شده',
        balanceEmpty: 'موجودی شما صفر است.',
        balanceEmptyHint: 'تا زمان افزایش اعتبار، درخواست‌ها پذیرفته نمی‌شوند.',
        noRecentSpend: 'در این بازه مصرفی نداشته‌اید',
        noRecentSpendHint: 'با ثبت مصرف، برآورد دوام موجودی نمایش داده می‌شود.',
        unitPerDay: 'واحد در روز',
        viewRateLimits: 'محدودیت‌ها',
        usageTitle: 'مصرف',
        period_24h: '۲۴ ساعت',
        period_7d: '۷ روز',
        period_28d: '۲۸ روز',
        requests: 'درخواست‌ها',
        requestsShort: 'درخواست',
        tokens: 'توکن‌ها',
        spendUnit: 'هزینه',
        spendUnitNote: 'هزینه و هزینه هر درخواست بر حسب',
        costPerRequest: 'هزینه هر درخواست',
        cacheHit: 'نرخ کش',
        modelsUsed: 'مدل‌های استفاده‌شده',
        costPerKTokens: 'هزینه هر ۱هزار توکن',
        tokensPerRequest: 'توکن در هر درخواست',
        outputRatio: 'نسبت خروجی به ورودی',
        requests_hint: 'تعداد فراخوانی‌های API در این بازه. نشانگر، نیمه دوم بازه را با نیمه اول مقایسه می‌کند.',
        tokens_hint: 'مجموع توکن‌های ورودی و خروجی محاسبه‌شده در این بازه، شامل توکن‌های کش‌شده ورودی.',
        spendUnit_hint: 'مجموع هزینه بر حسب واحد در این بازه. نشانگر، نیمه دوم را با نیمه اول مقایسه می‌کند و افزایش را برجسته می‌کند.',
        costPerKTokens_hint: 'میانگین هزینه به واحد برای هر ۱٬۰۰۰ توکن. با استفاده از مدل‌های ارزان‌تر یا نرخ کش بالاتر کاهش می‌یابد.',
        costPerRequest_hint: 'میانگین هزینه یک فراخوانی API به واحد. برای قیمت‌گذاری قابلیت‌هایی که با یک فراخوانی متناظرند مفید است.',
        tokensPerRequest_hint: 'میانگین اندازه ورودی و خروجی هر فراخوانی. اعداد بزرگ معمولا نشانه کانتکست طولانی یا تاریخچه هرس‌نشده است.',
        cacheHit_hint: 'سهم توکن‌های ورودی که از کش ارائه‌دهنده پاسخ گرفته‌اند. توکن‌های کش‌شده با تخفیف محاسبه می‌شوند؛ نرخ بالاتر یعنی هزینه کمتر برای هر ۱هزار توکن.',
        outputRatio_hint: 'توکن‌های خروجی نسبت به ورودی. کمتر از ۱۰۰٪ یعنی بیشتر می‌فرستید تا دریافت کنید؛ برای RAG و کانتکست طولانی طبیعی است.',
        tokenComposition: 'توکن‌ها کجا مصرف شدند',
        tokenComposition_hint: 'توکن‌های ورودی به کش‌شده و تازه، و توکن‌های خروجی به استدلال پنهان و خروجی قابل‌مشاهده تقسیم شده‌اند. سهم‌ها نسبت به مجموع کل است.',
        promptTokens: 'ورودی',
        outputTokens: 'خروجی',
        seg_cached: 'ورودی کش‌شده',
        seg_uncached: 'ورودی تازه',
        seg_reasoning: 'استدلال',
        seg_nonReasoning: 'خروجی قابل‌مشاهده',
        servedFromCache: 'از کش پاسخ گرفته',
        savedByCache: 'صرفه‌جویی با کش',
        cacheSavingsLabel: 'کش پرامپت',
        cacheHeadroom: 'بیشتر اگر همه پرامپت‌ها از کش می‌آمدند',
        cacheDetailUnavailable: 'برای این بازه جزئیات کش گزارش نشده است.',
        spentOnReasoning: 'صرف استدلال شده',
        noReasoningTokens: 'در این بازه توکن استدلالی مصرف نشده است.',
        noTokensInPeriod: 'در این بازه توکنی محاسبه نشده است.',
        busiestInterval: 'پرترافیک‌ترین بازه',
        providers: 'ارائه‌دهندگان بر اساس درخواست',
        perModel: 'به تفکیک مدل',
        perModel_hint: 'مدل‌ها بر اساس معیار انتخابی رتبه‌بندی شده‌اند. هزینه هر ۱هزار توکن و توکن در هر درخواست از مجموع بازه برای هر مدل محاسبه می‌شود.',
        rank_cost: 'هزینه',
        rank_requests: 'درخواست',
        rank_tokens: 'توکن',
        model: 'مدل',
        share: 'سهم',
        costPerKTokensShort: 'واحد / ۱هزار توکن',
        tokensPerRequestShort: 'توکن / درخواست',
        tokPerReq: 'توکن/درخواست',
        perKTokens: 'به ازای ۱هزار توکن',
        estimateCosts: 'برآورد هزینه',
        timelineTitle: 'درخواست‌ها و هزینه در طول زمان',
        updatedAt: 'به‌روزرسانی',
        rankBy: 'رتبه‌بندی مدل‌ها بر اساس',
        openInUsage: 'مشاهده در جزئیات مصرف',
        insight_topModel_a: 'بیشترین هزینه شما مربوط به',
        insight_topModel_b: 'با',
        insight_topModel_c: 'از کل است.',
        insight_halfSpend_a: 'نصف هزینه در',
        insight_halfSpend_b: 'مدل متمرکز است.',
        deltaHint: 'مقایسه نیمه دوم بازه با نیمه اول',
        timelineAria: 'درخواست‌ها و هزینه در طول زمان',
        noDataForBucket: 'برای این بازه داده‌ای ثبت نشده است',
        noUsageInPeriod: 'در این بازه درخواستی ثبت نشده است',
        noUsageInPeriodHint: 'بازه طولانی‌تری را انتخاب کنید یا یک درخواست بفرستید تا همین‌جا نمایش داده شود.',
        spendByModel: 'هزینه به تفکیک مدل',
        allModels: 'همه مدل‌ها',
        otherModels: 'مدل‌های دیگر:',
        noModelsYet: 'در این بازه از هیچ مدلی استفاده نشده است.',
        browseModels: 'مشاهده مدل‌ها',
        openUsage: 'جزئیات مصرف',
        downloadReport: 'گزارش‌ها',
        creditSources: 'منابع اعتبار',
        generalBalance: 'موجودی عمومی',
        sourceType_balance: 'موجودی',
        sourceType_package: 'بسته',
        sourceType_grant: 'اعتبار هدیه',
        remainingShort: 'باقی‌مانده',
        daysLeft: 'روز باقی‌مانده',
        expiresIn: 'انقضا در',
        inactiveSources: 'منبع منقضی یا تمام‌شده نمایش داده نمی‌شود.',
        noActiveSources: 'در حال حاضر بسته یا اعتبار هدیه فعالی ندارید.',
        browsePackages: 'مشاهده بسته‌ها',
        sourcesUnavailable: 'منابع اعتبار بارگذاری نشد.',
        recentTopUps: 'شارژهای اخیر',
        noTopUpsYet: 'هنوز پرداختی انجام نشده است.',
        getStarted: 'شروع کنید',
        stepsDone: 'مرحله انجام شده',
        step_topUp_title: 'موجودی حساب را افزایش دهید',
        step_topUp_body: 'هزینه درخواست‌ها بر اساس توکن از موجودی شما کسر می‌شود. برای شروع هر مقداری کافی است.',
        step_topUp_cta: 'افزایش موجودی',
        step_createKey_title: 'یک کلید API بسازید',
        step_createKey_body: 'کلیدها درخواست‌های شما را احراز هویت می‌کنند. می‌توانید هر کلید را به مدل‌ها، IPها و بودجه مشخصی محدود کنید.',
        step_createKey_cta: 'ساخت کلید',
        step_firstRequest_title: 'اولین درخواست را بفرستید',
        step_firstRequest_body: 'در هر SDK سازگار با OpenAI مقدار base_url را روی https://api.avalai.ir/v1 بگذارید و از کلید خود استفاده کنید.',
        step_firstRequest_cta: 'انتخاب مدل',
        action_apiKeys: 'ساخت و مدیریت کلیدها',
        action_models: 'فهرست مدل‌ها و قیمت‌ها',
        action_limits: 'سطح شما و محدودیت هر مدل',
        action_usage: 'تحلیل دقیق و گزارش‌ها',
        action_calculator: 'برآورد هزینه پیش از فراخوانی',
        action_history: 'پرداخت‌ها و فاکتورها',
        guest_title: 'یک کلید برای همه مدل‌های مهم هوش مصنوعی',
        guest_body: 'برای مشاهده موجودی، مصرف و مدل‌ها وارد شوید. حساب‌های جدید یک سطح رایگان برای آزمایش API دارند.',
        noAccess_title: 'حساب شما هنوز برای API فعال نشده است',
        noAccess_body: 'دسترسی API پس از تأیید حساب فعال می‌شود. در مستندات، امکانات هر سطح توضیح داده شده است.',
        guest_point_models: 'OpenAI، Anthropic، Google، DeepSeek و بیشتر، پشت یک نقطه اتصال',
        guest_point_billing: 'پرداخت به تومان با نرخ منتشرشده مدل، شامل کارمزد پردازش صورتحساب قابل اعمال',
        guest_point_usage: 'تحلیل مصرف، کش و هزینه به تفکیک مدل',
        guest_signIn: 'ورود'
      }
    },
    function: {
      tab: {
        tabOperate: {
          title: 'عملکرد برگه',
          addTab: 'افزودن برگه',
          addTabDesc: 'به صفحه درباره',
          closeTab: 'بستن برگه',
          closeCurrentTab: 'بستن برگه فعلی',
          closeAboutTab: '',
          addMultiTab: 'افزودن برگه چندگانه',
          addMultiTabDesc1: 'به صفحه MultiTab',
          addMultiTabDesc2: 'به صفحه MultiTab (با پارامترهای query)'
        },
        tabTitle: {
          title: 'عنوان برگه',
          changeTitle: 'تغییر عنوان',
          change: 'تغییر',
          resetTitle: 'بازنشانی عنوان',
          reset: 'بازنشانی'
        }
      },
      multiTab: {
        routeParam: 'پارامتر مسیر',
        backTab: 'برگشت به function_tab'
      },
      toggleAuth: {
        toggleAccount: 'تغییر حساب',
        authHook: 'کارکرد مجوز hasAuth',
        superAdminVisible: 'قابل مشاهده مدیر فوق العاده',
        adminVisible: 'قابل مشاهده مدیر',
        adminOrUserVisible: 'قابل مشاهده مدیر و کاربر'
      }
    },
    manage: {
      common: {
        status: {
          enable: 'فعال کردن',
          disable: 'غیر فعال کردن'
        }
      },
      role: {
        title: 'لیست نقش ها',
        roleName: 'نام نقش',
        roleCode: 'کد نقش',
        roleStatus: 'وضعیت نقش',
        roleDesc: 'توضیحات نقش',
        menuAuth: 'مجوز منو',
        buttonAuth: 'مجوز دکمه',
        form: {
          roleName: 'لطفا نام نقش را وارد کنید',
          roleCode: 'لطفا کد نقش را وارد کنید',
          roleStatus: 'لطفا وضعیت نقش را انتخاب کنید',
          roleDesc: 'لطفا توضیحات نقش را وارد کنید'
        },
        addRole: 'اضافه کردن نقش',
        editRole: 'ویرایش نقش'
      },
      user: {
        title: 'لیست کاربران',
        userName: 'نام کاربری',
        userGender: 'جنسیت',
        nickName: 'نام مستعار',
        userPhone: 'شماره تلفن',
        userEmail: 'ایمیل',
        userStatus: 'وضعیت کاربر',
        userRole: 'نقش کاربر',
        form: {
          userName: 'لطفا نام کاربری را وارد کنید',
          userGender: 'لطفا جنسیت را انتخاب کنید',
          nickName: 'لطفا نام مستعار را وارد کنید',
          userPhone: 'لطفا شماره تلفن را وارد کنید',
          userEmail: 'لطفا ایمیل را وارد کنید',
          userStatus: 'لطفا وضعیت کاربر را انتخاب کنید',
          userRole: 'لطفا نقش کاربر را انتخاب کنید'
        },
        addUser: 'اضافه کردن کاربر',
        editUser: 'ویرایش کاربر',
        gender: {
          male: 'مرد',
          female: 'زن'
        }
      },
      menu: {
        home: 'خانه',
        title: 'لیست منو',
        id: 'شناسه',
        parentId: 'شناسه والد',
        menuType: 'نوع منو',
        menuName: 'نام منو',
        routeName: 'نام مسیر',
        routePath: 'مسیر',
        routeParams: 'پارامترهای مسیر',
        layout: 'کامپوننت چیدمان',
        page: 'کامپوننت صفحه',
        i18nKey: 'کلید بین المللی',
        icon: 'آیکون',
        localIcon: 'آیکون محلی',
        iconTypeTitle: 'نوع آیکون',
        order: 'ترتیب',
        keepAlive: 'نگه داشتن زنده',
        href: 'آدرس اینترنتی',
        hideInMenu: 'مخفی کردن در منو',
        activeMenu: 'منوی فعال',
        multiTab: 'برگه های چندگانه',
        fixedIndexInTab: 'شاخص ثابت در برگه',
        button: 'دکمه',
        buttonCode: 'کد دکمه',
        buttonDesc: 'توضیح دکمه',
        menuStatus: 'وضعیت منو',
        form: {
          home: 'لطفا خانه را انتخاب کنید',
          menuType: 'لطفا نوع منو را انتخاب کنید',
          menuName: 'لطفا نام منو را وارد کنید',
          routeName: 'لطفا نام مسیر را وارد کنید',
          routePath: 'لطفا مسیر را وارد کنید',
          page: 'لطفا کامپوننت صفحه را انتخاب کنید',
          layout: 'لطفا کامپوننت چیدمان را انتخاب کنید',
          i18nKey: 'لطفا کلید بین المللی را وارد کنید',
          icon: 'لطفا نام آیکون را وارد کنید',
          localIcon: 'لطفا نام آیکون محلی را وارد کنید',
          order: 'لطفا ترتیب را وارد کنید',
          keepAlive: 'لطفا انتخاب کنید که آیا مسیر کش شود یا خیر',
          href: 'لطفا آدرس اینترنتی را وارد کنید',
          hideInMenu: 'لطفا انتخاب کنید که آیا منو مخفی شود یا خیر',
          activeMenu: 'لطفا نام مسیر منوی برجسته را وارد کنید',
          multiTab: 'لطفا انتخاب کنید که آیا پشتیبانی از برگه های چندگانه انجام شود یا خیر',
          fixedInTab: 'لطفا انتخاب کنید که آیا در برگه ثابت شود یا خیر',
          fixedIndexInTab: 'لطفا شاخص ثابت در برگه را وارد کنید',
          button: 'لطفا انتخاب کنید که آیا این یک دکمه است یا خیر',
          buttonCode: 'لطفا کد دکمه را وارد کنید',
          buttonDesc: 'لطفا توضیح دکمه را وارد کنید',
          menuStatus: 'لطفا وضعیت منو را انتخاب کنید'
        },
        addMenu: 'اضافه کردن منو',
        editMenu: 'ویرایش منو',
        addChildMenu: 'اضافه کردن زیرمنو',
        type: {
          directory: 'دایرکتوری',
          menu: 'منو'
        },
        iconType: {
          iconify: 'آیکون Iconify',
          local: 'آیکون محلی'
        }
      }
    }
  },
  form: {
    required: 'نمی تواند خالی باشد',
    userName: {
      required: 'لطفا نام کاربری را وارد کنید',
      invalid: 'فرمت نام کاربری اشتباه است'
    },
    phone: {
      required: 'لطفا شماره تلفن را وارد کنید',
      invalid: 'فرمت شماره تلفن اشتباه است'
    },
    pwd: {
      required: 'لطفا رمز عبور را وارد کنید',
      invalid: '6-18 کاراکتر، شامل حروف، اعداد، و خط زیر'
    },
    confirmPwd: {
      required: 'لطفا رمز عبور را دوباره وارد کنید',
      invalid: 'دو رمز عبور یکسان نیستند'
    },
    code: {
      required: 'لطفا کد تایید را وارد کنید',
      invalid: 'فرمت کد تایید اشتباه است'
    },
    email: {
      required: 'لطفا ایمیل را وارد کنید',
      invalid: 'فرمت ایمیل اشتباه است'
    }
  },
  dropdown: {
    closeCurrent: 'بستن فعلی',
    closeOther: 'بستن بقیه',
    closeLeft: 'بستن چپ',
    closeRight: 'بستن راست',
    closeAll: 'بستن همه'
  },
  icon: {
    themeConfig: 'پیکربندی تم',
    themeSchema: 'طرح تم',
    lang: 'تغییر زبان',
    fullscreen: 'تمام صفحه',
    fullscreenExit: 'خروج از حالت تمام صفحه',
    reload: 'بارگذاری مجدد صفحه',
    collapse: 'بستن منو',
    expand: 'باز کردن منو',
    pin: 'سنجاق',
    unpin: 'برداشتن سنجاق'
  },
  storage: {
    uploadModalTitle: 'بارگذاری فایل',
    fileSelected: 'فایل انتخاب شد',
    uploadFilePlaceholder: 'یک فایل بارگذاری کنید یا اینجا بکشید و رها کنید',
    fileNameLabel: 'نام',
    fileNameDescription: 'نام فایل بارگذاری شده',
    fileNamePlaceholder: 'نام فایل را وارد کنید',
    purposeLabel: 'هدف',
    purposeDescription: 'هدف از بارگذاری فایل',
    purposePlaceholder: 'انتخاب هدف',
    learnMoreLink: 'درباره اهداف فایل بیشتر بدانید',
    searchFilesPlaceholder: 'جستجوی فایل‌ها ...',
    invalidFileType: 'نوع فایل برای {purpose} نامعتبر است',
    supportedFormatsAssistants: 'فرمت‌های پشتیبانی‌شده: {formats}',
    supportedFormatsVision: 'فرمت‌های پشتیبانی‌شده: {formats}',
    supportedFormatsJsonl: 'فقط فایل‌های .jsonl پشتیبانی می‌شوند.',
    fileNotFound: 'فایل پیدا نشد.',
    fileUploadedButNotListed: 'فایل بارگذاری شد، اما هنوز در لیست نمایش داده نمی‌شود.',
    fileUploadedAndListed: 'فایل بارگذاری شد و در لیست تایید شد.',
    downloadStarting: 'شروع دانلود...',
    downloading: 'در حال دانلود...',
    downloadComplete: 'دانلود کامل شد.',
    downloadError: 'خطا در دانلود فایل.',
    file: 'فایل',
    status: 'وضعیت',
    fileId: 'شناسه فایل',
    purpose: 'هدف',
    size: 'اندازه',
    createdAt: 'تاریخ ایجاد',
    download: 'دانلود',
    delete: 'حذف',
    deleteConfirm: 'آیا مطمئن هستید که می‌خواهید این فایل را حذف کنید؟',
    selectFile: 'برای مشاهده جزئیات، یک فایل را انتخاب کنید.',
    files: 'فایل‌ها',
    vectorStores: 'مخازن برداری',
    upload: 'بارگذاری',
    noFiles: 'هنوز فایلی بارگذاری نشده است.',
    noVectorStores: 'هنوز مخزن برداری ایجاد نشده است.',
    selectItem: 'برای مشاهده جزئیات، یک مورد را انتخاب کنید.',
    uploadSuccess: 'فایل با موفقیت بارگذاری شد',
    uploadError: 'بارگذاری فایل با خطا مواجه شد',
    fileDeleted: 'فایل با موفقیت حذف شد',
    deleteError: 'حذف فایل با خطا مواجه شد',
    fetchError: 'دریافت اطلاعات با خطا مواجه شد'
  },
  assistants: {
    vectorStore: 'Vector Store',
    noAssistants: 'No assistants found',
    createAssistantGetStarted: 'Create an assistant to get started with Assistants API.',
    defineResponseSchema: 'Define Response Schema',
    responseSchemaDescription: "Define the JSON schema for the assistant's responses",
    enterVectorStoreId: 'Enter vector store Id',
    selectExisting: 'Select Existing',
    uploadNew: 'Upload New',
    uploadFile: 'Upload File',
    generate: 'Generate',
    examples: 'Examples',
    getStockPrice: 'Get Stock Price',
    weatherForecast: 'Weather Forecast',
    calculator: 'Calculator',
    functions: 'Functions',
    addFunction: 'Add Function',
    editFunction: 'Edit Function',
    removeFunction: 'Remove Function',
    functionName: 'Function Name',
    functionDescription:
      'Define a function that the assistant can call. The function should be defined using JSON Schema format.',
    functionDefinitionPlaceholder: '    Enter function definition in JSON Schema format...',
    definition: 'Function Definition',
    strictMode: 'Strict Mode',
    strictModeHelp:
      'When enabled, the assistant will only call functions exactly as defined. Disable for more flexible function calling.',
    invalidDefinition: 'Invalid function definition. Please check the JSON Schema format.',
    duplicateFunctionName: 'A function with this name already exists.',
    functionRequired: 'Function definition is required',
    generateFunction: 'Generate Function',
    exampleFunctions: 'Example Functions',
    functionSaved: 'Function saved successfully',
    functionRemoved: 'Function removed successfully',
    functionValidationError: 'Function validation failed. Please check the definition.',
    learnMoreFunctions: 'Learn more about function definitions',
    modelRequired: 'Model is required',
    responseFormatRequired: 'Response format is required',
    temperatureInvalid: 'Temperature must be between 0 and 2',
    topPInvalid: 'Top P must be between 0 and 1',
    maxResultsInvalid: 'Max results must be within the allowed range',
    title: 'Assistants',
    selectToView: 'Select an assistant to view details',
    createNew: 'Create New Assistant',
    name: 'Name',
    namePlaceholder: 'Enter a user friendly name',
    nameRequired: 'Name is required',
    instructions: 'Instructions',
    instructionsPlaceholder: 'You are a helpful assistant...',
    instructionsRequired: 'Instructions are required',
    model: 'Model',
    tools: 'Tools',
    fileSearch: 'File Search',
    codeInterpreter: 'Code Interpreter',
    addFiles: 'Add Files',
    selectVectorStore: 'Select Vector Store',
    modelConfig: 'Model Configuration',
    responseFormat: 'Response Format',
    temperature: 'Temperature',
    topP: 'Top P',
    maxResults: 'Max Results',
    maxResultsHelp: 'Maximum number of results to return from file search',
    create: 'Create',
    attachFiles: 'Attach Files to File Search',
    attachVectorStore: 'Attach Vector Store',
    dragFilesHere: 'Drag your files here',
    clickToUpload: 'Click to Upload',
    fileUploadHelp: 'Files will be processed and made available for the assistant to search through',
    vectorStoreHelp: 'Select an existing vector store to allow the assistant to search through its contents',
    searchVectorStores: 'Search vector stores...',
    noVectorStoresFound: 'No vector stores found',
    vectorStoreSearchPlaceholder: 'Enter vector store id',
    attach: 'Attach',
    back: 'Back',
    learnMore: 'Learn more',
    fileName: 'File Name',
    fileSize: 'Size',
    fileStatus: 'Status',
    fileActions: 'Actions',
    removeFile: 'Remove',
    fileAttached: 'File attached successfully',
    vectorStoreAttached: 'Vector store attached successfully',
    fileRemoved: 'File removed',
    invalidFileType: 'Invalid file type',
    fileTooLarge: 'File is too large',
    uploadError: 'Error uploading file',
    temperatureHelp: "Controls randomness in the assistant's responses",
    topPHelp: "Controls diversity of the assistant's responses",
    fileSearchHelp: 'Enable searching through attached files',
    codeInterpreterHelp: 'Enable Python code execution capabilities'
  }
};

export default local satisfies App.I18n.Schema &
  (App.I18n.IsExactLocaleKeyShape<typeof local.sponsorship, App.I18n.Schema['sponsorship']> extends true
    ? unknown
    : { readonly __sponsorshipLocaleKeyShapeMismatch: never });
